import { localeToFlagCode as Gr, useTheming as Yu, Theme as Be, onTheme as Af, useMessages as Vf, useActions as Rf, CompanyId as oi, useI18n as Ci, getLanguageName as Ha, languages as Lf, setupMessages as If } from "@loopia-group/services";
import { loadFlag as jf, loadIcon as qf, setupLoader as Ff } from "@loopia-group/assets";
import Wf from "bowser";
import xs from "xss";
import { get as ri } from "lodash-es";
import Gu from "axios";
import { toString as Bf } from "qrcode";
/**
* @vue/shared v3.5.4
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function pn(e) {
  const t = /* @__PURE__ */ Object.create(null);
  for (const n of e.split(",")) t[n] = 1;
  return (n) => n in t;
}
const Se = process.env.NODE_ENV !== "production" ? Object.freeze({}) : {}, Eo = process.env.NODE_ENV !== "production" ? Object.freeze([]) : [], Ke = () => {
}, zf = () => !1, wr = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // uppercase letter
(e.charCodeAt(2) > 122 || e.charCodeAt(2) < 97), ii = (e) => e.startsWith("onUpdate:"), We = Object.assign, ea = (e, t) => {
  const n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}, Hf = Object.prototype.hasOwnProperty, _e = (e, t) => Hf.call(e, t), ne = Array.isArray, Qn = (e) => Si(e) === "[object Map]", Qu = (e) => Si(e) === "[object Set]", se = (e) => typeof e == "function", Ae = (e) => typeof e == "string", An = (e) => typeof e == "symbol", Oe = (e) => e !== null && typeof e == "object", ta = (e) => (Oe(e) || se(e)) && se(e.then) && se(e.catch), Xu = Object.prototype.toString, Si = (e) => Xu.call(e), na = (e) => Si(e).slice(8, -1), Ju = (e) => Si(e) === "[object Object]", oa = (e) => Ae(e) && e !== "NaN" && e[0] !== "-" && "" + parseInt(e, 10) === e, Yo = /* @__PURE__ */ pn(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), Uf = /* @__PURE__ */ pn(
  "bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo"
), Oi = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  return (n) => t[n] || (t[n] = e(n));
}, Kf = /-(\w)/g, kt = Oi(
  (e) => e.replace(Kf, (t, n) => n ? n.toUpperCase() : "")
), Yf = /\B([A-Z])/g, dn = Oi(
  (e) => e.replace(Yf, "-$1").toLowerCase()
), so = Oi((e) => e.charAt(0).toUpperCase() + e.slice(1)), Fn = Oi(
  (e) => e ? `on${so(e)}` : ""
), Pn = (e, t) => !Object.is(e, t), go = (e, ...t) => {
  for (let n = 0; n < e.length; n++)
    e[n](...t);
}, si = (e, t, n, o = !1) => {
  Object.defineProperty(e, t, {
    configurable: !0,
    enumerable: !1,
    writable: o,
    value: n
  });
}, ks = (e) => {
  const t = parseFloat(e);
  return isNaN(t) ? e : t;
}, Gf = (e) => {
  const t = Ae(e) ? Number(e) : NaN;
  return isNaN(t) ? e : t;
};
let Ua;
const ra = () => Ua || (Ua = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function Ni(e) {
  if (ne(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
      const o = e[n], r = Ae(o) ? Zf(o) : Ni(o);
      if (r)
        for (const i in r)
          t[i] = r[i];
    }
    return t;
  } else if (Ae(e) || Oe(e))
    return e;
}
const Qf = /;(?![^(]*\))/g, Xf = /:([^]+)/, Jf = /\/\*[^]*?\*\//g;
function Zf(e) {
  const t = {};
  return e.replace(Jf, "").split(Qf).forEach((n) => {
    if (n) {
      const o = n.split(Xf);
      o.length > 1 && (t[o[0].trim()] = o[1].trim());
    }
  }), t;
}
function pt(e) {
  let t = "";
  if (Ae(e))
    t = e;
  else if (ne(e))
    for (let n = 0; n < e.length; n++) {
      const o = pt(e[n]);
      o && (t += o + " ");
    }
  else if (Oe(e))
    for (const n in e)
      e[n] && (t += n + " ");
  return t.trim();
}
const ep = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot", tp = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view", np = "annotation,annotation-xml,maction,maligngroup,malignmark,math,menclose,merror,mfenced,mfrac,mfraction,mglyph,mi,mlabeledtr,mlongdiv,mmultiscripts,mn,mo,mover,mpadded,mphantom,mprescripts,mroot,mrow,ms,mscarries,mscarry,msgroup,msline,mspace,msqrt,msrow,mstack,mstyle,msub,msubsup,msup,mtable,mtd,mtext,mtr,munder,munderover,none,semantics", op = /* @__PURE__ */ pn(ep), rp = /* @__PURE__ */ pn(tp), ip = /* @__PURE__ */ pn(np), sp = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", ap = /* @__PURE__ */ pn(sp);
function Zu(e) {
  return !!e || e === "";
}
const ec = (e) => !!(e && e.__v_isRef === !0), De = (e) => Ae(e) ? e : e == null ? "" : ne(e) || Oe(e) && (e.toString === Xu || !se(e.toString)) ? ec(e) ? De(e.value) : JSON.stringify(e, tc, 2) : String(e), tc = (e, t) => ec(t) ? tc(e, t.value) : Qn(t) ? {
  [`Map(${t.size})`]: [...t.entries()].reduce(
    (n, [o, r], i) => (n[Gi(o, i) + " =>"] = r, n),
    {}
  )
} : Qu(t) ? {
  [`Set(${t.size})`]: [...t.values()].map((n) => Gi(n))
} : An(t) ? Gi(t) : Oe(t) && !ne(t) && !Ju(t) ? String(t) : t, Gi = (e, t = "") => {
  var n;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    An(e) ? `Symbol(${(n = e.description) != null ? n : t})` : e
  );
};
/**
* @vue/reactivity v3.5.4
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Ft(e, ...t) {
  console.warn(`[Vue warn] ${e}`, ...t);
}
let Et;
class lp {
  constructor(t = !1) {
    this.detached = t, this._active = !0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Et, !t && Et && (this.index = (Et.scopes || (Et.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].pause();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let t, n;
      if (this.scopes)
        for (t = 0, n = this.scopes.length; t < n; t++)
          this.scopes[t].resume();
      for (t = 0, n = this.effects.length; t < n; t++)
        this.effects[t].resume();
    }
  }
  run(t) {
    if (this._active) {
      const n = Et;
      try {
        return Et = this, t();
      } finally {
        Et = n;
      }
    } else process.env.NODE_ENV !== "production" && Ft("cannot run an inactive effect scope.");
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    Et = this;
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    Et = this.parent;
  }
  stop(t) {
    if (this._active) {
      let n, o;
      for (n = 0, o = this.effects.length; n < o; n++)
        this.effects[n].stop();
      for (n = 0, o = this.cleanups.length; n < o; n++)
        this.cleanups[n]();
      if (this.scopes)
        for (n = 0, o = this.scopes.length; n < o; n++)
          this.scopes[n].stop(!0);
      if (!this.detached && this.parent && !t) {
        const r = this.parent.scopes.pop();
        r && r !== this && (this.parent.scopes[this.index] = r, r.index = this.index);
      }
      this.parent = void 0, this._active = !1;
    }
  }
}
function up() {
  return Et;
}
let Ce;
const Qi = /* @__PURE__ */ new WeakSet();
class nc {
  constructor(t) {
    this.fn = t, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.nextEffect = void 0, this.cleanup = void 0, this.scheduler = void 0, Et && Et.active && Et.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Qi.has(this) && (Qi.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || (this.flags |= 8, this.nextEffect = Go, Go = this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, Ka(this), rc(this);
    const t = Ce, n = qt;
    Ce = this, qt = !0;
    try {
      return this.fn();
    } finally {
      process.env.NODE_ENV !== "production" && Ce !== this && Ft(
        "Active effect was not restored correctly - this is likely a Vue internal bug."
      ), ic(this), Ce = t, qt = n, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let t = this.deps; t; t = t.nextDep)
        aa(t);
      this.deps = this.depsTail = void 0, Ka(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Qi.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    Cs(this) && this.run();
  }
  get dirty() {
    return Cs(this);
  }
}
let oc = 0, Go;
function ia() {
  oc++;
}
function sa() {
  if (--oc > 0)
    return;
  let e;
  for (; Go; ) {
    let t = Go;
    for (Go = void 0; t; ) {
      const n = t.nextEffect;
      if (t.nextEffect = void 0, t.flags &= -9, t.flags & 1)
        try {
          t.trigger();
        } catch (o) {
          e || (e = o);
        }
      t = n;
    }
  }
  if (e) throw e;
}
function rc(e) {
  for (let t = e.deps; t; t = t.nextDep)
    t.version = -1, t.prevActiveLink = t.dep.activeLink, t.dep.activeLink = t;
}
function ic(e) {
  let t, n = e.depsTail;
  for (let o = n; o; o = o.prevDep)
    o.version === -1 ? (o === n && (n = o.prevDep), aa(o), cp(o)) : t = o, o.dep.activeLink = o.prevActiveLink, o.prevActiveLink = void 0;
  e.deps = t, e.depsTail = n;
}
function Cs(e) {
  for (let t = e.deps; t; t = t.nextDep)
    if (t.dep.version !== t.version || t.dep.computed && sc(t.dep.computed) || t.dep.version !== t.version)
      return !0;
  return !!e._dirty;
}
function sc(e) {
  if (e.flags & 4 && !(e.flags & 16) || (e.flags &= -17, e.globalVersion === rr))
    return;
  e.globalVersion = rr;
  const t = e.dep;
  if (e.flags |= 2, t.version > 0 && !e.isSSR && !Cs(e)) {
    e.flags &= -3;
    return;
  }
  const n = Ce, o = qt;
  Ce = e, qt = !0;
  try {
    rc(e);
    const r = e.fn(e._value);
    (t.version === 0 || Pn(r, e._value)) && (e._value = r, t.version++);
  } catch (r) {
    throw t.version++, r;
  } finally {
    Ce = n, qt = o, ic(e), e.flags &= -3;
  }
}
function aa(e) {
  const { dep: t, prevSub: n, nextSub: o } = e;
  if (n && (n.nextSub = o, e.prevSub = void 0), o && (o.prevSub = n, e.nextSub = void 0), t.subs === e && (t.subs = n), !t.subs && t.computed) {
    t.computed.flags &= -5;
    for (let r = t.computed.deps; r; r = r.nextDep)
      aa(r);
  }
}
function cp(e) {
  const { prevDep: t, nextDep: n } = e;
  t && (t.nextDep = n, e.prevDep = void 0), n && (n.prevDep = t, e.nextDep = void 0);
}
let qt = !0;
const ac = [];
function mn() {
  ac.push(qt), qt = !1;
}
function hn() {
  const e = ac.pop();
  qt = e === void 0 ? !0 : e;
}
function Ka(e) {
  const { cleanup: t } = e;
  if (e.cleanup = void 0, t) {
    const n = Ce;
    Ce = void 0;
    try {
      t();
    } finally {
      Ce = n;
    }
  }
}
let rr = 0;
class la {
  constructor(t) {
    this.computed = t, this.version = 0, this.activeLink = void 0, this.subs = void 0, process.env.NODE_ENV !== "production" && (this.subsHead = void 0);
  }
  track(t) {
    if (!Ce || !qt || Ce === this.computed)
      return;
    let n = this.activeLink;
    if (n === void 0 || n.sub !== Ce)
      n = this.activeLink = {
        dep: this,
        sub: Ce,
        version: this.version,
        nextDep: void 0,
        prevDep: void 0,
        nextSub: void 0,
        prevSub: void 0,
        prevActiveLink: void 0
      }, Ce.deps ? (n.prevDep = Ce.depsTail, Ce.depsTail.nextDep = n, Ce.depsTail = n) : Ce.deps = Ce.depsTail = n, Ce.flags & 4 && lc(n);
    else if (n.version === -1 && (n.version = this.version, n.nextDep)) {
      const o = n.nextDep;
      o.prevDep = n.prevDep, n.prevDep && (n.prevDep.nextDep = o), n.prevDep = Ce.depsTail, n.nextDep = void 0, Ce.depsTail.nextDep = n, Ce.depsTail = n, Ce.deps === n && (Ce.deps = o);
    }
    return process.env.NODE_ENV !== "production" && Ce.onTrack && Ce.onTrack(
      We(
        {
          effect: Ce
        },
        t
      )
    ), n;
  }
  trigger(t) {
    this.version++, rr++, this.notify(t);
  }
  notify(t) {
    ia();
    try {
      if (process.env.NODE_ENV !== "production")
        for (let n = this.subsHead; n; n = n.nextSub)
          process.env.NODE_ENV !== "production" && n.sub.onTrigger && !(n.sub.flags & 8) && n.sub.onTrigger(
            We(
              {
                effect: n.sub
              },
              t
            )
          );
      for (let n = this.subs; n; n = n.prevSub)
        n.sub.notify();
    } finally {
      sa();
    }
  }
}
function lc(e) {
  const t = e.dep.computed;
  if (t && !e.dep.subs) {
    t.flags |= 20;
    for (let o = t.deps; o; o = o.nextDep)
      lc(o);
  }
  const n = e.dep.subs;
  n !== e && (e.prevSub = n, n && (n.nextSub = e)), process.env.NODE_ENV !== "production" && e.dep.subsHead === void 0 && (e.dep.subsHead = e), e.dep.subs = e;
}
const ai = /* @__PURE__ */ new WeakMap(), Xn = Symbol(
  process.env.NODE_ENV !== "production" ? "Object iterate" : ""
), Ss = Symbol(
  process.env.NODE_ENV !== "production" ? "Map keys iterate" : ""
), ir = Symbol(
  process.env.NODE_ENV !== "production" ? "Array iterate" : ""
);
function Ge(e, t, n) {
  if (qt && Ce) {
    let o = ai.get(e);
    o || ai.set(e, o = /* @__PURE__ */ new Map());
    let r = o.get(n);
    r || o.set(n, r = new la()), process.env.NODE_ENV !== "production" ? r.track({
      target: e,
      type: t,
      key: n
    }) : r.track();
  }
}
function Gt(e, t, n, o, r, i) {
  const s = ai.get(e);
  if (!s) {
    rr++;
    return;
  }
  const a = (l) => {
    l && (process.env.NODE_ENV !== "production" ? l.trigger({
      target: e,
      type: t,
      key: n,
      newValue: o,
      oldValue: r,
      oldTarget: i
    }) : l.trigger());
  };
  if (ia(), t === "clear")
    s.forEach(a);
  else {
    const l = ne(e), c = l && oa(n);
    if (l && n === "length") {
      const u = Number(o);
      s.forEach((d, f) => {
        (f === "length" || f === ir || !An(f) && f >= u) && a(d);
      });
    } else
      switch (n !== void 0 && a(s.get(n)), c && a(s.get(ir)), t) {
        case "add":
          l ? c && a(s.get("length")) : (a(s.get(Xn)), Qn(e) && a(s.get(Ss)));
          break;
        case "delete":
          l || (a(s.get(Xn)), Qn(e) && a(s.get(Ss)));
          break;
        case "set":
          Qn(e) && a(s.get(Xn));
          break;
      }
  }
  sa();
}
function dp(e, t) {
  var n;
  return (n = ai.get(e)) == null ? void 0 : n.get(t);
}
function co(e) {
  const t = ge(e);
  return t === e ? t : (Ge(t, "iterate", ir), mt(e) ? t : t.map(it));
}
function $i(e) {
  return Ge(e = ge(e), "iterate", ir), e;
}
const fp = {
  __proto__: null,
  [Symbol.iterator]() {
    return Xi(this, Symbol.iterator, it);
  },
  concat(...e) {
    return co(this).concat(
      ...e.map((t) => ne(t) ? co(t) : t)
    );
  },
  entries() {
    return Xi(this, "entries", (e) => (e[1] = it(e[1]), e));
  },
  every(e, t) {
    return tn(this, "every", e, t, void 0, arguments);
  },
  filter(e, t) {
    return tn(this, "filter", e, t, (n) => n.map(it), arguments);
  },
  find(e, t) {
    return tn(this, "find", e, t, it, arguments);
  },
  findIndex(e, t) {
    return tn(this, "findIndex", e, t, void 0, arguments);
  },
  findLast(e, t) {
    return tn(this, "findLast", e, t, it, arguments);
  },
  findLastIndex(e, t) {
    return tn(this, "findLastIndex", e, t, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(e, t) {
    return tn(this, "forEach", e, t, void 0, arguments);
  },
  includes(...e) {
    return Ji(this, "includes", e);
  },
  indexOf(...e) {
    return Ji(this, "indexOf", e);
  },
  join(e) {
    return co(this).join(e);
  },
  // keys() iterator only reads `length`, no optimisation required
  lastIndexOf(...e) {
    return Ji(this, "lastIndexOf", e);
  },
  map(e, t) {
    return tn(this, "map", e, t, void 0, arguments);
  },
  pop() {
    return Wo(this, "pop");
  },
  push(...e) {
    return Wo(this, "push", e);
  },
  reduce(e, ...t) {
    return Ya(this, "reduce", e, t);
  },
  reduceRight(e, ...t) {
    return Ya(this, "reduceRight", e, t);
  },
  shift() {
    return Wo(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(e, t) {
    return tn(this, "some", e, t, void 0, arguments);
  },
  splice(...e) {
    return Wo(this, "splice", e);
  },
  toReversed() {
    return co(this).toReversed();
  },
  toSorted(e) {
    return co(this).toSorted(e);
  },
  toSpliced(...e) {
    return co(this).toSpliced(...e);
  },
  unshift(...e) {
    return Wo(this, "unshift", e);
  },
  values() {
    return Xi(this, "values", it);
  }
};
function Xi(e, t, n) {
  const o = $i(e), r = o[t]();
  return o !== e && !mt(e) && (r._next = r.next, r.next = () => {
    const i = r._next();
    return i.value && (i.value = n(i.value)), i;
  }), r;
}
const pp = Array.prototype;
function tn(e, t, n, o, r, i) {
  const s = $i(e), a = s !== e && !mt(e), l = s[t];
  if (l !== pp[t]) {
    const d = l.apply(e, i);
    return a ? it(d) : d;
  }
  let c = n;
  s !== e && (a ? c = function(d, f) {
    return n.call(this, it(d), f, e);
  } : n.length > 2 && (c = function(d, f) {
    return n.call(this, d, f, e);
  }));
  const u = l.call(s, c, o);
  return a && r ? r(u) : u;
}
function Ya(e, t, n, o) {
  const r = $i(e);
  let i = n;
  return r !== e && (mt(e) ? n.length > 3 && (i = function(s, a, l) {
    return n.call(this, s, a, l, e);
  }) : i = function(s, a, l) {
    return n.call(this, s, it(a), l, e);
  }), r[t](i, ...o);
}
function Ji(e, t, n) {
  const o = ge(e);
  Ge(o, "iterate", ir);
  const r = o[t](...n);
  return (r === -1 || r === !1) && sr(n[0]) ? (n[0] = ge(n[0]), o[t](...n)) : r;
}
function Wo(e, t, n = []) {
  mn(), ia();
  const o = ge(e)[t].apply(e, n);
  return sa(), hn(), o;
}
const mp = /* @__PURE__ */ pn("__proto__,__v_isRef,__isVue"), uc = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(An)
);
function hp(e) {
  An(e) || (e = String(e));
  const t = ge(this);
  return Ge(t, "has", e), t.hasOwnProperty(e);
}
class cc {
  constructor(t = !1, n = !1) {
    this._isReadonly = t, this._isShallow = n;
  }
  get(t, n, o) {
    const r = this._isReadonly, i = this._isShallow;
    if (n === "__v_isReactive")
      return !r;
    if (n === "__v_isReadonly")
      return r;
    if (n === "__v_isShallow")
      return i;
    if (n === "__v_raw")
      return o === (r ? i ? gc : vc : i ? hc : mc).get(t) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(t) === Object.getPrototypeOf(o) ? t : void 0;
    const s = ne(t);
    if (!r) {
      let l;
      if (s && (l = fp[n]))
        return l;
      if (n === "hasOwnProperty")
        return hp;
    }
    const a = Reflect.get(
      t,
      n,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      $e(t) ? t : o
    );
    return (An(n) ? uc.has(n) : mp(n)) || (r || Ge(t, "get", n), i) ? a : $e(a) ? s && oa(n) ? a : a.value : Oe(a) ? r ? bc(a) : Ro(a) : a;
  }
}
class dc extends cc {
  constructor(t = !1) {
    super(!1, t);
  }
  set(t, n, o, r) {
    let i = t[n];
    if (!this._isShallow) {
      const l = fn(i);
      if (!mt(o) && !fn(o) && (i = ge(i), o = ge(o)), !ne(t) && $e(i) && !$e(o))
        return l ? !1 : (i.value = o, !0);
    }
    const s = ne(t) && oa(n) ? Number(n) < t.length : _e(t, n), a = Reflect.set(
      t,
      n,
      o,
      $e(t) ? t : r
    );
    return t === ge(r) && (s ? Pn(o, i) && Gt(t, "set", n, o, i) : Gt(t, "add", n, o)), a;
  }
  deleteProperty(t, n) {
    const o = _e(t, n), r = t[n], i = Reflect.deleteProperty(t, n);
    return i && o && Gt(t, "delete", n, void 0, r), i;
  }
  has(t, n) {
    const o = Reflect.has(t, n);
    return (!An(n) || !uc.has(n)) && Ge(t, "has", n), o;
  }
  ownKeys(t) {
    return Ge(
      t,
      "iterate",
      ne(t) ? "length" : Xn
    ), Reflect.ownKeys(t);
  }
}
class fc extends cc {
  constructor(t = !1) {
    super(!0, t);
  }
  set(t, n) {
    return process.env.NODE_ENV !== "production" && Ft(
      `Set operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
  deleteProperty(t, n) {
    return process.env.NODE_ENV !== "production" && Ft(
      `Delete operation on key "${String(n)}" failed: target is readonly.`,
      t
    ), !0;
  }
}
const vp = /* @__PURE__ */ new dc(), gp = /* @__PURE__ */ new fc(), bp = /* @__PURE__ */ new dc(!0), yp = /* @__PURE__ */ new fc(!0), ua = (e) => e, Ti = (e) => Reflect.getPrototypeOf(e);
function Mr(e, t, n = !1, o = !1) {
  e = e.__v_raw;
  const r = ge(e), i = ge(t);
  n || (Pn(t, i) && Ge(r, "get", t), Ge(r, "get", i));
  const { has: s } = Ti(r), a = o ? ua : n ? da : it;
  if (s.call(r, t))
    return a(e.get(t));
  if (s.call(r, i))
    return a(e.get(i));
  e !== r && e.get(t);
}
function Ar(e, t = !1) {
  const n = this.__v_raw, o = ge(n), r = ge(e);
  return t || (Pn(e, r) && Ge(o, "has", e), Ge(o, "has", r)), e === r ? n.has(e) : n.has(e) || n.has(r);
}
function Vr(e, t = !1) {
  return e = e.__v_raw, !t && Ge(ge(e), "iterate", Xn), Reflect.get(e, "size", e);
}
function Ga(e, t = !1) {
  !t && !mt(e) && !fn(e) && (e = ge(e));
  const n = ge(this);
  return Ti(n).has.call(n, e) || (n.add(e), Gt(n, "add", e, e)), this;
}
function Qa(e, t, n = !1) {
  !n && !mt(t) && !fn(t) && (t = ge(t));
  const o = ge(this), { has: r, get: i } = Ti(o);
  let s = r.call(o, e);
  s ? process.env.NODE_ENV !== "production" && pc(o, r, e) : (e = ge(e), s = r.call(o, e));
  const a = i.call(o, e);
  return o.set(e, t), s ? Pn(t, a) && Gt(o, "set", e, t, a) : Gt(o, "add", e, t), this;
}
function Xa(e) {
  const t = ge(this), { has: n, get: o } = Ti(t);
  let r = n.call(t, e);
  r ? process.env.NODE_ENV !== "production" && pc(t, n, e) : (e = ge(e), r = n.call(t, e));
  const i = o ? o.call(t, e) : void 0, s = t.delete(e);
  return r && Gt(t, "delete", e, void 0, i), s;
}
function Ja() {
  const e = ge(this), t = e.size !== 0, n = process.env.NODE_ENV !== "production" ? Qn(e) ? new Map(e) : new Set(e) : void 0, o = e.clear();
  return t && Gt(e, "clear", void 0, void 0, n), o;
}
function Rr(e, t) {
  return function(o, r) {
    const i = this, s = i.__v_raw, a = ge(s), l = t ? ua : e ? da : it;
    return !e && Ge(a, "iterate", Xn), s.forEach((c, u) => o.call(r, l(c), l(u), i));
  };
}
function Lr(e, t, n) {
  return function(...o) {
    const r = this.__v_raw, i = ge(r), s = Qn(i), a = e === "entries" || e === Symbol.iterator && s, l = e === "keys" && s, c = r[e](...o), u = n ? ua : t ? da : it;
    return !t && Ge(
      i,
      "iterate",
      l ? Ss : Xn
    ), {
      // iterator protocol
      next() {
        const { value: d, done: f } = c.next();
        return f ? { value: d, done: f } : {
          value: a ? [u(d[0]), u(d[1])] : u(d),
          done: f
        };
      },
      // iterable protocol
      [Symbol.iterator]() {
        return this;
      }
    };
  };
}
function bn(e) {
  return function(...t) {
    if (process.env.NODE_ENV !== "production") {
      const n = t[0] ? `on key "${t[0]}" ` : "";
      Ft(
        `${so(e)} operation ${n}failed: target is readonly.`,
        ge(this)
      );
    }
    return e === "delete" ? !1 : e === "clear" ? void 0 : this;
  };
}
function wp() {
  const e = {
    get(i) {
      return Mr(this, i);
    },
    get size() {
      return Vr(this);
    },
    has: Ar,
    add: Ga,
    set: Qa,
    delete: Xa,
    clear: Ja,
    forEach: Rr(!1, !1)
  }, t = {
    get(i) {
      return Mr(this, i, !1, !0);
    },
    get size() {
      return Vr(this);
    },
    has: Ar,
    add(i) {
      return Ga.call(this, i, !0);
    },
    set(i, s) {
      return Qa.call(this, i, s, !0);
    },
    delete: Xa,
    clear: Ja,
    forEach: Rr(!1, !0)
  }, n = {
    get(i) {
      return Mr(this, i, !0);
    },
    get size() {
      return Vr(this, !0);
    },
    has(i) {
      return Ar.call(this, i, !0);
    },
    add: bn("add"),
    set: bn("set"),
    delete: bn("delete"),
    clear: bn("clear"),
    forEach: Rr(!0, !1)
  }, o = {
    get(i) {
      return Mr(this, i, !0, !0);
    },
    get size() {
      return Vr(this, !0);
    },
    has(i) {
      return Ar.call(this, i, !0);
    },
    add: bn("add"),
    set: bn("set"),
    delete: bn("delete"),
    clear: bn("clear"),
    forEach: Rr(!0, !0)
  };
  return [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((i) => {
    e[i] = Lr(i, !1, !1), n[i] = Lr(i, !0, !1), t[i] = Lr(i, !1, !0), o[i] = Lr(
      i,
      !0,
      !0
    );
  }), [
    e,
    n,
    t,
    o
  ];
}
const [
  _p,
  Ep,
  xp,
  kp
] = /* @__PURE__ */ wp();
function Pi(e, t) {
  const n = t ? e ? kp : xp : e ? Ep : _p;
  return (o, r, i) => r === "__v_isReactive" ? !e : r === "__v_isReadonly" ? e : r === "__v_raw" ? o : Reflect.get(
    _e(n, r) && r in o ? n : o,
    r,
    i
  );
}
const Cp = {
  get: /* @__PURE__ */ Pi(!1, !1)
}, Sp = {
  get: /* @__PURE__ */ Pi(!1, !0)
}, Op = {
  get: /* @__PURE__ */ Pi(!0, !1)
}, Np = {
  get: /* @__PURE__ */ Pi(!0, !0)
};
function pc(e, t, n) {
  const o = ge(n);
  if (o !== n && t.call(e, o)) {
    const r = na(e);
    Ft(
      `Reactive ${r} contains both the raw and reactive versions of the same object${r === "Map" ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
    );
  }
}
const mc = /* @__PURE__ */ new WeakMap(), hc = /* @__PURE__ */ new WeakMap(), vc = /* @__PURE__ */ new WeakMap(), gc = /* @__PURE__ */ new WeakMap();
function $p(e) {
  switch (e) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function Tp(e) {
  return e.__v_skip || !Object.isExtensible(e) ? 0 : $p(na(e));
}
function Ro(e) {
  return fn(e) ? e : Di(
    e,
    !1,
    vp,
    Cp,
    mc
  );
}
function Pp(e) {
  return Di(
    e,
    !1,
    bp,
    Sp,
    hc
  );
}
function bc(e) {
  return Di(
    e,
    !0,
    gp,
    Op,
    vc
  );
}
function Yt(e) {
  return Di(
    e,
    !0,
    yp,
    Np,
    gc
  );
}
function Di(e, t, n, o, r) {
  if (!Oe(e))
    return process.env.NODE_ENV !== "production" && Ft(
      `value cannot be made ${t ? "readonly" : "reactive"}: ${String(
        e
      )}`
    ), e;
  if (e.__v_raw && !(t && e.__v_isReactive))
    return e;
  const i = r.get(e);
  if (i)
    return i;
  const s = Tp(e);
  if (s === 0)
    return e;
  const a = new Proxy(
    e,
    s === 2 ? o : n
  );
  return r.set(e, a), a;
}
function un(e) {
  return fn(e) ? un(e.__v_raw) : !!(e && e.__v_isReactive);
}
function fn(e) {
  return !!(e && e.__v_isReadonly);
}
function mt(e) {
  return !!(e && e.__v_isShallow);
}
function sr(e) {
  return e ? !!e.__v_raw : !1;
}
function ge(e) {
  const t = e && e.__v_raw;
  return t ? ge(t) : e;
}
function ca(e) {
  return !_e(e, "__v_skip") && Object.isExtensible(e) && si(e, "__v_skip", !0), e;
}
const it = (e) => Oe(e) ? Ro(e) : e, da = (e) => Oe(e) ? bc(e) : e;
function $e(e) {
  return e ? e.__v_isRef === !0 : !1;
}
function te(e) {
  return yc(e, !1);
}
function Dp(e) {
  return yc(e, !0);
}
function yc(e, t) {
  return $e(e) ? e : new Mp(e, t);
}
class Mp {
  constructor(t, n) {
    this.dep = new la(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = n ? t : ge(t), this._value = n ? t : it(t), this.__v_isShallow = n;
  }
  get value() {
    return process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track(), this._value;
  }
  set value(t) {
    const n = this._rawValue, o = this.__v_isShallow || mt(t) || fn(t);
    t = o ? t : ge(t), Pn(t, n) && (this._rawValue = t, this._value = o ? t : it(t), process.env.NODE_ENV !== "production" ? this.dep.trigger({
      target: this,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: n
    }) : this.dep.trigger());
  }
}
function re(e) {
  return $e(e) ? e.value : e;
}
const Ap = {
  get: (e, t, n) => t === "__v_raw" ? e : re(Reflect.get(e, t, n)),
  set: (e, t, n, o) => {
    const r = e[t];
    return $e(r) && !$e(n) ? (r.value = n, !0) : Reflect.set(e, t, n, o);
  }
};
function wc(e) {
  return un(e) ? e : new Proxy(e, Ap);
}
function _c(e) {
  process.env.NODE_ENV !== "production" && !sr(e) && Ft("toRefs() expects a reactive object but received a plain one.");
  const t = ne(e) ? new Array(e.length) : {};
  for (const n in e)
    t[n] = Rp(e, n);
  return t;
}
class Vp {
  constructor(t, n, o) {
    this._object = t, this._key = n, this._defaultValue = o, this.__v_isRef = !0, this._value = void 0;
  }
  get value() {
    const t = this._object[this._key];
    return this._value = t === void 0 ? this._defaultValue : t;
  }
  set value(t) {
    this._object[this._key] = t;
  }
  get dep() {
    return dp(ge(this._object), this._key);
  }
}
function Rp(e, t, n) {
  const o = e[t];
  return $e(o) ? o : new Vp(e, t, n);
}
class Lp {
  constructor(t, n, o) {
    this.fn = t, this.setter = n, this._value = void 0, this.dep = new la(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = rr - 1, this.effect = this, this.__v_isReadonly = !n, this.isSSR = o;
  }
  /**
   * @internal
   */
  notify() {
    this.flags |= 16, Ce !== this ? this.dep.notify() : process.env.NODE_ENV;
  }
  get value() {
    const t = process.env.NODE_ENV !== "production" ? this.dep.track({
      target: this,
      type: "get",
      key: "value"
    }) : this.dep.track();
    return sc(this), t && (t.version = this.dep.version), this._value;
  }
  set value(t) {
    this.setter ? this.setter(t) : process.env.NODE_ENV !== "production" && Ft("Write operation failed: computed value is readonly");
  }
}
function Ip(e, t, n = !1) {
  let o, r;
  se(e) ? o = e : (o = e.get, r = e.set);
  const i = new Lp(o, r, n);
  return process.env.NODE_ENV !== "production" && t && !n && (i.onTrack = t.onTrack, i.onTrigger = t.onTrigger), i;
}
const Ir = {}, li = /* @__PURE__ */ new WeakMap();
let Wn;
function jp(e, t = !1, n = Wn) {
  if (n) {
    let o = li.get(n);
    o || li.set(n, o = []), o.push(e);
  } else process.env.NODE_ENV !== "production" && !t && Ft(
    "onWatcherCleanup() was called when there was no active watcher to associate with."
  );
}
function qp(e, t, n = Se) {
  const { immediate: o, deep: r, once: i, scheduler: s, augmentJob: a, call: l } = n, c = (y) => {
    (n.onWarn || Ft)(
      "Invalid watch source: ",
      y,
      "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."
    );
  }, u = (y) => r ? y : mt(y) || r === !1 || r === 0 ? ln(y, 1) : ln(y);
  let d, f, p, v, w = !1, _ = !1;
  if ($e(e) ? (f = () => e.value, w = mt(e)) : un(e) ? (f = () => u(e), w = !0) : ne(e) ? (_ = !0, w = e.some((y) => un(y) || mt(y)), f = () => e.map((y) => {
    if ($e(y))
      return y.value;
    if (un(y))
      return u(y);
    if (se(y))
      return l ? l(y, 2) : y();
    process.env.NODE_ENV !== "production" && c(y);
  })) : se(e) ? t ? f = l ? () => l(e, 2) : e : f = () => {
    if (p) {
      mn();
      try {
        p();
      } finally {
        hn();
      }
    }
    const y = Wn;
    Wn = d;
    try {
      return l ? l(e, 3, [v]) : e(v);
    } finally {
      Wn = y;
    }
  } : (f = Ke, process.env.NODE_ENV !== "production" && c(e)), t && r) {
    const y = f, x = r === !0 ? 1 / 0 : r;
    f = () => ln(y(), x);
  }
  const C = up(), S = () => {
    d.stop(), C && ea(C.effects, d);
  };
  if (i)
    if (t) {
      const y = t;
      t = (...x) => {
        y(...x), S();
      };
    } else {
      const y = f;
      f = () => {
        y(), S();
      };
    }
  let N = _ ? new Array(e.length).fill(Ir) : Ir;
  const m = (y) => {
    if (!(!(d.flags & 1) || !d.dirty && !y))
      if (t) {
        const x = d.run();
        if (r || w || (_ ? x.some((k, D) => Pn(k, N[D])) : Pn(x, N))) {
          p && p();
          const k = Wn;
          Wn = d;
          try {
            const D = [
              x,
              // pass undefined as the old value when it's changed for the first time
              N === Ir ? void 0 : _ && N[0] === Ir ? [] : N,
              v
            ];
            l ? l(t, 3, D) : (
              // @ts-expect-error
              t(...D)
            ), N = x;
          } finally {
            Wn = k;
          }
        }
      } else
        d.run();
  };
  return a && a(m), d = new nc(f), d.scheduler = s ? () => s(m, !1) : m, v = (y) => jp(y, !1, d), p = d.onStop = () => {
    const y = li.get(d);
    if (y) {
      if (l)
        l(y, 4);
      else
        for (const x of y) x();
      li.delete(d);
    }
  }, process.env.NODE_ENV !== "production" && (d.onTrack = n.onTrack, d.onTrigger = n.onTrigger), t ? o ? m(!0) : N = d.run() : s ? s(m.bind(null, !0), !0) : d.run(), S.pause = d.pause.bind(d), S.resume = d.resume.bind(d), S.stop = S, S;
}
function ln(e, t = 1 / 0, n) {
  if (t <= 0 || !Oe(e) || e.__v_skip || (n = n || /* @__PURE__ */ new Set(), n.has(e)))
    return e;
  if (n.add(e), t--, $e(e))
    ln(e.value, t, n);
  else if (ne(e))
    for (let o = 0; o < e.length; o++)
      ln(e[o], t, n);
  else if (Qu(e) || Qn(e))
    e.forEach((o) => {
      ln(o, t, n);
    });
  else if (Ju(e)) {
    for (const o in e)
      ln(e[o], t, n);
    for (const o of Object.getOwnPropertySymbols(e))
      Object.prototype.propertyIsEnumerable.call(e, o) && ln(e[o], t, n);
  }
  return e;
}
/**
* @vue/runtime-core v3.5.4
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
const Jn = [];
function Qr(e) {
  Jn.push(e);
}
function Xr() {
  Jn.pop();
}
let Zi = !1;
function z(e, ...t) {
  if (Zi) return;
  Zi = !0, mn();
  const n = Jn.length ? Jn[Jn.length - 1].component : null, o = n && n.appContext.config.warnHandler, r = Fp();
  if (o)
    Lo(
      o,
      n,
      11,
      [
        // eslint-disable-next-line no-restricted-syntax
        e + t.map((i) => {
          var s, a;
          return (a = (s = i.toString) == null ? void 0 : s.call(i)) != null ? a : JSON.stringify(i);
        }).join(""),
        n && n.proxy,
        r.map(
          ({ vnode: i }) => `at <${Fi(n, i.type)}>`
        ).join(`
`),
        r
      ]
    );
  else {
    const i = [`[Vue warn]: ${e}`, ...t];
    r.length && i.push(`
`, ...Wp(r)), console.warn(...i);
  }
  hn(), Zi = !1;
}
function Fp() {
  let e = Jn[Jn.length - 1];
  if (!e)
    return [];
  const t = [];
  for (; e; ) {
    const n = t[0];
    n && n.vnode === e ? n.recurseCount++ : t.push({
      vnode: e,
      recurseCount: 0
    });
    const o = e.component && e.component.parent;
    e = o && o.vnode;
  }
  return t;
}
function Wp(e) {
  const t = [];
  return e.forEach((n, o) => {
    t.push(...o === 0 ? [] : [`
`], ...Bp(n));
  }), t;
}
function Bp({ vnode: e, recurseCount: t }) {
  const n = t > 0 ? `... (${t} recursive calls)` : "", o = e.component ? e.component.parent == null : !1, r = ` at <${Fi(
    e.component,
    e.type,
    o
  )}`, i = ">" + n;
  return e.props ? [r, ...zp(e.props), i] : [r + i];
}
function zp(e) {
  const t = [], n = Object.keys(e);
  return n.slice(0, 3).forEach((o) => {
    t.push(...Ec(o, e[o]));
  }), n.length > 3 && t.push(" ..."), t;
}
function Ec(e, t, n) {
  return Ae(t) ? (t = JSON.stringify(t), n ? t : [`${e}=${t}`]) : typeof t == "number" || typeof t == "boolean" || t == null ? n ? t : [`${e}=${t}`] : $e(t) ? (t = Ec(e, ge(t.value), !0), n ? t : [`${e}=Ref<`, t, ">"]) : se(t) ? [`${e}=fn${t.name ? `<${t.name}>` : ""}`] : (t = ge(t), n ? t : [`${e}=`, t]);
}
function Hp(e, t) {
  process.env.NODE_ENV !== "production" && e !== void 0 && (typeof e != "number" ? z(`${t} is not a valid number - got ${JSON.stringify(e)}.`) : isNaN(e) && z(`${t} is NaN - the duration expression might be incorrect.`));
}
const fa = {
  sp: "serverPrefetch hook",
  bc: "beforeCreate hook",
  c: "created hook",
  bm: "beforeMount hook",
  m: "mounted hook",
  bu: "beforeUpdate hook",
  u: "updated",
  bum: "beforeUnmount hook",
  um: "unmounted hook",
  a: "activated hook",
  da: "deactivated hook",
  ec: "errorCaptured hook",
  rtc: "renderTracked hook",
  rtg: "renderTriggered hook",
  0: "setup function",
  1: "render function",
  2: "watcher getter",
  3: "watcher callback",
  4: "watcher cleanup function",
  5: "native event handler",
  6: "component event handler",
  7: "vnode hook",
  8: "directive hook",
  9: "transition hook",
  10: "app errorHandler",
  11: "app warnHandler",
  12: "ref function",
  13: "async component loader",
  14: "scheduler flush",
  15: "component update",
  16: "app unmount cleanup function"
};
function Lo(e, t, n, o) {
  try {
    return o ? e(...o) : e();
  } catch (r) {
    _r(r, t, n);
  }
}
function Wt(e, t, n, o) {
  if (se(e)) {
    const r = Lo(e, t, n, o);
    return r && ta(r) && r.catch((i) => {
      _r(i, t, n);
    }), r;
  }
  if (ne(e)) {
    const r = [];
    for (let i = 0; i < e.length; i++)
      r.push(Wt(e[i], t, n, o));
    return r;
  } else process.env.NODE_ENV !== "production" && z(
    `Invalid value type passed to callWithAsyncErrorHandling(): ${typeof e}`
  );
}
function _r(e, t, n, o = !0) {
  const r = t ? t.vnode : null, { errorHandler: i, throwUnhandledErrorInProduction: s } = t && t.appContext.config || Se;
  if (t) {
    let a = t.parent;
    const l = t.proxy, c = process.env.NODE_ENV !== "production" ? fa[n] : `https://vuejs.org/error-reference/#runtime-${n}`;
    for (; a; ) {
      const u = a.ec;
      if (u) {
        for (let d = 0; d < u.length; d++)
          if (u[d](e, l, c) === !1)
            return;
      }
      a = a.parent;
    }
    if (i) {
      mn(), Lo(i, null, 10, [
        e,
        l,
        c
      ]), hn();
      return;
    }
  }
  Up(e, n, r, o, s);
}
function Up(e, t, n, o = !0, r = !1) {
  if (process.env.NODE_ENV !== "production") {
    const i = fa[t];
    if (n && Qr(n), z(`Unhandled error${i ? ` during execution of ${i}` : ""}`), n && Xr(), o)
      throw e;
    console.error(e);
  } else {
    if (r)
      throw e;
    console.error(e);
  }
}
let ar = !1, Os = !1;
const dt = [];
let Ut = 0;
const xo = [];
let En = null, bo = 0;
const xc = /* @__PURE__ */ Promise.resolve();
let pa = null;
const Kp = 100;
function tt(e) {
  const t = pa || xc;
  return e ? t.then(this ? e.bind(this) : e) : t;
}
function Yp(e) {
  let t = ar ? Ut + 1 : 0, n = dt.length;
  for (; t < n; ) {
    const o = t + n >>> 1, r = dt[o], i = lr(r);
    i < e || i === e && r.flags & 2 ? t = o + 1 : n = o;
  }
  return t;
}
function Mi(e) {
  if (!(e.flags & 1)) {
    const t = lr(e), n = dt[dt.length - 1];
    !n || // fast path when the job id is larger than the tail
    !(e.flags & 2) && t >= lr(n) ? dt.push(e) : dt.splice(Yp(t), 0, e), e.flags |= 1, kc();
  }
}
function kc() {
  !ar && !Os && (Os = !0, pa = xc.then(Oc));
}
function Cc(e) {
  ne(e) ? xo.push(...e) : En && e.id === -1 ? En.splice(bo + 1, 0, e) : e.flags & 1 || (xo.push(e), e.flags |= 1), kc();
}
function Za(e, t, n = ar ? Ut + 1 : 0) {
  for (process.env.NODE_ENV !== "production" && (t = t || /* @__PURE__ */ new Map()); n < dt.length; n++) {
    const o = dt[n];
    if (o && o.flags & 2) {
      if (e && o.id !== e.uid || process.env.NODE_ENV !== "production" && ma(t, o))
        continue;
      dt.splice(n, 1), n--, o.flags & 4 && (o.flags &= -2), o(), o.flags &= -2;
    }
  }
}
function Sc(e) {
  if (xo.length) {
    const t = [...new Set(xo)].sort(
      (n, o) => lr(n) - lr(o)
    );
    if (xo.length = 0, En) {
      En.push(...t);
      return;
    }
    for (En = t, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map()), bo = 0; bo < En.length; bo++) {
      const n = En[bo];
      process.env.NODE_ENV !== "production" && ma(e, n) || (n.flags & 4 && (n.flags &= -2), n.flags & 8 || n(), n.flags &= -2);
    }
    En = null, bo = 0;
  }
}
const lr = (e) => e.id == null ? e.flags & 2 ? -1 : 1 / 0 : e.id;
function Oc(e) {
  Os = !1, ar = !0, process.env.NODE_ENV !== "production" && (e = e || /* @__PURE__ */ new Map());
  const t = process.env.NODE_ENV !== "production" ? (n) => ma(e, n) : Ke;
  try {
    for (Ut = 0; Ut < dt.length; Ut++) {
      const n = dt[Ut];
      if (n && !(n.flags & 8)) {
        if (process.env.NODE_ENV !== "production" && t(n))
          continue;
        n.flags & 4 && (n.flags &= -2), Lo(
          n,
          n.i,
          n.i ? 15 : 14
        ), n.flags &= -2;
      }
    }
  } finally {
    for (; Ut < dt.length; Ut++) {
      const n = dt[Ut];
      n && (n.flags &= -2);
    }
    Ut = 0, dt.length = 0, Sc(e), ar = !1, pa = null, (dt.length || xo.length) && Oc(e);
  }
}
function ma(e, t) {
  const n = e.get(t) || 0;
  if (n > Kp) {
    const o = t.i, r = o && Ca(o.type);
    return _r(
      `Maximum recursive updates exceeded${r ? ` in component <${r}>` : ""}. This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function.`,
      null,
      10
    ), !0;
  }
  return e.set(t, n + 1), !1;
}
let $n = !1;
const Jr = /* @__PURE__ */ new Map();
process.env.NODE_ENV !== "production" && (ra().__VUE_HMR_RUNTIME__ = {
  createRecord: es(Nc),
  rerender: es(Xp),
  reload: es(Jp)
});
const ao = /* @__PURE__ */ new Map();
function Gp(e) {
  const t = e.type.__hmrId;
  let n = ao.get(t);
  n || (Nc(t, e.type), n = ao.get(t)), n.instances.add(e);
}
function Qp(e) {
  ao.get(e.type.__hmrId).instances.delete(e);
}
function Nc(e, t) {
  return ao.has(e) ? !1 : (ao.set(e, {
    initialDef: ui(t),
    instances: /* @__PURE__ */ new Set()
  }), !0);
}
function ui(e) {
  return bd(e) ? e.__vccOpts : e;
}
function Xp(e, t) {
  const n = ao.get(e);
  n && (n.initialDef.render = t, [...n.instances].forEach((o) => {
    t && (o.render = t, ui(o.type).render = t), o.renderCache = [], $n = !0, o.update(), $n = !1;
  }));
}
function Jp(e, t) {
  const n = ao.get(e);
  if (!n) return;
  t = ui(t), el(n.initialDef, t);
  const o = [...n.instances];
  for (let r = 0; r < o.length; r++) {
    const i = o[r], s = ui(i.type);
    let a = Jr.get(s);
    a || (s !== n.initialDef && el(s, t), Jr.set(s, a = /* @__PURE__ */ new Set())), a.add(i), i.appContext.propsCache.delete(i.type), i.appContext.emitsCache.delete(i.type), i.appContext.optionsCache.delete(i.type), i.ceReload ? (a.add(i), i.ceReload(t.styles), a.delete(i)) : i.parent ? Mi(() => {
      i.parent.update(), a.delete(i);
    }) : i.appContext.reload ? i.appContext.reload() : typeof window < "u" ? window.location.reload() : console.warn(
      "[HMR] Root or manually mounted instance modified. Full reload required."
    ), i.root.ce && i !== i.root && i.root.ce._removeChildStyle(s);
  }
  Cc(() => {
    Jr.clear();
  });
}
function el(e, t) {
  We(e, t);
  for (const n in e)
    n !== "__file" && !(n in t) && delete e[n];
}
function es(e) {
  return (t, n) => {
    try {
      return e(t, n);
    } catch (o) {
      console.error(o), console.warn(
        "[HMR] Something went wrong during Vue component hot-reload. Full reload required."
      );
    }
  };
}
let It, Uo = [], Ns = !1;
function Er(e, ...t) {
  It ? It.emit(e, ...t) : Ns || Uo.push({ event: e, args: t });
}
function ha(e, t) {
  var n, o;
  It = e, It ? (It.enabled = !0, Uo.forEach(({ event: r, args: i }) => It.emit(r, ...i)), Uo = []) : /* handle late devtools injection - only do this if we are in an actual */ /* browser environment to avoid the timer handle stalling test runner exit */ /* (#4815) */ typeof window < "u" && // some envs mock window but not fully
  window.HTMLElement && // also exclude jsdom
  // eslint-disable-next-line no-restricted-syntax
  !((o = (n = window.navigator) == null ? void 0 : n.userAgent) != null && o.includes("jsdom")) ? ((t.__VUE_DEVTOOLS_HOOK_REPLAY__ = t.__VUE_DEVTOOLS_HOOK_REPLAY__ || []).push((i) => {
    ha(i, t);
  }), setTimeout(() => {
    It || (t.__VUE_DEVTOOLS_HOOK_REPLAY__ = null, Ns = !0, Uo = []);
  }, 3e3)) : (Ns = !0, Uo = []);
}
function Zp(e, t) {
  Er("app:init", e, t, {
    Fragment: Je,
    Text: Sr,
    Comment: ze,
    Static: Zo
  });
}
function em(e) {
  Er("app:unmount", e);
}
const tm = /* @__PURE__ */ va(
  "component:added"
  /* COMPONENT_ADDED */
), $c = /* @__PURE__ */ va(
  "component:updated"
  /* COMPONENT_UPDATED */
), nm = /* @__PURE__ */ va(
  "component:removed"
  /* COMPONENT_REMOVED */
), om = (e) => {
  It && typeof It.cleanupBuffer == "function" && // remove the component if it wasn't buffered
  !It.cleanupBuffer(e) && nm(e);
};
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function va(e) {
  return (t) => {
    Er(
      e,
      t.appContext.app,
      t.uid,
      t.parent ? t.parent.uid : void 0,
      t
    );
  };
}
const rm = /* @__PURE__ */ Tc(
  "perf:start"
  /* PERFORMANCE_START */
), im = /* @__PURE__ */ Tc(
  "perf:end"
  /* PERFORMANCE_END */
);
function Tc(e) {
  return (t, n, o) => {
    Er(e, t.appContext.app, t.uid, t, n, o);
  };
}
function sm(e, t, n) {
  Er(
    "component:emit",
    e.appContext.app,
    e,
    t,
    n
  );
}
let st = null, Pc = null;
function ci(e) {
  const t = st;
  return st = e, Pc = e && e.type.__scopeId || null, t;
}
function Me(e, t = st, n) {
  if (!t || e._n)
    return e;
  const o = (...r) => {
    o._d && hl(-1);
    const i = ci(t);
    let s;
    try {
      s = e(...r);
    } finally {
      ci(i), o._d && hl(1);
    }
    return process.env.NODE_ENV !== "production" && $c(t), s;
  };
  return o._n = !0, o._c = !0, o._d = !0, o;
}
function Dc(e) {
  Uf(e) && z("Do not use built-in directive ids as custom directive id: " + e);
}
function ga(e, t) {
  if (st === null)
    return process.env.NODE_ENV !== "production" && z("withDirectives can only be used inside render functions."), e;
  const n = qi(st), o = e.dirs || (e.dirs = []);
  for (let r = 0; r < t.length; r++) {
    let [i, s, a, l = Se] = t[r];
    i && (se(i) && (i = {
      mounted: i,
      updated: i
    }), i.deep && ln(s), o.push({
      dir: i,
      instance: n,
      value: s,
      oldValue: void 0,
      arg: a,
      modifiers: l
    }));
  }
  return e;
}
function Ln(e, t, n, o) {
  const r = e.dirs, i = t && t.dirs;
  for (let s = 0; s < r.length; s++) {
    const a = r[s];
    i && (a.oldValue = i[s].value);
    let l = a.dir[o];
    l && (mn(), Wt(l, n, 8, [
      e.el,
      a,
      e,
      t
    ]), hn());
  }
}
const Mc = Symbol("_vte"), Ac = (e) => e.__isTeleport, Zn = (e) => e && (e.disabled || e.disabled === ""), am = (e) => e && (e.defer || e.defer === ""), tl = (e) => typeof SVGElement < "u" && e instanceof SVGElement, nl = (e) => typeof MathMLElement == "function" && e instanceof MathMLElement, $s = (e, t) => {
  const n = e && e.to;
  if (Ae(n))
    if (t) {
      const o = t(n);
      return process.env.NODE_ENV !== "production" && !o && !Zn(e) && z(
        `Failed to locate Teleport target with selector "${n}". Note the target element must exist before the component is mounted - i.e. the target cannot be rendered by the component itself, and ideally should be outside of the entire Vue component tree.`
      ), o;
    } else
      return process.env.NODE_ENV !== "production" && z(
        "Current renderer does not support string target for Teleports. (missing querySelector renderer option)"
      ), null;
  else
    return process.env.NODE_ENV !== "production" && !n && !Zn(e) && z(`Invalid Teleport target: ${n}`), n;
}, lm = {
  name: "Teleport",
  __isTeleport: !0,
  process(e, t, n, o, r, i, s, a, l, c) {
    const {
      mc: u,
      pc: d,
      pbc: f,
      o: { insert: p, querySelector: v, createText: w, createComment: _ }
    } = c, C = Zn(t.props);
    let { shapeFlag: S, children: N, dynamicChildren: m } = t;
    if (process.env.NODE_ENV !== "production" && $n && (l = !1, m = null), e == null) {
      const y = t.el = process.env.NODE_ENV !== "production" ? _("teleport start") : w(""), x = t.anchor = process.env.NODE_ENV !== "production" ? _("teleport end") : w("");
      p(y, n, o), p(x, n, o);
      const k = (E, O) => {
        S & 16 && u(
          N,
          E,
          O,
          r,
          i,
          s,
          a,
          l
        );
      }, D = () => {
        const E = t.target = $s(t.props, v), O = Vc(E, t, w, p);
        E ? (s !== "svg" && tl(E) ? s = "svg" : s !== "mathml" && nl(E) && (s = "mathml"), C || (k(E, O), Zr(t))) : process.env.NODE_ENV !== "production" && !C && z(
          "Invalid Teleport target on mount:",
          E,
          `(${typeof E})`
        );
      };
      C && (k(n, x), Zr(t)), am(t.props) ? gt(D, i) : D();
    } else {
      t.el = e.el, t.targetStart = e.targetStart;
      const y = t.anchor = e.anchor, x = t.target = e.target, k = t.targetAnchor = e.targetAnchor, D = Zn(e.props), E = D ? n : x, O = D ? y : k;
      if (s === "svg" || tl(x) ? s = "svg" : (s === "mathml" || nl(x)) && (s = "mathml"), m ? (f(
        e.dynamicChildren,
        m,
        E,
        r,
        i,
        s,
        a
      ), Jo(e, t, !0)) : l || d(
        e,
        t,
        E,
        O,
        r,
        i,
        s,
        a,
        !1
      ), C)
        D ? t.props && e.props && t.props.to !== e.props.to && (t.props.to = e.props.to) : jr(
          t,
          n,
          y,
          c,
          1
        );
      else if ((t.props && t.props.to) !== (e.props && e.props.to)) {
        const A = t.target = $s(
          t.props,
          v
        );
        A ? jr(
          t,
          A,
          null,
          c,
          0
        ) : process.env.NODE_ENV !== "production" && z(
          "Invalid Teleport target on update:",
          x,
          `(${typeof x})`
        );
      } else D && jr(
        t,
        x,
        k,
        c,
        1
      );
      Zr(t);
    }
  },
  remove(e, t, n, { um: o, o: { remove: r } }, i) {
    const {
      shapeFlag: s,
      children: a,
      anchor: l,
      targetStart: c,
      targetAnchor: u,
      target: d,
      props: f
    } = e;
    if (d && (r(c), r(u)), i && r(l), s & 16) {
      const p = i || !Zn(f);
      for (let v = 0; v < a.length; v++) {
        const w = a[v];
        o(
          w,
          t,
          n,
          p,
          !!w.dynamicChildren
        );
      }
    }
  },
  move: jr,
  hydrate: um
};
function jr(e, t, n, { o: { insert: o }, m: r }, i = 2) {
  i === 0 && o(e.targetAnchor, t, n);
  const { el: s, anchor: a, shapeFlag: l, children: c, props: u } = e, d = i === 2;
  if (d && o(s, t, n), (!d || Zn(u)) && l & 16)
    for (let f = 0; f < c.length; f++)
      r(
        c[f],
        t,
        n,
        2
      );
  d && o(a, t, n);
}
function um(e, t, n, o, r, i, {
  o: { nextSibling: s, parentNode: a, querySelector: l, insert: c, createText: u }
}, d) {
  const f = t.target = $s(
    t.props,
    l
  );
  if (f) {
    const p = f._lpa || f.firstChild;
    if (t.shapeFlag & 16)
      if (Zn(t.props))
        t.anchor = d(
          s(e),
          t,
          a(e),
          n,
          o,
          r,
          i
        ), t.targetStart = p, t.targetAnchor = p && s(p);
      else {
        t.anchor = s(e);
        let v = p;
        for (; v; ) {
          if (v && v.nodeType === 8) {
            if (v.data === "teleport start anchor")
              t.targetStart = v;
            else if (v.data === "teleport anchor") {
              t.targetAnchor = v, f._lpa = t.targetAnchor && s(t.targetAnchor);
              break;
            }
          }
          v = s(v);
        }
        t.targetAnchor || Vc(f, t, u, c), d(
          p && s(p),
          t,
          f,
          n,
          o,
          r,
          i
        );
      }
    Zr(t);
  }
  return t.anchor && s(t.anchor);
}
const cm = lm;
function Zr(e) {
  const t = e.ctx;
  if (t && t.ut) {
    let n = e.targetStart;
    for (; n && n !== e.targetAnchor; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", t.uid), n = n.nextSibling;
    t.ut();
  }
}
function Vc(e, t, n, o) {
  const r = t.targetStart = n(""), i = t.targetAnchor = n("");
  return r[Mc] = i, e && (o(r, e), o(i, e)), i;
}
const xn = Symbol("_leaveCb"), qr = Symbol("_enterCb");
function dm() {
  const e = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Ct(() => {
    e.isMounted = !0;
  }), St(() => {
    e.isUnmounting = !0;
  }), e;
}
const Nt = [Function, Array], Rc = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Nt,
  onEnter: Nt,
  onAfterEnter: Nt,
  onEnterCancelled: Nt,
  // leave
  onBeforeLeave: Nt,
  onLeave: Nt,
  onAfterLeave: Nt,
  onLeaveCancelled: Nt,
  // appear
  onBeforeAppear: Nt,
  onAppear: Nt,
  onAfterAppear: Nt,
  onAppearCancelled: Nt
}, Lc = (e) => {
  const t = e.subTree;
  return t.component ? Lc(t.component) : t;
}, fm = {
  name: "BaseTransition",
  props: Rc,
  setup(e, { slots: t }) {
    const n = Fe(), o = dm();
    return () => {
      const r = t.default && qc(t.default(), !0);
      if (!r || !r.length)
        return;
      const i = Ic(r), s = ge(e), { mode: a } = s;
      if (process.env.NODE_ENV !== "production" && a && a !== "in-out" && a !== "out-in" && a !== "default" && z(`invalid <transition> mode: ${a}`), o.isLeaving)
        return ts(i);
      const l = ol(i);
      if (!l)
        return ts(i);
      let c = Ts(
        l,
        s,
        o,
        n,
        // #11061, ensure enterHooks is fresh after clone
        (f) => c = f
      );
      l.type !== ze && ur(l, c);
      const u = n.subTree, d = u && ol(u);
      if (d && d.type !== ze && !Hn(l, d) && Lc(n).type !== ze) {
        const f = Ts(
          d,
          s,
          o,
          n
        );
        if (ur(d, f), a === "out-in" && l.type !== ze)
          return o.isLeaving = !0, f.afterLeave = () => {
            o.isLeaving = !1, n.job.flags & 8 || n.update(), delete f.afterLeave;
          }, ts(i);
        a === "in-out" && l.type !== ze && (f.delayLeave = (p, v, w) => {
          const _ = jc(
            o,
            d
          );
          _[String(d.key)] = d, p[xn] = () => {
            v(), p[xn] = void 0, delete c.delayedLeave;
          }, c.delayedLeave = w;
        });
      }
      return i;
    };
  }
};
function Ic(e) {
  let t = e[0];
  if (e.length > 1) {
    let n = !1;
    for (const o of e)
      if (o.type !== ze) {
        if (process.env.NODE_ENV !== "production" && n) {
          z(
            "<transition> can only be used on a single element or component. Use <transition-group> for lists."
          );
          break;
        }
        if (t = o, n = !0, process.env.NODE_ENV === "production") break;
      }
  }
  return t;
}
const pm = fm;
function jc(e, t) {
  const { leavingVNodes: n } = e;
  let o = n.get(t.type);
  return o || (o = /* @__PURE__ */ Object.create(null), n.set(t.type, o)), o;
}
function Ts(e, t, n, o, r) {
  const {
    appear: i,
    mode: s,
    persisted: a = !1,
    onBeforeEnter: l,
    onEnter: c,
    onAfterEnter: u,
    onEnterCancelled: d,
    onBeforeLeave: f,
    onLeave: p,
    onAfterLeave: v,
    onLeaveCancelled: w,
    onBeforeAppear: _,
    onAppear: C,
    onAfterAppear: S,
    onAppearCancelled: N
  } = t, m = String(e.key), y = jc(n, e), x = (E, O) => {
    E && Wt(
      E,
      o,
      9,
      O
    );
  }, k = (E, O) => {
    const A = O[1];
    x(E, O), ne(E) ? E.every((g) => g.length <= 1) && A() : E.length <= 1 && A();
  }, D = {
    mode: s,
    persisted: a,
    beforeEnter(E) {
      let O = l;
      if (!n.isMounted)
        if (i)
          O = _ || l;
        else
          return;
      E[xn] && E[xn](
        !0
        /* cancelled */
      );
      const A = y[m];
      A && Hn(e, A) && A.el[xn] && A.el[xn](), x(O, [E]);
    },
    enter(E) {
      let O = c, A = u, g = d;
      if (!n.isMounted)
        if (i)
          O = C || c, A = S || u, g = N || d;
        else
          return;
      let R = !1;
      const M = E[qr] = (G) => {
        R || (R = !0, G ? x(g, [E]) : x(A, [E]), D.delayedLeave && D.delayedLeave(), E[qr] = void 0);
      };
      O ? k(O, [E, M]) : M();
    },
    leave(E, O) {
      const A = String(e.key);
      if (E[qr] && E[qr](
        !0
        /* cancelled */
      ), n.isUnmounting)
        return O();
      x(f, [E]);
      let g = !1;
      const R = E[xn] = (M) => {
        g || (g = !0, O(), M ? x(w, [E]) : x(v, [E]), E[xn] = void 0, y[A] === e && delete y[A]);
      };
      y[A] = e, p ? k(p, [E, R]) : R();
    },
    clone(E) {
      const O = Ts(
        E,
        t,
        n,
        o,
        r
      );
      return r && r(O), O;
    }
  };
  return D;
}
function ts(e) {
  if (xr(e))
    return e = Xt(e), e.children = null, e;
}
function ol(e) {
  if (!xr(e))
    return Ac(e.type) && e.children ? Ic(e.children) : e;
  if (process.env.NODE_ENV !== "production" && e.component)
    return e.component.subTree;
  const { shapeFlag: t, children: n } = e;
  if (n) {
    if (t & 16)
      return n[0];
    if (t & 32 && se(n.default))
      return n.default();
  }
}
function ur(e, t) {
  e.shapeFlag & 6 && e.component ? (e.transition = t, ur(e.component.subTree, t)) : e.shapeFlag & 128 ? (e.ssContent.transition = t.clone(e.ssContent), e.ssFallback.transition = t.clone(e.ssFallback)) : e.transition = t;
}
function qc(e, t = !1, n) {
  let o = [], r = 0;
  for (let i = 0; i < e.length; i++) {
    let s = e[i];
    const a = n == null ? s.key : String(n) + String(s.key != null ? s.key : i);
    s.type === Je ? (s.patchFlag & 128 && r++, o = o.concat(
      qc(s.children, t, a)
    )) : (t || s.type !== ze) && o.push(a != null ? Xt(s, { key: a }) : s);
  }
  if (r > 1)
    for (let i = 0; i < o.length; i++)
      o[i].patchFlag = -2;
  return o;
}
/*! #__NO_SIDE_EFFECTS__ */
// @__NO_SIDE_EFFECTS__
function Ee(e, t) {
  return se(e) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    We({ name: e.name }, t, { setup: e })
  ) : e;
}
function Fc(e) {
  e.ids = [e.ids[0] + e.ids[2]++ + "-", 0, 0];
}
const mm = /* @__PURE__ */ new WeakSet();
function Ps(e, t, n, o, r = !1) {
  if (ne(e)) {
    e.forEach(
      (v, w) => Ps(
        v,
        t && (ne(t) ? t[w] : t),
        n,
        o,
        r
      )
    );
    return;
  }
  if (Qo(o) && !r)
    return;
  const i = o.shapeFlag & 4 ? qi(o.component) : o.el, s = r ? null : i, { i: a, r: l } = e;
  if (process.env.NODE_ENV !== "production" && !a) {
    z(
      "Missing ref owner context. ref cannot be used on hoisted vnodes. A vnode with ref must be created inside the render function."
    );
    return;
  }
  const c = t && t.r, u = a.refs === Se ? a.refs = {} : a.refs, d = a.setupState, f = ge(d), p = d === Se ? () => !1 : (v) => process.env.NODE_ENV !== "production" && mm.has(f[v]) ? !1 : _e(f, v);
  if (c != null && c !== l && (Ae(c) ? (u[c] = null, p(c) && (d[c] = null)) : $e(c) && (c.value = null)), se(l))
    Lo(l, a, 12, [s, u]);
  else {
    const v = Ae(l), w = $e(l);
    if (v || w) {
      const _ = () => {
        if (e.f) {
          const C = v ? p(l) ? d[l] : u[l] : l.value;
          r ? ne(C) && ea(C, i) : ne(C) ? C.includes(i) || C.push(i) : v ? (u[l] = [i], p(l) && (d[l] = u[l])) : (l.value = [i], e.k && (u[e.k] = l.value));
        } else v ? (u[l] = s, p(l) && (d[l] = s)) : w ? (l.value = s, e.k && (u[e.k] = s)) : process.env.NODE_ENV !== "production" && z("Invalid template ref type:", l, `(${typeof l})`);
      };
      s ? (_.id = -1, gt(_, n)) : _();
    } else process.env.NODE_ENV !== "production" && z("Invalid template ref type:", l, `(${typeof l})`);
  }
}
const Qo = (e) => !!e.type.__asyncLoader, xr = (e) => e.type.__isKeepAlive;
function Wc(e, t) {
  Bc(e, "a", t);
}
function Ai(e, t) {
  Bc(e, "da", t);
}
function Bc(e, t, n = Ye) {
  const o = e.__wdc || (e.__wdc = () => {
    let r = n;
    for (; r; ) {
      if (r.isDeactivated)
        return;
      r = r.parent;
    }
    return e();
  });
  if (Vi(t, o, n), n) {
    let r = n.parent;
    for (; r && r.parent; )
      xr(r.parent.vnode) && hm(o, t, n, r), r = r.parent;
  }
}
function hm(e, t, n, o) {
  const r = Vi(
    t,
    e,
    o,
    !0
    /* prepend */
  );
  kr(() => {
    ea(o[t], r);
  }, n);
}
function Vi(e, t, n = Ye, o = !1) {
  if (n) {
    const r = n[e] || (n[e] = []), i = t.__weh || (t.__weh = (...s) => {
      mn();
      const a = Or(n), l = Wt(t, n, e, s);
      return a(), hn(), l;
    });
    return o ? r.unshift(i) : r.push(i), i;
  } else if (process.env.NODE_ENV !== "production") {
    const r = Fn(fa[e].replace(/ hook$/, ""));
    z(
      `${r} is called when there is no active component instance to be associated with. Lifecycle injection APIs can only be used during execution of setup(). If you are using async setup(), make sure to register lifecycle hooks before the first await statement.`
    );
  }
}
const vn = (e) => (t, n = Ye) => {
  (!ji || e === "sp") && Vi(e, (...o) => t(...o), n);
}, vm = vn("bm"), Ct = vn("m"), zc = vn(
  "bu"
), gm = vn("u"), St = vn(
  "bum"
), kr = vn("um"), bm = vn(
  "sp"
), ym = vn("rtg"), wm = vn("rtc");
function _m(e, t = Ye) {
  Vi("ec", e, t);
}
const di = "components", Em = "directives";
function nt(e, t) {
  return ya(di, e, !0, t) || e;
}
const Hc = Symbol.for("v-ndc");
function ba(e) {
  return Ae(e) ? ya(di, e, !1) || e : e || Hc;
}
function xm(e) {
  return ya(Em, e);
}
function ya(e, t, n = !0, o = !1) {
  const r = st || Ye;
  if (r) {
    const i = r.type;
    if (e === di) {
      const a = Ca(
        i,
        !1
      );
      if (a && (a === t || a === kt(t) || a === so(kt(t))))
        return i;
    }
    const s = (
      // local registration
      // check instance[type] first which is resolved for options API
      rl(r[e] || i[e], t) || // global registration
      rl(r.appContext[e], t)
    );
    if (!s && o)
      return i;
    if (process.env.NODE_ENV !== "production" && n && !s) {
      const a = e === di ? `
If this is a native custom element, make sure to exclude it from component resolution via compilerOptions.isCustomElement.` : "";
      z(`Failed to resolve ${e.slice(0, -1)}: ${t}${a}`);
    }
    return s;
  } else process.env.NODE_ENV !== "production" && z(
    `resolve${so(e.slice(0, -1))} can only be used in render() or setup().`
  );
}
function rl(e, t) {
  return e && (e[t] || e[kt(t)] || e[so(kt(t))]);
}
function Ri(e, t, n, o) {
  let r;
  const i = n, s = ne(e);
  if (s || Ae(e)) {
    const a = s && un(e);
    let l = !1;
    a && (l = !mt(e), e = $i(e)), r = new Array(e.length);
    for (let c = 0, u = e.length; c < u; c++)
      r[c] = t(
        l ? it(e[c]) : e[c],
        c,
        void 0,
        i
      );
  } else if (typeof e == "number") {
    process.env.NODE_ENV !== "production" && !Number.isInteger(e) && z(`The v-for range expect an integer value but got ${e}.`), r = new Array(e);
    for (let a = 0; a < e; a++)
      r[a] = t(a + 1, a, void 0, i);
  } else if (Oe(e))
    if (e[Symbol.iterator])
      r = Array.from(
        e,
        (a, l) => t(a, l, void 0, i)
      );
    else {
      const a = Object.keys(e);
      r = new Array(a.length);
      for (let l = 0, c = a.length; l < c; l++) {
        const u = a[l];
        r[l] = t(e[u], u, l, i);
      }
    }
  else
    r = [];
  return r;
}
const Ds = (e) => e ? hd(e) ? qi(e) : Ds(e.parent) : null, eo = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ We(/* @__PURE__ */ Object.create(null), {
    $: (e) => e,
    $el: (e) => e.vnode.el,
    $data: (e) => e.data,
    $props: (e) => process.env.NODE_ENV !== "production" ? Yt(e.props) : e.props,
    $attrs: (e) => process.env.NODE_ENV !== "production" ? Yt(e.attrs) : e.attrs,
    $slots: (e) => process.env.NODE_ENV !== "production" ? Yt(e.slots) : e.slots,
    $refs: (e) => process.env.NODE_ENV !== "production" ? Yt(e.refs) : e.refs,
    $parent: (e) => Ds(e.parent),
    $root: (e) => Ds(e.root),
    $host: (e) => e.ce,
    $emit: (e) => e.emit,
    $options: (e) => _a(e),
    $forceUpdate: (e) => e.f || (e.f = () => {
      Mi(e.update);
    }),
    $nextTick: (e) => e.n || (e.n = tt.bind(e.proxy)),
    $watch: (e) => nh.bind(e)
  })
), wa = (e) => e === "_" || e === "$", ns = (e, t) => e !== Se && !e.__isScriptSetup && _e(e, t), Uc = {
  get({ _: e }, t) {
    if (t === "__v_skip")
      return !0;
    const { ctx: n, setupState: o, data: r, props: i, accessCache: s, type: a, appContext: l } = e;
    if (process.env.NODE_ENV !== "production" && t === "__isVue")
      return !0;
    let c;
    if (t[0] !== "$") {
      const p = s[t];
      if (p !== void 0)
        switch (p) {
          case 1:
            return o[t];
          case 2:
            return r[t];
          case 4:
            return n[t];
          case 3:
            return i[t];
        }
      else {
        if (ns(o, t))
          return s[t] = 1, o[t];
        if (r !== Se && _e(r, t))
          return s[t] = 2, r[t];
        if (
          // only cache other properties when instance has declared (thus stable)
          // props
          (c = e.propsOptions[0]) && _e(c, t)
        )
          return s[t] = 3, i[t];
        if (n !== Se && _e(n, t))
          return s[t] = 4, n[t];
        Ms && (s[t] = 0);
      }
    }
    const u = eo[t];
    let d, f;
    if (u)
      return t === "$attrs" ? (Ge(e.attrs, "get", ""), process.env.NODE_ENV !== "production" && mi()) : process.env.NODE_ENV !== "production" && t === "$slots" && Ge(e, "get", t), u(e);
    if (
      // css module (injected by vue-loader)
      (d = a.__cssModules) && (d = d[t])
    )
      return d;
    if (n !== Se && _e(n, t))
      return s[t] = 4, n[t];
    if (
      // global properties
      f = l.config.globalProperties, _e(f, t)
    )
      return f[t];
    process.env.NODE_ENV !== "production" && st && (!Ae(t) || // #1091 avoid internal isRef/isVNode checks on component instance leading
    // to infinite warning loop
    t.indexOf("__v") !== 0) && (r !== Se && wa(t[0]) && _e(r, t) ? z(
      `Property ${JSON.stringify(
        t
      )} must be accessed via $data because it starts with a reserved character ("$" or "_") and is not proxied on the render context.`
    ) : e === st && z(
      `Property ${JSON.stringify(t)} was accessed during render but is not defined on instance.`
    ));
  },
  set({ _: e }, t, n) {
    const { data: o, setupState: r, ctx: i } = e;
    return ns(r, t) ? (r[t] = n, !0) : process.env.NODE_ENV !== "production" && r.__isScriptSetup && _e(r, t) ? (z(`Cannot mutate <script setup> binding "${t}" from Options API.`), !1) : o !== Se && _e(o, t) ? (o[t] = n, !0) : _e(e.props, t) ? (process.env.NODE_ENV !== "production" && z(`Attempting to mutate prop "${t}". Props are readonly.`), !1) : t[0] === "$" && t.slice(1) in e ? (process.env.NODE_ENV !== "production" && z(
      `Attempting to mutate public property "${t}". Properties starting with $ are reserved and readonly.`
    ), !1) : (process.env.NODE_ENV !== "production" && t in e.appContext.config.globalProperties ? Object.defineProperty(i, t, {
      enumerable: !0,
      configurable: !0,
      value: n
    }) : i[t] = n, !0);
  },
  has({
    _: { data: e, setupState: t, accessCache: n, ctx: o, appContext: r, propsOptions: i }
  }, s) {
    let a;
    return !!n[s] || e !== Se && _e(e, s) || ns(t, s) || (a = i[0]) && _e(a, s) || _e(o, s) || _e(eo, s) || _e(r.config.globalProperties, s);
  },
  defineProperty(e, t, n) {
    return n.get != null ? e._.accessCache[t] = 0 : _e(n, "value") && this.set(e, t, n.value, null), Reflect.defineProperty(e, t, n);
  }
};
process.env.NODE_ENV !== "production" && (Uc.ownKeys = (e) => (z(
  "Avoid app logic that relies on enumerating keys on a component instance. The keys will be empty in production mode to avoid performance overhead."
), Reflect.ownKeys(e)));
function km(e) {
  const t = {};
  return Object.defineProperty(t, "_", {
    configurable: !0,
    enumerable: !1,
    get: () => e
  }), Object.keys(eo).forEach((n) => {
    Object.defineProperty(t, n, {
      configurable: !0,
      enumerable: !1,
      get: () => eo[n](e),
      // intercepted by the proxy so no need for implementation,
      // but needed to prevent set errors
      set: Ke
    });
  }), t;
}
function Cm(e) {
  const {
    ctx: t,
    propsOptions: [n]
  } = e;
  n && Object.keys(n).forEach((o) => {
    Object.defineProperty(t, o, {
      enumerable: !0,
      configurable: !0,
      get: () => e.props[o],
      set: Ke
    });
  });
}
function Sm(e) {
  const { ctx: t, setupState: n } = e;
  Object.keys(ge(n)).forEach((o) => {
    if (!n.__isScriptSetup) {
      if (wa(o[0])) {
        z(
          `setup() return property ${JSON.stringify(
            o
          )} should not start with "$" or "_" which are reserved prefixes for Vue internals.`
        );
        return;
      }
      Object.defineProperty(t, o, {
        enumerable: !0,
        configurable: !0,
        get: () => n[o],
        set: Ke
      });
    }
  });
}
function Li() {
  return Kc().slots;
}
function Cr() {
  return Kc().attrs;
}
function Kc() {
  const e = Fe();
  return process.env.NODE_ENV !== "production" && !e && z("useContext() called without active instance."), e.setupContext || (e.setupContext = gd(e));
}
function il(e) {
  return ne(e) ? e.reduce(
    (t, n) => (t[n] = null, t),
    {}
  ) : e;
}
function Om() {
  const e = /* @__PURE__ */ Object.create(null);
  return (t, n) => {
    e[n] ? z(`${t} property "${n}" is already defined in ${e[n]}.`) : e[n] = t;
  };
}
let Ms = !0;
function Nm(e) {
  const t = _a(e), n = e.proxy, o = e.ctx;
  Ms = !1, t.beforeCreate && sl(t.beforeCreate, e, "bc");
  const {
    // state
    data: r,
    computed: i,
    methods: s,
    watch: a,
    provide: l,
    inject: c,
    // lifecycle
    created: u,
    beforeMount: d,
    mounted: f,
    beforeUpdate: p,
    updated: v,
    activated: w,
    deactivated: _,
    beforeDestroy: C,
    beforeUnmount: S,
    destroyed: N,
    unmounted: m,
    render: y,
    renderTracked: x,
    renderTriggered: k,
    errorCaptured: D,
    serverPrefetch: E,
    // public API
    expose: O,
    inheritAttrs: A,
    // assets
    components: g,
    directives: R,
    filters: M
  } = t, G = process.env.NODE_ENV !== "production" ? Om() : null;
  if (process.env.NODE_ENV !== "production") {
    const [$] = e.propsOptions;
    if ($)
      for (const W in $)
        G("Props", W);
  }
  if (c && $m(c, o, G), s)
    for (const $ in s) {
      const W = s[$];
      se(W) ? (process.env.NODE_ENV !== "production" ? Object.defineProperty(o, $, {
        value: W.bind(n),
        configurable: !0,
        enumerable: !0,
        writable: !0
      }) : o[$] = W.bind(n), process.env.NODE_ENV !== "production" && G("Methods", $)) : process.env.NODE_ENV !== "production" && z(
        `Method "${$}" has type "${typeof W}" in the component definition. Did you reference the function correctly?`
      );
    }
  if (r) {
    process.env.NODE_ENV !== "production" && !se(r) && z(
      "The data option must be a function. Plain object usage is no longer supported."
    );
    const $ = r.call(n, n);
    if (process.env.NODE_ENV !== "production" && ta($) && z(
      "data() returned a Promise - note data() cannot be async; If you intend to perform data fetching before component renders, use async setup() + <Suspense>."
    ), !Oe($))
      process.env.NODE_ENV !== "production" && z("data() should return an object.");
    else if (e.data = Ro($), process.env.NODE_ENV !== "production")
      for (const W in $)
        G("Data", W), wa(W[0]) || Object.defineProperty(o, W, {
          configurable: !0,
          enumerable: !0,
          get: () => $[W],
          set: Ke
        });
  }
  if (Ms = !0, i)
    for (const $ in i) {
      const W = i[$], he = se(W) ? W.bind(n, n) : se(W.get) ? W.get.bind(n, n) : Ke;
      process.env.NODE_ENV !== "production" && he === Ke && z(`Computed property "${$}" has no getter.`);
      const fe = !se(W) && se(W.set) ? W.set.bind(n) : process.env.NODE_ENV !== "production" ? () => {
        z(
          `Write operation failed: computed property "${$}" is readonly.`
        );
      } : Ke, we = V({
        get: he,
        set: fe
      });
      Object.defineProperty(o, $, {
        enumerable: !0,
        configurable: !0,
        get: () => we.value,
        set: (q) => we.value = q
      }), process.env.NODE_ENV !== "production" && G("Computed", $);
    }
  if (a)
    for (const $ in a)
      Yc(a[$], o, n, $);
  if (l) {
    const $ = se(l) ? l.call(n) : l;
    Reflect.ownKeys($).forEach((W) => {
      Vm(W, $[W]);
    });
  }
  u && sl(u, e, "c");
  function Q($, W) {
    ne(W) ? W.forEach((he) => $(he.bind(n))) : W && $(W.bind(n));
  }
  if (Q(vm, d), Q(Ct, f), Q(zc, p), Q(gm, v), Q(Wc, w), Q(Ai, _), Q(_m, D), Q(wm, x), Q(ym, k), Q(St, S), Q(kr, m), Q(bm, E), ne(O))
    if (O.length) {
      const $ = e.exposed || (e.exposed = {});
      O.forEach((W) => {
        Object.defineProperty($, W, {
          get: () => n[W],
          set: (he) => n[W] = he
        });
      });
    } else e.exposed || (e.exposed = {});
  y && e.render === Ke && (e.render = y), A != null && (e.inheritAttrs = A), g && (e.components = g), R && (e.directives = R), E && Fc(e);
}
function $m(e, t, n = Ke) {
  ne(e) && (e = As(e));
  for (const o in e) {
    const r = e[o];
    let i;
    Oe(r) ? "default" in r ? i = Xo(
      r.from || o,
      r.default,
      !0
    ) : i = Xo(r.from || o) : i = Xo(r), $e(i) ? Object.defineProperty(t, o, {
      enumerable: !0,
      configurable: !0,
      get: () => i.value,
      set: (s) => i.value = s
    }) : t[o] = i, process.env.NODE_ENV !== "production" && n("Inject", o);
  }
}
function sl(e, t, n) {
  Wt(
    ne(e) ? e.map((o) => o.bind(t.proxy)) : e.bind(t.proxy),
    t,
    n
  );
}
function Yc(e, t, n, o) {
  let r = o.includes(".") ? ad(n, o) : () => n[o];
  if (Ae(e)) {
    const i = t[e];
    se(i) ? ye(r, i) : process.env.NODE_ENV !== "production" && z(`Invalid watch handler specified by key "${e}"`, i);
  } else if (se(e))
    ye(r, e.bind(n));
  else if (Oe(e))
    if (ne(e))
      e.forEach((i) => Yc(i, t, n, o));
    else {
      const i = se(e.handler) ? e.handler.bind(n) : t[e.handler];
      se(i) ? ye(r, i, e) : process.env.NODE_ENV !== "production" && z(`Invalid watch handler specified by key "${e.handler}"`, i);
    }
  else process.env.NODE_ENV !== "production" && z(`Invalid watch option: "${o}"`, e);
}
function _a(e) {
  const t = e.type, { mixins: n, extends: o } = t, {
    mixins: r,
    optionsCache: i,
    config: { optionMergeStrategies: s }
  } = e.appContext, a = i.get(t);
  let l;
  return a ? l = a : !r.length && !n && !o ? l = t : (l = {}, r.length && r.forEach(
    (c) => fi(l, c, s, !0)
  ), fi(l, t, s)), Oe(t) && i.set(t, l), l;
}
function fi(e, t, n, o = !1) {
  const { mixins: r, extends: i } = t;
  i && fi(e, i, n, !0), r && r.forEach(
    (s) => fi(e, s, n, !0)
  );
  for (const s in t)
    if (o && s === "expose")
      process.env.NODE_ENV !== "production" && z(
        '"expose" option is ignored when declared in mixins or extends. It should only be declared in the base component itself.'
      );
    else {
      const a = Tm[s] || n && n[s];
      e[s] = a ? a(e[s], t[s]) : t[s];
    }
  return e;
}
const Tm = {
  data: al,
  props: ll,
  emits: ll,
  // objects
  methods: Ko,
  computed: Ko,
  // lifecycle
  beforeCreate: ct,
  created: ct,
  beforeMount: ct,
  mounted: ct,
  beforeUpdate: ct,
  updated: ct,
  beforeDestroy: ct,
  beforeUnmount: ct,
  destroyed: ct,
  unmounted: ct,
  activated: ct,
  deactivated: ct,
  errorCaptured: ct,
  serverPrefetch: ct,
  // assets
  components: Ko,
  directives: Ko,
  // watch
  watch: Dm,
  // provide / inject
  provide: al,
  inject: Pm
};
function al(e, t) {
  return t ? e ? function() {
    return We(
      se(e) ? e.call(this, this) : e,
      se(t) ? t.call(this, this) : t
    );
  } : t : e;
}
function Pm(e, t) {
  return Ko(As(e), As(t));
}
function As(e) {
  if (ne(e)) {
    const t = {};
    for (let n = 0; n < e.length; n++)
      t[e[n]] = e[n];
    return t;
  }
  return e;
}
function ct(e, t) {
  return e ? [...new Set([].concat(e, t))] : t;
}
function Ko(e, t) {
  return e ? We(/* @__PURE__ */ Object.create(null), e, t) : t;
}
function ll(e, t) {
  return e ? ne(e) && ne(t) ? [.../* @__PURE__ */ new Set([...e, ...t])] : We(
    /* @__PURE__ */ Object.create(null),
    il(e),
    il(t ?? {})
  ) : t;
}
function Dm(e, t) {
  if (!e) return t;
  if (!t) return e;
  const n = We(/* @__PURE__ */ Object.create(null), e);
  for (const o in t)
    n[o] = ct(e[o], t[o]);
  return n;
}
function Gc() {
  return {
    app: null,
    config: {
      isNativeTag: zf,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Mm = 0;
function Am(e, t) {
  return function(o, r = null) {
    se(o) || (o = We({}, o)), r != null && !Oe(r) && (process.env.NODE_ENV !== "production" && z("root props passed to app.mount() must be an object."), r = null);
    const i = Gc(), s = /* @__PURE__ */ new WeakSet(), a = [];
    let l = !1;
    const c = i.app = {
      _uid: Mm++,
      _component: o,
      _props: r,
      _container: null,
      _context: i,
      _instance: null,
      version: yl,
      get config() {
        return i.config;
      },
      set config(u) {
        process.env.NODE_ENV !== "production" && z(
          "app.config cannot be replaced. Modify individual options instead."
        );
      },
      use(u, ...d) {
        return s.has(u) ? process.env.NODE_ENV !== "production" && z("Plugin has already been applied to target app.") : u && se(u.install) ? (s.add(u), u.install(c, ...d)) : se(u) ? (s.add(u), u(c, ...d)) : process.env.NODE_ENV !== "production" && z(
          'A plugin must either be a function or an object with an "install" function.'
        ), c;
      },
      mixin(u) {
        return i.mixins.includes(u) ? process.env.NODE_ENV !== "production" && z(
          "Mixin has already been applied to target app" + (u.name ? `: ${u.name}` : "")
        ) : i.mixins.push(u), c;
      },
      component(u, d) {
        return process.env.NODE_ENV !== "production" && js(u, i.config), d ? (process.env.NODE_ENV !== "production" && i.components[u] && z(`Component "${u}" has already been registered in target app.`), i.components[u] = d, c) : i.components[u];
      },
      directive(u, d) {
        return process.env.NODE_ENV !== "production" && Dc(u), d ? (process.env.NODE_ENV !== "production" && i.directives[u] && z(`Directive "${u}" has already been registered in target app.`), i.directives[u] = d, c) : i.directives[u];
      },
      mount(u, d, f) {
        if (l)
          process.env.NODE_ENV !== "production" && z(
            "App has already been mounted.\nIf you want to remount the same app, move your app creation logic into a factory function and create fresh app instances for each mount - e.g. `const createMyApp = () => createApp(App)`"
          );
        else {
          process.env.NODE_ENV !== "production" && u.__vue_app__ && z(
            "There is already an app instance mounted on the host container.\n If you want to mount another app on the same host container, you need to unmount the previous app by calling `app.unmount()` first."
          );
          const p = c._ceVNode || le(o, r);
          return p.appContext = i, f === !0 ? f = "svg" : f === !1 && (f = void 0), process.env.NODE_ENV !== "production" && (i.reload = () => {
            e(
              Xt(p),
              u,
              f
            );
          }), d && t ? t(p, u) : e(p, u, f), l = !0, c._container = u, u.__vue_app__ = c, process.env.NODE_ENV !== "production" && (c._instance = p.component, Zp(c, yl)), qi(p.component);
        }
      },
      onUnmount(u) {
        process.env.NODE_ENV !== "production" && typeof u != "function" && z(
          `Expected function as first argument to app.onUnmount(), but got ${typeof u}`
        ), a.push(u);
      },
      unmount() {
        l ? (Wt(
          a,
          c._instance,
          16
        ), e(null, c._container), process.env.NODE_ENV !== "production" && (c._instance = null, em(c)), delete c._container.__vue_app__) : process.env.NODE_ENV !== "production" && z("Cannot unmount an app that is not mounted.");
      },
      provide(u, d) {
        return process.env.NODE_ENV !== "production" && u in i.provides && z(
          `App already provides property with key "${String(u)}". It will be overwritten with the new value.`
        ), i.provides[u] = d, c;
      },
      runWithContext(u) {
        const d = ko;
        ko = c;
        try {
          return u();
        } finally {
          ko = d;
        }
      }
    };
    return c;
  };
}
let ko = null;
function Vm(e, t) {
  if (!Ye)
    process.env.NODE_ENV !== "production" && z("provide() can only be used inside setup().");
  else {
    let n = Ye.provides;
    const o = Ye.parent && Ye.parent.provides;
    o === n && (n = Ye.provides = Object.create(o)), n[e] = t;
  }
}
function Xo(e, t, n = !1) {
  const o = Ye || st;
  if (o || ko) {
    const r = ko ? ko._context.provides : o ? o.parent == null ? o.vnode.appContext && o.vnode.appContext.provides : o.parent.provides : void 0;
    if (r && e in r)
      return r[e];
    if (arguments.length > 1)
      return n && se(t) ? t.call(o && o.proxy) : t;
    process.env.NODE_ENV !== "production" && z(`injection "${String(e)}" not found.`);
  } else process.env.NODE_ENV !== "production" && z("inject() can only be used inside setup() or functional components.");
}
const Qc = {}, Xc = () => Object.create(Qc), Jc = (e) => Object.getPrototypeOf(e) === Qc;
function Rm(e, t, n, o = !1) {
  const r = {}, i = Xc();
  e.propsDefaults = /* @__PURE__ */ Object.create(null), Zc(e, t, r, i);
  for (const s in e.propsOptions[0])
    s in r || (r[s] = void 0);
  process.env.NODE_ENV !== "production" && td(t || {}, r, e), n ? e.props = o ? r : Pp(r) : e.type.props ? e.props = r : e.props = i, e.attrs = i;
}
function Lm(e) {
  for (; e; ) {
    if (e.type.__hmrId) return !0;
    e = e.parent;
  }
}
function Im(e, t, n, o) {
  const {
    props: r,
    attrs: i,
    vnode: { patchFlag: s }
  } = e, a = ge(r), [l] = e.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    !(process.env.NODE_ENV !== "production" && Lm(e)) && (o || s > 0) && !(s & 16)
  ) {
    if (s & 8) {
      const u = e.vnode.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        let f = u[d];
        if (Ii(e.emitsOptions, f))
          continue;
        const p = t[f];
        if (l)
          if (_e(i, f))
            p !== i[f] && (i[f] = p, c = !0);
          else {
            const v = kt(f);
            r[v] = Vs(
              l,
              a,
              v,
              p,
              e,
              !1
            );
          }
        else
          p !== i[f] && (i[f] = p, c = !0);
      }
    }
  } else {
    Zc(e, t, r, i) && (c = !0);
    let u;
    for (const d in a)
      (!t || // for camelCase
      !_e(t, d) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((u = dn(d)) === d || !_e(t, u))) && (l ? n && // for camelCase
      (n[d] !== void 0 || // for kebab-case
      n[u] !== void 0) && (r[d] = Vs(
        l,
        a,
        d,
        void 0,
        e,
        !0
      )) : delete r[d]);
    if (i !== a)
      for (const d in i)
        (!t || !_e(t, d)) && (delete i[d], c = !0);
  }
  c && Gt(e.attrs, "set", ""), process.env.NODE_ENV !== "production" && td(t || {}, r, e);
}
function Zc(e, t, n, o) {
  const [r, i] = e.propsOptions;
  let s = !1, a;
  if (t)
    for (let l in t) {
      if (Yo(l))
        continue;
      const c = t[l];
      let u;
      r && _e(r, u = kt(l)) ? !i || !i.includes(u) ? n[u] = c : (a || (a = {}))[u] = c : Ii(e.emitsOptions, l) || (!(l in o) || c !== o[l]) && (o[l] = c, s = !0);
    }
  if (i) {
    const l = ge(n), c = a || Se;
    for (let u = 0; u < i.length; u++) {
      const d = i[u];
      n[d] = Vs(
        r,
        l,
        d,
        c[d],
        e,
        !_e(c, d)
      );
    }
  }
  return s;
}
function Vs(e, t, n, o, r, i) {
  const s = e[n];
  if (s != null) {
    const a = _e(s, "default");
    if (a && o === void 0) {
      const l = s.default;
      if (s.type !== Function && !s.skipFactory && se(l)) {
        const { propsDefaults: c } = r;
        if (n in c)
          o = c[n];
        else {
          const u = Or(r);
          o = c[n] = l.call(
            null,
            t
          ), u();
        }
      } else
        o = l;
      r.ce && r.ce._setProp(n, o);
    }
    s[
      0
      /* shouldCast */
    ] && (i && !a ? o = !1 : s[
      1
      /* shouldCastTrue */
    ] && (o === "" || o === dn(n)) && (o = !0));
  }
  return o;
}
const jm = /* @__PURE__ */ new WeakMap();
function ed(e, t, n = !1) {
  const o = n ? jm : t.propsCache, r = o.get(e);
  if (r)
    return r;
  const i = e.props, s = {}, a = [];
  let l = !1;
  if (!se(e)) {
    const u = (d) => {
      l = !0;
      const [f, p] = ed(d, t, !0);
      We(s, f), p && a.push(...p);
    };
    !n && t.mixins.length && t.mixins.forEach(u), e.extends && u(e.extends), e.mixins && e.mixins.forEach(u);
  }
  if (!i && !l)
    return Oe(e) && o.set(e, Eo), Eo;
  if (ne(i))
    for (let u = 0; u < i.length; u++) {
      process.env.NODE_ENV !== "production" && !Ae(i[u]) && z("props must be strings when using array syntax.", i[u]);
      const d = kt(i[u]);
      ul(d) && (s[d] = Se);
    }
  else if (i) {
    process.env.NODE_ENV !== "production" && !Oe(i) && z("invalid props options", i);
    for (const u in i) {
      const d = kt(u);
      if (ul(d)) {
        const f = i[u], p = s[d] = ne(f) || se(f) ? { type: f } : We({}, f), v = p.type;
        let w = !1, _ = !0;
        if (ne(v))
          for (let C = 0; C < v.length; ++C) {
            const S = v[C], N = se(S) && S.name;
            if (N === "Boolean") {
              w = !0;
              break;
            } else N === "String" && (_ = !1);
          }
        else
          w = se(v) && v.name === "Boolean";
        p[
          0
          /* shouldCast */
        ] = w, p[
          1
          /* shouldCastTrue */
        ] = _, (w || _e(p, "default")) && a.push(d);
      }
    }
  }
  const c = [s, a];
  return Oe(e) && o.set(e, c), c;
}
function ul(e) {
  return e[0] !== "$" && !Yo(e) ? !0 : (process.env.NODE_ENV !== "production" && z(`Invalid prop name: "${e}" is a reserved property.`), !1);
}
function qm(e) {
  return e === null ? "null" : typeof e == "function" ? e.name || "" : typeof e == "object" && e.constructor && e.constructor.name || "";
}
function td(e, t, n) {
  const o = ge(t), r = n.propsOptions[0];
  for (const i in r) {
    let s = r[i];
    s != null && Fm(
      i,
      o[i],
      s,
      process.env.NODE_ENV !== "production" ? Yt(o) : o,
      !_e(e, i) && !_e(e, dn(i))
    );
  }
}
function Fm(e, t, n, o, r) {
  const { type: i, required: s, validator: a, skipCheck: l } = n;
  if (s && r) {
    z('Missing required prop: "' + e + '"');
    return;
  }
  if (!(t == null && !s)) {
    if (i != null && i !== !0 && !l) {
      let c = !1;
      const u = ne(i) ? i : [i], d = [];
      for (let f = 0; f < u.length && !c; f++) {
        const { valid: p, expectedType: v } = Bm(t, u[f]);
        d.push(v || ""), c = p;
      }
      if (!c) {
        z(zm(e, t, d));
        return;
      }
    }
    a && !a(t, o) && z('Invalid prop: custom validator check failed for prop "' + e + '".');
  }
}
const Wm = /* @__PURE__ */ pn(
  "String,Number,Boolean,Function,Symbol,BigInt"
);
function Bm(e, t) {
  let n;
  const o = qm(t);
  if (o === "null")
    n = e === null;
  else if (Wm(o)) {
    const r = typeof e;
    n = r === o.toLowerCase(), !n && r === "object" && (n = e instanceof t);
  } else o === "Object" ? n = Oe(e) : o === "Array" ? n = ne(e) : n = e instanceof t;
  return {
    valid: n,
    expectedType: o
  };
}
function zm(e, t, n) {
  if (n.length === 0)
    return `Prop type [] for prop "${e}" won't match anything. Did you mean to use type Array instead?`;
  let o = `Invalid prop: type check failed for prop "${e}". Expected ${n.map(so).join(" | ")}`;
  const r = n[0], i = na(t), s = cl(t, r), a = cl(t, i);
  return n.length === 1 && dl(r) && !Hm(r, i) && (o += ` with value ${s}`), o += `, got ${i} `, dl(i) && (o += `with value ${a}.`), o;
}
function cl(e, t) {
  return t === "String" ? `"${e}"` : t === "Number" ? `${Number(e)}` : `${e}`;
}
function dl(e) {
  return ["string", "number", "boolean"].some((n) => e.toLowerCase() === n);
}
function Hm(...e) {
  return e.some((t) => t.toLowerCase() === "boolean");
}
const nd = (e) => e[0] === "_" || e === "$stable", Ea = (e) => ne(e) ? e.map(Lt) : [Lt(e)], Um = (e, t, n) => {
  if (t._n)
    return t;
  const o = Me((...r) => (process.env.NODE_ENV !== "production" && Ye && (!n || n.root === Ye.root) && z(
    `Slot "${e}" invoked outside of the render function: this will not track dependencies used in the slot. Invoke the slot function inside the render function instead.`
  ), Ea(t(...r))), n);
  return o._c = !1, o;
}, od = (e, t, n) => {
  const o = e._ctx;
  for (const r in e) {
    if (nd(r)) continue;
    const i = e[r];
    if (se(i))
      t[r] = Um(r, i, o);
    else if (i != null) {
      process.env.NODE_ENV !== "production" && z(
        `Non-function value encountered for slot "${r}". Prefer function slots for better performance.`
      );
      const s = Ea(i);
      t[r] = () => s;
    }
  }
}, rd = (e, t) => {
  process.env.NODE_ENV !== "production" && !xr(e.vnode) && z(
    "Non-function value encountered for default slot. Prefer function slots for better performance."
  );
  const n = Ea(t);
  e.slots.default = () => n;
}, Rs = (e, t, n) => {
  for (const o in t)
    (n || o !== "_") && (e[o] = t[o]);
}, Km = (e, t, n) => {
  const o = e.slots = Xc();
  if (e.vnode.shapeFlag & 32) {
    const r = t._;
    r ? (Rs(o, t, n), n && si(o, "_", r, !0)) : od(t, o);
  } else t && rd(e, t);
}, Ym = (e, t, n) => {
  const { vnode: o, slots: r } = e;
  let i = !0, s = Se;
  if (o.shapeFlag & 32) {
    const a = t._;
    a ? process.env.NODE_ENV !== "production" && $n ? (Rs(r, t, n), Gt(e, "set", "$slots")) : n && a === 1 ? i = !1 : Rs(r, t, n) : (i = !t.$stable, od(t, r)), s = t;
  } else t && (rd(e, t), s = { default: 1 });
  if (i)
    for (const a in r)
      !nd(a) && s[a] == null && delete r[a];
};
let Bo, Sn;
function nn(e, t) {
  e.appContext.config.performance && pi() && Sn.mark(`vue-${t}-${e.uid}`), process.env.NODE_ENV !== "production" && rm(e, t, pi() ? Sn.now() : Date.now());
}
function on(e, t) {
  if (e.appContext.config.performance && pi()) {
    const n = `vue-${t}-${e.uid}`, o = n + ":end";
    Sn.mark(o), Sn.measure(
      `<${Fi(e, e.type)}> ${t}`,
      n,
      o
    ), Sn.clearMarks(n), Sn.clearMarks(o);
  }
  process.env.NODE_ENV !== "production" && im(e, t, pi() ? Sn.now() : Date.now());
}
function pi() {
  return Bo !== void 0 || (typeof window < "u" && window.performance ? (Bo = !0, Sn = window.performance) : Bo = !1), Bo;
}
function Gm() {
  const e = [];
  if (process.env.NODE_ENV !== "production" && e.length) {
    const t = e.length > 1;
    console.warn(
      `Feature flag${t ? "s" : ""} ${e.join(", ")} ${t ? "are" : "is"} not explicitly defined. You are running the esm-bundler build of Vue, which expects these compile-time feature flags to be globally injected via the bundler config in order to get better tree-shaking in the production bundle.

For more details, see https://link.vuejs.org/feature-flags.`
    );
  }
}
const gt = uh;
function Qm(e) {
  return Xm(e);
}
function Xm(e, t) {
  Gm();
  const n = ra();
  n.__VUE__ = !0, process.env.NODE_ENV !== "production" && ha(n.__VUE_DEVTOOLS_GLOBAL_HOOK__, n);
  const {
    insert: o,
    remove: r,
    patchProp: i,
    createElement: s,
    createText: a,
    createComment: l,
    setText: c,
    setElementText: u,
    parentNode: d,
    nextSibling: f,
    setScopeId: p = Ke,
    insertStaticContent: v
  } = e, w = (h, b, T, F = null, L = null, I = null, K = void 0, B = null, H = process.env.NODE_ENV !== "production" && $n ? !1 : !!b.dynamicChildren) => {
    if (h === b)
      return;
    h && !Hn(h, b) && (F = ot(h), ve(h, L, I, !0), h = null), b.patchFlag === -2 && (H = !1, b.dynamicChildren = null);
    const { type: j, ref: oe, shapeFlag: Y } = b;
    switch (j) {
      case Sr:
        _(h, b, T, F);
        break;
      case ze:
        C(h, b, T, F);
        break;
      case Zo:
        h == null ? S(b, T, F, K) : process.env.NODE_ENV !== "production" && N(h, b, T, K);
        break;
      case Je:
        R(
          h,
          b,
          T,
          F,
          L,
          I,
          K,
          B,
          H
        );
        break;
      default:
        Y & 1 ? x(
          h,
          b,
          T,
          F,
          L,
          I,
          K,
          B,
          H
        ) : Y & 6 ? M(
          h,
          b,
          T,
          F,
          L,
          I,
          K,
          B,
          H
        ) : Y & 64 || Y & 128 ? j.process(
          h,
          b,
          T,
          F,
          L,
          I,
          K,
          B,
          H,
          vt
        ) : process.env.NODE_ENV !== "production" && z("Invalid VNode type:", j, `(${typeof j})`);
    }
    oe != null && L && Ps(oe, h && h.ref, I, b || h, !b);
  }, _ = (h, b, T, F) => {
    if (h == null)
      o(
        b.el = a(b.children),
        T,
        F
      );
    else {
      const L = b.el = h.el;
      b.children !== h.children && c(L, b.children);
    }
  }, C = (h, b, T, F) => {
    h == null ? o(
      b.el = l(b.children || ""),
      T,
      F
    ) : b.el = h.el;
  }, S = (h, b, T, F) => {
    [h.el, h.anchor] = v(
      h.children,
      b,
      T,
      F,
      h.el,
      h.anchor
    );
  }, N = (h, b, T, F) => {
    if (b.children !== h.children) {
      const L = f(h.anchor);
      y(h), [b.el, b.anchor] = v(
        b.children,
        T,
        L,
        F
      );
    } else
      b.el = h.el, b.anchor = h.anchor;
  }, m = ({ el: h, anchor: b }, T, F) => {
    let L;
    for (; h && h !== b; )
      L = f(h), o(h, T, F), h = L;
    o(b, T, F);
  }, y = ({ el: h, anchor: b }) => {
    let T;
    for (; h && h !== b; )
      T = f(h), r(h), h = T;
    r(b);
  }, x = (h, b, T, F, L, I, K, B, H) => {
    b.type === "svg" ? K = "svg" : b.type === "math" && (K = "mathml"), h == null ? k(
      b,
      T,
      F,
      L,
      I,
      K,
      B,
      H
    ) : O(
      h,
      b,
      L,
      I,
      K,
      B,
      H
    );
  }, k = (h, b, T, F, L, I, K, B) => {
    let H, j;
    const { props: oe, shapeFlag: Y, transition: Z, dirs: ie } = h;
    if (H = h.el = s(
      h.type,
      I,
      oe && oe.is,
      oe
    ), Y & 8 ? u(H, h.children) : Y & 16 && E(
      h.children,
      H,
      null,
      F,
      L,
      os(h, I),
      K,
      B
    ), ie && Ln(h, null, F, "created"), D(H, h, h.scopeId, K, F), oe) {
      for (const Ne in oe)
        Ne !== "value" && !Yo(Ne) && i(H, Ne, null, oe[Ne], I, F);
      "value" in oe && i(H, "value", null, oe.value, I), (j = oe.onVnodeBeforeMount) && Ht(j, F, h);
    }
    process.env.NODE_ENV !== "production" && (si(H, "__vnode", h, !0), si(H, "__vueParentComponent", F, !0)), ie && Ln(h, null, F, "beforeMount");
    const be = Jm(L, Z);
    be && Z.beforeEnter(H), o(H, b, T), ((j = oe && oe.onVnodeMounted) || be || ie) && gt(() => {
      j && Ht(j, F, h), be && Z.enter(H), ie && Ln(h, null, F, "mounted");
    }, L);
  }, D = (h, b, T, F, L) => {
    if (T && p(h, T), F)
      for (let I = 0; I < F.length; I++)
        p(h, F[I]);
    if (L) {
      let I = L.subTree;
      if (process.env.NODE_ENV !== "production" && I.patchFlag > 0 && I.patchFlag & 2048 && (I = xa(I.children) || I), b === I || cd(I.type) && (I.ssContent === b || I.ssFallback === b)) {
        const K = L.vnode;
        D(
          h,
          K,
          K.scopeId,
          K.slotScopeIds,
          L.parent
        );
      }
    }
  }, E = (h, b, T, F, L, I, K, B, H = 0) => {
    for (let j = H; j < h.length; j++) {
      const oe = h[j] = B ? kn(h[j]) : Lt(h[j]);
      w(
        null,
        oe,
        b,
        T,
        F,
        L,
        I,
        K,
        B
      );
    }
  }, O = (h, b, T, F, L, I, K) => {
    const B = b.el = h.el;
    process.env.NODE_ENV !== "production" && (B.__vnode = b);
    let { patchFlag: H, dynamicChildren: j, dirs: oe } = b;
    H |= h.patchFlag & 16;
    const Y = h.props || Se, Z = b.props || Se;
    let ie;
    if (T && In(T, !1), (ie = Z.onVnodeBeforeUpdate) && Ht(ie, T, b, h), oe && Ln(b, h, T, "beforeUpdate"), T && In(T, !0), process.env.NODE_ENV !== "production" && $n && (H = 0, K = !1, j = null), (Y.innerHTML && Z.innerHTML == null || Y.textContent && Z.textContent == null) && u(B, ""), j ? (A(
      h.dynamicChildren,
      j,
      B,
      T,
      F,
      os(b, L),
      I
    ), process.env.NODE_ENV !== "production" && Jo(h, b)) : K || he(
      h,
      b,
      B,
      null,
      T,
      F,
      os(b, L),
      I,
      !1
    ), H > 0) {
      if (H & 16)
        g(B, Y, Z, T, L);
      else if (H & 2 && Y.class !== Z.class && i(B, "class", null, Z.class, L), H & 4 && i(B, "style", Y.style, Z.style, L), H & 8) {
        const be = b.dynamicProps;
        for (let Ne = 0; Ne < be.length; Ne++) {
          const ke = be[Ne], ut = Y[ke], Qe = Z[ke];
          (Qe !== ut || ke === "value") && i(B, ke, ut, Qe, L, T);
        }
      }
      H & 1 && h.children !== b.children && u(B, b.children);
    } else !K && j == null && g(B, Y, Z, T, L);
    ((ie = Z.onVnodeUpdated) || oe) && gt(() => {
      ie && Ht(ie, T, b, h), oe && Ln(b, h, T, "updated");
    }, F);
  }, A = (h, b, T, F, L, I, K) => {
    for (let B = 0; B < b.length; B++) {
      const H = h[B], j = b[B], oe = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        H.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (H.type === Je || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Hn(H, j) || // - In the case of a component, it could contain anything.
        H.shapeFlag & 70) ? d(H.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          T
        )
      );
      w(
        H,
        j,
        oe,
        null,
        F,
        L,
        I,
        K,
        !0
      );
    }
  }, g = (h, b, T, F, L) => {
    if (b !== T) {
      if (b !== Se)
        for (const I in b)
          !Yo(I) && !(I in T) && i(
            h,
            I,
            b[I],
            null,
            L,
            F
          );
      for (const I in T) {
        if (Yo(I)) continue;
        const K = T[I], B = b[I];
        K !== B && I !== "value" && i(h, I, B, K, L, F);
      }
      "value" in T && i(h, "value", b.value, T.value, L);
    }
  }, R = (h, b, T, F, L, I, K, B, H) => {
    const j = b.el = h ? h.el : a(""), oe = b.anchor = h ? h.anchor : a("");
    let { patchFlag: Y, dynamicChildren: Z, slotScopeIds: ie } = b;
    process.env.NODE_ENV !== "production" && // #5523 dev root fragment may inherit directives
    ($n || Y & 2048) && (Y = 0, H = !1, Z = null), ie && (B = B ? B.concat(ie) : ie), h == null ? (o(j, T, F), o(oe, T, F), E(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      b.children || [],
      T,
      oe,
      L,
      I,
      K,
      B,
      H
    )) : Y > 0 && Y & 64 && Z && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    h.dynamicChildren ? (A(
      h.dynamicChildren,
      Z,
      T,
      L,
      I,
      K,
      B
    ), process.env.NODE_ENV !== "production" ? Jo(h, b) : (
      // #2080 if the stable fragment has a key, it's a <template v-for> that may
      //  get moved around. Make sure all root level vnodes inherit el.
      // #2134 or if it's a component root, it may also get moved around
      // as the component is being moved.
      (b.key != null || L && b === L.subTree) && Jo(
        h,
        b,
        !0
        /* shallow */
      )
    )) : he(
      h,
      b,
      T,
      oe,
      L,
      I,
      K,
      B,
      H
    );
  }, M = (h, b, T, F, L, I, K, B, H) => {
    b.slotScopeIds = B, h == null ? b.shapeFlag & 512 ? L.ctx.activate(
      b,
      T,
      F,
      K,
      H
    ) : G(
      b,
      T,
      F,
      L,
      I,
      K,
      H
    ) : Q(h, b, H);
  }, G = (h, b, T, F, L, I, K) => {
    const B = h.component = vh(
      h,
      F,
      L
    );
    if (process.env.NODE_ENV !== "production" && B.type.__hmrId && Gp(B), process.env.NODE_ENV !== "production" && (Qr(h), nn(B, "mount")), xr(h) && (B.ctx.renderer = vt), process.env.NODE_ENV !== "production" && nn(B, "init"), bh(B, !1, K), process.env.NODE_ENV !== "production" && on(B, "init"), B.asyncDep) {
      if (L && L.registerDep(B, $, K), !h.el) {
        const H = B.subTree = le(ze);
        C(null, H, b, T);
      }
    } else
      $(
        B,
        h,
        b,
        T,
        L,
        I,
        K
      );
    process.env.NODE_ENV !== "production" && (Xr(), on(B, "mount"));
  }, Q = (h, b, T) => {
    const F = b.component = h.component;
    if (ah(h, b, T))
      if (F.asyncDep && !F.asyncResolved) {
        process.env.NODE_ENV !== "production" && Qr(b), W(F, b, T), process.env.NODE_ENV !== "production" && Xr();
        return;
      } else
        F.next = b, F.update();
    else
      b.el = h.el, F.vnode = b;
  }, $ = (h, b, T, F, L, I, K) => {
    const B = () => {
      if (h.isMounted) {
        let { next: Y, bu: Z, u: ie, parent: be, vnode: Ne } = h;
        {
          const P = id(h);
          if (P) {
            Y && (Y.el = Ne.el, W(h, Y, K)), P.asyncDep.then(() => {
              h.isUnmounted || B();
            });
            return;
          }
        }
        let ke = Y, ut;
        process.env.NODE_ENV !== "production" && Qr(Y || h.vnode), In(h, !1), Y ? (Y.el = Ne.el, W(h, Y, K)) : Y = Ne, Z && go(Z), (ut = Y.props && Y.props.onVnodeBeforeUpdate) && Ht(ut, be, Y, Ne), In(h, !0), process.env.NODE_ENV !== "production" && nn(h, "render");
        const Qe = rs(h);
        process.env.NODE_ENV !== "production" && on(h, "render");
        const _t = h.subTree;
        h.subTree = Qe, process.env.NODE_ENV !== "production" && nn(h, "patch"), w(
          _t,
          Qe,
          // parent may have changed if it's in a teleport
          d(_t.el),
          // anchor may have changed if it's in a fragment
          ot(_t),
          h,
          L,
          I
        ), process.env.NODE_ENV !== "production" && on(h, "patch"), Y.el = Qe.el, ke === null && lh(h, Qe.el), ie && gt(ie, L), (ut = Y.props && Y.props.onVnodeUpdated) && gt(
          () => Ht(ut, be, Y, Ne),
          L
        ), process.env.NODE_ENV !== "production" && $c(h), process.env.NODE_ENV !== "production" && Xr();
      } else {
        let Y;
        const { el: Z, props: ie } = b, { bm: be, m: Ne, parent: ke, root: ut, type: Qe } = h, _t = Qo(b);
        if (In(h, !1), be && go(be), !_t && (Y = ie && ie.onVnodeBeforeMount) && Ht(Y, ke, b), In(h, !0), Z && gn) {
          const P = () => {
            process.env.NODE_ENV !== "production" && nn(h, "render"), h.subTree = rs(h), process.env.NODE_ENV !== "production" && on(h, "render"), process.env.NODE_ENV !== "production" && nn(h, "hydrate"), gn(
              Z,
              h.subTree,
              h,
              L,
              null
            ), process.env.NODE_ENV !== "production" && on(h, "hydrate");
          };
          _t && Qe.__asyncHydrate ? Qe.__asyncHydrate(
            Z,
            h,
            P
          ) : P();
        } else {
          ut.ce && ut.ce._injectChildStyle(Qe), process.env.NODE_ENV !== "production" && nn(h, "render");
          const P = h.subTree = rs(h);
          process.env.NODE_ENV !== "production" && on(h, "render"), process.env.NODE_ENV !== "production" && nn(h, "patch"), w(
            null,
            P,
            T,
            F,
            h,
            L,
            I
          ), process.env.NODE_ENV !== "production" && on(h, "patch"), b.el = P.el;
        }
        if (Ne && gt(Ne, L), !_t && (Y = ie && ie.onVnodeMounted)) {
          const P = b;
          gt(
            () => Ht(Y, ke, P),
            L
          );
        }
        (b.shapeFlag & 256 || ke && Qo(ke.vnode) && ke.vnode.shapeFlag & 256) && h.a && gt(h.a, L), h.isMounted = !0, process.env.NODE_ENV !== "production" && tm(h), b = T = F = null;
      }
    };
    h.scope.on();
    const H = h.effect = new nc(B);
    h.scope.off();
    const j = h.update = H.run.bind(H), oe = h.job = H.runIfDirty.bind(H);
    oe.i = h, oe.id = h.uid, H.scheduler = () => Mi(oe), In(h, !0), process.env.NODE_ENV !== "production" && (H.onTrack = h.rtc ? (Y) => go(h.rtc, Y) : void 0, H.onTrigger = h.rtg ? (Y) => go(h.rtg, Y) : void 0), j();
  }, W = (h, b, T) => {
    b.component = h;
    const F = h.vnode.props;
    h.vnode = b, h.next = null, Im(h, b.props, F, T), Ym(h, b.children, T), mn(), Za(h), hn();
  }, he = (h, b, T, F, L, I, K, B, H = !1) => {
    const j = h && h.children, oe = h ? h.shapeFlag : 0, Y = b.children, { patchFlag: Z, shapeFlag: ie } = b;
    if (Z > 0) {
      if (Z & 128) {
        we(
          j,
          Y,
          T,
          F,
          L,
          I,
          K,
          B,
          H
        );
        return;
      } else if (Z & 256) {
        fe(
          j,
          Y,
          T,
          F,
          L,
          I,
          K,
          B,
          H
        );
        return;
      }
    }
    ie & 8 ? (oe & 16 && Re(j, L, I), Y !== j && u(T, Y)) : oe & 16 ? ie & 16 ? we(
      j,
      Y,
      T,
      F,
      L,
      I,
      K,
      B,
      H
    ) : Re(j, L, I, !0) : (oe & 8 && u(T, ""), ie & 16 && E(
      Y,
      T,
      F,
      L,
      I,
      K,
      B,
      H
    ));
  }, fe = (h, b, T, F, L, I, K, B, H) => {
    h = h || Eo, b = b || Eo;
    const j = h.length, oe = b.length, Y = Math.min(j, oe);
    let Z;
    for (Z = 0; Z < Y; Z++) {
      const ie = b[Z] = H ? kn(b[Z]) : Lt(b[Z]);
      w(
        h[Z],
        ie,
        T,
        null,
        L,
        I,
        K,
        B,
        H
      );
    }
    j > oe ? Re(
      h,
      L,
      I,
      !0,
      !1,
      Y
    ) : E(
      b,
      T,
      F,
      L,
      I,
      K,
      B,
      H,
      Y
    );
  }, we = (h, b, T, F, L, I, K, B, H) => {
    let j = 0;
    const oe = b.length;
    let Y = h.length - 1, Z = oe - 1;
    for (; j <= Y && j <= Z; ) {
      const ie = h[j], be = b[j] = H ? kn(b[j]) : Lt(b[j]);
      if (Hn(ie, be))
        w(
          ie,
          be,
          T,
          null,
          L,
          I,
          K,
          B,
          H
        );
      else
        break;
      j++;
    }
    for (; j <= Y && j <= Z; ) {
      const ie = h[Y], be = b[Z] = H ? kn(b[Z]) : Lt(b[Z]);
      if (Hn(ie, be))
        w(
          ie,
          be,
          T,
          null,
          L,
          I,
          K,
          B,
          H
        );
      else
        break;
      Y--, Z--;
    }
    if (j > Y) {
      if (j <= Z) {
        const ie = Z + 1, be = ie < oe ? b[ie].el : F;
        for (; j <= Z; )
          w(
            null,
            b[j] = H ? kn(b[j]) : Lt(b[j]),
            T,
            be,
            L,
            I,
            K,
            B,
            H
          ), j++;
      }
    } else if (j > Z)
      for (; j <= Y; )
        ve(h[j], L, I, !0), j++;
    else {
      const ie = j, be = j, Ne = /* @__PURE__ */ new Map();
      for (j = be; j <= Z; j++) {
        const pe = b[j] = H ? kn(b[j]) : Lt(b[j]);
        pe.key != null && (process.env.NODE_ENV !== "production" && Ne.has(pe.key) && z(
          "Duplicate keys found during update:",
          JSON.stringify(pe.key),
          "Make sure keys are unique."
        ), Ne.set(pe.key, j));
      }
      let ke, ut = 0;
      const Qe = Z - be + 1;
      let _t = !1, P = 0;
      const J = new Array(Qe);
      for (j = 0; j < Qe; j++) J[j] = 0;
      for (j = ie; j <= Y; j++) {
        const pe = h[j];
        if (ut >= Qe) {
          ve(pe, L, I, !0);
          continue;
        }
        let me;
        if (pe.key != null)
          me = Ne.get(pe.key);
        else
          for (ke = be; ke <= Z; ke++)
            if (J[ke - be] === 0 && Hn(pe, b[ke])) {
              me = ke;
              break;
            }
        me === void 0 ? ve(pe, L, I, !0) : (J[me - be] = j + 1, me >= P ? P = me : _t = !0, w(
          pe,
          b[me],
          T,
          null,
          L,
          I,
          K,
          B,
          H
        ), ut++);
      }
      const ae = _t ? Zm(J) : Eo;
      for (ke = ae.length - 1, j = Qe - 1; j >= 0; j--) {
        const pe = be + j, me = b[pe], Xe = pe + 1 < oe ? b[pe + 1].el : F;
        J[j] === 0 ? w(
          null,
          me,
          T,
          Xe,
          L,
          I,
          K,
          B,
          H
        ) : _t && (ke < 0 || j !== ae[ke] ? q(me, T, Xe, 2) : ke--);
      }
    }
  }, q = (h, b, T, F, L = null) => {
    const { el: I, type: K, transition: B, children: H, shapeFlag: j } = h;
    if (j & 6) {
      q(h.component.subTree, b, T, F);
      return;
    }
    if (j & 128) {
      h.suspense.move(b, T, F);
      return;
    }
    if (j & 64) {
      K.move(h, b, T, vt);
      return;
    }
    if (K === Je) {
      o(I, b, T);
      for (let Y = 0; Y < H.length; Y++)
        q(H[Y], b, T, F);
      o(h.anchor, b, T);
      return;
    }
    if (K === Zo) {
      m(h, b, T);
      return;
    }
    if (F !== 2 && j & 1 && B)
      if (F === 0)
        B.beforeEnter(I), o(I, b, T), gt(() => B.enter(I), L);
      else {
        const { leave: Y, delayLeave: Z, afterLeave: ie } = B, be = () => o(I, b, T), Ne = () => {
          Y(I, () => {
            be(), ie && ie();
          });
        };
        Z ? Z(I, be, Ne) : Ne();
      }
    else
      o(I, b, T);
  }, ve = (h, b, T, F = !1, L = !1) => {
    const {
      type: I,
      props: K,
      ref: B,
      children: H,
      dynamicChildren: j,
      shapeFlag: oe,
      patchFlag: Y,
      dirs: Z,
      cacheIndex: ie
    } = h;
    if (Y === -2 && (L = !1), B != null && Ps(B, null, T, h, !0), ie != null && (b.renderCache[ie] = void 0), oe & 256) {
      b.ctx.deactivate(h);
      return;
    }
    const be = oe & 1 && Z, Ne = !Qo(h);
    let ke;
    if (Ne && (ke = K && K.onVnodeBeforeUnmount) && Ht(ke, b, h), oe & 6)
      xe(h.component, T, F);
    else {
      if (oe & 128) {
        h.suspense.unmount(T, F);
        return;
      }
      be && Ln(h, null, b, "beforeUnmount"), oe & 64 ? h.type.remove(
        h,
        b,
        T,
        vt,
        F
      ) : j && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !j.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (I !== Je || Y > 0 && Y & 64) ? Re(
        j,
        b,
        T,
        !1,
        !0
      ) : (I === Je && Y & 384 || !L && oe & 16) && Re(H, b, T), F && Ve(h);
    }
    (Ne && (ke = K && K.onVnodeUnmounted) || be) && gt(() => {
      ke && Ht(ke, b, h), be && Ln(h, null, b, "unmounted");
    }, T);
  }, Ve = (h) => {
    const { type: b, el: T, anchor: F, transition: L } = h;
    if (b === Je) {
      process.env.NODE_ENV !== "production" && h.patchFlag > 0 && h.patchFlag & 2048 && L && !L.persisted ? h.children.forEach((K) => {
        K.type === ze ? r(K.el) : Ve(K);
      }) : Te(T, F);
      return;
    }
    if (b === Zo) {
      y(h);
      return;
    }
    const I = () => {
      r(T), L && !L.persisted && L.afterLeave && L.afterLeave();
    };
    if (h.shapeFlag & 1 && L && !L.persisted) {
      const { leave: K, delayLeave: B } = L, H = () => K(T, I);
      B ? B(h.el, I, H) : H();
    } else
      I();
  }, Te = (h, b) => {
    let T;
    for (; h !== b; )
      T = f(h), r(h), h = T;
    r(b);
  }, xe = (h, b, T) => {
    process.env.NODE_ENV !== "production" && h.type.__hmrId && Qp(h);
    const { bum: F, scope: L, job: I, subTree: K, um: B, m: H, a: j } = h;
    fl(H), fl(j), F && go(F), L.stop(), I && (I.flags |= 8, ve(K, h, b, T)), B && gt(B, b), gt(() => {
      h.isUnmounted = !0;
    }, b), b && b.pendingBranch && !b.isUnmounted && h.asyncDep && !h.asyncResolved && h.suspenseId === b.pendingId && (b.deps--, b.deps === 0 && b.resolve()), process.env.NODE_ENV !== "production" && om(h);
  }, Re = (h, b, T, F = !1, L = !1, I = 0) => {
    for (let K = I; K < h.length; K++)
      ve(h[K], b, T, F, L);
  }, ot = (h) => {
    if (h.shapeFlag & 6)
      return ot(h.component.subTree);
    if (h.shapeFlag & 128)
      return h.suspense.next();
    const b = f(h.anchor || h.el), T = b && b[Mc];
    return T ? f(T) : b;
  };
  let de = !1;
  const lt = (h, b, T) => {
    h == null ? b._vnode && ve(b._vnode, null, null, !0) : w(
      b._vnode || null,
      h,
      b,
      null,
      null,
      null,
      T
    ), b._vnode = h, de || (de = !0, Za(), Sc(), de = !1);
  }, vt = {
    p: w,
    um: ve,
    m: q,
    r: Ve,
    mt: G,
    mc: E,
    pc: he,
    pbc: A,
    n: ot,
    o: e
  };
  let en, gn;
  return {
    render: lt,
    hydrate: en,
    createApp: Am(lt, en)
  };
}
function os({ type: e, props: t }, n) {
  return n === "svg" && e === "foreignObject" || n === "mathml" && e === "annotation-xml" && t && t.encoding && t.encoding.includes("html") ? void 0 : n;
}
function In({ effect: e, job: t }, n) {
  n ? (e.flags |= 32, t.flags |= 4) : (e.flags &= -33, t.flags &= -5);
}
function Jm(e, t) {
  return (!e || e && !e.pendingBranch) && t && !t.persisted;
}
function Jo(e, t, n = !1) {
  const o = e.children, r = t.children;
  if (ne(o) && ne(r))
    for (let i = 0; i < o.length; i++) {
      const s = o[i];
      let a = r[i];
      a.shapeFlag & 1 && !a.dynamicChildren && ((a.patchFlag <= 0 || a.patchFlag === 32) && (a = r[i] = kn(r[i]), a.el = s.el), !n && a.patchFlag !== -2 && Jo(s, a)), a.type === Sr && (a.el = s.el), process.env.NODE_ENV !== "production" && a.type === ze && !a.el && (a.el = s.el);
    }
}
function Zm(e) {
  const t = e.slice(), n = [0];
  let o, r, i, s, a;
  const l = e.length;
  for (o = 0; o < l; o++) {
    const c = e[o];
    if (c !== 0) {
      if (r = n[n.length - 1], e[r] < c) {
        t[o] = r, n.push(o);
        continue;
      }
      for (i = 0, s = n.length - 1; i < s; )
        a = i + s >> 1, e[n[a]] < c ? i = a + 1 : s = a;
      c < e[n[i]] && (i > 0 && (t[o] = n[i - 1]), n[i] = o);
    }
  }
  for (i = n.length, s = n[i - 1]; i-- > 0; )
    n[i] = s, s = t[s];
  return n;
}
function id(e) {
  const t = e.subTree.component;
  if (t)
    return t.asyncDep && !t.asyncResolved ? t : id(t);
}
function fl(e) {
  if (e)
    for (let t = 0; t < e.length; t++)
      e[t].flags |= 8;
}
const eh = Symbol.for("v-scx"), th = () => {
  {
    const e = Xo(eh);
    return e || process.env.NODE_ENV !== "production" && z(
      "Server rendering context not provided. Make sure to only call useSSRContext() conditionally in the server build."
    ), e;
  }
};
function ye(e, t, n) {
  return process.env.NODE_ENV !== "production" && !se(t) && z(
    "`watch(fn, options?)` signature has been moved to a separate API. Use `watchEffect(fn, options?)` instead. `watch` now only supports `watch(source, cb, options?) signature."
  ), sd(e, t, n);
}
function sd(e, t, n = Se) {
  const { immediate: o, deep: r, flush: i, once: s } = n;
  process.env.NODE_ENV !== "production" && !t && (o !== void 0 && z(
    'watch() "immediate" option is only respected when using the watch(source, callback, options?) signature.'
  ), r !== void 0 && z(
    'watch() "deep" option is only respected when using the watch(source, callback, options?) signature.'
  ), s !== void 0 && z(
    'watch() "once" option is only respected when using the watch(source, callback, options?) signature.'
  ));
  const a = We({}, n);
  process.env.NODE_ENV !== "production" && (a.onWarn = z);
  let l;
  if (ji)
    if (i === "sync") {
      const f = th();
      l = f.__watcherHandles || (f.__watcherHandles = []);
    } else if (!t || o)
      a.once = !0;
    else
      return {
        stop: Ke,
        resume: Ke,
        pause: Ke
      };
  const c = Ye;
  a.call = (f, p, v) => Wt(f, c, p, v);
  let u = !1;
  i === "post" ? a.scheduler = (f) => {
    gt(f, c && c.suspense);
  } : i !== "sync" && (u = !0, a.scheduler = (f, p) => {
    p ? f() : Mi(f);
  }), a.augmentJob = (f) => {
    t && (f.flags |= 4), u && (f.flags |= 2, c && (f.id = c.uid, f.i = c));
  };
  const d = qp(e, t, a);
  return l && l.push(d), d;
}
function nh(e, t, n) {
  const o = this.proxy, r = Ae(e) ? e.includes(".") ? ad(o, e) : () => o[e] : e.bind(o, o);
  let i;
  se(t) ? i = t : (i = t.handler, n = t);
  const s = Or(this), a = sd(r, i.bind(o), n);
  return s(), a;
}
function ad(e, t) {
  const n = t.split(".");
  return () => {
    let o = e;
    for (let r = 0; r < n.length && o; r++)
      o = o[n[r]];
    return o;
  };
}
const oh = (e, t) => t === "modelValue" || t === "model-value" ? e.modelModifiers : e[`${t}Modifiers`] || e[`${kt(t)}Modifiers`] || e[`${dn(t)}Modifiers`];
function rh(e, t, ...n) {
  if (e.isUnmounted) return;
  const o = e.vnode.props || Se;
  if (process.env.NODE_ENV !== "production") {
    const {
      emitsOptions: u,
      propsOptions: [d]
    } = e;
    if (u)
      if (!(t in u))
        (!d || !(Fn(kt(t)) in d)) && z(
          `Component emitted event "${t}" but it is neither declared in the emits option nor as an "${Fn(kt(t))}" prop.`
        );
      else {
        const f = u[t];
        se(f) && (f(...n) || z(
          `Invalid event arguments: event validation failed for event "${t}".`
        ));
      }
  }
  let r = n;
  const i = t.startsWith("update:"), s = i && oh(o, t.slice(7));
  if (s && (s.trim && (r = n.map((u) => Ae(u) ? u.trim() : u)), s.number && (r = n.map(ks))), process.env.NODE_ENV !== "production" && sm(e, t, r), process.env.NODE_ENV !== "production") {
    const u = t.toLowerCase();
    u !== t && o[Fn(u)] && z(
      `Event "${u}" is emitted in component ${Fi(
        e,
        e.type
      )} but the handler is registered for "${t}". Note that HTML attributes are case-insensitive and you cannot use v-on to listen to camelCase events when using in-DOM templates. You should probably use "${dn(
        t
      )}" instead of "${t}".`
    );
  }
  let a, l = o[a = Fn(t)] || // also try camelCase event handler (#2249)
  o[a = Fn(kt(t))];
  !l && i && (l = o[a = Fn(dn(t))]), l && Wt(
    l,
    e,
    6,
    r
  );
  const c = o[a + "Once"];
  if (c) {
    if (!e.emitted)
      e.emitted = {};
    else if (e.emitted[a])
      return;
    e.emitted[a] = !0, Wt(
      c,
      e,
      6,
      r
    );
  }
}
function ld(e, t, n = !1) {
  const o = t.emitsCache, r = o.get(e);
  if (r !== void 0)
    return r;
  const i = e.emits;
  let s = {}, a = !1;
  if (!se(e)) {
    const l = (c) => {
      const u = ld(c, t, !0);
      u && (a = !0, We(s, u));
    };
    !n && t.mixins.length && t.mixins.forEach(l), e.extends && l(e.extends), e.mixins && e.mixins.forEach(l);
  }
  return !i && !a ? (Oe(e) && o.set(e, null), null) : (ne(i) ? i.forEach((l) => s[l] = null) : We(s, i), Oe(e) && o.set(e, s), s);
}
function Ii(e, t) {
  return !e || !wr(t) ? !1 : (t = t.slice(2).replace(/Once$/, ""), _e(e, t[0].toLowerCase() + t.slice(1)) || _e(e, dn(t)) || _e(e, t));
}
let Ls = !1;
function mi() {
  Ls = !0;
}
function rs(e) {
  const {
    type: t,
    vnode: n,
    proxy: o,
    withProxy: r,
    propsOptions: [i],
    slots: s,
    attrs: a,
    emit: l,
    render: c,
    renderCache: u,
    props: d,
    data: f,
    setupState: p,
    ctx: v,
    inheritAttrs: w
  } = e, _ = ci(e);
  let C, S;
  process.env.NODE_ENV !== "production" && (Ls = !1);
  try {
    if (n.shapeFlag & 4) {
      const y = r || o, x = process.env.NODE_ENV !== "production" && p.__isScriptSetup ? new Proxy(y, {
        get(k, D, E) {
          return z(
            `Property '${String(
              D
            )}' was accessed via 'this'. Avoid using 'this' in templates.`
          ), Reflect.get(k, D, E);
        }
      }) : y;
      C = Lt(
        c.call(
          x,
          y,
          u,
          process.env.NODE_ENV !== "production" ? Yt(d) : d,
          p,
          f,
          v
        )
      ), S = a;
    } else {
      const y = t;
      process.env.NODE_ENV !== "production" && a === d && mi(), C = Lt(
        y.length > 1 ? y(
          process.env.NODE_ENV !== "production" ? Yt(d) : d,
          process.env.NODE_ENV !== "production" ? {
            get attrs() {
              return mi(), Yt(a);
            },
            slots: s,
            emit: l
          } : { attrs: a, slots: s, emit: l }
        ) : y(
          process.env.NODE_ENV !== "production" ? Yt(d) : d,
          null
        )
      ), S = t.props ? a : ih(a);
    }
  } catch (y) {
    er.length = 0, _r(y, e, 1), C = le(ze);
  }
  let N = C, m;
  if (process.env.NODE_ENV !== "production" && C.patchFlag > 0 && C.patchFlag & 2048 && ([N, m] = ud(C)), S && w !== !1) {
    const y = Object.keys(S), { shapeFlag: x } = N;
    if (y.length) {
      if (x & 7)
        i && y.some(ii) && (S = sh(
          S,
          i
        )), N = Xt(N, S, !1, !0);
      else if (process.env.NODE_ENV !== "production" && !Ls && N.type !== ze) {
        const k = Object.keys(a), D = [], E = [];
        for (let O = 0, A = k.length; O < A; O++) {
          const g = k[O];
          wr(g) ? ii(g) || D.push(g[2].toLowerCase() + g.slice(3)) : E.push(g);
        }
        E.length && z(
          `Extraneous non-props attributes (${E.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes.`
        ), D.length && z(
          `Extraneous non-emits event listeners (${D.join(", ")}) were passed to component but could not be automatically inherited because component renders fragment or text root nodes. If the listener is intended to be a component custom event listener only, declare it using the "emits" option.`
        );
      }
    }
  }
  return n.dirs && (process.env.NODE_ENV !== "production" && !pl(N) && z(
    "Runtime directive used on component with non-element root node. The directives will not function as intended."
  ), N = Xt(N, null, !1, !0), N.dirs = N.dirs ? N.dirs.concat(n.dirs) : n.dirs), n.transition && (process.env.NODE_ENV !== "production" && !pl(N) && z(
    "Component inside <Transition> renders non-element root node that cannot be animated."
  ), ur(N, n.transition)), process.env.NODE_ENV !== "production" && m ? m(N) : C = N, ci(_), C;
}
const ud = (e) => {
  const t = e.children, n = e.dynamicChildren, o = xa(t, !1);
  if (o) {
    if (process.env.NODE_ENV !== "production" && o.patchFlag > 0 && o.patchFlag & 2048)
      return ud(o);
  } else return [e, void 0];
  const r = t.indexOf(o), i = n ? n.indexOf(o) : -1, s = (a) => {
    t[r] = a, n && (i > -1 ? n[i] = a : a.patchFlag > 0 && (e.dynamicChildren = [...n, a]));
  };
  return [Lt(o), s];
};
function xa(e, t = !0) {
  let n;
  for (let o = 0; o < e.length; o++) {
    const r = e[o];
    if (So(r)) {
      if (r.type !== ze || r.children === "v-if") {
        if (n)
          return;
        if (n = r, process.env.NODE_ENV !== "production" && t && n.patchFlag > 0 && n.patchFlag & 2048)
          return xa(n.children);
      }
    } else
      return;
  }
  return n;
}
const ih = (e) => {
  let t;
  for (const n in e)
    (n === "class" || n === "style" || wr(n)) && ((t || (t = {}))[n] = e[n]);
  return t;
}, sh = (e, t) => {
  const n = {};
  for (const o in e)
    (!ii(o) || !(o.slice(9) in t)) && (n[o] = e[o]);
  return n;
}, pl = (e) => e.shapeFlag & 7 || e.type === ze;
function ah(e, t, n) {
  const { props: o, children: r, component: i } = e, { props: s, children: a, patchFlag: l } = t, c = i.emitsOptions;
  if (process.env.NODE_ENV !== "production" && (r || a) && $n || t.dirs || t.transition)
    return !0;
  if (n && l >= 0) {
    if (l & 1024)
      return !0;
    if (l & 16)
      return o ? ml(o, s, c) : !!s;
    if (l & 8) {
      const u = t.dynamicProps;
      for (let d = 0; d < u.length; d++) {
        const f = u[d];
        if (s[f] !== o[f] && !Ii(c, f))
          return !0;
      }
    }
  } else
    return (r || a) && (!a || !a.$stable) ? !0 : o === s ? !1 : o ? s ? ml(o, s, c) : !0 : !!s;
  return !1;
}
function ml(e, t, n) {
  const o = Object.keys(t);
  if (o.length !== Object.keys(e).length)
    return !0;
  for (let r = 0; r < o.length; r++) {
    const i = o[r];
    if (t[i] !== e[i] && !Ii(n, i))
      return !0;
  }
  return !1;
}
function lh({ vnode: e, parent: t }, n) {
  for (; t; ) {
    const o = t.subTree;
    if (o.suspense && o.suspense.activeBranch === e && (o.el = e.el), o === e)
      (e = t.vnode).el = n, t = t.parent;
    else
      break;
  }
}
const cd = (e) => e.__isSuspense;
function uh(e, t) {
  t && t.pendingBranch ? ne(e) ? t.effects.push(...e) : t.effects.push(e) : Cc(e);
}
const Je = Symbol.for("v-fgt"), Sr = Symbol.for("v-txt"), ze = Symbol.for("v-cmt"), Zo = Symbol.for("v-stc"), er = [];
let xt = null;
function X(e = !1) {
  er.push(xt = e ? null : []);
}
function ch() {
  er.pop(), xt = er[er.length - 1] || null;
}
let cr = 1;
function hl(e) {
  cr += e, e < 0 && xt && (xt.hasOnce = !0);
}
function dd(e) {
  return e.dynamicChildren = cr > 0 ? xt || Eo : null, ch(), cr > 0 && xt && xt.push(e), e;
}
function ue(e, t, n, o, r, i) {
  return dd(
    ce(
      e,
      t,
      n,
      o,
      r,
      i,
      !0
    )
  );
}
function He(e, t, n, o, r) {
  return dd(
    le(
      e,
      t,
      n,
      o,
      r,
      !0
    )
  );
}
function So(e) {
  return e ? e.__v_isVNode === !0 : !1;
}
function Hn(e, t) {
  if (process.env.NODE_ENV !== "production" && t.shapeFlag & 6 && e.component) {
    const n = Jr.get(t.type);
    if (n && n.has(e.component))
      return e.shapeFlag &= -257, t.shapeFlag &= -513, !1;
  }
  return e.type === t.type && e.key === t.key;
}
const dh = (...e) => pd(
  ...e
), fd = ({ key: e }) => e ?? null, ei = ({
  ref: e,
  ref_key: t,
  ref_for: n
}) => (typeof e == "number" && (e = "" + e), e != null ? Ae(e) || $e(e) || se(e) ? { i: st, r: e, k: t, f: !!n } : e : null);
function ce(e, t = null, n = null, o = 0, r = null, i = e === Je ? 0 : 1, s = !1, a = !1) {
  const l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e,
    props: t,
    key: t && fd(t),
    ref: t && ei(t),
    scopeId: Pc,
    slotScopeIds: null,
    children: n,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: i,
    patchFlag: o,
    dynamicProps: r,
    dynamicChildren: null,
    appContext: null,
    ctx: st
  };
  return a ? (ka(l, n), i & 128 && e.normalize(l)) : n && (l.shapeFlag |= Ae(n) ? 8 : 16), process.env.NODE_ENV !== "production" && l.key !== l.key && z("VNode created with invalid key (NaN). VNode type:", l.type), cr > 0 && // avoid a block node from tracking itself
  !s && // has current parent block
  xt && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (l.patchFlag > 0 || i & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  l.patchFlag !== 32 && xt.push(l), l;
}
const le = process.env.NODE_ENV !== "production" ? dh : pd;
function pd(e, t = null, n = null, o = 0, r = null, i = !1) {
  if ((!e || e === Hc) && (process.env.NODE_ENV !== "production" && !e && z(`Invalid vnode type when creating vnode: ${e}.`), e = ze), So(e)) {
    const a = Xt(
      e,
      t,
      !0
      /* mergeRef: true */
    );
    return n && ka(a, n), cr > 0 && !i && xt && (a.shapeFlag & 6 ? xt[xt.indexOf(e)] = a : xt.push(a)), a.patchFlag = -2, a;
  }
  if (bd(e) && (e = e.__vccOpts), t) {
    t = fh(t);
    let { class: a, style: l } = t;
    a && !Ae(a) && (t.class = pt(a)), Oe(l) && (sr(l) && !ne(l) && (l = We({}, l)), t.style = Ni(l));
  }
  const s = Ae(e) ? 1 : cd(e) ? 128 : Ac(e) ? 64 : Oe(e) ? 4 : se(e) ? 2 : 0;
  return process.env.NODE_ENV !== "production" && s & 4 && sr(e) && (e = ge(e), z(
    "Vue received a Component that was made a reactive object. This can lead to unnecessary performance overhead and should be avoided by marking the component with `markRaw` or using `shallowRef` instead of `ref`.",
    `
Component that was made reactive: `,
    e
  )), ce(
    e,
    t,
    n,
    o,
    r,
    s,
    i,
    !0
  );
}
function fh(e) {
  return e ? sr(e) || Jc(e) ? We({}, e) : e : null;
}
function Xt(e, t, n = !1, o = !1) {
  const { props: r, ref: i, patchFlag: s, children: a, transition: l } = e, c = t ? Bt(r || {}, t) : r, u = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: e.type,
    props: c,
    key: c && fd(c),
    ref: t && t.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      n && i ? ne(i) ? i.concat(ei(t)) : [i, ei(t)] : ei(t)
    ) : i,
    scopeId: e.scopeId,
    slotScopeIds: e.slotScopeIds,
    children: process.env.NODE_ENV !== "production" && s === -1 && ne(a) ? a.map(md) : a,
    target: e.target,
    targetStart: e.targetStart,
    targetAnchor: e.targetAnchor,
    staticCount: e.staticCount,
    shapeFlag: e.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: t && e.type !== Je ? s === -1 ? 16 : s | 16 : s,
    dynamicProps: e.dynamicProps,
    dynamicChildren: e.dynamicChildren,
    appContext: e.appContext,
    dirs: e.dirs,
    transition: l,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: e.component,
    suspense: e.suspense,
    ssContent: e.ssContent && Xt(e.ssContent),
    ssFallback: e.ssFallback && Xt(e.ssFallback),
    el: e.el,
    anchor: e.anchor,
    ctx: e.ctx,
    ce: e.ce
  };
  return l && o && ur(
    u,
    l.clone(u)
  ), u;
}
function md(e) {
  const t = Xt(e);
  return ne(e.children) && (t.children = e.children.map(md)), t;
}
function ft(e = " ", t = 0) {
  return le(Sr, null, e, t);
}
function ph(e, t) {
  const n = le(Zo, null, e);
  return n.staticCount = t, n;
}
function Pe(e = "", t = !1) {
  return t ? (X(), He(ze, null, e)) : le(ze, null, e);
}
function Lt(e) {
  return e == null || typeof e == "boolean" ? le(ze) : ne(e) ? le(
    Je,
    null,
    // #3666, avoid reference pollution when reusing vnode
    e.slice()
  ) : typeof e == "object" ? kn(e) : le(Sr, null, String(e));
}
function kn(e) {
  return e.el === null && e.patchFlag !== -1 || e.memo ? e : Xt(e);
}
function ka(e, t) {
  let n = 0;
  const { shapeFlag: o } = e;
  if (t == null)
    t = null;
  else if (ne(t))
    n = 16;
  else if (typeof t == "object")
    if (o & 65) {
      const r = t.default;
      r && (r._c && (r._d = !1), ka(e, r()), r._c && (r._d = !0));
      return;
    } else {
      n = 32;
      const r = t._;
      !r && !Jc(t) ? t._ctx = st : r === 3 && st && (st.slots._ === 1 ? t._ = 1 : (t._ = 2, e.patchFlag |= 1024));
    }
  else se(t) ? (t = { default: t, _ctx: st }, n = 32) : (t = String(t), o & 64 ? (n = 16, t = [ft(t)]) : n = 8);
  e.children = t, e.shapeFlag |= n;
}
function Bt(...e) {
  const t = {};
  for (let n = 0; n < e.length; n++) {
    const o = e[n];
    for (const r in o)
      if (r === "class")
        t.class !== o.class && (t.class = pt([t.class, o.class]));
      else if (r === "style")
        t.style = Ni([t.style, o.style]);
      else if (wr(r)) {
        const i = t[r], s = o[r];
        s && i !== s && !(ne(i) && i.includes(s)) && (t[r] = i ? [].concat(i, s) : s);
      } else r !== "" && (t[r] = o[r]);
  }
  return t;
}
function Ht(e, t, n, o = null) {
  Wt(e, t, 7, [
    n,
    o
  ]);
}
const mh = Gc();
let hh = 0;
function vh(e, t, n) {
  const o = e.type, r = (t ? t.appContext : e.appContext) || mh, i = {
    uid: hh++,
    vnode: e,
    type: o,
    parent: t,
    appContext: r,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new lp(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: t ? t.provides : Object.create(r.provides),
    ids: t ? t.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: ed(o, r),
    emitsOptions: ld(o, r),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: Se,
    // inheritAttrs
    inheritAttrs: o.inheritAttrs,
    // state
    ctx: Se,
    data: Se,
    props: Se,
    attrs: Se,
    slots: Se,
    refs: Se,
    setupState: Se,
    setupContext: null,
    // suspense related
    suspense: n,
    suspenseId: n ? n.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return process.env.NODE_ENV !== "production" ? i.ctx = km(i) : i.ctx = { _: i }, i.root = t ? t.root : i, i.emit = rh.bind(null, i), e.ce && e.ce(i), i;
}
let Ye = null;
const Fe = () => Ye || st;
let hi, Is;
{
  const e = ra(), t = (n, o) => {
    let r;
    return (r = e[n]) || (r = e[n] = []), r.push(o), (i) => {
      r.length > 1 ? r.forEach((s) => s(i)) : r[0](i);
    };
  };
  hi = t(
    "__VUE_INSTANCE_SETTERS__",
    (n) => Ye = n
  ), Is = t(
    "__VUE_SSR_SETTERS__",
    (n) => ji = n
  );
}
const Or = (e) => {
  const t = Ye;
  return hi(e), e.scope.on(), () => {
    e.scope.off(), hi(t);
  };
}, vl = () => {
  Ye && Ye.scope.off(), hi(null);
}, gh = /* @__PURE__ */ pn("slot,component");
function js(e, { isNativeTag: t }) {
  (gh(e) || t(e)) && z(
    "Do not use built-in or reserved HTML elements as component id: " + e
  );
}
function hd(e) {
  return e.vnode.shapeFlag & 4;
}
let ji = !1;
function bh(e, t = !1, n = !1) {
  t && Is(t);
  const { props: o, children: r } = e.vnode, i = hd(e);
  Rm(e, o, i, t), Km(e, r, n);
  const s = i ? yh(e, t) : void 0;
  return t && Is(!1), s;
}
function yh(e, t) {
  var n;
  const o = e.type;
  if (process.env.NODE_ENV !== "production") {
    if (o.name && js(o.name, e.appContext.config), o.components) {
      const i = Object.keys(o.components);
      for (let s = 0; s < i.length; s++)
        js(i[s], e.appContext.config);
    }
    if (o.directives) {
      const i = Object.keys(o.directives);
      for (let s = 0; s < i.length; s++)
        Dc(i[s]);
    }
    o.compilerOptions && wh() && z(
      '"compilerOptions" is only supported when using a build of Vue that includes the runtime compiler. Since you are using a runtime-only build, the options should be passed via your build tool config instead.'
    );
  }
  e.accessCache = /* @__PURE__ */ Object.create(null), e.proxy = new Proxy(e.ctx, Uc), process.env.NODE_ENV !== "production" && Cm(e);
  const { setup: r } = o;
  if (r) {
    const i = e.setupContext = r.length > 1 ? gd(e) : null, s = Or(e);
    mn();
    const a = Lo(
      r,
      e,
      0,
      [
        process.env.NODE_ENV !== "production" ? Yt(e.props) : e.props,
        i
      ]
    );
    if (hn(), s(), ta(a)) {
      if (Qo(e) || Fc(e), a.then(vl, vl), t)
        return a.then((l) => {
          gl(e, l, t);
        }).catch((l) => {
          _r(l, e, 0);
        });
      if (e.asyncDep = a, process.env.NODE_ENV !== "production" && !e.suspense) {
        const l = (n = o.name) != null ? n : "Anonymous";
        z(
          `Component <${l}>: setup function returned a promise, but no <Suspense> boundary was found in the parent component tree. A component with async setup() must be nested in a <Suspense> in order to be rendered.`
        );
      }
    } else
      gl(e, a, t);
  } else
    vd(e, t);
}
function gl(e, t, n) {
  se(t) ? e.type.__ssrInlineRender ? e.ssrRender = t : e.render = t : Oe(t) ? (process.env.NODE_ENV !== "production" && So(t) && z(
    "setup() should not return VNodes directly - return a render function instead."
  ), process.env.NODE_ENV !== "production" && (e.devtoolsRawSetupState = t), e.setupState = wc(t), process.env.NODE_ENV !== "production" && Sm(e)) : process.env.NODE_ENV !== "production" && t !== void 0 && z(
    `setup() should return an object. Received: ${t === null ? "null" : typeof t}`
  ), vd(e, n);
}
let qs;
const wh = () => !qs;
function vd(e, t, n) {
  const o = e.type;
  if (!e.render) {
    if (!t && qs && !o.render) {
      const r = o.template || _a(e).template;
      if (r) {
        process.env.NODE_ENV !== "production" && nn(e, "compile");
        const { isCustomElement: i, compilerOptions: s } = e.appContext.config, { delimiters: a, compilerOptions: l } = o, c = We(
          We(
            {
              isCustomElement: i,
              delimiters: a
            },
            s
          ),
          l
        );
        o.render = qs(r, c), process.env.NODE_ENV !== "production" && on(e, "compile");
      }
    }
    e.render = o.render || Ke;
  }
  {
    const r = Or(e);
    mn();
    try {
      Nm(e);
    } finally {
      hn(), r();
    }
  }
  process.env.NODE_ENV !== "production" && !o.render && e.render === Ke && !t && (o.template ? z(
    'Component provided template option but runtime compilation is not supported in this build of Vue. Configure your bundler to alias "vue" to "vue/dist/vue.esm-bundler.js".'
  ) : z("Component is missing template or render function: ", o));
}
const bl = process.env.NODE_ENV !== "production" ? {
  get(e, t) {
    return mi(), Ge(e, "get", ""), e[t];
  },
  set() {
    return z("setupContext.attrs is readonly."), !1;
  },
  deleteProperty() {
    return z("setupContext.attrs is readonly."), !1;
  }
} : {
  get(e, t) {
    return Ge(e, "get", ""), e[t];
  }
};
function _h(e) {
  return new Proxy(e.slots, {
    get(t, n) {
      return Ge(e, "get", "$slots"), t[n];
    }
  });
}
function gd(e) {
  const t = (n) => {
    if (process.env.NODE_ENV !== "production" && (e.exposed && z("expose() should be called only once per setup()."), n != null)) {
      let o = typeof n;
      o === "object" && (ne(n) ? o = "array" : $e(n) && (o = "ref")), o !== "object" && z(
        `expose() should be passed a plain object, received ${o}.`
      );
    }
    e.exposed = n || {};
  };
  if (process.env.NODE_ENV !== "production") {
    let n, o;
    return Object.freeze({
      get attrs() {
        return n || (n = new Proxy(e.attrs, bl));
      },
      get slots() {
        return o || (o = _h(e));
      },
      get emit() {
        return (r, ...i) => e.emit(r, ...i);
      },
      expose: t
    });
  } else
    return {
      attrs: new Proxy(e.attrs, bl),
      slots: e.slots,
      emit: e.emit,
      expose: t
    };
}
function qi(e) {
  return e.exposed ? e.exposeProxy || (e.exposeProxy = new Proxy(wc(ca(e.exposed)), {
    get(t, n) {
      if (n in t)
        return t[n];
      if (n in eo)
        return eo[n](e);
    },
    has(t, n) {
      return n in t || n in eo;
    }
  })) : e.proxy;
}
const Eh = /(?:^|[-_])(\w)/g, xh = (e) => e.replace(Eh, (t) => t.toUpperCase()).replace(/[-_]/g, "");
function Ca(e, t = !0) {
  return se(e) ? e.displayName || e.name : e.name || t && e.__name;
}
function Fi(e, t, n = !1) {
  let o = Ca(t);
  if (!o && t.__file) {
    const r = t.__file.match(/([^/\\]+)\.\w+$/);
    r && (o = r[1]);
  }
  if (!o && e && e.parent) {
    const r = (i) => {
      for (const s in i)
        if (i[s] === t)
          return s;
    };
    o = r(
      e.components || e.parent.type.components
    ) || r(e.appContext.components);
  }
  return o ? xh(o) : n ? "App" : "Anonymous";
}
function bd(e) {
  return se(e) && "__vccOpts" in e;
}
const V = (e, t) => {
  const n = Ip(e, t, ji);
  if (process.env.NODE_ENV !== "production") {
    const o = Fe();
    o && o.appContext.config.warnRecursiveComputed && (n._warnRecursive = !0);
  }
  return n;
};
function U(e, t, n) {
  const o = arguments.length;
  return o === 2 ? Oe(t) && !ne(t) ? So(t) ? le(e, null, [t]) : le(e, t) : le(e, null, t) : (o > 3 ? n = Array.prototype.slice.call(arguments, 2) : o === 3 && So(n) && (n = [n]), le(e, t, n));
}
function kh() {
  if (process.env.NODE_ENV === "production" || typeof window > "u")
    return;
  const e = { style: "color:#3ba776" }, t = { style: "color:#1677ff" }, n = { style: "color:#f5222d" }, o = { style: "color:#eb2f96" }, r = {
    __vue_custom_formatter: !0,
    header(d) {
      return Oe(d) ? d.__isVue ? ["div", e, "VueInstance"] : $e(d) ? [
        "div",
        {},
        ["span", e, u(d)],
        "<",
        // avoid debugger accessing value affecting behavior
        a("_value" in d ? d._value : d),
        ">"
      ] : un(d) ? [
        "div",
        {},
        ["span", e, mt(d) ? "ShallowReactive" : "Reactive"],
        "<",
        a(d),
        `>${fn(d) ? " (readonly)" : ""}`
      ] : fn(d) ? [
        "div",
        {},
        ["span", e, mt(d) ? "ShallowReadonly" : "Readonly"],
        "<",
        a(d),
        ">"
      ] : null : null;
    },
    hasBody(d) {
      return d && d.__isVue;
    },
    body(d) {
      if (d && d.__isVue)
        return [
          "div",
          {},
          ...i(d.$)
        ];
    }
  };
  function i(d) {
    const f = [];
    d.type.props && d.props && f.push(s("props", ge(d.props))), d.setupState !== Se && f.push(s("setup", d.setupState)), d.data !== Se && f.push(s("data", ge(d.data)));
    const p = l(d, "computed");
    p && f.push(s("computed", p));
    const v = l(d, "inject");
    return v && f.push(s("injected", v)), f.push([
      "div",
      {},
      [
        "span",
        {
          style: o.style + ";opacity:0.66"
        },
        "$ (internal): "
      ],
      ["object", { object: d }]
    ]), f;
  }
  function s(d, f) {
    return f = We({}, f), Object.keys(f).length ? [
      "div",
      { style: "line-height:1.25em;margin-bottom:0.6em" },
      [
        "div",
        {
          style: "color:#476582"
        },
        d
      ],
      [
        "div",
        {
          style: "padding-left:1.25em"
        },
        ...Object.keys(f).map((p) => [
          "div",
          {},
          ["span", o, p + ": "],
          a(f[p], !1)
        ])
      ]
    ] : ["span", {}];
  }
  function a(d, f = !0) {
    return typeof d == "number" ? ["span", t, d] : typeof d == "string" ? ["span", n, JSON.stringify(d)] : typeof d == "boolean" ? ["span", o, d] : Oe(d) ? ["object", { object: f ? ge(d) : d }] : ["span", n, String(d)];
  }
  function l(d, f) {
    const p = d.type;
    if (se(p))
      return;
    const v = {};
    for (const w in d.ctx)
      c(p, w, f) && (v[w] = d.ctx[w]);
    return v;
  }
  function c(d, f, p) {
    const v = d[p];
    if (ne(v) && v.includes(f) || Oe(v) && f in v || d.extends && c(d.extends, f, p) || d.mixins && d.mixins.some((w) => c(w, f, p)))
      return !0;
  }
  function u(d) {
    return mt(d) ? "ShallowRef" : d.effect ? "ComputedRef" : "Ref";
  }
  window.devtoolsFormatters ? window.devtoolsFormatters.push(r) : window.devtoolsFormatters = [r];
}
const yl = "3.5.4", cn = process.env.NODE_ENV !== "production" ? z : Ke;
process.env.NODE_ENV;
process.env.NODE_ENV;
/**
* @vue/runtime-dom v3.5.4
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Fs;
const wl = typeof window < "u" && window.trustedTypes;
if (wl)
  try {
    Fs = /* @__PURE__ */ wl.createPolicy("vue", {
      createHTML: (e) => e
    });
  } catch (e) {
    process.env.NODE_ENV !== "production" && cn(`Error creating trusted types policy: ${e}`);
  }
const yd = Fs ? (e) => Fs.createHTML(e) : (e) => e, Ch = "http://www.w3.org/2000/svg", Sh = "http://www.w3.org/1998/Math/MathML", rn = typeof document < "u" ? document : null, _l = rn && /* @__PURE__ */ rn.createElement("template"), Oh = {
  insert: (e, t, n) => {
    t.insertBefore(e, n || null);
  },
  remove: (e) => {
    const t = e.parentNode;
    t && t.removeChild(e);
  },
  createElement: (e, t, n, o) => {
    const r = t === "svg" ? rn.createElementNS(Ch, e) : t === "mathml" ? rn.createElementNS(Sh, e) : n ? rn.createElement(e, { is: n }) : rn.createElement(e);
    return e === "select" && o && o.multiple != null && r.setAttribute("multiple", o.multiple), r;
  },
  createText: (e) => rn.createTextNode(e),
  createComment: (e) => rn.createComment(e),
  setText: (e, t) => {
    e.nodeValue = t;
  },
  setElementText: (e, t) => {
    e.textContent = t;
  },
  parentNode: (e) => e.parentNode,
  nextSibling: (e) => e.nextSibling,
  querySelector: (e) => rn.querySelector(e),
  setScopeId(e, t) {
    e.setAttribute(t, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(e, t, n, o, r, i) {
    const s = n ? n.previousSibling : t.lastChild;
    if (r && (r === i || r.nextSibling))
      for (; t.insertBefore(r.cloneNode(!0), n), !(r === i || !(r = r.nextSibling)); )
        ;
    else {
      _l.innerHTML = yd(
        o === "svg" ? `<svg>${e}</svg>` : o === "mathml" ? `<math>${e}</math>` : e
      );
      const a = _l.content;
      if (o === "svg" || o === "mathml") {
        const l = a.firstChild;
        for (; l.firstChild; )
          a.appendChild(l.firstChild);
        a.removeChild(l);
      }
      t.insertBefore(a, n);
    }
    return [
      // first
      s ? s.nextSibling : t.firstChild,
      // last
      n ? n.previousSibling : t.lastChild
    ];
  }
}, yn = "transition", zo = "animation", dr = Symbol("_vtc"), wd = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, Nh = /* @__PURE__ */ We(
  {},
  Rc,
  wd
), $h = (e) => (e.displayName = "Transition", e.props = Nh, e), Sa = /* @__PURE__ */ $h(
  (e, { slots: t }) => U(pm, Th(e), t)
), jn = (e, t = []) => {
  ne(e) ? e.forEach((n) => n(...t)) : e && e(...t);
}, El = (e) => e ? ne(e) ? e.some((t) => t.length > 1) : e.length > 1 : !1;
function Th(e) {
  const t = {};
  for (const g in e)
    g in wd || (t[g] = e[g]);
  if (e.css === !1)
    return t;
  const {
    name: n = "v",
    type: o,
    duration: r,
    enterFromClass: i = `${n}-enter-from`,
    enterActiveClass: s = `${n}-enter-active`,
    enterToClass: a = `${n}-enter-to`,
    appearFromClass: l = i,
    appearActiveClass: c = s,
    appearToClass: u = a,
    leaveFromClass: d = `${n}-leave-from`,
    leaveActiveClass: f = `${n}-leave-active`,
    leaveToClass: p = `${n}-leave-to`
  } = e, v = Ph(r), w = v && v[0], _ = v && v[1], {
    onBeforeEnter: C,
    onEnter: S,
    onEnterCancelled: N,
    onLeave: m,
    onLeaveCancelled: y,
    onBeforeAppear: x = C,
    onAppear: k = S,
    onAppearCancelled: D = N
  } = t, E = (g, R, M) => {
    qn(g, R ? u : a), qn(g, R ? c : s), M && M();
  }, O = (g, R) => {
    g._isLeaving = !1, qn(g, d), qn(g, p), qn(g, f), R && R();
  }, A = (g) => (R, M) => {
    const G = g ? k : S, Q = () => E(R, g, M);
    jn(G, [R, Q]), xl(() => {
      qn(R, g ? l : i), wn(R, g ? u : a), El(G) || kl(R, o, w, Q);
    });
  };
  return We(t, {
    onBeforeEnter(g) {
      jn(C, [g]), wn(g, i), wn(g, s);
    },
    onBeforeAppear(g) {
      jn(x, [g]), wn(g, l), wn(g, c);
    },
    onEnter: A(!1),
    onAppear: A(!0),
    onLeave(g, R) {
      g._isLeaving = !0;
      const M = () => O(g, R);
      wn(g, d), wn(g, f), Ah(), xl(() => {
        g._isLeaving && (qn(g, d), wn(g, p), El(m) || kl(g, o, _, M));
      }), jn(m, [g, M]);
    },
    onEnterCancelled(g) {
      E(g, !1), jn(N, [g]);
    },
    onAppearCancelled(g) {
      E(g, !0), jn(D, [g]);
    },
    onLeaveCancelled(g) {
      O(g), jn(y, [g]);
    }
  });
}
function Ph(e) {
  if (e == null)
    return null;
  if (Oe(e))
    return [is(e.enter), is(e.leave)];
  {
    const t = is(e);
    return [t, t];
  }
}
function is(e) {
  const t = Gf(e);
  return process.env.NODE_ENV !== "production" && Hp(t, "<transition> explicit duration"), t;
}
function wn(e, t) {
  t.split(/\s+/).forEach((n) => n && e.classList.add(n)), (e[dr] || (e[dr] = /* @__PURE__ */ new Set())).add(t);
}
function qn(e, t) {
  t.split(/\s+/).forEach((o) => o && e.classList.remove(o));
  const n = e[dr];
  n && (n.delete(t), n.size || (e[dr] = void 0));
}
function xl(e) {
  requestAnimationFrame(() => {
    requestAnimationFrame(e);
  });
}
let Dh = 0;
function kl(e, t, n, o) {
  const r = e._endId = ++Dh, i = () => {
    r === e._endId && o();
  };
  if (n)
    return setTimeout(i, n);
  const { type: s, timeout: a, propCount: l } = Mh(e, t);
  if (!s)
    return o();
  const c = s + "end";
  let u = 0;
  const d = () => {
    e.removeEventListener(c, f), i();
  }, f = (p) => {
    p.target === e && ++u >= l && d();
  };
  setTimeout(() => {
    u < l && d();
  }, a + 1), e.addEventListener(c, f);
}
function Mh(e, t) {
  const n = window.getComputedStyle(e), o = (v) => (n[v] || "").split(", "), r = o(`${yn}Delay`), i = o(`${yn}Duration`), s = Cl(r, i), a = o(`${zo}Delay`), l = o(`${zo}Duration`), c = Cl(a, l);
  let u = null, d = 0, f = 0;
  t === yn ? s > 0 && (u = yn, d = s, f = i.length) : t === zo ? c > 0 && (u = zo, d = c, f = l.length) : (d = Math.max(s, c), u = d > 0 ? s > c ? yn : zo : null, f = u ? u === yn ? i.length : l.length : 0);
  const p = u === yn && /\b(transform|all)(,|$)/.test(
    o(`${yn}Property`).toString()
  );
  return {
    type: u,
    timeout: d,
    propCount: f,
    hasTransform: p
  };
}
function Cl(e, t) {
  for (; e.length < t.length; )
    e = e.concat(e);
  return Math.max(...t.map((n, o) => Sl(n) + Sl(e[o])));
}
function Sl(e) {
  return e === "auto" ? 0 : Number(e.slice(0, -1).replace(",", ".")) * 1e3;
}
function Ah() {
  return document.body.offsetHeight;
}
function Vh(e, t, n) {
  const o = e[dr];
  o && (t = (t ? [t, ...o] : [...o]).join(" ")), t == null ? e.removeAttribute("class") : n ? e.setAttribute("class", t) : e.className = t;
}
const Ol = Symbol("_vod"), Rh = Symbol("_vsh");
process.env.NODE_ENV;
const Lh = Symbol(process.env.NODE_ENV !== "production" ? "CSS_VAR_TEXT" : ""), Ih = /(^|;)\s*display\s*:/;
function jh(e, t, n) {
  const o = e.style, r = Ae(n);
  let i = !1;
  if (n && !r) {
    if (t)
      if (Ae(t))
        for (const s of t.split(";")) {
          const a = s.slice(0, s.indexOf(":")).trim();
          n[a] == null && ti(o, a, "");
        }
      else
        for (const s in t)
          n[s] == null && ti(o, s, "");
    for (const s in n)
      s === "display" && (i = !0), ti(o, s, n[s]);
  } else if (r) {
    if (t !== n) {
      const s = o[Lh];
      s && (n += ";" + s), o.cssText = n, i = Ih.test(n);
    }
  } else t && e.removeAttribute("style");
  Ol in e && (e[Ol] = i ? o.display : "", e[Rh] && (o.display = "none"));
}
const qh = /[^\\];\s*$/, Nl = /\s*!important$/;
function ti(e, t, n) {
  if (ne(n))
    n.forEach((o) => ti(e, t, o));
  else if (n == null && (n = ""), process.env.NODE_ENV !== "production" && qh.test(n) && cn(
    `Unexpected semicolon at the end of '${t}' style value: '${n}'`
  ), t.startsWith("--"))
    e.setProperty(t, n);
  else {
    const o = Fh(e, t);
    Nl.test(n) ? e.setProperty(
      dn(o),
      n.replace(Nl, ""),
      "important"
    ) : e[o] = n;
  }
}
const $l = ["Webkit", "Moz", "ms"], ss = {};
function Fh(e, t) {
  const n = ss[t];
  if (n)
    return n;
  let o = kt(t);
  if (o !== "filter" && o in e)
    return ss[t] = o;
  o = so(o);
  for (let r = 0; r < $l.length; r++) {
    const i = $l[r] + o;
    if (i in e)
      return ss[t] = i;
  }
  return t;
}
const Tl = "http://www.w3.org/1999/xlink";
function Pl(e, t, n, o, r, i = ap(t)) {
  o && t.startsWith("xlink:") ? n == null ? e.removeAttributeNS(Tl, t.slice(6, t.length)) : e.setAttributeNS(Tl, t, n) : n == null || i && !Zu(n) ? e.removeAttribute(t) : e.setAttribute(
    t,
    i ? "" : An(n) ? String(n) : n
  );
}
function Wh(e, t, n, o) {
  if (t === "innerHTML" || t === "textContent") {
    n != null && (e[t] = t === "innerHTML" ? yd(n) : n);
    return;
  }
  const r = e.tagName;
  if (t === "value" && r !== "PROGRESS" && // custom elements may use _value internally
  !r.includes("-")) {
    const s = r === "OPTION" ? e.getAttribute("value") || "" : e.value, a = n == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      e.type === "checkbox" ? "on" : ""
    ) : String(n);
    (s !== a || !("_value" in e)) && (e.value = a), n == null && e.removeAttribute(t), e._value = n;
    return;
  }
  let i = !1;
  if (n === "" || n == null) {
    const s = typeof e[t];
    s === "boolean" ? n = Zu(n) : n == null && s === "string" ? (n = "", i = !0) : s === "number" && (n = 0, i = !0);
  }
  try {
    e[t] = n;
  } catch (s) {
    process.env.NODE_ENV !== "production" && !i && cn(
      `Failed setting prop "${t}" on <${r.toLowerCase()}>: value ${n} is invalid.`,
      s
    );
  }
  i && e.removeAttribute(t);
}
function yo(e, t, n, o) {
  e.addEventListener(t, n, o);
}
function Bh(e, t, n, o) {
  e.removeEventListener(t, n, o);
}
const Dl = Symbol("_vei");
function zh(e, t, n, o, r = null) {
  const i = e[Dl] || (e[Dl] = {}), s = i[t];
  if (o && s)
    s.value = process.env.NODE_ENV !== "production" ? Al(o, t) : o;
  else {
    const [a, l] = Hh(t);
    if (o) {
      const c = i[t] = Yh(
        process.env.NODE_ENV !== "production" ? Al(o, t) : o,
        r
      );
      yo(e, a, c, l);
    } else s && (Bh(e, a, s, l), i[t] = void 0);
  }
}
const Ml = /(?:Once|Passive|Capture)$/;
function Hh(e) {
  let t;
  if (Ml.test(e)) {
    t = {};
    let o;
    for (; o = e.match(Ml); )
      e = e.slice(0, e.length - o[0].length), t[o[0].toLowerCase()] = !0;
  }
  return [e[2] === ":" ? e.slice(3) : dn(e.slice(2)), t];
}
let as = 0;
const Uh = /* @__PURE__ */ Promise.resolve(), Kh = () => as || (Uh.then(() => as = 0), as = Date.now());
function Yh(e, t) {
  const n = (o) => {
    if (!o._vts)
      o._vts = Date.now();
    else if (o._vts <= n.attached)
      return;
    Wt(
      Gh(o, n.value),
      t,
      5,
      [o]
    );
  };
  return n.value = e, n.attached = Kh(), n;
}
function Al(e, t) {
  return se(e) || ne(e) ? e : (cn(
    `Wrong type passed as event handler to ${t} - did you forget @ or : in front of your prop?
Expected function or array of functions, received type ${typeof e}.`
  ), Ke);
}
function Gh(e, t) {
  if (ne(t)) {
    const n = e.stopImmediatePropagation;
    return e.stopImmediatePropagation = () => {
      n.call(e), e._stopped = !0;
    }, t.map(
      (o) => (r) => !r._stopped && o && o(r)
    );
  } else
    return t;
}
const Vl = (e) => e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && // lowercase letter
e.charCodeAt(2) > 96 && e.charCodeAt(2) < 123, Qh = (e, t, n, o, r, i) => {
  const s = r === "svg";
  t === "class" ? Vh(e, o, s) : t === "style" ? jh(e, n, o) : wr(t) ? ii(t) || zh(e, t, n, o, i) : (t[0] === "." ? (t = t.slice(1), !0) : t[0] === "^" ? (t = t.slice(1), !1) : Xh(e, t, o, s)) ? (Wh(e, t, o), !e.tagName.includes("-") && (t === "value" || t === "checked" || t === "selected") && Pl(e, t, o, s, i, t !== "value")) : (t === "true-value" ? e._trueValue = o : t === "false-value" && (e._falseValue = o), Pl(e, t, o, s));
};
function Xh(e, t, n, o) {
  if (o)
    return !!(t === "innerHTML" || t === "textContent" || t in e && Vl(t) && se(n));
  if (t === "spellcheck" || t === "draggable" || t === "translate" || t === "form" || t === "list" && e.tagName === "INPUT" || t === "type" && e.tagName === "TEXTAREA")
    return !1;
  if (t === "width" || t === "height") {
    const r = e.tagName;
    if (r === "IMG" || r === "VIDEO" || r === "CANVAS" || r === "SOURCE")
      return !1;
  }
  return Vl(t) && Ae(n) ? !1 : !!(t in e || e._isVueCE && (/[A-Z]/.test(t) || !Ae(n)));
}
const Rl = (e) => {
  const t = e.props["onUpdate:modelValue"] || !1;
  return ne(t) ? (n) => go(t, n) : t;
};
function Jh(e) {
  e.target.composing = !0;
}
function Ll(e) {
  const t = e.target;
  t.composing && (t.composing = !1, t.dispatchEvent(new Event("input")));
}
const ls = Symbol("_assign"), Zh = {
  created(e, { modifiers: { lazy: t, trim: n, number: o } }, r) {
    e[ls] = Rl(r);
    const i = o || r.props && r.props.type === "number";
    yo(e, t ? "change" : "input", (s) => {
      if (s.target.composing) return;
      let a = e.value;
      n && (a = a.trim()), i && (a = ks(a)), e[ls](a);
    }), n && yo(e, "change", () => {
      e.value = e.value.trim();
    }), t || (yo(e, "compositionstart", Jh), yo(e, "compositionend", Ll), yo(e, "change", Ll));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(e, { value: t }) {
    e.value = t ?? "";
  },
  beforeUpdate(e, { value: t, oldValue: n, modifiers: { lazy: o, trim: r, number: i } }, s) {
    if (e[ls] = Rl(s), e.composing) return;
    const a = (i || e.type === "number") && !/^0\d/.test(e.value) ? ks(e.value) : e.value, l = t ?? "";
    a !== l && (document.activeElement === e && e.type !== "range" && (o && t === n || r && e.value.trim() === l) || (e.value = l));
  }
}, ev = ["ctrl", "shift", "alt", "meta"], tv = {
  stop: (e) => e.stopPropagation(),
  prevent: (e) => e.preventDefault(),
  self: (e) => e.target !== e.currentTarget,
  ctrl: (e) => !e.ctrlKey,
  shift: (e) => !e.shiftKey,
  alt: (e) => !e.altKey,
  meta: (e) => !e.metaKey,
  left: (e) => "button" in e && e.button !== 0,
  middle: (e) => "button" in e && e.button !== 1,
  right: (e) => "button" in e && e.button !== 2,
  exact: (e, t) => ev.some((n) => e[`${n}Key`] && !t.includes(n))
}, nv = (e, t) => {
  const n = e._withMods || (e._withMods = {}), o = t.join(".");
  return n[o] || (n[o] = (r, ...i) => {
    for (let s = 0; s < t.length; s++) {
      const a = tv[t[s]];
      if (a && a(r, t)) return;
    }
    return e(r, ...i);
  });
}, ov = /* @__PURE__ */ We({ patchProp: Qh }, Oh);
let Il;
function rv() {
  return Il || (Il = Qm(ov));
}
const Ws = (...e) => {
  const t = rv().createApp(...e);
  process.env.NODE_ENV !== "production" && (sv(t), av(t));
  const { mount: n } = t;
  return t.mount = (o) => {
    const r = lv(o);
    if (!r) return;
    const i = t._component;
    !se(i) && !i.render && !i.template && (i.template = r.innerHTML), r.nodeType === 1 && (r.textContent = "");
    const s = n(r, !1, iv(r));
    return r instanceof Element && (r.removeAttribute("v-cloak"), r.setAttribute("data-v-app", "")), s;
  }, t;
};
function iv(e) {
  if (e instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && e instanceof MathMLElement)
    return "mathml";
}
function sv(e) {
  Object.defineProperty(e.config, "isNativeTag", {
    value: (t) => op(t) || rp(t) || ip(t),
    writable: !1
  });
}
function av(e) {
  {
    const t = e.config.isCustomElement;
    Object.defineProperty(e.config, "isCustomElement", {
      get() {
        return t;
      },
      set() {
        cn(
          "The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead."
        );
      }
    });
    const n = e.config.compilerOptions, o = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
    Object.defineProperty(e.config, "compilerOptions", {
      get() {
        return cn(o), n;
      },
      set() {
        cn(o);
      }
    });
  }
}
function lv(e) {
  if (Ae(e)) {
    const t = document.querySelector(e);
    return process.env.NODE_ENV !== "production" && !t && cn(
      `Failed to mount app: mount target selector "${e}" returned null.`
    ), t;
  }
  return process.env.NODE_ENV !== "production" && window.ShadowRoot && e instanceof window.ShadowRoot && e.mode === "closed" && cn(
    'mounting on a ShadowRoot with `{mode: "closed"}` may lead to unpredictable bugs'
  ), e;
}
/**
* vue v3.5.4
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function uv() {
  kh();
}
process.env.NODE_ENV !== "production" && uv();
let _d = (e, t, n, o) => {
}, Ed = (e, t, n) => {
}, xd = (e) => {
};
const cv = {
  __isTeleport: !0,
  process(e, t, n, o, r, i, s, a, l, c) {
    const { p: u, mt: d, um: f } = c;
    Ed = (p, v, w) => {
      d(
        p,
        v,
        w,
        r,
        null,
        !1,
        a,
        !1
      ), dv(p);
    }, _d = (p, v, w, _) => {
      u(
        p,
        v,
        w,
        _,
        null,
        null,
        !1,
        a,
        !1
      );
    }, xd = (p) => {
      f(
        p,
        r,
        i,
        !0,
        // @ts-ignore
        !!p.dynamicChildren
      );
    };
  },
  remove(e, t, n, o, { um: r }) {
    r(
      // @ts-ignore
      e.children[0],
      t,
      n,
      !0,
      // @ts-ignore
      !!e.children[0].dynamicChildren
    );
  }
};
function dv(e) {
  const t = e.ctx;
  if (t && t.ut) {
    let n = e.children[0].el;
    for (; n !== e.targetAnchor; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", t.uid), n = n.nextSibling;
    t.ut();
  }
}
let fv = 0;
const Oo = {}, V1 = (e) => {
  const t = "p" + fv++, n = U(
    e.component,
    { ...e.attrs, "component-id": t, portalSlots: e.slots }
  );
  return Oo[t] = { ...e, vnode: n }, Ed(n, e.getContainer(), e.getAnchor()), { id: t, vm: n };
}, R1 = (e, t) => {
  const n = Oo[e];
  n.vnode.props = {}, n.attrs = t;
  const o = U(n.component, { ...n.attrs, "component-id": e, portalSlots: n.slots });
  _d(n.vnode, o, n.getContainer(), n.getAnchor()), Oo[e].vnode = o;
}, L1 = (e) => {
  xd(Oo[e].vnode), delete Oo[e];
}, pv = (e, t) => Oo[e].requestSlot(t);
let kd = () => U(ze, "anchor");
const mv = (e) => {
  e === "vue2" && (kd = () => U("div", []));
}, Wi = (e, t) => {
  if (e.slot)
    return e.slot();
  const n = pv(e.componentId, e.name);
  if (!n)
    return t.slots.default ? t.slots.default() : [];
  const o = kd();
  return n({
    name: e.name || "default",
    // @ts-ignore
    getAnchor: () => o.el,
    // @ts-ignore
    getContainer: () => o.el.parentElement,
    attrs: t.attrs
  }), o;
};
Wi.props = {
  name: {
    type: String,
    default: "default"
  },
  componentId: {
    type: String
  },
  slot: {
    default: () => {
    }
  }
};
const hv = { class: "item" }, vv = /* @__PURE__ */ Ee({
  __name: "TestItem",
  props: {
    title: { type: String, default: "" }
  },
  emits: {
    customClick: null,
    renderFinished: null
  },
  setup(e, { emit: t }) {
    const n = e, o = t;
    return Ct(() => {
      o("renderFinished", null);
    }), (r, i) => (X(), ue("div", hv, [
      ce("span", null, De(n.title), 1),
      le(re(Wi), {
        "component-id": r.$attrs["component-id"],
        name: "default"
      }, null, 8, ["component-id"]),
      ce("button", {
        onClick: i[0] || (i[0] = (s) => o("customClick"))
      }, " Click me ")
    ]));
  }
}), je = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, r] of t)
    n[o] = r;
  return n;
}, I1 = /* @__PURE__ */ je(vv, [["__scopeId", "data-v-21944908"]]), gv = { class: "ws-delimiter" }, bv = /* @__PURE__ */ Ee({
  __name: "WsDelimiter",
  props: {
    text: {
      type: String,
      default: ""
    },
    textClass: {
      type: String,
      default: ""
    },
    lineClass: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    return (t, n) => (X(), ue("div", gv, [
      ce("div", {
        class: pt(["ws-delimiter__line", e.lineClass])
      }, null, 2),
      e.text ? (X(), ue("div", {
        key: 0,
        class: pt(["ws-delimiter__text ws-typo-xs", e.textClass])
      }, De(t.$t(e.text)), 3)) : Pe("", !0),
      e.text ? (X(), ue("div", {
        key: 1,
        class: pt(["ws-delimiter__line", e.lineClass])
      }, null, 2)) : Pe("", !0)
    ]));
  }
}), j1 = /* @__PURE__ */ je(bv, [["__scopeId", "data-v-01861062"]]), yv = {}, wv = { class: "ws-typography horizontal-divider col-12" };
function _v(e, t) {
  return X(), ue("div", wv, t[0] || (t[0] = [
    ce("div", { class: "horizontal-line" }, null, -1)
  ]));
}
const q1 = /* @__PURE__ */ je(yv, [["render", _v], ["__scopeId", "data-v-e91930be"]]), Io = {
  dark: {
    type: Boolean,
    default: null
  }
};
function jo(e, t) {
  return V(() => e.dark === null ? t.dark.isActive : e.dark);
}
const Bs = {
  xs: 18,
  sm: 24,
  md: 32,
  lg: 38,
  xl: 46
}, Oa = {
  size: String
};
function Na(e, t = Bs) {
  return V(() => e.size !== void 0 ? { fontSize: e.size in t ? `${t[e.size]}px` : e.size } : null);
}
const wt = (e) => ca(/* @__PURE__ */ Ee(e)), Ev = (e) => ca(e);
function Pt(e, t) {
  return e !== void 0 && e() || t;
}
function xv(e, t) {
  if (e !== void 0) {
    const n = e();
    if (n != null)
      return n.slice();
  }
  return t;
}
function wo(e, t) {
  return e !== void 0 ? t.concat(e()) : t;
}
const kv = {
  xs: 2,
  sm: 4,
  md: 6,
  lg: 10,
  xl: 14
};
function jl(e, t, n) {
  return {
    transform: t === !0 ? `translateX(${n.lang.rtl === !0 ? "-" : ""}100%) scale3d(${-e},1,1)` : `scale3d(${e},1,1)`
  };
}
const Cv = wt({
  name: "QLinearProgress",
  props: {
    ...Io,
    ...Oa,
    value: {
      type: Number,
      default: 0
    },
    buffer: Number,
    color: String,
    trackColor: String,
    reverse: Boolean,
    stripe: Boolean,
    indeterminate: Boolean,
    query: Boolean,
    rounded: Boolean,
    animationSpeed: {
      type: [String, Number],
      default: 2100
    },
    instantFeedback: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: n } = Fe(), o = jo(e, n.$q), r = Na(e, kv), i = V(() => e.indeterminate === !0 || e.query === !0), s = V(() => e.reverse !== e.query), a = V(() => ({
      ...r.value !== null ? r.value : {},
      "--q-linear-progress-speed": `${e.animationSpeed}ms`
    })), l = V(
      () => "q-linear-progress" + (e.color !== void 0 ? ` text-${e.color}` : "") + (e.reverse === !0 || e.query === !0 ? " q-linear-progress--reverse" : "") + (e.rounded === !0 ? " rounded-borders" : "")
    ), c = V(() => jl(e.buffer !== void 0 ? e.buffer : 1, s.value, n.$q)), u = V(() => `with${e.instantFeedback === !0 ? "out" : ""}-transition`), d = V(
      () => `q-linear-progress__track absolute-full q-linear-progress__track--${u.value} q-linear-progress__track--${o.value === !0 ? "dark" : "light"}` + (e.trackColor !== void 0 ? ` bg-${e.trackColor}` : "")
    ), f = V(() => jl(i.value === !0 ? 1 : e.value, s.value, n.$q)), p = V(
      () => `q-linear-progress__model absolute-full q-linear-progress__model--${u.value} q-linear-progress__model--${i.value === !0 ? "in" : ""}determinate`
    ), v = V(() => ({ width: `${e.value * 100}%` })), w = V(
      () => `q-linear-progress__stripe absolute-${e.reverse === !0 ? "right" : "left"} q-linear-progress__stripe--${u.value}`
    );
    return () => {
      const _ = [
        U("div", {
          class: d.value,
          style: c.value
        }),
        U("div", {
          class: p.value,
          style: f.value
        })
      ];
      return e.stripe === !0 && i.value === !1 && _.push(
        U("div", {
          class: w.value,
          style: v.value
        })
      ), U("div", {
        class: l.value,
        style: a.value,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 1,
        "aria-valuenow": e.indeterminate === !0 ? void 0 : e.value
      }, wo(t.default, _));
    };
  }
}), Sv = /* @__PURE__ */ Ee({
  __name: "WsLinearProgress",
  props: {
    modelValue: { type: Number, default: void 0 },
    size: { type: String, default: "" },
    color: { type: String, default: "" }
  },
  setup(e) {
    return (t, n) => (X(), He(re(Cv), {
      color: e.color ? e.color : "focus",
      value: e.modelValue,
      size: e.size,
      class: pt([
        "ws-linear-progress",
        {
          "ws-linear-progress--gradient-green": isNaN(e.modelValue),
          "ws-linear-progress--gradient-primary": e.color === "primary" && isNaN(e.modelValue)
        }
      ])
    }, null, 8, ["color", "value", "size", "class"]));
  }
}), F1 = /* @__PURE__ */ je(Sv, [["__scopeId", "data-v-ce164aac"]]);
/*!
  * vue-tippy v6.5.0
  * (c) 2024 
  * @license MIT
  */
var bt = "top", Mt = "bottom", At = "right", yt = "left", $a = "auto", Nr = [bt, Mt, At, yt], No = "start", fr = "end", Ov = "clippingParents", Cd = "viewport", Ho = "popper", Nv = "reference", ql = /* @__PURE__ */ Nr.reduce(function(e, t) {
  return e.concat([t + "-" + No, t + "-" + fr]);
}, []), Sd = /* @__PURE__ */ [].concat(Nr, [$a]).reduce(function(e, t) {
  return e.concat([t, t + "-" + No, t + "-" + fr]);
}, []), $v = "beforeRead", Tv = "read", Pv = "afterRead", Dv = "beforeMain", Mv = "main", Av = "afterMain", Vv = "beforeWrite", Rv = "write", Lv = "afterWrite", Iv = [$v, Tv, Pv, Dv, Mv, Av, Vv, Rv, Lv];
function Jt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function zt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function $o(e) {
  var t = zt(e).Element;
  return e instanceof t || e instanceof Element;
}
function Dt(e) {
  var t = zt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function Od(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = zt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function jv(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(n) {
    var o = t.styles[n] || {}, r = t.attributes[n] || {}, i = t.elements[n];
    !Dt(i) || !Jt(i) || (Object.assign(i.style, o), Object.keys(r).forEach(function(s) {
      var a = r[s];
      a === !1 ? i.removeAttribute(s) : i.setAttribute(s, a === !0 ? "" : a);
    }));
  });
}
function qv(e) {
  var t = e.state, n = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, n.popper), t.styles = n, t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow), function() {
    Object.keys(t.elements).forEach(function(o) {
      var r = t.elements[o], i = t.attributes[o] || {}, s = Object.keys(t.styles.hasOwnProperty(o) ? t.styles[o] : n[o]), a = s.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Dt(r) || !Jt(r) || (Object.assign(r.style, a), Object.keys(i).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
var Nd = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: jv,
  effect: qv,
  requires: ["computeStyles"]
};
function Qt(e) {
  return e.split("-")[0];
}
var to = Math.max, vi = Math.min, To = Math.round;
function Po(e, t) {
  t === void 0 && (t = !1);
  var n = e.getBoundingClientRect(), o = 1, r = 1;
  if (Dt(e) && t) {
    var i = e.offsetHeight, s = e.offsetWidth;
    s > 0 && (o = To(n.width) / s || 1), i > 0 && (r = To(n.height) / i || 1);
  }
  return {
    width: n.width / o,
    height: n.height / r,
    top: n.top / r,
    right: n.right / o,
    bottom: n.bottom / r,
    left: n.left / o,
    x: n.left / o,
    y: n.top / r
  };
}
function Ta(e) {
  var t = Po(e), n = e.offsetWidth, o = e.offsetHeight;
  return Math.abs(t.width - n) <= 1 && (n = t.width), Math.abs(t.height - o) <= 1 && (o = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: n,
    height: o
  };
}
function $d(e, t) {
  var n = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (n && Od(n)) {
    var o = t;
    do {
      if (o && e.isSameNode(o))
        return !0;
      o = o.parentNode || o.host;
    } while (o);
  }
  return !1;
}
function Zt(e) {
  return zt(e).getComputedStyle(e);
}
function Fv(e) {
  return ["table", "td", "th"].indexOf(Jt(e)) >= 0;
}
function Vn(e) {
  return (($o(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Bi(e) {
  return Jt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (Od(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    Vn(e)
  );
}
function Fl(e) {
  return !Dt(e) || // https://github.com/popperjs/popper-core/issues/837
  Zt(e).position === "fixed" ? null : e.offsetParent;
}
function Wv(e) {
  var t = navigator.userAgent.toLowerCase().indexOf("firefox") !== -1, n = navigator.userAgent.indexOf("Trident") !== -1;
  if (n && Dt(e)) {
    var o = Zt(e);
    if (o.position === "fixed")
      return null;
  }
  for (var r = Bi(e); Dt(r) && ["html", "body"].indexOf(Jt(r)) < 0; ) {
    var i = Zt(r);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function $r(e) {
  for (var t = zt(e), n = Fl(e); n && Fv(n) && Zt(n).position === "static"; )
    n = Fl(n);
  return n && (Jt(n) === "html" || Jt(n) === "body" && Zt(n).position === "static") ? t : n || Wv(e) || t;
}
function Pa(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function tr(e, t, n) {
  return to(e, vi(t, n));
}
function Bv(e, t, n) {
  var o = tr(e, t, n);
  return o > n ? n : o;
}
function Td() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function Pd(e) {
  return Object.assign({}, Td(), e);
}
function Dd(e, t) {
  return t.reduce(function(n, o) {
    return n[o] = e, n;
  }, {});
}
var zv = function(t, n) {
  return t = typeof t == "function" ? t(Object.assign({}, n.rects, {
    placement: n.placement
  })) : t, Pd(typeof t != "number" ? t : Dd(t, Nr));
};
function Hv(e) {
  var t, n = e.state, o = e.name, r = e.options, i = n.elements.arrow, s = n.modifiersData.popperOffsets, a = Qt(n.placement), l = Pa(a), c = [yt, At].indexOf(a) >= 0, u = c ? "height" : "width";
  if (!(!i || !s)) {
    var d = zv(r.padding, n), f = Ta(i), p = l === "y" ? bt : yt, v = l === "y" ? Mt : At, w = n.rects.reference[u] + n.rects.reference[l] - s[l] - n.rects.popper[u], _ = s[l] - n.rects.reference[l], C = $r(i), S = C ? l === "y" ? C.clientHeight || 0 : C.clientWidth || 0 : 0, N = w / 2 - _ / 2, m = d[p], y = S - f[u] - d[v], x = S / 2 - f[u] / 2 + N, k = tr(m, x, y), D = l;
    n.modifiersData[o] = (t = {}, t[D] = k, t.centerOffset = k - x, t);
  }
}
function Uv(e) {
  var t = e.state, n = e.options, o = n.element, r = o === void 0 ? "[data-popper-arrow]" : o;
  r != null && (typeof r == "string" && (r = t.elements.popper.querySelector(r), !r) || $d(t.elements.popper, r) && (t.elements.arrow = r));
}
var Kv = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: Hv,
  effect: Uv,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Do(e) {
  return e.split("-")[1];
}
var Yv = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function Gv(e) {
  var t = e.x, n = e.y, o = window, r = o.devicePixelRatio || 1;
  return {
    x: To(t * r) / r || 0,
    y: To(n * r) / r || 0
  };
}
function Wl(e) {
  var t, n = e.popper, o = e.popperRect, r = e.placement, i = e.variation, s = e.offsets, a = e.position, l = e.gpuAcceleration, c = e.adaptive, u = e.roundOffsets, d = e.isFixed, f = u === !0 ? Gv(s) : typeof u == "function" ? u(s) : s, p = f.x, v = p === void 0 ? 0 : p, w = f.y, _ = w === void 0 ? 0 : w, C = s.hasOwnProperty("x"), S = s.hasOwnProperty("y"), N = yt, m = bt, y = window;
  if (c) {
    var x = $r(n), k = "clientHeight", D = "clientWidth";
    if (x === zt(n) && (x = Vn(n), Zt(x).position !== "static" && a === "absolute" && (k = "scrollHeight", D = "scrollWidth")), x = x, r === bt || (r === yt || r === At) && i === fr) {
      m = Mt;
      var E = d && y.visualViewport ? y.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        x[k]
      );
      _ -= E - o.height, _ *= l ? 1 : -1;
    }
    if (r === yt || (r === bt || r === Mt) && i === fr) {
      N = At;
      var O = d && y.visualViewport ? y.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        x[D]
      );
      v -= O - o.width, v *= l ? 1 : -1;
    }
  }
  var A = Object.assign({
    position: a
  }, c && Yv);
  if (l) {
    var g;
    return Object.assign({}, A, (g = {}, g[m] = S ? "0" : "", g[N] = C ? "0" : "", g.transform = (y.devicePixelRatio || 1) <= 1 ? "translate(" + v + "px, " + _ + "px)" : "translate3d(" + v + "px, " + _ + "px, 0)", g));
  }
  return Object.assign({}, A, (t = {}, t[m] = S ? _ + "px" : "", t[N] = C ? v + "px" : "", t.transform = "", t));
}
function Qv(e) {
  var t = e.state, n = e.options, o = n.gpuAcceleration, r = o === void 0 ? !0 : o, i = n.adaptive, s = i === void 0 ? !0 : i, a = n.roundOffsets, l = a === void 0 ? !0 : a, c = {
    placement: Qt(t.placement),
    variation: Do(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: r,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Wl(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: s,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Wl(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
var Xv = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: Qv,
  data: {}
}, Fr = {
  passive: !0
};
function Jv(e) {
  var t = e.state, n = e.instance, o = e.options, r = o.scroll, i = r === void 0 ? !0 : r, s = o.resize, a = s === void 0 ? !0 : s, l = zt(t.elements.popper), c = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, Fr);
  }), a && l.addEventListener("resize", n.update, Fr), function() {
    i && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, Fr);
    }), a && l.removeEventListener("resize", n.update, Fr);
  };
}
var Zv = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: Jv,
  data: {}
}, eg = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function ni(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return eg[t];
  });
}
var tg = {
  start: "end",
  end: "start"
};
function Bl(e) {
  return e.replace(/start|end/g, function(t) {
    return tg[t];
  });
}
function Da(e) {
  var t = zt(e), n = t.pageXOffset, o = t.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: o
  };
}
function Ma(e) {
  return Po(Vn(e)).left + Da(e).scrollLeft;
}
function ng(e) {
  var t = zt(e), n = Vn(e), o = t.visualViewport, r = n.clientWidth, i = n.clientHeight, s = 0, a = 0;
  return o && (r = o.width, i = o.height, /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || (s = o.offsetLeft, a = o.offsetTop)), {
    width: r,
    height: i,
    x: s + Ma(e),
    y: a
  };
}
function og(e) {
  var t, n = Vn(e), o = Da(e), r = (t = e.ownerDocument) == null ? void 0 : t.body, i = to(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), s = to(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), a = -o.scrollLeft + Ma(e), l = -o.scrollTop;
  return Zt(r || n).direction === "rtl" && (a += to(n.clientWidth, r ? r.clientWidth : 0) - i), {
    width: i,
    height: s,
    x: a,
    y: l
  };
}
function Aa(e) {
  var t = Zt(e), n = t.overflow, o = t.overflowX, r = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + o);
}
function Md(e) {
  return ["html", "body", "#document"].indexOf(Jt(e)) >= 0 ? e.ownerDocument.body : Dt(e) && Aa(e) ? e : Md(Bi(e));
}
function nr(e, t) {
  var n;
  t === void 0 && (t = []);
  var o = Md(e), r = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = zt(o), s = r ? [i].concat(i.visualViewport || [], Aa(o) ? o : []) : o, a = t.concat(s);
  return r ? a : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    a.concat(nr(Bi(s)))
  );
}
function zs(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function rg(e) {
  var t = Po(e);
  return t.top = t.top + e.clientTop, t.left = t.left + e.clientLeft, t.bottom = t.top + e.clientHeight, t.right = t.left + e.clientWidth, t.width = e.clientWidth, t.height = e.clientHeight, t.x = t.left, t.y = t.top, t;
}
function zl(e, t) {
  return t === Cd ? zs(ng(e)) : $o(t) ? rg(t) : zs(og(Vn(e)));
}
function ig(e) {
  var t = nr(Bi(e)), n = ["absolute", "fixed"].indexOf(Zt(e).position) >= 0, o = n && Dt(e) ? $r(e) : e;
  return $o(o) ? t.filter(function(r) {
    return $o(r) && $d(r, o) && Jt(r) !== "body" && (n ? Zt(r).position !== "static" : !0);
  }) : [];
}
function sg(e, t, n) {
  var o = t === "clippingParents" ? ig(e) : [].concat(t), r = [].concat(o, [n]), i = r[0], s = r.reduce(function(a, l) {
    var c = zl(e, l);
    return a.top = to(c.top, a.top), a.right = vi(c.right, a.right), a.bottom = vi(c.bottom, a.bottom), a.left = to(c.left, a.left), a;
  }, zl(e, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Ad(e) {
  var t = e.reference, n = e.element, o = e.placement, r = o ? Qt(o) : null, i = o ? Do(o) : null, s = t.x + t.width / 2 - n.width / 2, a = t.y + t.height / 2 - n.height / 2, l;
  switch (r) {
    case bt:
      l = {
        x: s,
        y: t.y - n.height
      };
      break;
    case Mt:
      l = {
        x: s,
        y: t.y + t.height
      };
      break;
    case At:
      l = {
        x: t.x + t.width,
        y: a
      };
      break;
    case yt:
      l = {
        x: t.x - n.width,
        y: a
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var c = r ? Pa(r) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (i) {
      case No:
        l[c] = l[c] - (t[u] / 2 - n[u] / 2);
        break;
      case fr:
        l[c] = l[c] + (t[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function pr(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = o === void 0 ? e.placement : o, i = n.boundary, s = i === void 0 ? Ov : i, a = n.rootBoundary, l = a === void 0 ? Cd : a, c = n.elementContext, u = c === void 0 ? Ho : c, d = n.altBoundary, f = d === void 0 ? !1 : d, p = n.padding, v = p === void 0 ? 0 : p, w = Pd(typeof v != "number" ? v : Dd(v, Nr)), _ = u === Ho ? Nv : Ho, C = e.rects.popper, S = e.elements[f ? _ : u], N = sg($o(S) ? S : S.contextElement || Vn(e.elements.popper), s, l), m = Po(e.elements.reference), y = Ad({
    reference: m,
    element: C,
    strategy: "absolute",
    placement: r
  }), x = zs(Object.assign({}, C, y)), k = u === Ho ? x : m, D = {
    top: N.top - k.top + w.top,
    bottom: k.bottom - N.bottom + w.bottom,
    left: N.left - k.left + w.left,
    right: k.right - N.right + w.right
  }, E = e.modifiersData.offset;
  if (u === Ho && E) {
    var O = E[r];
    Object.keys(D).forEach(function(A) {
      var g = [At, Mt].indexOf(A) >= 0 ? 1 : -1, R = [bt, Mt].indexOf(A) >= 0 ? "y" : "x";
      D[A] += O[R] * g;
    });
  }
  return D;
}
function ag(e, t) {
  t === void 0 && (t = {});
  var n = t, o = n.placement, r = n.boundary, i = n.rootBoundary, s = n.padding, a = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? Sd : l, u = Do(o), d = u ? a ? ql : ql.filter(function(v) {
    return Do(v) === u;
  }) : Nr, f = d.filter(function(v) {
    return c.indexOf(v) >= 0;
  });
  f.length === 0 && (f = d);
  var p = f.reduce(function(v, w) {
    return v[w] = pr(e, {
      placement: w,
      boundary: r,
      rootBoundary: i,
      padding: s
    })[Qt(w)], v;
  }, {});
  return Object.keys(p).sort(function(v, w) {
    return p[v] - p[w];
  });
}
function lg(e) {
  if (Qt(e) === $a)
    return [];
  var t = ni(e);
  return [Bl(e), t, Bl(t)];
}
function ug(e) {
  var t = e.state, n = e.options, o = e.name;
  if (!t.modifiersData[o]._skip) {
    for (var r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !0 : s, l = n.fallbackPlacements, c = n.padding, u = n.boundary, d = n.rootBoundary, f = n.altBoundary, p = n.flipVariations, v = p === void 0 ? !0 : p, w = n.allowedAutoPlacements, _ = t.options.placement, C = Qt(_), S = C === _, N = l || (S || !v ? [ni(_)] : lg(_)), m = [_].concat(N).reduce(function(Ve, Te) {
      return Ve.concat(Qt(Te) === $a ? ag(t, {
        placement: Te,
        boundary: u,
        rootBoundary: d,
        padding: c,
        flipVariations: v,
        allowedAutoPlacements: w
      }) : Te);
    }, []), y = t.rects.reference, x = t.rects.popper, k = /* @__PURE__ */ new Map(), D = !0, E = m[0], O = 0; O < m.length; O++) {
      var A = m[O], g = Qt(A), R = Do(A) === No, M = [bt, Mt].indexOf(g) >= 0, G = M ? "width" : "height", Q = pr(t, {
        placement: A,
        boundary: u,
        rootBoundary: d,
        altBoundary: f,
        padding: c
      }), $ = M ? R ? At : yt : R ? Mt : bt;
      y[G] > x[G] && ($ = ni($));
      var W = ni($), he = [];
      if (i && he.push(Q[g] <= 0), a && he.push(Q[$] <= 0, Q[W] <= 0), he.every(function(Ve) {
        return Ve;
      })) {
        E = A, D = !1;
        break;
      }
      k.set(A, he);
    }
    if (D)
      for (var fe = v ? 3 : 1, we = function(Te) {
        var xe = m.find(function(Re) {
          var ot = k.get(Re);
          if (ot)
            return ot.slice(0, Te).every(function(de) {
              return de;
            });
        });
        if (xe)
          return E = xe, "break";
      }, q = fe; q > 0; q--) {
        var ve = we(q);
        if (ve === "break") break;
      }
    t.placement !== E && (t.modifiersData[o]._skip = !0, t.placement = E, t.reset = !0);
  }
}
var cg = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: ug,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Hl(e, t, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - n.y,
    right: e.right - t.width + n.x,
    bottom: e.bottom - t.height + n.y,
    left: e.left - t.width - n.x
  };
}
function Ul(e) {
  return [bt, At, Mt, yt].some(function(t) {
    return e[t] >= 0;
  });
}
function dg(e) {
  var t = e.state, n = e.name, o = t.rects.reference, r = t.rects.popper, i = t.modifiersData.preventOverflow, s = pr(t, {
    elementContext: "reference"
  }), a = pr(t, {
    altBoundary: !0
  }), l = Hl(s, o), c = Hl(a, r, i), u = Ul(l), d = Ul(c);
  t.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: d
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": d
  });
}
var fg = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: dg
};
function pg(e, t, n) {
  var o = Qt(e), r = [yt, bt].indexOf(o) >= 0 ? -1 : 1, i = typeof n == "function" ? n(Object.assign({}, t, {
    placement: e
  })) : n, s = i[0], a = i[1];
  return s = s || 0, a = (a || 0) * r, [yt, At].indexOf(o) >= 0 ? {
    x: a,
    y: s
  } : {
    x: s,
    y: a
  };
}
function mg(e) {
  var t = e.state, n = e.options, o = e.name, r = n.offset, i = r === void 0 ? [0, 0] : r, s = Sd.reduce(function(u, d) {
    return u[d] = pg(d, t.rects, i), u;
  }, {}), a = s[t.placement], l = a.x, c = a.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += c), t.modifiersData[o] = s;
}
var hg = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: mg
};
function vg(e) {
  var t = e.state, n = e.name;
  t.modifiersData[n] = Ad({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
var gg = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: vg,
  data: {}
};
function bg(e) {
  return e === "x" ? "y" : "x";
}
function yg(e) {
  var t = e.state, n = e.options, o = e.name, r = n.mainAxis, i = r === void 0 ? !0 : r, s = n.altAxis, a = s === void 0 ? !1 : s, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, d = n.padding, f = n.tether, p = f === void 0 ? !0 : f, v = n.tetherOffset, w = v === void 0 ? 0 : v, _ = pr(t, {
    boundary: l,
    rootBoundary: c,
    padding: d,
    altBoundary: u
  }), C = Qt(t.placement), S = Do(t.placement), N = !S, m = Pa(C), y = bg(m), x = t.modifiersData.popperOffsets, k = t.rects.reference, D = t.rects.popper, E = typeof w == "function" ? w(Object.assign({}, t.rects, {
    placement: t.placement
  })) : w, O = typeof E == "number" ? {
    mainAxis: E,
    altAxis: E
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, E), A = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, g = {
    x: 0,
    y: 0
  };
  if (x) {
    if (i) {
      var R, M = m === "y" ? bt : yt, G = m === "y" ? Mt : At, Q = m === "y" ? "height" : "width", $ = x[m], W = $ + _[M], he = $ - _[G], fe = p ? -D[Q] / 2 : 0, we = S === No ? k[Q] : D[Q], q = S === No ? -D[Q] : -k[Q], ve = t.elements.arrow, Ve = p && ve ? Ta(ve) : {
        width: 0,
        height: 0
      }, Te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Td(), xe = Te[M], Re = Te[G], ot = tr(0, k[Q], Ve[Q]), de = N ? k[Q] / 2 - fe - ot - xe - O.mainAxis : we - ot - xe - O.mainAxis, lt = N ? -k[Q] / 2 + fe + ot + Re + O.mainAxis : q + ot + Re + O.mainAxis, vt = t.elements.arrow && $r(t.elements.arrow), en = vt ? m === "y" ? vt.clientTop || 0 : vt.clientLeft || 0 : 0, gn = (R = A == null ? void 0 : A[m]) != null ? R : 0, h = $ + de - gn - en, b = $ + lt - gn, T = tr(p ? vi(W, h) : W, $, p ? to(he, b) : he);
      x[m] = T, g[m] = T - $;
    }
    if (a) {
      var F, L = m === "x" ? bt : yt, I = m === "x" ? Mt : At, K = x[y], B = y === "y" ? "height" : "width", H = K + _[L], j = K - _[I], oe = [bt, yt].indexOf(C) !== -1, Y = (F = A == null ? void 0 : A[y]) != null ? F : 0, Z = oe ? H : K - k[B] - D[B] - Y + O.altAxis, ie = oe ? K + k[B] + D[B] - Y - O.altAxis : j, be = p && oe ? Bv(Z, K, ie) : tr(p ? Z : H, K, p ? ie : j);
      x[y] = be, g[y] = be - K;
    }
    t.modifiersData[o] = g;
  }
}
var wg = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: yg,
  requiresIfExists: ["offset"]
};
function _g(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function Eg(e) {
  return e === zt(e) || !Dt(e) ? Da(e) : _g(e);
}
function xg(e) {
  var t = e.getBoundingClientRect(), n = To(t.width) / e.offsetWidth || 1, o = To(t.height) / e.offsetHeight || 1;
  return n !== 1 || o !== 1;
}
function kg(e, t, n) {
  n === void 0 && (n = !1);
  var o = Dt(t), r = Dt(t) && xg(t), i = Vn(t), s = Po(e, r), a = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (o || !o && !n) && ((Jt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Aa(i)) && (a = Eg(t)), Dt(t) ? (l = Po(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Ma(i))), {
    x: s.left + a.scrollLeft - l.x,
    y: s.top + a.scrollTop - l.y,
    width: s.width,
    height: s.height
  };
}
function Cg(e) {
  var t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), o = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function r(i) {
    n.add(i.name);
    var s = [].concat(i.requires || [], i.requiresIfExists || []);
    s.forEach(function(a) {
      if (!n.has(a)) {
        var l = t.get(a);
        l && r(l);
      }
    }), o.push(i);
  }
  return e.forEach(function(i) {
    n.has(i.name) || r(i);
  }), o;
}
function Sg(e) {
  var t = Cg(e);
  return Iv.reduce(function(n, o) {
    return n.concat(t.filter(function(r) {
      return r.phase === o;
    }));
  }, []);
}
function Og(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(n) {
      Promise.resolve().then(function() {
        t = void 0, n(e());
      });
    })), t;
  };
}
function Ng(e) {
  var t = e.reduce(function(n, o) {
    var r = n[o.name];
    return n[o.name] = r ? Object.assign({}, r, o, {
      options: Object.assign({}, r.options, o.options),
      data: Object.assign({}, r.data, o.data)
    }) : o, n;
  }, {});
  return Object.keys(t).map(function(n) {
    return t[n];
  });
}
var Kl = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function Yl() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return !t.some(function(o) {
    return !(o && typeof o.getBoundingClientRect == "function");
  });
}
function $g(e) {
  e === void 0 && (e = {});
  var t = e, n = t.defaultModifiers, o = n === void 0 ? [] : n, r = t.defaultOptions, i = r === void 0 ? Kl : r;
  return function(a, l, c) {
    c === void 0 && (c = i);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Kl, i),
      modifiersData: {},
      elements: {
        reference: a,
        popper: l
      },
      attributes: {},
      styles: {}
    }, d = [], f = !1, p = {
      state: u,
      setOptions: function(C) {
        var S = typeof C == "function" ? C(u.options) : C;
        w(), u.options = Object.assign({}, i, u.options, S), u.scrollParents = {
          reference: $o(a) ? nr(a) : a.contextElement ? nr(a.contextElement) : [],
          popper: nr(l)
        };
        var N = Sg(Ng([].concat(o, u.options.modifiers)));
        return u.orderedModifiers = N.filter(function(m) {
          return m.enabled;
        }), v(), p.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var C = u.elements, S = C.reference, N = C.popper;
          if (Yl(S, N)) {
            u.rects = {
              reference: kg(S, $r(N), u.options.strategy === "fixed"),
              popper: Ta(N)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(O) {
              return u.modifiersData[O.name] = Object.assign({}, O.data);
            });
            for (var m = 0; m < u.orderedModifiers.length; m++) {
              if (u.reset === !0) {
                u.reset = !1, m = -1;
                continue;
              }
              var y = u.orderedModifiers[m], x = y.fn, k = y.options, D = k === void 0 ? {} : k, E = y.name;
              typeof x == "function" && (u = x({
                state: u,
                options: D,
                name: E,
                instance: p
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Og(function() {
        return new Promise(function(_) {
          p.forceUpdate(), _(u);
        });
      }),
      destroy: function() {
        w(), f = !0;
      }
    };
    if (!Yl(a, l))
      return p;
    p.setOptions(c).then(function(_) {
      !f && c.onFirstUpdate && c.onFirstUpdate(_);
    });
    function v() {
      u.orderedModifiers.forEach(function(_) {
        var C = _.name, S = _.options, N = S === void 0 ? {} : S, m = _.effect;
        if (typeof m == "function") {
          var y = m({
            state: u,
            name: C,
            instance: p,
            options: N
          }), x = function() {
          };
          d.push(y || x);
        }
      });
    }
    function w() {
      d.forEach(function(_) {
        return _();
      }), d = [];
    }
    return p;
  };
}
var Tg = [Zv, gg, Xv, Nd, hg, cg, wg, Kv, fg], Pg = /* @__PURE__ */ $g({
  defaultModifiers: Tg
}), Dg = "tippy-box", Vd = "tippy-content", Rd = "tippy-backdrop", Ld = "tippy-arrow", Id = "tippy-svg-arrow", Bn = {
  passive: !0,
  capture: !0
}, jd = function() {
  return document.body;
};
function us(e, t, n) {
  if (Array.isArray(e)) {
    var o = e[t];
    return o ?? (Array.isArray(n) ? n[t] : n);
  }
  return e;
}
function Va(e, t) {
  var n = {}.toString.call(e);
  return n.indexOf("[object") === 0 && n.indexOf(t + "]") > -1;
}
function qd(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function Gl(e, t) {
  if (t === 0)
    return e;
  var n;
  return function(o) {
    clearTimeout(n), n = setTimeout(function() {
      e(o);
    }, t);
  };
}
function Mg(e, t) {
  var n = Object.assign({}, e);
  return t.forEach(function(o) {
    delete n[o];
  }), n;
}
function Ag(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Un(e) {
  return [].concat(e);
}
function Ql(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Vg(e) {
  return e.filter(function(t, n) {
    return e.indexOf(t) === n;
  });
}
function Fd(e) {
  return e.split("-")[0];
}
function Mo(e) {
  return [].slice.call(e);
}
function Xl(e) {
  return Object.keys(e).reduce(function(t, n) {
    return e[n] !== void 0 && (t[n] = e[n]), t;
  }, {});
}
function no() {
  return document.createElement("div");
}
function zi(e) {
  return ["Element", "Fragment"].some(function(t) {
    return Va(e, t);
  });
}
function Rg(e) {
  return Va(e, "NodeList");
}
function Ra(e) {
  return Va(e, "MouseEvent");
}
function Lg(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function Ig(e) {
  return zi(e) ? [e] : Rg(e) ? Mo(e) : Array.isArray(e) ? e : Mo(document.querySelectorAll(e));
}
function cs(e, t) {
  e.forEach(function(n) {
    n && (n.style.transitionDuration = t + "ms");
  });
}
function mr(e, t) {
  e.forEach(function(n) {
    n && n.setAttribute("data-state", t);
  });
}
function Wd(e) {
  var t, n = Un(e), o = n[0];
  return o != null && (t = o.ownerDocument) != null && t.body ? o.ownerDocument : document;
}
function jg(e, t) {
  var n = t.clientX, o = t.clientY;
  return e.every(function(r) {
    var i = r.popperRect, s = r.popperState, a = r.props, l = a.interactiveBorder, c = Fd(s.placement), u = s.modifiersData.offset;
    if (!u)
      return !0;
    var d = c === "bottom" ? u.top.y : 0, f = c === "top" ? u.bottom.y : 0, p = c === "right" ? u.left.x : 0, v = c === "left" ? u.right.x : 0, w = i.top - o + d > l, _ = o - i.bottom - f > l, C = i.left - n + p > l, S = n - i.right - v > l;
    return w || _ || C || S;
  });
}
function ds(e, t, n) {
  var o = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    e[o](r, n);
  });
}
function Jl(e, t) {
  for (var n = t; n; ) {
    var o;
    if (e.contains(n))
      return !0;
    n = n.getRootNode == null || (o = n.getRootNode()) == null ? void 0 : o.host;
  }
  return !1;
}
var Kt = {
  isTouch: !1
}, Zl = 0;
function qg() {
  Kt.isTouch || (Kt.isTouch = !0, window.performance && document.addEventListener("mousemove", Bd));
}
function Bd() {
  var e = performance.now();
  e - Zl < 20 && (Kt.isTouch = !1, document.removeEventListener("mousemove", Bd)), Zl = e;
}
function Fg() {
  var e = document.activeElement;
  if (Lg(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function Wg() {
  document.addEventListener("touchstart", qg, Bn), window.addEventListener("blur", Fg);
}
var Bg = typeof window < "u" && typeof document < "u", zg = Bg ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, Hg = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, Ug = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, jt = Object.assign({
  appendTo: jd,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Hg, Ug), Kg = Object.keys(jt), Yg = function(t) {
  var n = Object.keys(t);
  n.forEach(function(o) {
    jt[o] = t[o];
  });
};
function zd(e) {
  var t = e.plugins || [], n = t.reduce(function(o, r) {
    var i = r.name, s = r.defaultValue;
    if (i) {
      var a;
      o[i] = e[i] !== void 0 ? e[i] : (a = jt[i]) != null ? a : s;
    }
    return o;
  }, {});
  return Object.assign({}, e, n);
}
function Gg(e, t) {
  var n = t ? Object.keys(zd(Object.assign({}, jt, {
    plugins: t
  }))) : Kg, o = n.reduce(function(r, i) {
    var s = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!s)
      return r;
    if (i === "content")
      r[i] = s;
    else
      try {
        r[i] = JSON.parse(s);
      } catch {
        r[i] = s;
      }
    return r;
  }, {});
  return o;
}
function eu(e, t) {
  var n = Object.assign({}, t, {
    content: qd(t.content, [e])
  }, t.ignoreAttributes ? {} : Gg(e, t.plugins));
  return n.aria = Object.assign({}, jt.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? t.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? t.interactive ? null : "describedby" : n.aria.content
  }, n;
}
var Qg = function() {
  return "innerHTML";
};
function Hs(e, t) {
  e[Qg()] = t;
}
function tu(e) {
  var t = no();
  return e === !0 ? t.className = Ld : (t.className = Id, zi(e) ? t.appendChild(e) : Hs(t, e)), t;
}
function nu(e, t) {
  zi(t.content) ? (Hs(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? Hs(e, t.content) : e.textContent = t.content);
}
function gi(e) {
  var t = e.firstElementChild, n = Mo(t.children);
  return {
    box: t,
    content: n.find(function(o) {
      return o.classList.contains(Vd);
    }),
    arrow: n.find(function(o) {
      return o.classList.contains(Ld) || o.classList.contains(Id);
    }),
    backdrop: n.find(function(o) {
      return o.classList.contains(Rd);
    })
  };
}
function Hd(e) {
  var t = no(), n = no();
  n.className = Dg, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var o = no();
  o.className = Vd, o.setAttribute("data-state", "hidden"), nu(o, e.props), t.appendChild(n), n.appendChild(o), r(e.props, e.props);
  function r(i, s) {
    var a = gi(t), l = a.box, c = a.content, u = a.arrow;
    s.theme ? l.setAttribute("data-theme", s.theme) : l.removeAttribute("data-theme"), typeof s.animation == "string" ? l.setAttribute("data-animation", s.animation) : l.removeAttribute("data-animation"), s.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof s.maxWidth == "number" ? s.maxWidth + "px" : s.maxWidth, s.role ? l.setAttribute("role", s.role) : l.removeAttribute("role"), (i.content !== s.content || i.allowHTML !== s.allowHTML) && nu(c, e.props), s.arrow ? u ? i.arrow !== s.arrow && (l.removeChild(u), l.appendChild(tu(s.arrow))) : l.appendChild(tu(s.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: t,
    onUpdate: r
  };
}
Hd.$$tippy = !0;
var Xg = 1, Wr = [], fs = [];
function Jg(e, t) {
  var n = eu(e, Object.assign({}, jt, zd(Xl(t)))), o, r, i, s = !1, a = !1, l = !1, c = !1, u, d, f, p = [], v = Gl(h, n.interactiveDebounce), w, _ = Xg++, C = null, S = Vg(n.plugins), N = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, m = {
    // properties
    id: _,
    reference: e,
    popper: no(),
    popperInstance: C,
    props: n,
    state: N,
    plugins: S,
    // methods
    clearDelayTimeouts: Z,
    setProps: ie,
    setContent: be,
    show: Ne,
    hide: ke,
    hideWithInteractivity: ut,
    enable: oe,
    disable: Y,
    unmount: Qe,
    destroy: _t
  };
  if (!n.render)
    return m;
  var y = n.render(m), x = y.popper, k = y.onUpdate;
  x.setAttribute("data-tippy-root", ""), x.id = "tippy-" + m.id, m.popper = x, e._tippy = m, x._tippy = m;
  var D = S.map(function(P) {
    return P.fn(m);
  }), E = e.hasAttribute("aria-expanded");
  return vt(), fe(), $(), W("onCreate", [m]), n.showOnCreate && H(), x.addEventListener("mouseenter", function() {
    m.props.interactive && m.state.isVisible && m.clearDelayTimeouts();
  }), x.addEventListener("mouseleave", function() {
    m.props.interactive && m.props.trigger.indexOf("mouseenter") >= 0 && M().addEventListener("mousemove", v);
  }), m;
  function O() {
    var P = m.props.touch;
    return Array.isArray(P) ? P : [P, 0];
  }
  function A() {
    return O()[0] === "hold";
  }
  function g() {
    var P;
    return !!((P = m.props.render) != null && P.$$tippy);
  }
  function R() {
    return w || e;
  }
  function M() {
    var P = R().parentNode;
    return P ? Wd(P) : document;
  }
  function G() {
    return gi(x);
  }
  function Q(P) {
    return m.state.isMounted && !m.state.isVisible || Kt.isTouch || u && u.type === "focus" ? 0 : us(m.props.delay, P ? 0 : 1, jt.delay);
  }
  function $(P) {
    P === void 0 && (P = !1), x.style.pointerEvents = m.props.interactive && !P ? "" : "none", x.style.zIndex = "" + m.props.zIndex;
  }
  function W(P, J, ae) {
    if (ae === void 0 && (ae = !0), D.forEach(function(me) {
      me[P] && me[P].apply(me, J);
    }), ae) {
      var pe;
      (pe = m.props)[P].apply(pe, J);
    }
  }
  function he() {
    var P = m.props.aria;
    if (P.content) {
      var J = "aria-" + P.content, ae = x.id, pe = Un(m.props.triggerTarget || e);
      pe.forEach(function(me) {
        var Xe = me.getAttribute(J);
        if (m.state.isVisible)
          me.setAttribute(J, Xe ? Xe + " " + ae : ae);
        else {
          var Ot = Xe && Xe.replace(ae, "").trim();
          Ot ? me.setAttribute(J, Ot) : me.removeAttribute(J);
        }
      });
    }
  }
  function fe() {
    if (!(E || !m.props.aria.expanded)) {
      var P = Un(m.props.triggerTarget || e);
      P.forEach(function(J) {
        m.props.interactive ? J.setAttribute("aria-expanded", m.state.isVisible && J === R() ? "true" : "false") : J.removeAttribute("aria-expanded");
      });
    }
  }
  function we() {
    M().removeEventListener("mousemove", v), Wr = Wr.filter(function(P) {
      return P !== v;
    });
  }
  function q(P) {
    if (!(Kt.isTouch && (l || P.type === "mousedown"))) {
      var J = P.composedPath && P.composedPath()[0] || P.target;
      if (!(m.props.interactive && Jl(x, J))) {
        if (Un(m.props.triggerTarget || e).some(function(ae) {
          return Jl(ae, J);
        })) {
          if (Kt.isTouch || m.state.isVisible && m.props.trigger.indexOf("click") >= 0)
            return;
        } else
          W("onClickOutside", [m, P]);
        m.props.hideOnClick === !0 && (m.clearDelayTimeouts(), m.hide(), a = !0, setTimeout(function() {
          a = !1;
        }), m.state.isMounted || xe());
      }
    }
  }
  function ve() {
    l = !0;
  }
  function Ve() {
    l = !1;
  }
  function Te() {
    var P = M();
    P.addEventListener("mousedown", q, !0), P.addEventListener("touchend", q, Bn), P.addEventListener("touchstart", Ve, Bn), P.addEventListener("touchmove", ve, Bn);
  }
  function xe() {
    var P = M();
    P.removeEventListener("mousedown", q, !0), P.removeEventListener("touchend", q, Bn), P.removeEventListener("touchstart", Ve, Bn), P.removeEventListener("touchmove", ve, Bn);
  }
  function Re(P, J) {
    de(P, function() {
      !m.state.isVisible && x.parentNode && x.parentNode.contains(x) && J();
    });
  }
  function ot(P, J) {
    de(P, J);
  }
  function de(P, J) {
    var ae = G().box;
    function pe(me) {
      me.target === ae && (ds(ae, "remove", pe), J());
    }
    if (P === 0)
      return J();
    ds(ae, "remove", d), ds(ae, "add", pe), d = pe;
  }
  function lt(P, J, ae) {
    ae === void 0 && (ae = !1);
    var pe = Un(m.props.triggerTarget || e);
    pe.forEach(function(me) {
      me.addEventListener(P, J, ae), p.push({
        node: me,
        eventType: P,
        handler: J,
        options: ae
      });
    });
  }
  function vt() {
    A() && (lt("touchstart", gn, {
      passive: !0
    }), lt("touchend", b, {
      passive: !0
    })), Ag(m.props.trigger).forEach(function(P) {
      if (P !== "manual")
        switch (lt(P, gn), P) {
          case "mouseenter":
            lt("mouseleave", b);
            break;
          case "focus":
            lt(zg ? "focusout" : "blur", T);
            break;
          case "focusin":
            lt("focusout", T);
            break;
        }
    });
  }
  function en() {
    p.forEach(function(P) {
      var J = P.node, ae = P.eventType, pe = P.handler, me = P.options;
      J.removeEventListener(ae, pe, me);
    }), p = [];
  }
  function gn(P) {
    var J, ae = !1;
    if (!(!m.state.isEnabled || F(P) || a)) {
      var pe = ((J = u) == null ? void 0 : J.type) === "focus";
      u = P, w = P.currentTarget, fe(), !m.state.isVisible && Ra(P) && Wr.forEach(function(me) {
        return me(P);
      }), P.type === "click" && (m.props.trigger.indexOf("mouseenter") < 0 || s) && m.props.hideOnClick !== !1 && m.state.isVisible ? ae = !0 : H(P), P.type === "click" && (s = !ae), ae && !pe && j(P);
    }
  }
  function h(P) {
    var J = P.target, ae = R().contains(J) || x.contains(J);
    if (!(P.type === "mousemove" && ae)) {
      var pe = B().concat(x).map(function(me) {
        var Xe, Ot = me._tippy, lo = (Xe = Ot.popperInstance) == null ? void 0 : Xe.state;
        return lo ? {
          popperRect: me.getBoundingClientRect(),
          popperState: lo,
          props: n
        } : null;
      }).filter(Boolean);
      jg(pe, P) && (we(), j(P));
    }
  }
  function b(P) {
    var J = F(P) || m.props.trigger.indexOf("click") >= 0 && s;
    if (!J) {
      if (m.props.interactive) {
        m.hideWithInteractivity(P);
        return;
      }
      j(P);
    }
  }
  function T(P) {
    m.props.trigger.indexOf("focusin") < 0 && P.target !== R() || m.props.interactive && P.relatedTarget && x.contains(P.relatedTarget) || j(P);
  }
  function F(P) {
    return Kt.isTouch ? A() !== P.type.indexOf("touch") >= 0 : !1;
  }
  function L() {
    I();
    var P = m.props, J = P.popperOptions, ae = P.placement, pe = P.offset, me = P.getReferenceClientRect, Xe = P.moveTransition, Ot = g() ? gi(x).arrow : null, lo = me ? {
      getBoundingClientRect: me,
      contextElement: me.contextElement || R()
    } : e, za = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Pr) {
        var uo = Pr.state;
        if (g()) {
          var Mf = G(), Yi = Mf.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(Dr) {
            Dr === "placement" ? Yi.setAttribute("data-placement", uo.placement) : uo.attributes.popper["data-popper-" + Dr] ? Yi.setAttribute("data-" + Dr, "") : Yi.removeAttribute("data-" + Dr);
          }), uo.attributes.popper = {};
        }
      }
    }, Rn = [{
      name: "offset",
      options: {
        offset: pe
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Xe
      }
    }, za];
    g() && Ot && Rn.push({
      name: "arrow",
      options: {
        element: Ot,
        padding: 3
      }
    }), Rn.push.apply(Rn, (J == null ? void 0 : J.modifiers) || []), m.popperInstance = Pg(lo, x, Object.assign({}, J, {
      placement: ae,
      onFirstUpdate: f,
      modifiers: Rn
    }));
  }
  function I() {
    m.popperInstance && (m.popperInstance.destroy(), m.popperInstance = null);
  }
  function K() {
    var P = m.props.appendTo, J, ae = R();
    m.props.interactive && P === jd || P === "parent" ? J = ae.parentNode : J = qd(P, [ae]), J.contains(x) || J.appendChild(x), m.state.isMounted = !0, L();
  }
  function B() {
    return Mo(x.querySelectorAll("[data-tippy-root]"));
  }
  function H(P) {
    m.clearDelayTimeouts(), P && W("onTrigger", [m, P]), Te();
    var J = Q(!0), ae = O(), pe = ae[0], me = ae[1];
    Kt.isTouch && pe === "hold" && me && (J = me), J ? o = setTimeout(function() {
      m.show();
    }, J) : m.show();
  }
  function j(P) {
    if (m.clearDelayTimeouts(), W("onUntrigger", [m, P]), !m.state.isVisible) {
      xe();
      return;
    }
    if (!(m.props.trigger.indexOf("mouseenter") >= 0 && m.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(P.type) >= 0 && s)) {
      var J = Q(!1);
      J ? r = setTimeout(function() {
        m.state.isVisible && m.hide();
      }, J) : i = requestAnimationFrame(function() {
        m.hide();
      });
    }
  }
  function oe() {
    m.state.isEnabled = !0;
  }
  function Y() {
    m.hide(), m.state.isEnabled = !1;
  }
  function Z() {
    clearTimeout(o), clearTimeout(r), cancelAnimationFrame(i);
  }
  function ie(P) {
    if (!m.state.isDestroyed) {
      W("onBeforeUpdate", [m, P]), en();
      var J = m.props, ae = eu(e, Object.assign({}, J, Xl(P), {
        ignoreAttributes: !0
      }));
      m.props = ae, vt(), J.interactiveDebounce !== ae.interactiveDebounce && (we(), v = Gl(h, ae.interactiveDebounce)), J.triggerTarget && !ae.triggerTarget ? Un(J.triggerTarget).forEach(function(pe) {
        pe.removeAttribute("aria-expanded");
      }) : ae.triggerTarget && e.removeAttribute("aria-expanded"), fe(), $(), k && k(J, ae), m.popperInstance && (L(), B().forEach(function(pe) {
        requestAnimationFrame(pe._tippy.popperInstance.forceUpdate);
      })), W("onAfterUpdate", [m, P]);
    }
  }
  function be(P) {
    m.setProps({
      content: P
    });
  }
  function Ne() {
    var P = m.state.isVisible, J = m.state.isDestroyed, ae = !m.state.isEnabled, pe = Kt.isTouch && !m.props.touch, me = us(m.props.duration, 0, jt.duration);
    if (!(P || J || ae || pe) && !R().hasAttribute("disabled") && (W("onShow", [m], !1), m.props.onShow(m) !== !1)) {
      if (m.state.isVisible = !0, g() && (x.style.visibility = "visible"), $(), Te(), m.state.isMounted || (x.style.transition = "none"), g()) {
        var Xe = G(), Ot = Xe.box, lo = Xe.content;
        cs([Ot, lo], 0);
      }
      f = function() {
        var Rn;
        if (!(!m.state.isVisible || c)) {
          if (c = !0, x.offsetHeight, x.style.transition = m.props.moveTransition, g() && m.props.animation) {
            var Ki = G(), Pr = Ki.box, uo = Ki.content;
            cs([Pr, uo], me), mr([Pr, uo], "visible");
          }
          he(), fe(), Ql(fs, m), (Rn = m.popperInstance) == null || Rn.forceUpdate(), W("onMount", [m]), m.props.animation && g() && ot(me, function() {
            m.state.isShown = !0, W("onShown", [m]);
          });
        }
      }, K();
    }
  }
  function ke() {
    var P = !m.state.isVisible, J = m.state.isDestroyed, ae = !m.state.isEnabled, pe = us(m.props.duration, 1, jt.duration);
    if (!(P || J || ae) && (W("onHide", [m], !1), m.props.onHide(m) !== !1)) {
      if (m.state.isVisible = !1, m.state.isShown = !1, c = !1, s = !1, g() && (x.style.visibility = "hidden"), we(), xe(), $(!0), g()) {
        var me = G(), Xe = me.box, Ot = me.content;
        m.props.animation && (cs([Xe, Ot], pe), mr([Xe, Ot], "hidden"));
      }
      he(), fe(), m.props.animation ? g() && Re(pe, m.unmount) : m.unmount();
    }
  }
  function ut(P) {
    M().addEventListener("mousemove", v), Ql(Wr, v), v(P);
  }
  function Qe() {
    m.state.isVisible && m.hide(), m.state.isMounted && (I(), B().forEach(function(P) {
      P._tippy.unmount();
    }), x.parentNode && x.parentNode.removeChild(x), fs = fs.filter(function(P) {
      return P !== m;
    }), m.state.isMounted = !1, W("onHidden", [m]));
  }
  function _t() {
    m.state.isDestroyed || (m.clearDelayTimeouts(), m.unmount(), en(), delete e._tippy, m.state.isDestroyed = !0, W("onDestroy", [m]));
  }
}
function ee(e, t) {
  t === void 0 && (t = {});
  var n = jt.plugins.concat(t.plugins || []);
  Wg();
  var o = Object.assign({}, t, {
    plugins: n
  }), r = Ig(e), i = r.reduce(function(s, a) {
    var l = a && Jg(a, o);
    return l && s.push(l), s;
  }, []);
  return zi(e) ? i[0] : i;
}
ee.defaultProps = jt;
ee.setDefaultProps = Yg;
ee.currentInput = Kt;
var Zg = Object.assign({}, Nd, {
  effect: function(t) {
    var n = t.state, o = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, o.popper), n.styles = o, n.elements.arrow && Object.assign(n.elements.arrow.style, o.arrow);
  }
}), eb = function(t, n) {
  var o;
  n === void 0 && (n = {});
  var r = t, i = [], s = [], a, l = n.overrides, c = [], u = !1;
  function d() {
    s = r.map(function(m) {
      return Un(m.props.triggerTarget || m.reference);
    }).reduce(function(m, y) {
      return m.concat(y);
    }, []);
  }
  function f() {
    i = r.map(function(m) {
      return m.reference;
    });
  }
  function p(m) {
    r.forEach(function(y) {
      m ? y.enable() : y.disable();
    });
  }
  function v(m) {
    return r.map(function(y) {
      var x = y.setProps;
      return y.setProps = function(k) {
        x(k), y.reference === a && m.setProps(k);
      }, function() {
        y.setProps = x;
      };
    });
  }
  function w(m, y) {
    var x = s.indexOf(y);
    if (y !== a) {
      a = y;
      var k = (l || []).concat("content").reduce(function(D, E) {
        return D[E] = r[x].props[E], D;
      }, {});
      m.setProps(Object.assign({}, k, {
        getReferenceClientRect: typeof k.getReferenceClientRect == "function" ? k.getReferenceClientRect : function() {
          var D;
          return (D = i[x]) == null ? void 0 : D.getBoundingClientRect();
        }
      }));
    }
  }
  p(!1), f(), d();
  var _ = {
    fn: function() {
      return {
        onDestroy: function() {
          p(!0);
        },
        onHidden: function() {
          a = null;
        },
        onClickOutside: function(x) {
          x.props.showOnCreate && !u && (u = !0, a = null);
        },
        onShow: function(x) {
          x.props.showOnCreate && !u && (u = !0, w(x, i[0]));
        },
        onTrigger: function(x, k) {
          w(x, k.currentTarget);
        }
      };
    }
  }, C = ee(no(), Object.assign({}, Mg(n, ["overrides"]), {
    plugins: [_].concat(n.plugins || []),
    triggerTarget: s,
    popperOptions: Object.assign({}, n.popperOptions, {
      modifiers: [].concat(((o = n.popperOptions) == null ? void 0 : o.modifiers) || [], [Zg])
    })
  })), S = C.show;
  C.show = function(m) {
    if (S(), !a && m == null)
      return w(C, i[0]);
    if (!(a && m == null)) {
      if (typeof m == "number")
        return i[m] && w(C, i[m]);
      if (r.indexOf(m) >= 0) {
        var y = m.reference;
        return w(C, y);
      }
      if (i.indexOf(m) >= 0)
        return w(C, m);
    }
  }, C.showNext = function() {
    var m = i[0];
    if (!a)
      return C.show(0);
    var y = i.indexOf(a);
    C.show(i[y + 1] || m);
  }, C.showPrevious = function() {
    var m = i[i.length - 1];
    if (!a)
      return C.show(m);
    var y = i.indexOf(a), x = i[y - 1] || m;
    C.show(x);
  };
  var N = C.setProps;
  return C.setProps = function(m) {
    l = m.overrides || l, N(m);
  }, C.setInstances = function(m) {
    p(!0), c.forEach(function(y) {
      return y();
    }), r = m, p(!1), f(), d(), c = v(C), C.setProps({
      triggerTarget: s
    });
  }, c = v(C), C;
}, tb = {
  name: "animateFill",
  defaultValue: !1,
  fn: function(t) {
    var n;
    if (!((n = t.props.render) != null && n.$$tippy))
      return {};
    var o = gi(t.popper), r = o.box, i = o.content, s = t.props.animateFill ? nb() : null;
    return {
      onCreate: function() {
        s && (r.insertBefore(s, r.firstElementChild), r.setAttribute("data-animatefill", ""), r.style.overflow = "hidden", t.setProps({
          arrow: !1,
          animation: "shift-away"
        }));
      },
      onMount: function() {
        if (s) {
          var l = r.style.transitionDuration, c = Number(l.replace("ms", ""));
          i.style.transitionDelay = Math.round(c / 10) + "ms", s.style.transitionDuration = l, mr([s], "visible");
        }
      },
      onShow: function() {
        s && (s.style.transitionDuration = "0ms");
      },
      onHide: function() {
        s && mr([s], "hidden");
      }
    };
  }
};
function nb() {
  var e = no();
  return e.className = Rd, mr([e], "hidden"), e;
}
var Us = {
  clientX: 0,
  clientY: 0
}, Br = [];
function Ud(e) {
  var t = e.clientX, n = e.clientY;
  Us = {
    clientX: t,
    clientY: n
  };
}
function ob(e) {
  e.addEventListener("mousemove", Ud);
}
function rb(e) {
  e.removeEventListener("mousemove", Ud);
}
var ib = {
  name: "followCursor",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, o = Wd(t.props.triggerTarget || n), r = !1, i = !1, s = !0, a = t.props;
    function l() {
      return t.props.followCursor === "initial" && t.state.isVisible;
    }
    function c() {
      o.addEventListener("mousemove", f);
    }
    function u() {
      o.removeEventListener("mousemove", f);
    }
    function d() {
      r = !0, t.setProps({
        getReferenceClientRect: null
      }), r = !1;
    }
    function f(w) {
      var _ = w.target ? n.contains(w.target) : !0, C = t.props.followCursor, S = w.clientX, N = w.clientY, m = n.getBoundingClientRect(), y = S - m.left, x = N - m.top;
      (_ || !t.props.interactive) && t.setProps({
        // @ts-ignore - unneeded DOMRect properties
        getReferenceClientRect: function() {
          var D = n.getBoundingClientRect(), E = S, O = N;
          C === "initial" && (E = D.left + y, O = D.top + x);
          var A = C === "horizontal" ? D.top : O, g = C === "vertical" ? D.right : E, R = C === "horizontal" ? D.bottom : O, M = C === "vertical" ? D.left : E;
          return {
            width: g - M,
            height: R - A,
            top: A,
            right: g,
            bottom: R,
            left: M
          };
        }
      });
    }
    function p() {
      t.props.followCursor && (Br.push({
        instance: t,
        doc: o
      }), ob(o));
    }
    function v() {
      Br = Br.filter(function(w) {
        return w.instance !== t;
      }), Br.filter(function(w) {
        return w.doc === o;
      }).length === 0 && rb(o);
    }
    return {
      onCreate: p,
      onDestroy: v,
      onBeforeUpdate: function() {
        a = t.props;
      },
      onAfterUpdate: function(_, C) {
        var S = C.followCursor;
        r || S !== void 0 && a.followCursor !== S && (v(), S ? (p(), t.state.isMounted && !i && !l() && c()) : (u(), d()));
      },
      onMount: function() {
        t.props.followCursor && !i && (s && (f(Us), s = !1), l() || c());
      },
      onTrigger: function(_, C) {
        Ra(C) && (Us = {
          clientX: C.clientX,
          clientY: C.clientY
        }), i = C.type === "focus";
      },
      onHidden: function() {
        t.props.followCursor && (d(), u(), s = !0);
      }
    };
  }
};
function sb(e, t) {
  var n;
  return {
    popperOptions: Object.assign({}, e.popperOptions, {
      modifiers: [].concat((((n = e.popperOptions) == null ? void 0 : n.modifiers) || []).filter(function(o) {
        var r = o.name;
        return r !== t.name;
      }), [t])
    })
  };
}
var ab = {
  name: "inlinePositioning",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference;
    function o() {
      return !!t.props.inlinePositioning;
    }
    var r, i = -1, s = !1, a = [], l = {
      name: "tippyInlinePositioning",
      enabled: !0,
      phase: "afterWrite",
      fn: function(p) {
        var v = p.state;
        o() && (a.indexOf(v.placement) !== -1 && (a = []), r !== v.placement && a.indexOf(v.placement) === -1 && (a.push(v.placement), t.setProps({
          // @ts-ignore - unneeded DOMRect properties
          getReferenceClientRect: function() {
            return c(v.placement);
          }
        })), r = v.placement);
      }
    };
    function c(f) {
      return lb(Fd(f), n.getBoundingClientRect(), Mo(n.getClientRects()), i);
    }
    function u(f) {
      s = !0, t.setProps(f), s = !1;
    }
    function d() {
      s || u(sb(t.props, l));
    }
    return {
      onCreate: d,
      onAfterUpdate: d,
      onTrigger: function(p, v) {
        if (Ra(v)) {
          var w = Mo(t.reference.getClientRects()), _ = w.find(function(S) {
            return S.left - 2 <= v.clientX && S.right + 2 >= v.clientX && S.top - 2 <= v.clientY && S.bottom + 2 >= v.clientY;
          }), C = w.indexOf(_);
          i = C > -1 ? C : i;
        }
      },
      onHidden: function() {
        i = -1;
      }
    };
  }
};
function lb(e, t, n, o) {
  if (n.length < 2 || e === null)
    return t;
  if (n.length === 2 && o >= 0 && n[0].left > n[1].right)
    return n[o] || t;
  switch (e) {
    case "top":
    case "bottom": {
      var r = n[0], i = n[n.length - 1], s = e === "top", a = r.top, l = i.bottom, c = s ? r.left : i.left, u = s ? r.right : i.right, d = u - c, f = l - a;
      return {
        top: a,
        bottom: l,
        left: c,
        right: u,
        width: d,
        height: f
      };
    }
    case "left":
    case "right": {
      var p = Math.min.apply(Math, n.map(function(x) {
        return x.left;
      })), v = Math.max.apply(Math, n.map(function(x) {
        return x.right;
      })), w = n.filter(function(x) {
        return e === "left" ? x.left === p : x.right === v;
      }), _ = w[0].top, C = w[w.length - 1].bottom, S = p, N = v, m = N - S, y = C - _;
      return {
        top: _,
        bottom: C,
        left: S,
        right: N,
        width: m,
        height: y
      };
    }
    default:
      return t;
  }
}
var ub = {
  name: "sticky",
  defaultValue: !1,
  fn: function(t) {
    var n = t.reference, o = t.popper;
    function r() {
      return t.popperInstance ? t.popperInstance.state.elements.reference : n;
    }
    function i(c) {
      return t.props.sticky === !0 || t.props.sticky === c;
    }
    var s = null, a = null;
    function l() {
      var c = i("reference") ? r().getBoundingClientRect() : null, u = i("popper") ? o.getBoundingClientRect() : null;
      (c && ou(s, c) || u && ou(a, u)) && t.popperInstance && t.popperInstance.update(), s = c, a = u, t.state.isMounted && requestAnimationFrame(l);
    }
    return {
      onMount: function() {
        t.props.sticky && l();
      }
    };
  }
};
function ou(e, t) {
  return e && t ? e.top !== t.top || e.right !== t.right || e.bottom !== t.bottom || e.left !== t.left : !0;
}
ee.setDefaultProps({
  render: Hd
});
ee.setDefaultProps({
  //@ts-ignore
  onShow: (e) => {
    if (!e.props.content)
      return !1;
  }
});
function Kd(e, t = {}, n = { mount: !0, appName: "Tippy" }) {
  n = Object.assign({ mount: !0, appName: "Tippy" }, n);
  const o = Fe(), r = te(), i = te({
    isEnabled: !1,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }), s = Dp();
  let a = null;
  const l = () => a || (a = document.createDocumentFragment(), a), c = (k) => {
    let D, E = $e(k) ? k.value : k;
    return So(E) ? (s.value || (s.value = Ws({
      name: n.appName,
      setup: () => () => $e(k) ? k.value : k
    }), o && Object.assign(s.value._context, o.appContext), s.value.mount(l())), D = () => l()) : typeof E == "object" ? (s.value || (s.value = Ws({
      name: n.appName,
      setup: () => () => U($e(k) ? k.value : k)
    }), o && Object.assign(s.value._context, o.appContext), s.value.mount(l())), D = () => l()) : D = E, D;
  }, u = (k) => {
    let D = {};
    return $e(k) ? D = k.value || {} : un(k) ? D = { ...k } : D = { ...k }, D.content && (D.content = c(D.content)), D.triggerTarget && (D.triggerTarget = $e(D.triggerTarget) ? D.triggerTarget.value : D.triggerTarget), (!D.plugins || !Array.isArray(D.plugins)) && (D.plugins = []), D.plugins = D.plugins.filter((E) => E.name !== "vueTippyReactiveState"), D.plugins.push({
      name: "vueTippyReactiveState",
      fn: () => ({
        onCreate() {
          i.value.isEnabled = !0;
        },
        onMount() {
          i.value.isMounted = !0;
        },
        onShow() {
          i.value.isMounted = !0, i.value.isVisible = !0;
        },
        onShown() {
          i.value.isShown = !0;
        },
        onHide() {
          i.value.isMounted = !1, i.value.isVisible = !1;
        },
        onHidden() {
          i.value.isShown = !1;
        },
        onUnmounted() {
          i.value.isMounted = !1;
        },
        onDestroy() {
          i.value.isDestroyed = !0;
        }
      })
    }), D;
  }, d = () => {
    r.value && r.value.setProps(u(t));
  }, f = () => {
    !r.value || !t.content || r.value.setContent(c(t.content));
  }, p = (k) => {
    var D;
    (D = r.value) === null || D === void 0 || D.setContent(c(k));
  }, v = (k) => {
    var D;
    (D = r.value) === null || D === void 0 || D.setProps(u(k));
  }, w = () => {
    var k;
    r.value && (r.value.destroy(), r.value = void 0), a = null, (k = s.value) === null || k === void 0 || k.unmount(), s.value = void 0;
  }, _ = () => {
    var k;
    (k = r.value) === null || k === void 0 || k.show();
  }, C = () => {
    var k;
    (k = r.value) === null || k === void 0 || k.hide();
  }, S = () => {
    var k;
    (k = r.value) === null || k === void 0 || k.disable(), i.value.isEnabled = !1;
  }, N = () => {
    var k;
    (k = r.value) === null || k === void 0 || k.enable(), i.value.isEnabled = !0;
  }, m = () => {
    var k;
    (k = r.value) === null || k === void 0 || k.unmount();
  }, y = () => {
    if (!e)
      return;
    let k = $e(e) ? e.value : e;
    typeof k == "function" && (k = k()), k && (r.value = ee(k, u(t)), k.$tippy = x);
  }, x = {
    tippy: r,
    refresh: d,
    refreshContent: f,
    setContent: p,
    setProps: v,
    destroy: w,
    hide: C,
    show: _,
    disable: S,
    enable: N,
    unmount: m,
    mount: y,
    state: i
  };
  return n.mount && (o ? o.isMounted ? y() : Ct(y) : y()), o && kr(() => {
    w();
  }), $e(t) || un(t) ? ye(t, d, { immediate: !1 }) : $e(t.content) && ye(t.content, f, { immediate: !1 }), x;
}
function cb(e, t) {
  const n = te();
  return Ct(() => {
    const r = (Array.isArray(e) ? e.map((i) => i.value) : typeof e == "function" ? e() : e.value).map((i) => i instanceof Element ? i._tippy : i).filter(Boolean);
    n.value = eb(r, t ? { allowHTML: !0, ...t } : { allowHTML: !0 });
  }), {
    singleton: n
  };
}
function db(e) {
  return typeof e == "function" ? e() : re(e);
}
function fb(e) {
  var t, n;
  const o = db(e);
  return (n = (t = o) === null || t === void 0 ? void 0 : t.$el) !== null && n !== void 0 ? n : o;
}
const Yd = /* @__PURE__ */ Ee({
  props: {
    to: {
      type: [String, Function]
    },
    tag: {
      type: [String, Object],
      default: "span"
    },
    contentTag: {
      type: [String, Object],
      default: "span"
    },
    contentClass: {
      type: String,
      default: null
    },
    appendTo: { default: () => ee.defaultProps.appendTo },
    aria: { default: () => ee.defaultProps.aria },
    delay: { default: () => ee.defaultProps.delay },
    duration: { default: () => ee.defaultProps.duration },
    getReferenceClientRect: { default: () => ee.defaultProps.getReferenceClientRect },
    hideOnClick: { type: [Boolean, String], default: () => ee.defaultProps.hideOnClick },
    ignoreAttributes: { type: Boolean, default: () => ee.defaultProps.ignoreAttributes },
    interactive: { type: Boolean, default: () => ee.defaultProps.interactive },
    interactiveBorder: { default: () => ee.defaultProps.interactiveBorder },
    interactiveDebounce: { default: () => ee.defaultProps.interactiveDebounce },
    moveTransition: { default: () => ee.defaultProps.moveTransition },
    offset: { default: () => ee.defaultProps.offset },
    onAfterUpdate: { default: () => ee.defaultProps.onAfterUpdate },
    onBeforeUpdate: { default: () => ee.defaultProps.onBeforeUpdate },
    onCreate: { default: () => ee.defaultProps.onCreate },
    onDestroy: { default: () => ee.defaultProps.onDestroy },
    onHidden: { default: () => ee.defaultProps.onHidden },
    onHide: { default: () => ee.defaultProps.onHide },
    onMount: { default: () => ee.defaultProps.onMount },
    onShow: { default: () => ee.defaultProps.onShow },
    onShown: { default: () => ee.defaultProps.onShown },
    onTrigger: { default: () => ee.defaultProps.onTrigger },
    onUntrigger: { default: () => ee.defaultProps.onUntrigger },
    onClickOutside: { default: () => ee.defaultProps.onClickOutside },
    placement: { default: () => ee.defaultProps.placement },
    plugins: { default: () => ee.defaultProps.plugins },
    popperOptions: { default: () => ee.defaultProps.popperOptions },
    render: { default: () => ee.defaultProps.render },
    showOnCreate: { type: Boolean, default: () => ee.defaultProps.showOnCreate },
    touch: { type: [Boolean, String, Array], default: () => ee.defaultProps.touch },
    trigger: { default: () => ee.defaultProps.trigger },
    triggerTarget: { default: () => ee.defaultProps.triggerTarget },
    animateFill: { type: Boolean, default: () => ee.defaultProps.animateFill },
    followCursor: { type: [Boolean, String], default: () => ee.defaultProps.followCursor },
    inlinePositioning: { type: Boolean, default: () => ee.defaultProps.inlinePositioning },
    sticky: { type: [Boolean, String], default: () => ee.defaultProps.sticky },
    allowHTML: { type: Boolean, default: () => ee.defaultProps.allowHTML },
    animation: { default: () => ee.defaultProps.animation },
    arrow: { default: () => ee.defaultProps.arrow },
    content: { default: () => ee.defaultProps.content },
    inertia: { default: () => ee.defaultProps.inertia },
    maxWidth: { default: () => ee.defaultProps.maxWidth },
    role: { default: () => ee.defaultProps.role },
    theme: { default: () => ee.defaultProps.theme },
    zIndex: { default: () => ee.defaultProps.zIndex }
  },
  emits: ["state"],
  setup(e, { slots: t, emit: n, expose: o }) {
    const r = te(), i = te(), s = te(), a = te(!1), l = () => {
      let p = { ...e };
      for (const v of ["to", "tag", "contentTag", "contentClass"])
        p.hasOwnProperty(v) && delete p[v];
      return p;
    };
    let c = () => fb(r);
    e.to && (typeof Element < "u" && e.to instanceof Element ? c = () => e.to : e.to === "parent" ? c = () => {
      let p = r.value;
      return p || (p = r.value = i.value.parentElement), p;
    } : (typeof e.to == "string" || e.to instanceof String) && (c = () => document.querySelector(e.to)));
    const u = Kd(c, l());
    let d = t.content;
    !d && e.to === "parent" && (d = t.default), Ct(() => {
      a.value = !0, tt(() => {
        d && u.setContent(() => s.value);
      });
    }), ye(u.state, () => {
      n("state", re(u.state));
    }, { immediate: !0, deep: !0 }), ye(() => e, () => {
      u.setProps(l()), d && u.setContent(() => s.value);
    }, { deep: !0 });
    let f = Ro({
      elem: r,
      contentElem: s,
      mounted: a,
      ...u
    });
    return o(f), () => {
      const p = (typeof e.contentTag == "string", e.contentTag), v = d ? U(p, {
        ref: s,
        style: { display: a.value ? "inherit" : "none" },
        class: e.contentClass
      }, d(f)) : null;
      if (e.to === "parent") {
        const C = [];
        if (!r.value) {
          const S = U("span", {
            ref: i,
            "data-v-tippy": "",
            style: { display: "none" }
          });
          C.push(S);
        }
        return v && C.push(v), C;
      }
      const w = t.default ? t.default(f) : [];
      if (!e.tag) {
        const C = U(w[0], {
          ref: r,
          "data-v-tippy": ""
        });
        return v ? [C, v] : C;
      }
      const _ = (typeof e.tag == "string", e.tag);
      return U(_, { ref: r, "data-v-tippy": "" }, v ? [w, v] : w);
    };
  }
}), pb = [
  "a11y",
  "allowHTML",
  "arrow",
  "flip",
  "flipOnUpdate",
  "hideOnClick",
  "ignoreAttributes",
  "inertia",
  "interactive",
  "lazy",
  "multiple",
  "showOnInit",
  "touch",
  "touchHold"
];
let Ks = {};
Object.keys(ee.defaultProps).forEach((e) => {
  pb.includes(e) ? Ks[e] = {
    type: Boolean,
    default: function() {
      return ee.defaultProps[e];
    }
  } : Ks[e] = {
    default: function() {
      return ee.defaultProps[e];
    }
  };
});
const mb = /* @__PURE__ */ Ee({
  props: Ks,
  setup(e) {
    const t = te([]), { singleton: n } = cb(t, e);
    return { instances: t, singleton: n };
  },
  mounted() {
    var e;
    const n = this.$el.parentElement.querySelectorAll("[data-v-tippy]");
    this.instances = Array.from(n).map((o) => o._tippy).filter(Boolean), (e = this.singleton) === null || e === void 0 || e.setInstances(this.instances);
  },
  render() {
    let e = this.$slots.default ? this.$slots.default() : [];
    return U(() => e);
  }
}), hb = {
  mounted(e, t, n) {
    const o = typeof t.value == "string" ? { content: t.value } : t.value || {}, r = Object.keys(t.modifiers || {}), i = r.find((a) => a !== "arrow"), s = r.findIndex((a) => a === "arrow") !== -1;
    i && (o.placement = o.placement || i), s && (o.arrow = o.arrow !== void 0 ? o.arrow : !0), n.props && n.props.onTippyShow && (o.onShow = function(...a) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShow(...a);
    }), n.props && n.props.onTippyShown && (o.onShown = function(...a) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyShown(...a);
    }), n.props && n.props.onTippyHidden && (o.onHidden = function(...a) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHidden(...a);
    }), n.props && n.props.onTippyHide && (o.onHide = function(...a) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyHide(...a);
    }), n.props && n.props.onTippyMount && (o.onMount = function(...a) {
      var l;
      return (l = n.props) === null || l === void 0 ? void 0 : l.onTippyMount(...a);
    }), e.getAttribute("title") && !o.content && (o.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !o.content && (o.content = e.getAttribute("content")), Kd(e, o);
  },
  unmounted(e) {
    e.$tippy ? e.$tippy.destroy() : e._tippy && e._tippy.destroy();
  },
  updated(e, t) {
    const n = typeof t.value == "string" ? { content: t.value } : t.value || {};
    e.getAttribute("title") && !n.content && (n.content = e.getAttribute("title"), e.removeAttribute("title")), e.getAttribute("content") && !n.content && (n.content = e.getAttribute("content")), e.$tippy ? e.$tippy.setProps(n || {}) : e._tippy && e._tippy.setProps(n || {});
  }
}, vb = {
  install(e, t = {}) {
    ee.setDefaultProps(t.defaultProps || {}), e.directive(t.directive || "tippy", hb), e.component(t.component || "tippy", Yd), e.component(t.componentSingleton || "tippy-singleton", mb);
  }
}, gb = ee.setDefaultProps;
gb({
  ignoreAttributes: !0,
  plugins: [ub, ab, ib, tb]
});
const Gd = /* @__PURE__ */ Ee({
  __name: "WsTooltip",
  props: {
    placement: {
      type: String,
      default: "top"
    },
    maxWidth: {
      type: [String, Number],
      default: "100%"
    },
    // Only show the tooltip when the parent is overflowing
    onOverflowOnly: {
      type: Boolean,
      default: !1
    },
    onDark: {
      type: Boolean,
      default: !1
    },
    offset: {
      type: Array,
      default: () => [0, 14]
    },
    modelValue: {
      type: Boolean,
      default: void 0
    },
    delay: {
      type: Number,
      default: 0
    },
    hideDelay: {
      type: Number,
      default: 0
    }
  },
  setup(e, { expose: t }) {
    var l;
    const n = e, o = (l = Fe()) == null ? void 0 : l.proxy, r = te(!0), i = te(null);
    return ye(() => n.modelValue, (c) => {
      i.value && (c ? i.value.show() : i.value.hide());
    }), Ct(() => {
      if (n.onOverflowOnly) {
        const c = o.$el.parentNode;
        c && (r.value = c.scrollWidth > c.clientWidth);
      }
    }), t({
      show: () => {
        i.value.show();
      },
      hide: () => {
        i.value.hide();
      }
    }), (c, u) => {
      const d = nt("portal-slot");
      return r.value ? (X(), He(re(Yd), {
        key: 0,
        ref_key: "tippyEl",
        ref: i,
        to: "parent",
        interactive: !0,
        duration: [350, 350],
        delay: [e.delay, e.hideDelay],
        "max-width": e.maxWidth,
        placement: e.placement,
        offset: e.offset,
        "popper-options": {
          strategy: "fixed"
        },
        theme: "websupport",
        "hide-on-click": typeof e.modelValue > "u",
        trigger: typeof e.modelValue > "u" ? "mouseenter focus" : "manual"
      }, {
        default: Me(() => [
          le(d, {
            slot: c.$slots.default,
            "component-id": c.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ]),
        _: 1
      }, 8, ["delay", "max-width", "placement", "offset", "hide-on-click", "trigger"])) : Pe("", !0);
    };
  }
}), bb = ["innerHTML"], yb = /* @__PURE__ */ Ee({
  __name: "WsQrCode",
  props: {
    content: { type: String, default: "" }
  },
  setup(e) {
    const t = e, n = te(""), o = () => Bf(
      t.content,
      {
        errorCorrectionLevel: "L",
        // Low
        type: "svg",
        width: 200,
        margin: 0
      },
      (r, i) => {
        n.value = i;
      }
    );
    return ye(
      () => t.content,
      () => {
        o();
      },
      { immediate: !0 }
    ), (r, i) => (X(), ue("div", {
      class: "qr-code-wrapper",
      innerHTML: n.value
    }, null, 8, bb));
  }
}), W1 = /* @__PURE__ */ je(yb, [["__scopeId", "data-v-babbd241"]]), wb = ["src", "alt"], _b = /* @__PURE__ */ Ee({
  __name: "WsCountryFlag",
  props: {
    country: { type: String, default: "" },
    size: { type: String, default: "medium" }
  },
  setup(e) {
    const t = e, n = te("");
    async function o() {
      try {
        n.value = await jf(Gr(t.country).toUpperCase());
      } catch (r) {
        console.error(`Country flag not found (${t.country.toUpperCase()}).`), console.error(r);
      }
    }
    return o(), (r, i) => e.country ? (X(), ue("img", {
      key: 0,
      class: pt(["ws-country-flag", e.size]),
      src: n.value,
      alt: e.country
    }, null, 10, wb)) : Pe("", !0);
  }
}), ru = /* @__PURE__ */ je(_b, [["__scopeId", "data-v-91fc7bfa"]]), zr = {}, Eb = '<rect x="20%" y="20%" stroke="#555" fill="none" width="60%" height="60%"/>', xb = /* @__PURE__ */ Ee({
  name: "WsIcon",
  inheritAttrs: !1,
  props: {
    name: {
      type: String,
      required: !0
    },
    color: {
      type: String,
      required: !1,
      default: void 0
    },
    size: {
      type: Number,
      default: void 0
    },
    height: {
      type: Number,
      default: 16
    },
    width: {
      type: Number,
      default: 16
    },
    circle: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["loaded", "unloaded", "error"],
  // eslint-disable-next-line max-lines-per-function
  setup(e, t) {
    const n = te(null), o = V(() => {
      const c = ["ws-icon"];
      return t.attrs.class && c.push(t.attrs.class), e.color && c.push("text-" + e.color), e.circle && c.push("ws-icon--circle"), c.join(" ");
    }), r = V(() => {
      let c, u;
      return e.size ? (c = e.size.toString(), u = e.size.toString()) : (c = e.height, u = e.width), [
        `
      height: ${c}px;
      min-height: ${c}px;
      width: ${u}px;
      min-width: ${u}px;
     `,
        t.attrs.style
      ];
    }), i = (c) => Object.keys(c).reduce((u, d) => (c[d] !== !1 && c[d] !== null && c[d] !== void 0 && (u[d] = c[d]), u), {}), s = (c) => {
      const u = {
        class: o.value,
        title: e.name,
        style: r.value,
        "data-test": `ws-icon-${e.name}`
      };
      if (c) {
        const d = c.attributes;
        if (!d)
          return u;
        for (let f = d.length - 1; f >= 0; f--)
          u[d[f].name] = d[f].value;
      }
      return u;
    }, a = (c) => new Promise((u, d) => {
      qf(c).then((f) => {
        const p = atob(f.replace("data:image/svg+xml;base64,", ""));
        try {
          const _ = new DOMParser().parseFromString(p, "text/xml").getElementsByTagName("svg")[0];
          _ ? u(_) : d(new Error('Loaded file is not valid SVG"'));
        } catch (v) {
          d(v);
        }
      });
    }), l = (c) => {
      zr[c] || (zr[c] = a(c)), zr[c].then((u) => {
        n.value = u;
      }).catch((u) => {
        delete zr[c], t.emit("error", u);
      });
    };
    return ye(() => e.name, () => {
      l(e.name);
    }, { immediate: !0 }), (c) => U(
      "svg",
      Object.assign(
        { innerHTML: n.value ? n.value.innerHTML : Eb },
        // component attrs and listeners
        i(c.$attrs),
        // source attrs
        s(n.value)
      )
    );
  }
}), Tn = /* @__PURE__ */ je(xb, [["__scopeId", "data-v-e5a222b4"]]), kb = typeof window < "u", bi = kb ? Wf.getParser(window.navigator.userAgent) : null;
bi == null || bi.satisfies({
  ie: "<20",
  safari: "<7",
  chrome: "<40",
  firefox: "<60",
  android: "<4",
  iOS: {
    firefox: "<13"
  }
});
bi == null || bi.satisfies({
  ie: ">=1"
});
function Cb(e, t) {
  window.open(
    e,
    "_self"
  ), window.location.href.startsWith(e.split("#")[0]) && e.includes("#") && window.location.reload();
}
const Qd = {
  size: {
    type: [Number, String],
    default: "1em"
  },
  color: String
};
function Xd(e) {
  return {
    cSize: V(() => e.size in Bs ? `${Bs[e.size]}px` : e.size),
    classes: V(
      () => "q-spinner" + (e.color ? ` text-${e.color}` : "")
    )
  };
}
const Sb = [
  U("circle", {
    cx: "15",
    cy: "15",
    r: "15"
  }, [
    U("animate", {
      attributeName: "r",
      from: "15",
      to: "15",
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    U("animate", {
      attributeName: "fill-opacity",
      from: "1",
      to: "1",
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })
  ]),
  U("circle", {
    cx: "60",
    cy: "15",
    r: "9",
    "fill-opacity": ".3"
  }, [
    U("animate", {
      attributeName: "r",
      from: "9",
      to: "9",
      begin: "0s",
      dur: "0.8s",
      values: "9;15;9",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    U("animate", {
      attributeName: "fill-opacity",
      from: ".5",
      to: ".5",
      begin: "0s",
      dur: "0.8s",
      values: ".5;1;.5",
      calcMode: "linear",
      repeatCount: "indefinite"
    })
  ]),
  U("circle", {
    cx: "105",
    cy: "15",
    r: "15"
  }, [
    U("animate", {
      attributeName: "r",
      from: "15",
      to: "15",
      begin: "0s",
      dur: "0.8s",
      values: "15;9;15",
      calcMode: "linear",
      repeatCount: "indefinite"
    }),
    U("animate", {
      attributeName: "fill-opacity",
      from: "1",
      to: "1",
      begin: "0s",
      dur: "0.8s",
      values: "1;.5;1",
      calcMode: "linear",
      repeatCount: "indefinite"
    })
  ])
], Ob = wt({
  name: "QSpinnerDots",
  props: Qd,
  setup(e) {
    const { cSize: t, classes: n } = Xd(e);
    return () => U("svg", {
      class: n.value,
      fill: "currentColor",
      width: t.value,
      height: t.value,
      viewBox: "0 0 120 30",
      xmlns: "http://www.w3.org/2000/svg"
    }, Sb);
  }
}), La = wt({
  name: "QSpinner",
  props: {
    ...Qd,
    thickness: {
      type: Number,
      default: 5
    }
  },
  setup(e) {
    const { cSize: t, classes: n } = Xd(e);
    return () => U("svg", {
      class: n.value + " q-spinner-mat",
      width: t.value,
      height: t.value,
      viewBox: "25 25 50 50"
    }, [
      U("circle", {
        class: "path",
        cx: "50",
        cy: "50",
        r: "20",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": e.thickness,
        "stroke-miterlimit": "10"
      })
    ]);
  }
}), Nb = {
  dark: "dark",
  white: "white"
}, $b = ["width", "height"], Tb = ["id"], Pb = ["fill"], Db = {
  id: "Page-1",
  stroke: "none",
  "stroke-width": "1",
  fill: "none",
  "fill-rule": "evenodd"
}, Mb = { id: "junglebug" }, Ab = { id: "Fill-1-Clipped" }, Vb = ["fill"], Rb = /* @__PURE__ */ Ee({
  __name: "WsCarySpinner",
  props: {
    color: {
      type: String,
      default: "dark",
      validator: (e) => !!e && e in Nb
    },
    width: {
      type: String,
      default: "80px"
    },
    height: {
      type: String,
      default: "30px"
    }
  },
  setup(e) {
    const t = e;
    return (n, o) => (X(), ue("svg", {
      class: "ws-cary-spinner",
      width: t.width,
      height: t.height,
      viewBox: "0 0 64 26",
      xmlns: "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }, [
      o[1] || (o[1] = ph('<defs data-v-3be1c167><linearGradient id="gradient_dark" x1="100%" y1="0%" x2="0%" y2="0%" data-v-3be1c167><stop offset="0" style="stop-color:rgba(44, 56, 67, 0);" data-v-3be1c167></stop><stop offset="50%" style="stop-color:rgba(44, 56, 67, 1);" data-v-3be1c167></stop><stop offset="100%" style="stop-color:rgba(44, 56, 67, 0);" data-v-3be1c167></stop></linearGradient><linearGradient id="gradient_white" x1="100%" y1="0%" x2="0%" y2="0%" data-v-3be1c167><stop offset="0" style="stop-color:rgba(255,255,255,0);" data-v-3be1c167></stop><stop offset="50%" style="stop-color:rgba(255,255,255,1);" data-v-3be1c167></stop><stop offset="100%" style="stop-color:rgba(255,255,255,0);" data-v-3be1c167></stop></linearGradient><linearGradient id="gradient_default" x1="100%" y1="0%" x2="0%" y2="0%" data-v-3be1c167><stop offset="0" style="stop-color:rgba(0,250,160,0);" data-v-3be1c167></stop><stop offset="50%" style="stop-color:#00FFA0;" data-v-3be1c167></stop><stop offset="100%" style="stop-color:rgba(0,250,160,0);" data-v-3be1c167></stop></linearGradient></defs>', 1)),
      ce("pattern", {
        id: `pattern_${t.color || "default"}`,
        x: "0",
        y: "0",
        width: "400%",
        height: "100%",
        patternUnits: "userSpaceOnUse"
      }, [
        ce("rect", {
          x: "-100%",
          y: "0",
          width: "200%",
          height: "100%",
          fill: `url(#gradient_${t.color || "default"})`,
          transform: "rotate(0)"
        }, o[0] || (o[0] = [
          ce("animate", {
            attributeType: "XML",
            attributeName: "x",
            from: "-400%",
            to: "100%",
            dur: "1.25s",
            repeatCount: "indefinite"
          }, null, -1)
        ]), 8, Pb)
      ], 8, Tb),
      ce("g", Db, [
        ce("g", Mb, [
          ce("g", Ab, [
            ce("path", {
              id: "Fill-1",
              fill: `url(#pattern_${t.color || "default"})`,
              "fill-rule": "nonzero",
              d: `M10.6641 20.0838L17.9686 3.22916C18.5365 1.86109 19.8652
               0.982178 21.3326 0.982178C22.8043 0.982178 24.0821 1.86109
               24.6998 3.22916L31.9989 20.0838L39.3013 3.22916C39.8713 1.86109
               41.1978 0.982178 42.6663 0.982178C44.137 0.982178 45.4158
               1.86109 46.0335 3.22916L53.3315 20.0838L60.636 3.22916C61.2039
               1.86109 62.5315 0.982178 64 0.982178V6.50359L56.8429
               22.7227C56.1764 24.188 54.8499 25.0177 53.3315 25.0177C51.8154
               25.0177 50.4867 24.188 49.8267 22.7227L42.6663 6.50359L35.5092
               22.7227C34.8427 24.188 33.5151 25.0177 31.9989 25.0177C30.4817
               25.0177 29.1541 24.188 28.493 22.7227L21.3326 6.50359L14.1755
               22.7227C13.509 24.188 12.1825 25.0177 10.6641 25.0177C9.14796
               25.0177 7.82037 24.188 7.1582 22.7227L0 6.50359V0.982178C1.46957
               0.982178 2.74949 1.86109 3.36614 3.22916L10.6641 20.0838Z`
            }, null, 8, Vb)
          ])
        ])
      ])
    ], 8, $b));
  }
}), Lb = /* @__PURE__ */ je(Rb, [["__scopeId", "data-v-3be1c167"]]);
var Kn = /* @__PURE__ */ ((e) => (e.CARY = "cary", e.CIRCULAR = "circular", e.DOTS = "dots", e.NONE = "", e))(Kn || {});
const B1 = Kn, Ib = /* @__PURE__ */ Ee({
  name: "WsSpinner",
  components: {
    QSpinner: La,
    QSpinnerDots: Ob,
    WsCarySpinner: Lb
  },
  props: {
    spinnerType: {
      type: String,
      default: ""
    },
    width: {
      type: [String, void 0],
      required: !1,
      default: void 0
    },
    height: {
      type: [String, void 0],
      required: !1,
      default: void 0
    },
    color: {
      type: [String, void 0],
      required: !1,
      default: void 0
    },
    text: {
      type: String,
      required: !1,
      default: ""
    }
  },
  data(e) {
    const t = e.spinnerType, { isTheme: n } = Yu(), o = {
      [Kn.CIRCULAR]: "q-spinner",
      [Kn.CARY]: "ws-cary-spinner",
      [Kn.DOTS]: "q-spinner-dots"
    }, r = V(() => t in o ? o[t] : n(Be.CARY) ? "ws-cary-spinner" : n(Be.LOOPIA) || n(Be.ACTIVE_24) ? "q-spinner-dots" : "q-spinner"), i = V(() => t && t === Kn.CIRCULAR || n(Be.ADMIN) ? e.width || "24px" : e.width || "80px"), s = V(() => e.color ? e.color : n(Be.CARY) ? "dark" : n(Be.LOOPIA) ? "white" : void 0);
    return {
      Theme: Be,
      SpinnerType: Kn,
      currentSpinner: r,
      getSpinnerDefaultSize: i,
      getSpinnerColor: s
    };
  }
}), jb = { class: "ws-spinner" }, qb = {
  key: 0,
  class: "text q-ml-md"
};
function Fb(e, t, n, o, r, i) {
  return X(), ue("div", jb, [
    (X(), He(ba(e.currentSpinner), Bt(e.$attrs, {
      width: e.getSpinnerDefaultSize,
      height: e.height,
      color: e.getSpinnerColor
    }), null, 16, ["width", "height", "color"])),
    e.text ? (X(), ue("span", qb, De(e.$t(e.text)), 1)) : Pe("", !0)
  ]);
}
const Wb = /* @__PURE__ */ je(Ib, [["render", Fb], ["__scopeId", "data-v-a5f5fc2d"]]);
var et = /* @__PURE__ */ ((e) => (e.PRIMARY = "primary", e.SECONDARY = "secondary", e.SECONDARY_INVERSE = "secondary-inverse", e.GHOST = "ghost", e.DANGER = "danger", e.AGENT = "agent", e.TERTIARY = "tertiary", e.TERTIARY_AGENT = "tertiary-agent", e.TERTIARY_DANGER = "tertiary-danger", e.TERTIARY_NEUTRAL = "tertiary-neutral", e.TERTIARY_WHITE = "tertiary-white", e))(et || {}), _o = /* @__PURE__ */ ((e) => (e.A = "a", e.BUTTON = "button", e))(_o || {}), Cn = /* @__PURE__ */ ((e) => (e.SMALL = "small", e.MEDIUM = "medium", e.LARGE = "large", e.XL = "xl", e))(Cn || {});
const z1 = {
  Type: et,
  Element: _o,
  Size: Cn
}, Co = te(Be.CARY), qo = () => ({
  theme: Co,
  isTheme: Bb,
  setTheme: zb
}), Bb = (e) => Co.value === e, zb = (e) => {
  Co.value = e;
}, Hb = {
  install: (e) => {
    const { theme: t } = Yu();
    Co.value = t, Af((n) => Co.value = n), e.config.globalProperties.$theme = Co;
  }
}, Ub = /* @__PURE__ */ Ee({
  __name: "WsButton",
  props: {
    // Keep these first, so they can be used in default values.
    href: {
      type: String,
      required: !1,
      default: void 0
    },
    type: {
      type: String,
      required: !1,
      default: et.GHOST
    },
    element: {
      type: String,
      required: !1,
      default: (e) => e.submit ? _o.BUTTON : e.href && !e.ajax || e.targetBlank ? _o.A : _o.BUTTON
    },
    size: {
      type: String,
      required: !1,
      default: (e) => [
        et.TERTIARY,
        et.TERTIARY_NEUTRAL,
        et.TERTIARY_AGENT,
        et.TERTIARY_DANGER
      ].includes(e.type) ? Cn.SMALL : Cn.LARGE
    },
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    iconRight: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    loading: {
      type: Boolean,
      default: !1
    },
    loaderColor: {
      type: String,
      required: !1,
      default: void 0
    },
    // Ajax props
    ajax: {
      type: Boolean,
      required: !1,
      default: !1
    },
    url: {
      type: String,
      required: !1,
      default: void 0
    },
    ajaxMethod: {
      type: String,
      required: !1,
      default: "POST"
    },
    ajaxErrorMessagePath: {
      type: String,
      required: !1,
      default: "general"
    },
    ajaxParams: {
      type: [Object, Array],
      required: !1,
      default: () => {
      }
    },
    onSuccess: {
      type: Object,
      required: !1,
      default: () => {
      }
    },
    label: {
      type: String,
      required: !1,
      default: void 0
    },
    tooltip: {
      type: String,
      required: !1,
      default: void 0
    },
    // Flags
    submit: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    targetBlank: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    fullWidth: {
      type: Boolean,
      required: !1,
      default: void 0
    },
    noIconType: {
      type: Boolean,
      required: !1,
      default: !1
    }
  },
  emits: [
    "ajax-action-start",
    "ajax-action-success",
    "ajax-action-failed"
  ],
  setup(e, { emit: t }) {
    const { isTheme: n } = qo(), { handleUnstructuredError: o } = Vf(), { responseAction: r } = Rf(), i = Cr(), s = e, a = t, l = te(!1), c = V(() => s.ajax ? l.value : s.loading), u = () => {
      if (s.loaderColor)
        return s.loaderColor;
      if (s.disabled)
        return "dark";
      switch (s.type) {
        case et.PRIMARY:
          return "button-primary";
        case et.DANGER:
          return "white";
        case et.SECONDARY:
          return "dark";
        default:
          return s.loaderColor;
      }
    }, d = () => {
      var _;
      return !s.noIconType && !s.label && !((_ = i.portalSlots) != null && _.includes("default"));
    }, f = V(() => {
      if ([
        et.TERTIARY,
        et.TERTIARY_NEUTRAL,
        et.TERTIARY_AGENT,
        et.TERTIARY_DANGER
      ].includes(s.type))
        return 16;
      switch (s.size) {
        case Cn.SMALL:
          return 16;
        case Cn.MEDIUM:
        case Cn.LARGE:
        case Cn.XL:
        default:
          return 24;
      }
    }), p = () => {
      let _ = {};
      return s.element === _o.A ? (_.role = "button", s.disabled || (_.href = s.href), s.targetBlank && (_.target = "_blank")) : s.submit ?? s.type === et.PRIMARY ? _ = {
        type: "submit"
      } : _ = {
        type: "button"
      }, _;
    }, v = () => {
      var C, S;
      const _ = {};
      return !((C = s.onSuccess) != null && C.reload) && !((S = s.onSuccess) != null && S.redirect) && (_["X-WITH-FLASH-MESSAGES"] = "1"), _;
    }, w = async () => {
      if (s.disabled || c.value)
        return !1;
      if (!s.ajax)
        return !0;
      try {
        a("ajax-action-start"), l.value = !0;
        const { data: _, headers: C } = await Gu({
          url: s.url,
          data: s.ajaxParams,
          method: s.ajaxMethod,
          headers: v()
        }), S = await r(_, C, s.onSuccess);
        a("ajax-action-success", _), l.value = await S.actionPromise;
      } catch (_) {
        console.error(_), o(s.ajaxErrorMessagePath, _), a("ajax-action-failed", _), l.value = !1;
      }
    };
    return (_, C) => {
      const S = nt("portal-slot"), N = xm("ws-analytics");
      return ga((X(), He(ba(e.element), Bt({
        class: [
          "ws-button",
          "type-" + e.type,
          "size-" + e.size,
          {
            "icon-only": d(),
            "icon-right": e.iconRight,
            "full-width": e.fullWidth,
            "state-loading": c.value
          }
        ],
        disabled: e.disabled ? !0 : null
      }, p(), { onClick: w }), {
        default: Me(() => [
          c.value ? (X(), He(Wb, {
            key: 0,
            color: u(),
            width: re(n)(re(Be).ACTIVE_24) ? "50px" : void 0
          }, null, 8, ["color", "width"])) : Pe("", !0),
          ce("div", {
            class: pt(["ws-button__content", { loading: c.value }])
          }, [
            e.icon ? (X(), He(Tn, {
              key: 0,
              name: e.icon,
              size: f.value
            }, null, 8, ["name", "size"])) : Pe("", !0),
            e.label ? (X(), ue(Je, { key: 1 }, [
              ft(De(e.label), 1)
            ], 64)) : (X(), He(S, {
              key: 2,
              slot: _.$slots.default,
              "component-id": _.$attrs["component-id"],
              name: "default"
            }, null, 8, ["slot", "component-id"]))
          ], 2),
          e.tooltip ? (X(), He(Gd, {
            key: 1,
            placement: "top"
          }, {
            default: Me(() => [
              ft(De(e.tooltip), 1)
            ]),
            _: 1
          })) : Pe("", !0)
        ]),
        _: 1
      }, 16, ["class", "disabled"])), [
        [N, _.$attrs["ws-analytics"]]
      ]);
    };
  }
}), Kb = /* @__PURE__ */ je(Ub, [["__scopeId", "data-v-04d62614"]]), H1 = /* @__PURE__ */ Ee({
  __name: "WsBack",
  props: {
    callback: { type: Function, required: !1, default: null },
    url: { type: String, required: !1, default: "" },
    icon: { type: String, required: !1, default: "arrow_left" },
    isCancel: Boolean
  },
  setup(e) {
    const t = e, n = () => {
      t.callback ? t.callback() : t.url && Cb(t.url);
    };
    return (o, r) => (X(), He(Kb, Bt({
      class: "ws-back",
      icon: e.isCancel ? void 0 : e.icon,
      label: o.$t(e.isCancel ? "uikit:general.cancel" : "uikit:general.back"),
      type: re(et).SECONDARY
    }, o.$attrs, { onClick: n }), null, 16, ["icon", "label", "type"]));
  }
});
let hr;
const qe = "https://websupport", Yb = {
  help: {
    se: `${qe}.se/support`,
    hu: `${qe}.hu/tamogatas`,
    sk: `${qe}.sk/podpora`,
    cs: `${qe}.cz/podpora`,
    en_se: `${qe}.se/en/support`,
    en: `${qe}.se/en/support`
  },
  contact: {
    se: `${qe}.se/support`,
    hu: `${qe}.hu/kapcsolat`,
    sk: `${qe}.sk/kontakt`,
    cs: `${qe}.cz/kontakt`,
    en_se: `${qe}.se/en/support`,
    en: `${qe}.se/en/support`
  },
  terms: {
    se: `${qe}.se/om-websupport/avtalsvillkor`,
    hu: `${qe}.hu/aszf`,
    sk: `${qe}.sk/obchodne-podmienky`,
    cs: `${qe}.cz/obchodni-podminky`,
    en_se: `${qe}.se/en/about-websupport/terms-and-conditions`,
    en: `${qe}.se/en/about-websupport/terms-and-conditions`
  },
  privacy: {
    se: `${qe}.se/om-websupport/dataskyddspolicy`,
    hu: `${qe}.hu/adatvedelem`,
    sk: `${qe}.sk/sukromie`,
    cs: `${qe}.cz/soukromi`,
    en_se: `${qe}.se/en/about-websupport/terms-and-conditions`,
    en: `${qe}.se/en/about-websupport/data-protection`
  },
  webadmin: {
    se: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=standard",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=standard",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=standard",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=standard",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=standard"
  },
  webadmin_email: {
    se: "https://auth.websupport.se/?s=admin&l=sv&c=websupport.se&account=email",
    hu: "https://login.websupport.hu/?s=admin&l=hu&c=websupport.hu&account=email",
    sk: "https://login.websupport.sk/?s=admin&l=sk&c=websupport.sk&account=email",
    cs: "https://login.websupport.cz/?s=admin&l=cs&c=websupport.cz&account=email",
    en_se: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email",
    en: "https://auth.websupport.se/?s=admin&l=en&c=websupport.se&account=email"
  }
}, _n = "https://loopia", Gb = {
  help: {
    sv: `${_n}.se/support`,
    en_se: `${_n}.com/support`
  },
  contact: {
    sv: `${_n}.se/support`,
    en_se: `${_n}.com/support`
  },
  terms: {
    sv: `${_n}.se/avtalsvillkor`,
    en_se: `${_n}.com/terms-and-conditions/`
  },
  privacy: {
    sv: `${_n}.se/omloopia/dataskydd/`,
    en_se: `${_n}.com/aboutloopia/data-protection/`
  },
  webadmin: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  },
  webadmin_email: {
    sv: "https://www.loopia.se/loggain/",
    en_se: "https://www.loopia.com/login/"
  }
}, fo = "https://policies.google.com/terms?hl=", po = "https://policies.google.com/privacy?hl=";
let zn = "https://admin.websupport";
const Qb = () => ({
  // Maybe needs to be moved to the company specific part
  admin: {
    se: `${zn}.se`,
    hu: `${zn}.hu`,
    sk: `${zn}.sk`,
    cs: `${zn}.cz`,
    en_se: `${zn}.se/en`,
    en: `${zn}.se/en`
  },
  googleTermsOfService: {
    se: `${fo}sv`,
    hu: `${fo}hu`,
    sk: `${fo}sk`,
    cs: `${fo}cs`,
    en_se: `${fo}en`,
    en: `${fo}en`
  },
  googlePrivacy: {
    se: `${po}sv`,
    hu: `${po}hu`,
    sk: `${po}sk`,
    cs: `${po}cs`,
    en_se: `${po}en`,
    en: `${po}en`
  }
}), Ys = {
  ws: Yb,
  lp: Gb,
  global: Qb()
}, Xb = (e) => {
  let t = e.split("-").shift() || "";
  return [oi.WEBSUPPORT_SE, oi.LOOPIA_SE].includes(hr.company) && t === "en" && (t += "_se"), t;
}, Jb = (e) => new URL(e).hostname.split(".").pop() || "", Zb = (e, t) => {
  const n = Jb(window.location.href), o = t === "en_se" ? "en" : t, r = ri(Ys, [hr.company, e, n]);
  if (!r)
    return;
  const i = new URL(r);
  return i.searchParams.set("l", o), i.toString();
};
function Jd(e) {
  hr = e, zn = [oi.LOOPIA_SE, oi.LOOPIA_NO].includes(hr.company) ? "https://admin.loopia" : "https://admin.websupport";
}
function Gs(e, t) {
  const n = Xb(t), o = hr.company.split("-").pop() || "", r = ri(Ys, [o, e, n]);
  if (e === "webadmin" || e === "webadmin_email") {
    const s = Zb(e, n);
    if (s)
      return s;
  }
  if (r)
    return r;
  const i = ri(Ys, ["global", e, n]);
  return i || console.error(`Url '${e}' not defined!`), i;
}
const ey = { class: "footer__text" }, ty = { class: "q-mb-sm" }, ny = ["innerHTML"], oy = /* @__PURE__ */ Ee({
  __name: "WsHelpSection",
  props: {
    config: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    Jd(e.config);
    const { getLang: n, t: o } = Ci(), { theme: r, isTheme: i } = qo(), s = `assets/images/${r.value.toLowerCase()}/logins`, a = V(() => {
      switch (r.value) {
        case Be.LOOPIA:
          return {
            srcset: `${s}/footer@2x.png 2x`,
            src: `${s}/footer.png`,
            width: 141,
            height: 141
          };
        case Be.ACTIVE_24:
        case Be.CARY:
        default:
          return {
            srcset: `${s}/footer@2x.png 2x`,
            src: `${s}/footer.png`,
            width: 143,
            height: 121
          };
      }
    }), l = () => xs(o("uikit:login_pages.help.text", {
      kb_url: Gs("help", n()),
      support_url: Gs("contact", n())
    }));
    return (c, u) => (X(), ue("div", {
      class: pt(["footer", {
        "items-center": re(i)(re(Be).LOOPIA),
        "items-end": re(i)(re(Be).CARY)
      }])
    }, [
      ce("div", ey, [
        ce("h5", ty, De(re(o)("uikit:login_pages.help.title")), 1),
        ce("p", {
          class: "customized-paragraph text-ws-base110 small q-mb-none",
          innerHTML: l()
        }, null, 8, ny)
      ]),
      ce("img", Bt(a.value, {
        class: "footer__image q-ml-lg",
        alt: ""
      }), null, 16)
    ], 2));
  }
}), U1 = /* @__PURE__ */ je(oy, [["__scopeId", "data-v-07d37e5f"]]), ry = wt({
  name: "QCard",
  props: {
    ...Io,
    tag: {
      type: String,
      default: "div"
    },
    square: Boolean,
    flat: Boolean,
    bordered: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: n } } = Fe(), o = jo(e, n), r = V(
      () => "q-card" + (o.value === !0 ? " q-card--dark q-dark" : "") + (e.bordered === !0 ? " q-card--bordered" : "") + (e.square === !0 ? " q-card--square no-border-radius" : "") + (e.flat === !0 ? " q-card--flat no-shadow" : "")
    );
    return () => U(e.tag, { class: r.value }, Pt(t.default));
  }
}), iu = wt({
  name: "QItemSection",
  props: {
    avatar: Boolean,
    thumbnail: Boolean,
    side: Boolean,
    top: Boolean,
    noWrap: Boolean
  },
  setup(e, { slots: t }) {
    const n = V(
      () => `q-item__section column q-item__section--${e.avatar === !0 || e.side === !0 || e.thumbnail === !0 ? "side" : "main"}` + (e.top === !0 ? " q-item__section--top justify-start" : " justify-center") + (e.avatar === !0 ? " q-item__section--avatar" : "") + (e.thumbnail === !0 ? " q-item__section--thumbnail" : "") + (e.noWrap === !0 ? " q-item__section--nowrap" : "")
    );
    return () => U("div", { class: n.value }, Pt(t.default));
  }
}), iy = wt({
  name: "QItemLabel",
  props: {
    overline: Boolean,
    caption: Boolean,
    header: Boolean,
    lines: [Number, String]
  },
  setup(e, { slots: t }) {
    const n = V(() => parseInt(e.lines, 10)), o = V(
      () => "q-item__label" + (e.overline === !0 ? " q-item__label--overline text-overline" : "") + (e.caption === !0 ? " q-item__label--caption text-caption" : "") + (e.header === !0 ? " q-item__label--header" : "") + (n.value === 1 ? " ellipsis" : "")
    ), r = V(() => e.lines !== void 0 && n.value > 1 ? {
      overflow: "hidden",
      display: "-webkit-box",
      "-webkit-box-orient": "vertical",
      "-webkit-line-clamp": n.value
    } : null);
    return () => U("div", {
      style: r.value,
      class: o.value
    }, Pt(t.default));
  }
});
function ps(e) {
  if (Object(e.$parent) === e.$parent)
    return e.$parent;
  let { parent: t } = e.$;
  for (; Object(t) === t; ) {
    if (Object(t.proxy) === t.proxy)
      return t.proxy;
    t = t.parent;
  }
}
function Zd(e) {
  return e.appContext.config.globalProperties.$router !== void 0;
}
function ef(e) {
  return e.isUnmounted === !0 || e.isDeactivated === !0;
}
function su(e) {
  return e ? e.aliasOf ? e.aliasOf.path : e.path : "";
}
function au(e, t) {
  return (e.aliasOf || e) === (t.aliasOf || t);
}
function sy(e, t) {
  for (const n in t) {
    const o = t[n], r = e[n];
    if (typeof o == "string") {
      if (o !== r)
        return !1;
    } else if (Array.isArray(r) === !1 || r.length !== o.length || o.some((i, s) => i !== r[s]))
      return !1;
  }
  return !0;
}
function lu(e, t) {
  return Array.isArray(t) === !0 ? e.length === t.length && e.every((n, o) => n === t[o]) : e.length === 1 && e[0] === t;
}
function ay(e, t) {
  return Array.isArray(e) === !0 ? lu(e, t) : Array.isArray(t) === !0 ? lu(t, e) : e === t;
}
function ly(e, t) {
  if (Object.keys(e).length !== Object.keys(t).length)
    return !1;
  for (const n in e)
    if (ay(e[n], t[n]) === !1)
      return !1;
  return !0;
}
const tf = {
  // router-link
  to: [String, Object],
  replace: Boolean,
  exact: Boolean,
  activeClass: {
    type: String,
    default: "q-router-link--active"
  },
  exactActiveClass: {
    type: String,
    default: "q-router-link--exact-active"
  },
  // regular <a> link
  href: String,
  target: String,
  // state
  disable: Boolean
};
function nf({ fallbackTag: e, useDisableForRouterLinkProps: t = !0 } = {}) {
  const n = Fe(), { props: o, proxy: r, emit: i } = n, s = Zd(n), a = V(() => o.disable !== !0 && o.href !== void 0), l = V(
    t === !0 ? () => s === !0 && o.disable !== !0 && a.value !== !0 && o.to !== void 0 && o.to !== null && o.to !== "" : () => s === !0 && a.value !== !0 && o.to !== void 0 && o.to !== null && o.to !== ""
  ), c = V(() => l.value === !0 ? S(o.to) : null), u = V(() => c.value !== null), d = V(() => a.value === !0 || u.value === !0), f = V(() => o.type === "a" || d.value === !0 ? "a" : o.tag || e || "div"), p = V(() => a.value === !0 ? {
    href: o.href,
    target: o.target
  } : u.value === !0 ? {
    href: c.value.href,
    target: o.target
  } : {}), v = V(() => {
    if (u.value === !1)
      return -1;
    const { matched: y } = c.value, { length: x } = y, k = y[x - 1];
    if (k === void 0)
      return -1;
    const D = r.$route.matched;
    if (D.length === 0)
      return -1;
    const E = D.findIndex(
      au.bind(null, k)
    );
    if (E > -1)
      return E;
    const O = su(y[x - 2]);
    return (
      // we are dealing with nested routes
      x > 1 && su(k) === O && D[D.length - 1].path !== O ? D.findIndex(
        au.bind(null, y[x - 2])
      ) : E
    );
  }), w = V(
    () => u.value === !0 && v.value !== -1 && sy(r.$route.params, c.value.params)
  ), _ = V(
    () => w.value === !0 && v.value === r.$route.matched.length - 1 && ly(r.$route.params, c.value.params)
  ), C = V(() => u.value === !0 ? _.value === !0 ? ` ${o.exactActiveClass} ${o.activeClass}` : o.exact === !0 ? "" : w.value === !0 ? ` ${o.activeClass}` : "" : "");
  function S(y) {
    try {
      return r.$router.resolve(y);
    } catch {
    }
    return null;
  }
  function N(y, { returnRouterError: x, to: k = o.to, replace: D = o.replace } = {}) {
    if (o.disable === !0)
      return y.preventDefault(), Promise.resolve(!1);
    if (
      // don't redirect with control keys;
      // should match RouterLink from Vue Router
      y.metaKey || y.altKey || y.ctrlKey || y.shiftKey || y.button !== void 0 && y.button !== 0 || o.target === "_blank"
    )
      return Promise.resolve(!1);
    y.preventDefault();
    const E = r.$router[D === !0 ? "replace" : "push"](k);
    return x === !0 ? E : E.then(() => {
    }).catch(() => {
    });
  }
  function m(y) {
    if (u.value === !0) {
      const x = (k) => N(y, k);
      i("click", y, x), y.defaultPrevented !== !0 && x();
    } else
      i("click", y);
  }
  return {
    hasRouterLink: u,
    hasHrefLink: a,
    hasLink: d,
    linkTag: f,
    resolvedLink: c,
    linkIsActive: w,
    linkIsExactActive: _,
    linkClass: C,
    linkAttrs: p,
    getLink: S,
    navigateToRouterLink: N,
    navigateOnClick: m
  };
}
const Dn = {
  hasPassive: !1,
  passiveCapture: !0,
  notPassiveCapture: !0
};
try {
  const e = Object.defineProperty({}, "passive", {
    get() {
      Object.assign(Dn, {
        hasPassive: !0,
        passive: { passive: !0 },
        notPassive: { passive: !1 },
        passiveCapture: { passive: !0, capture: !0 },
        notPassiveCapture: { passive: !1, capture: !0 }
      });
    }
  });
  window.addEventListener("qtest", null, e), window.removeEventListener("qtest", null, e);
} catch {
}
function vr() {
}
function of(e) {
  return e.touches && e.touches[0] ? e = e.touches[0] : e.changedTouches && e.changedTouches[0] ? e = e.changedTouches[0] : e.targetTouches && e.targetTouches[0] && (e = e.targetTouches[0]), {
    top: e.clientY,
    left: e.clientX
  };
}
function gr(e) {
  e.stopPropagation();
}
function On(e) {
  e.cancelable !== !1 && e.preventDefault();
}
function an(e) {
  e.cancelable !== !1 && e.preventDefault(), e.stopPropagation();
}
function Qs(e, t, n) {
  const o = `__q_${t}_evt`;
  e[o] = e[o] !== void 0 ? e[o].concat(n) : n, n.forEach((r) => {
    r[0].addEventListener(r[1], e[r[2]], Dn[r[3]]);
  });
}
function rf(e, t) {
  const n = `__q_${t}_evt`;
  e[n] !== void 0 && (e[n].forEach((o) => {
    o[0].removeEventListener(o[1], e[o[2]], Dn[o[3]]);
  }), e[n] = void 0);
}
let sf = !1;
function uy(e) {
  sf = e.isComposing === !0;
}
function af(e) {
  return sf === !0 || e !== Object(e) || e.isComposing === !0 || e.qKeyEvent === !0;
}
function Ao(e, t) {
  return af(e) === !0 ? !1 : [].concat(t).includes(e.keyCode);
}
const cy = wt({
  name: "QItem",
  props: {
    ...Io,
    ...tf,
    tag: {
      type: String,
      default: "div"
    },
    active: {
      type: Boolean,
      default: null
    },
    clickable: Boolean,
    dense: Boolean,
    insetLevel: Number,
    tabindex: [String, Number],
    focused: Boolean,
    manualFocus: Boolean
  },
  emits: ["click", "keyup"],
  setup(e, { slots: t, emit: n }) {
    const { proxy: { $q: o } } = Fe(), r = jo(e, o), { hasLink: i, linkAttrs: s, linkClass: a, linkTag: l, navigateOnClick: c } = nf(), u = te(null), d = te(null), f = V(
      () => e.clickable === !0 || i.value === !0 || e.tag === "label"
    ), p = V(
      () => e.disable !== !0 && f.value === !0
    ), v = V(
      () => "q-item q-item-type row no-wrap" + (e.dense === !0 ? " q-item--dense" : "") + (r.value === !0 ? " q-item--dark" : "") + (i.value === !0 && e.active === null ? a.value : e.active === !0 ? ` q-item--active${e.activeClass !== void 0 ? ` ${e.activeClass}` : ""}` : "") + (e.disable === !0 ? " disabled" : "") + (p.value === !0 ? " q-item--clickable q-link cursor-pointer " + (e.manualFocus === !0 ? "q-manual-focusable" : "q-focusable q-hoverable") + (e.focused === !0 ? " q-manual-focusable--focused" : "") : "")
    ), w = V(() => e.insetLevel === void 0 ? null : {
      ["padding" + (o.lang.rtl === !0 ? "Right" : "Left")]: 16 + e.insetLevel * 56 + "px"
    });
    function _(N) {
      p.value === !0 && (d.value !== null && (N.qKeyEvent !== !0 && document.activeElement === u.value ? d.value.focus() : document.activeElement === d.value && u.value.focus()), c(N));
    }
    function C(N) {
      if (p.value === !0 && Ao(N, [13, 32]) === !0) {
        an(N), N.qKeyEvent = !0;
        const m = new MouseEvent("click", N);
        m.qKeyEvent = !0, u.value.dispatchEvent(m);
      }
      n("keyup", N);
    }
    function S() {
      const N = xv(t.default, []);
      return p.value === !0 && N.unshift(
        U("div", { class: "q-focus-helper", tabindex: -1, ref: d })
      ), N;
    }
    return () => {
      const N = {
        ref: u,
        class: v.value,
        style: w.value,
        role: "listitem",
        onClick: _,
        onKeyup: C
      };
      return p.value === !0 ? (N.tabindex = e.tabindex || "0", Object.assign(N, s.value)) : f.value === !0 && (N["aria-disabled"] = "true"), U(
        l.value,
        N,
        S()
      );
    };
  }
}), dy = wt({
  name: "QList",
  props: {
    ...Io,
    bordered: Boolean,
    dense: Boolean,
    separator: Boolean,
    padding: Boolean,
    tag: {
      type: String,
      default: "div"
    }
  },
  setup(e, { slots: t }) {
    const n = Fe(), o = jo(e, n.proxy.$q), r = V(
      () => "q-list" + (e.bordered === !0 ? " q-list--bordered" : "") + (e.dense === !0 ? " q-list--dense" : "") + (e.separator === !0 ? " q-list--separator" : "") + (o.value === !0 ? " q-list--dark" : "") + (e.padding === !0 ? " q-list--padding" : "")
    );
    return () => U(e.tag, { class: r.value }, Pt(t.default));
  }
}), uu = "0 0 24 24", cu = (e) => e, ms = (e) => `ionicons ${e}`, lf = {
  "mdi-": (e) => `mdi ${e}`,
  "icon-": cu,
  // fontawesome equiv
  "bt-": (e) => `bt ${e}`,
  "eva-": (e) => `eva ${e}`,
  "ion-md": ms,
  "ion-ios": ms,
  "ion-logo": ms,
  "iconfont ": cu,
  "ti-": (e) => `themify-icon ${e}`,
  "bi-": (e) => `bootstrap-icons ${e}`
}, uf = {
  o_: "-outlined",
  r_: "-round",
  s_: "-sharp"
}, cf = {
  sym_o_: "-outlined",
  sym_r_: "-rounded",
  sym_s_: "-sharp"
}, fy = new RegExp("^(" + Object.keys(lf).join("|") + ")"), py = new RegExp("^(" + Object.keys(uf).join("|") + ")"), du = new RegExp("^(" + Object.keys(cf).join("|") + ")"), my = /^[Mm]\s?[-+]?\.?\d/, hy = /^img:/, vy = /^svguse:/, gy = /^ion-/, by = /^(fa-(sharp|solid|regular|light|brands|duotone|thin)|[lf]a[srlbdk]?) /, br = wt({
  name: "QIcon",
  props: {
    ...Oa,
    tag: {
      type: String,
      default: "i"
    },
    name: String,
    color: String,
    left: Boolean,
    right: Boolean
  },
  setup(e, { slots: t }) {
    const { proxy: { $q: n } } = Fe(), o = Na(e), r = V(
      () => "q-icon" + (e.left === !0 ? " on-left" : "") + (e.right === !0 ? " on-right" : "") + (e.color !== void 0 ? ` text-${e.color}` : "")
    ), i = V(() => {
      let s, a = e.name;
      if (a === "none" || !a)
        return { none: !0 };
      if (n.iconMapFn !== null) {
        const u = n.iconMapFn(a);
        if (u !== void 0)
          if (u.icon !== void 0) {
            if (a = u.icon, a === "none" || !a)
              return { none: !0 };
          } else
            return {
              cls: u.cls,
              content: u.content !== void 0 ? u.content : " "
            };
      }
      if (my.test(a) === !0) {
        const [u, d = uu] = a.split("|");
        return {
          svg: !0,
          viewBox: d,
          nodes: u.split("&&").map((f) => {
            const [p, v, w] = f.split("@@");
            return U("path", { style: v, d: p, transform: w });
          })
        };
      }
      if (hy.test(a) === !0)
        return {
          img: !0,
          src: a.substring(4)
        };
      if (vy.test(a) === !0) {
        const [u, d = uu] = a.split("|");
        return {
          svguse: !0,
          src: u.substring(7),
          viewBox: d
        };
      }
      let l = " ";
      const c = a.match(fy);
      if (c !== null)
        s = lf[c[1]](a);
      else if (by.test(a) === !0)
        s = a;
      else if (gy.test(a) === !0)
        s = `ionicons ion-${n.platform.is.ios === !0 ? "ios" : "md"}${a.substring(3)}`;
      else if (du.test(a) === !0) {
        s = "notranslate material-symbols";
        const u = a.match(du);
        u !== null && (a = a.substring(6), s += cf[u[1]]), l = a;
      } else {
        s = "notranslate material-icons";
        const u = a.match(py);
        u !== null && (a = a.substring(2), s += uf[u[1]]), l = a;
      }
      return {
        cls: s,
        content: l
      };
    });
    return () => {
      const s = {
        class: r.value,
        style: o.value,
        "aria-hidden": "true",
        role: "presentation"
      };
      return i.value.none === !0 ? U(e.tag, s, Pt(t.default)) : i.value.img === !0 ? U("span", s, wo(t.default, [
        U("img", { src: i.value.src })
      ])) : i.value.svg === !0 ? U("span", s, wo(t.default, [
        U("svg", {
          viewBox: i.value.viewBox || "0 0 24 24"
        }, i.value.nodes)
      ])) : i.value.svguse === !0 ? U("span", s, wo(t.default, [
        U("svg", {
          viewBox: i.value.viewBox
        }, [
          U("use", { "xlink:href": i.value.src })
        ])
      ])) : (i.value.cls !== void 0 && (s.class += " " + i.value.cls), U(e.tag, s, wo(t.default, [
        i.value.content
      ])));
    };
  }
});
function Xs(e, t) {
  const n = e.style;
  for (const o in t)
    n[o] = t[o];
}
function yy(e) {
  if (e == null)
    return;
  if (typeof e == "string")
    try {
      return document.querySelector(e) || void 0;
    } catch {
      return;
    }
  const t = re(e);
  if (t)
    return t.$el || t;
}
function wy(e, t) {
  if (e == null || e.contains(t) === !0)
    return !0;
  for (let n = e.nextElementSibling; n !== null; n = n.nextElementSibling)
    if (n.contains(t))
      return !0;
  return !1;
}
function _y(e, t = 250) {
  let n = !1, o;
  return function() {
    return n === !1 && (n = !0, setTimeout(() => {
      n = !1;
    }, t), o = e.apply(this, arguments)), o;
  };
}
function fu(e, t, n, o) {
  n.modifiers.stop === !0 && gr(e);
  const r = n.modifiers.color;
  let i = n.modifiers.center;
  i = i === !0 || o === !0;
  const s = document.createElement("span"), a = document.createElement("span"), l = of(e), { left: c, top: u, width: d, height: f } = t.getBoundingClientRect(), p = Math.sqrt(d * d + f * f), v = p / 2, w = `${(d - p) / 2}px`, _ = i ? w : `${l.left - c - v}px`, C = `${(f - p) / 2}px`, S = i ? C : `${l.top - u - v}px`;
  a.className = "q-ripple__inner", Xs(a, {
    height: `${p}px`,
    width: `${p}px`,
    transform: `translate3d(${_},${S},0) scale3d(.2,.2,1)`,
    opacity: 0
  }), s.className = `q-ripple${r ? " text-" + r : ""}`, s.setAttribute("dir", "ltr"), s.appendChild(a), t.appendChild(s);
  const N = () => {
    s.remove(), clearTimeout(m);
  };
  n.abort.push(N);
  let m = setTimeout(() => {
    a.classList.add("q-ripple__inner--enter"), a.style.transform = `translate3d(${w},${C},0) scale3d(1,1,1)`, a.style.opacity = 0.2, m = setTimeout(() => {
      a.classList.remove("q-ripple__inner--enter"), a.classList.add("q-ripple__inner--leave"), a.style.opacity = 0, m = setTimeout(() => {
        s.remove(), n.abort.splice(n.abort.indexOf(N), 1);
      }, 275);
    }, 250);
  }, 50);
}
function pu(e, { modifiers: t, value: n, arg: o }) {
  const r = Object.assign({}, e.cfg.ripple, t, n);
  e.modifiers = {
    early: r.early === !0,
    stop: r.stop === !0,
    center: r.center === !0,
    color: r.color || o,
    keyCodes: [].concat(r.keyCodes || 13)
  };
}
const Ey = Ev(
  {
    name: "ripple",
    beforeMount(e, t) {
      const n = t.instance.$.appContext.config.globalProperties.$q.config || {};
      if (n.ripple === !1)
        return;
      const o = {
        cfg: n,
        enabled: t.value !== !1,
        modifiers: {},
        abort: [],
        start(r) {
          o.enabled === !0 && r.qSkipRipple !== !0 && r.type === (o.modifiers.early === !0 ? "pointerdown" : "click") && fu(r, e, o, r.qKeyEvent === !0);
        },
        keystart: _y((r) => {
          o.enabled === !0 && r.qSkipRipple !== !0 && Ao(r, o.modifiers.keyCodes) === !0 && r.type === `key${o.modifiers.early === !0 ? "down" : "up"}` && fu(r, e, o, !0);
        }, 300)
      };
      pu(o, t), e.__qripple = o, Qs(o, "main", [
        [e, "pointerdown", "start", "passive"],
        [e, "click", "start", "passive"],
        [e, "keydown", "keystart", "passive"],
        [e, "keyup", "keystart", "passive"]
      ]);
    },
    updated(e, t) {
      if (t.oldValue !== t.value) {
        const n = e.__qripple;
        n !== void 0 && (n.enabled = t.value !== !1, n.enabled === !0 && Object(t.value) === t.value && pu(n, t));
      }
    },
    beforeUnmount(e) {
      const t = e.__qripple;
      t !== void 0 && (t.abort.forEach((n) => {
        n();
      }), rf(t, "main"), delete e._qripple);
    }
  }
), df = {
  left: "start",
  center: "center",
  right: "end",
  between: "between",
  around: "around",
  evenly: "evenly",
  stretch: "stretch"
}, xy = Object.keys(df), ky = {
  align: {
    type: String,
    validator: (e) => xy.includes(e)
  }
};
function Cy(e) {
  return V(() => {
    const t = e.align === void 0 ? e.vertical === !0 ? "stretch" : "left" : e.align;
    return `${e.vertical === !0 ? "items" : "justify"}-${df[t]}`;
  });
}
const mu = {
  none: 0,
  xs: 4,
  sm: 8,
  md: 16,
  lg: 24,
  xl: 32
}, Sy = {
  xs: 8,
  sm: 10,
  md: 14,
  lg: 20,
  xl: 24
}, Oy = ["button", "submit", "reset"], Ny = /[^\s]\/[^\s]/, $y = ["flat", "outline", "push", "unelevated"], ff = (e, t) => e.flat === !0 ? "flat" : e.outline === !0 ? "outline" : e.push === !0 ? "push" : e.unelevated === !0 ? "unelevated" : t, Ty = (e) => {
  const t = ff(e);
  return t !== void 0 ? { [t]: !0 } : {};
}, Ia = {
  ...Oa,
  ...tf,
  type: {
    type: String,
    default: "button"
  },
  label: [Number, String],
  icon: String,
  iconRight: String,
  ...$y.reduce(
    (e, t) => (e[t] = Boolean) && e,
    {}
  ),
  square: Boolean,
  round: Boolean,
  rounded: Boolean,
  glossy: Boolean,
  size: String,
  fab: Boolean,
  fabMini: Boolean,
  padding: String,
  color: String,
  textColor: String,
  noCaps: Boolean,
  noWrap: Boolean,
  dense: Boolean,
  tabindex: [Number, String],
  ripple: {
    type: [Boolean, Object],
    default: !0
  },
  align: {
    ...ky.align,
    default: "center"
  },
  stack: Boolean,
  stretch: Boolean,
  loading: {
    type: Boolean,
    default: null
  },
  disable: Boolean
};
function Py(e) {
  const t = Na(e, Sy), n = Cy(e), { hasRouterLink: o, hasLink: r, linkTag: i, linkAttrs: s, navigateOnClick: a } = nf({
    fallbackTag: "button"
  }), l = V(() => {
    const _ = e.fab === !1 && e.fabMini === !1 ? t.value : {};
    return e.padding !== void 0 ? Object.assign({}, _, {
      padding: e.padding.split(/\s+/).map((C) => C in mu ? mu[C] + "px" : C).join(" "),
      minWidth: "0",
      minHeight: "0"
    }) : _;
  }), c = V(
    () => e.rounded === !0 || e.fab === !0 || e.fabMini === !0
  ), u = V(
    () => e.disable !== !0 && e.loading !== !0
  ), d = V(() => u.value === !0 ? e.tabindex || 0 : -1), f = V(() => ff(e, "standard")), p = V(() => {
    const _ = { tabindex: d.value };
    return r.value === !0 ? Object.assign(_, s.value) : Oy.includes(e.type) === !0 && (_.type = e.type), i.value === "a" ? (e.disable === !0 ? _["aria-disabled"] = "true" : _.href === void 0 && (_.role = "button"), o.value !== !0 && Ny.test(e.type) === !0 && (_.type = e.type)) : e.disable === !0 && (_.disabled = "", _["aria-disabled"] = "true"), e.loading === !0 && e.percentage !== void 0 && Object.assign(_, {
      role: "progressbar",
      "aria-valuemin": 0,
      "aria-valuemax": 100,
      "aria-valuenow": e.percentage
    }), _;
  }), v = V(() => {
    let _;
    e.color !== void 0 ? e.flat === !0 || e.outline === !0 ? _ = `text-${e.textColor || e.color}` : _ = `bg-${e.color} text-${e.textColor || "white"}` : e.textColor && (_ = `text-${e.textColor}`);
    const C = e.round === !0 ? "round" : `rectangle${c.value === !0 ? " q-btn--rounded" : e.square === !0 ? " q-btn--square" : ""}`;
    return `q-btn--${f.value} q-btn--${C}` + (_ !== void 0 ? " " + _ : "") + (u.value === !0 ? " q-btn--actionable q-focusable q-hoverable" : e.disable === !0 ? " disabled" : "") + (e.fab === !0 ? " q-btn--fab" : e.fabMini === !0 ? " q-btn--fab-mini" : "") + (e.noCaps === !0 ? " q-btn--no-uppercase" : "") + (e.dense === !0 ? " q-btn--dense" : "") + (e.stretch === !0 ? " no-border-radius self-stretch" : "") + (e.glossy === !0 ? " glossy" : "") + (e.square ? " q-btn--square" : "");
  }), w = V(
    () => n.value + (e.stack === !0 ? " column" : " row") + (e.noWrap === !0 ? " no-wrap text-no-wrap" : "") + (e.loading === !0 ? " q-btn__content--hidden" : "")
  );
  return {
    classes: v,
    style: l,
    innerClasses: w,
    attributes: p,
    hasLink: r,
    linkTag: i,
    navigateOnClick: a,
    isActionable: u
  };
}
const { passiveCapture: $t } = Dn;
let mo = null, ho = null, vo = null;
const hs = wt({
  name: "QBtn",
  props: {
    ...Ia,
    percentage: Number,
    darkPercentage: Boolean,
    onTouchstart: [Function, Array]
  },
  emits: ["click", "keydown", "mousedown", "keyup"],
  setup(e, { slots: t, emit: n }) {
    const { proxy: o } = Fe(), {
      classes: r,
      style: i,
      innerClasses: s,
      attributes: a,
      hasLink: l,
      linkTag: c,
      navigateOnClick: u,
      isActionable: d
    } = Py(e), f = te(null), p = te(null);
    let v = null, w, _ = null;
    const C = V(
      () => e.label !== void 0 && e.label !== null && e.label !== ""
    ), S = V(() => e.disable === !0 || e.ripple === !1 ? !1 : {
      keyCodes: l.value === !0 ? [13, 32] : [13],
      ...e.ripple === !0 ? {} : e.ripple
    }), N = V(() => ({ center: e.round })), m = V(() => {
      const M = Math.max(0, Math.min(100, e.percentage));
      return M > 0 ? { transition: "transform 0.6s", transform: `translateX(${M - 100}%)` } : {};
    }), y = V(() => {
      if (e.loading === !0)
        return {
          onMousedown: R,
          onTouchstart: R,
          onClick: R,
          onKeydown: R,
          onKeyup: R
        };
      if (d.value === !0) {
        const M = {
          onClick: k,
          onKeydown: D,
          onMousedown: O
        };
        if (o.$q.platform.has.touch === !0) {
          const G = e.onTouchstart !== void 0 ? "" : "Passive";
          M[`onTouchstart${G}`] = E;
        }
        return M;
      }
      return {
        // needed; especially for disabled <a> tags
        onClick: an
      };
    }), x = V(() => ({
      ref: f,
      class: "q-btn q-btn-item non-selectable no-outline " + r.value,
      style: i.value,
      ...a.value,
      ...y.value
    }));
    function k(M) {
      if (f.value !== null) {
        if (M !== void 0) {
          if (M.defaultPrevented === !0)
            return;
          const G = document.activeElement;
          if (e.type === "submit" && G !== document.body && f.value.contains(G) === !1 && G.contains(f.value) === !1) {
            f.value.focus();
            const Q = () => {
              document.removeEventListener("keydown", an, !0), document.removeEventListener("keyup", Q, $t), f.value !== null && f.value.removeEventListener("blur", Q, $t);
            };
            document.addEventListener("keydown", an, !0), document.addEventListener("keyup", Q, $t), f.value.addEventListener("blur", Q, $t);
          }
        }
        u(M);
      }
    }
    function D(M) {
      f.value !== null && (n("keydown", M), Ao(M, [13, 32]) === !0 && ho !== f.value && (ho !== null && g(), M.defaultPrevented !== !0 && (f.value.focus(), ho = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("keyup", A, !0), f.value.addEventListener("blur", A, $t)), an(M)));
    }
    function E(M) {
      f.value !== null && (n("touchstart", M), M.defaultPrevented !== !0 && (mo !== f.value && (mo !== null && g(), mo = f.value, v = M.target, v.addEventListener("touchcancel", A, $t), v.addEventListener("touchend", A, $t)), w = !0, _ !== null && clearTimeout(_), _ = setTimeout(() => {
        _ = null, w = !1;
      }, 200)));
    }
    function O(M) {
      f.value !== null && (M.qSkipRipple = w === !0, n("mousedown", M), M.defaultPrevented !== !0 && vo !== f.value && (vo !== null && g(), vo = f.value, f.value.classList.add("q-btn--active"), document.addEventListener("mouseup", A, $t)));
    }
    function A(M) {
      if (f.value !== null && !(M !== void 0 && M.type === "blur" && document.activeElement === f.value)) {
        if (M !== void 0 && M.type === "keyup") {
          if (ho === f.value && Ao(M, [13, 32]) === !0) {
            const G = new MouseEvent("click", M);
            G.qKeyEvent = !0, M.defaultPrevented === !0 && On(G), M.cancelBubble === !0 && gr(G), f.value.dispatchEvent(G), an(M), M.qKeyEvent = !0;
          }
          n("keyup", M);
        }
        g();
      }
    }
    function g(M) {
      const G = p.value;
      M !== !0 && (mo === f.value || vo === f.value) && G !== null && G !== document.activeElement && (G.setAttribute("tabindex", -1), G.focus()), mo === f.value && (v !== null && (v.removeEventListener("touchcancel", A, $t), v.removeEventListener("touchend", A, $t)), mo = v = null), vo === f.value && (document.removeEventListener("mouseup", A, $t), vo = null), ho === f.value && (document.removeEventListener("keyup", A, !0), f.value !== null && f.value.removeEventListener("blur", A, $t), ho = null), f.value !== null && f.value.classList.remove("q-btn--active");
    }
    function R(M) {
      an(M), M.qSkipRipple = !0;
    }
    return St(() => {
      g(!0);
    }), Object.assign(o, { click: k }), () => {
      let M = [];
      e.icon !== void 0 && M.push(
        U(br, {
          name: e.icon,
          left: e.stack !== !0 && C.value === !0,
          role: "img",
          "aria-hidden": "true"
        })
      ), C.value === !0 && M.push(
        U("span", { class: "block" }, [e.label])
      ), M = wo(t.default, M), e.iconRight !== void 0 && e.round === !1 && M.push(
        U(br, {
          name: e.iconRight,
          right: e.stack !== !0 && C.value === !0,
          role: "img",
          "aria-hidden": "true"
        })
      );
      const G = [
        U("span", {
          class: "q-focus-helper",
          ref: p
        })
      ];
      return e.loading === !0 && e.percentage !== void 0 && G.push(
        U("span", {
          class: "q-btn__progress absolute-full overflow-hidden" + (e.darkPercentage === !0 ? " q-btn__progress--dark" : "")
        }, [
          U("span", {
            class: "q-btn__progress-indicator fit block",
            style: m.value
          })
        ])
      ), G.push(
        U("span", {
          class: "q-btn__content text-center col items-center q-anchor--skip " + s.value
        }, M)
      ), e.loading !== null && G.push(
        U(Sa, {
          name: "q-transition--fade"
        }, () => e.loading === !0 ? [
          U("span", {
            key: "loading",
            class: "absolute-full flex flex-center"
          }, t.loading !== void 0 ? t.loading() : [U(La)])
        ] : null)
      ), ga(
        U(
          c.value,
          x.value,
          G
        ),
        [[
          Ey,
          S.value,
          void 0,
          N.value
        ]]
      );
    };
  }
}), Dy = wt({
  name: "QBtnGroup",
  props: {
    unelevated: Boolean,
    outline: Boolean,
    flat: Boolean,
    rounded: Boolean,
    square: Boolean,
    push: Boolean,
    stretch: Boolean,
    glossy: Boolean,
    spread: Boolean
  },
  setup(e, { slots: t }) {
    const n = V(() => {
      const o = ["unelevated", "outline", "flat", "rounded", "square", "push", "stretch", "glossy"].filter((r) => e[r] === !0).map((r) => `q-btn-group--${r}`).join(" ");
      return `q-btn-group row no-wrap${o.length !== 0 ? " " + o : ""}` + (e.spread === !0 ? " q-btn-group--spread" : " inline");
    });
    return () => U("div", { class: n.value }, Pt(t.default));
  }
});
function Fo(e, t, n, o) {
  return Object.defineProperty(e, t, {
    get: n,
    set: o,
    enumerable: !0
  }), e;
}
const Mn = te(
  !1
);
let Hi;
function My(e, t) {
  const n = /(edg|edge|edga|edgios)\/([\w.]+)/.exec(e) || /(opr)[\/]([\w.]+)/.exec(e) || /(vivaldi)[\/]([\w.]+)/.exec(e) || /(chrome|crios)[\/]([\w.]+)/.exec(e) || /(version)(applewebkit)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+).*(version)[\/]([\w.]+).*(safari)[\/]([\w.]+)/.exec(e) || /(firefox|fxios)[\/]([\w.]+)/.exec(e) || /(webkit)[\/]([\w.]+)/.exec(e) || /(opera)(?:.*version|)[\/]([\w.]+)/.exec(e) || [];
  return {
    browser: n[5] || n[3] || n[1] || "",
    version: n[2] || n[4] || "0",
    versionNumber: n[4] || n[2] || "0",
    platform: t[0] || ""
  };
}
function Ay(e) {
  return /(ipad)/.exec(e) || /(ipod)/.exec(e) || /(windows phone)/.exec(e) || /(iphone)/.exec(e) || /(kindle)/.exec(e) || /(silk)/.exec(e) || /(android)/.exec(e) || /(win)/.exec(e) || /(mac)/.exec(e) || /(linux)/.exec(e) || /(cros)/.exec(e) || /(playbook)/.exec(e) || /(bb)/.exec(e) || /(blackberry)/.exec(e) || [];
}
const pf = "ontouchstart" in window || window.navigator.maxTouchPoints > 0;
function Vy(e) {
  Hi = { is: { ...e } }, delete e.mac, delete e.desktop;
  const t = Math.min(window.innerHeight, window.innerWidth) > 414 ? "ipad" : "iphone";
  Object.assign(e, {
    mobile: !0,
    ios: !0,
    platform: t,
    [t]: !0
  });
}
function Ry(e) {
  const t = e.toLowerCase(), n = Ay(t), o = My(t, n), r = {};
  o.browser && (r[o.browser] = !0, r.version = o.version, r.versionNumber = parseInt(o.versionNumber, 10)), o.platform && (r[o.platform] = !0);
  const i = r.android || r.ios || r.bb || r.blackberry || r.ipad || r.iphone || r.ipod || r.kindle || r.playbook || r.silk || r["windows phone"];
  return i === !0 || t.indexOf("mobile") > -1 ? (r.mobile = !0, r.edga || r.edgios ? (r.edge = !0, o.browser = "edge") : r.crios ? (r.chrome = !0, o.browser = "chrome") : r.fxios && (r.firefox = !0, o.browser = "firefox")) : r.desktop = !0, (r.ipod || r.ipad || r.iphone) && (r.ios = !0), r["windows phone"] && (r.winphone = !0, delete r["windows phone"]), (r.chrome || r.opr || r.safari || r.vivaldi || r.mobile === !0 && r.ios !== !0 && i !== !0) && (r.webkit = !0), r.edg && (o.browser = "edgechromium", r.edgeChromium = !0), (r.safari && r.blackberry || r.bb) && (o.browser = "blackberry", r.blackberry = !0), r.safari && r.playbook && (o.browser = "playbook", r.playbook = !0), r.opr && (o.browser = "opera", r.opera = !0), r.safari && r.android && (o.browser = "android", r.android = !0), r.safari && r.kindle && (o.browser = "kindle", r.kindle = !0), r.safari && r.silk && (o.browser = "silk", r.silk = !0), r.vivaldi && (o.browser = "vivaldi", r.vivaldi = !0), r.name = o.browser, r.platform = o.platform, t.indexOf("electron") > -1 ? r.electron = !0 : document.location.href.indexOf("-extension://") > -1 ? r.bex = !0 : (window.Capacitor !== void 0 ? (r.capacitor = !0, r.nativeMobile = !0, r.nativeMobileWrapper = "capacitor") : (window._cordovaNative !== void 0 || window.cordova !== void 0) && (r.cordova = !0, r.nativeMobile = !0, r.nativeMobileWrapper = "cordova"), pf === !0 && r.mac === !0 && (r.desktop === !0 && r.safari === !0 || r.nativeMobile === !0 && r.android !== !0 && r.ios !== !0 && r.ipad !== !0) && Vy(r)), r;
}
const hu = navigator.userAgent || navigator.vendor || window.opera, Ly = {
  has: {
    touch: !1,
    webStorage: !1
  },
  within: { iframe: !1 }
}, at = {
  userAgent: hu,
  is: Ry(hu),
  has: {
    touch: pf
  },
  within: {
    iframe: window.self !== window.top
  }
}, yi = {
  install(e) {
    const { $q: t } = e;
    Mn.value === !0 ? (e.onSSRHydrated.push(() => {
      Object.assign(t.platform, at), Mn.value = !1, Hi = void 0;
    }), t.platform = Ro(this)) : t.platform = this;
  }
};
{
  let e;
  Fo(at.has, "webStorage", () => {
    if (e !== void 0)
      return e;
    try {
      if (window.localStorage)
        return e = !0, !0;
    } catch {
    }
    return e = !1, !1;
  }), at.is.ios === !0 && window.navigator.vendor.toLowerCase().indexOf("apple"), Mn.value === !0 ? Object.assign(yi, at, Hi, Ly) : Object.assign(yi, at);
}
function Iy() {
  if (window.getSelection !== void 0) {
    const e = window.getSelection();
    e.empty !== void 0 ? e.empty() : e.removeAllRanges !== void 0 && (e.removeAllRanges(), yi.is.mobile !== !0 && e.addRange(document.createRange()));
  } else document.selection !== void 0 && document.selection.empty();
}
const jy = {
  target: {
    default: !0
  },
  noParentEvent: Boolean,
  contextMenu: Boolean
};
function qy({
  showing: e,
  avoidEmit: t,
  // required for QPopupProxy (true)
  configureAnchorEl: n
  // optional
}) {
  const { props: o, proxy: r, emit: i } = Fe(), s = te(null);
  let a = null;
  function l(p) {
    return s.value === null ? !1 : p === void 0 || p.touches === void 0 || p.touches.length <= 1;
  }
  const c = {};
  n === void 0 && (Object.assign(c, {
    hide(p) {
      r.hide(p);
    },
    toggle(p) {
      r.toggle(p), p.qAnchorHandled = !0;
    },
    toggleKey(p) {
      Ao(p, 13) === !0 && c.toggle(p);
    },
    contextClick(p) {
      r.hide(p), On(p), tt(() => {
        r.show(p), p.qAnchorHandled = !0;
      });
    },
    prevent: On,
    mobileTouch(p) {
      if (c.mobileCleanup(p), l(p) !== !0)
        return;
      r.hide(p), s.value.classList.add("non-selectable");
      const v = p.target;
      Qs(c, "anchor", [
        [v, "touchmove", "mobileCleanup", "passive"],
        [v, "touchend", "mobileCleanup", "passive"],
        [v, "touchcancel", "mobileCleanup", "passive"],
        [s.value, "contextmenu", "prevent", "notPassive"]
      ]), a = setTimeout(() => {
        a = null, r.show(p), p.qAnchorHandled = !0;
      }, 300);
    },
    mobileCleanup(p) {
      s.value.classList.remove("non-selectable"), a !== null && (clearTimeout(a), a = null), e.value === !0 && p !== void 0 && Iy();
    }
  }), n = function(p = o.contextMenu) {
    if (o.noParentEvent === !0 || s.value === null)
      return;
    let v;
    p === !0 ? r.$q.platform.is.mobile === !0 ? v = [
      [s.value, "touchstart", "mobileTouch", "passive"]
    ] : v = [
      [s.value, "mousedown", "hide", "passive"],
      [s.value, "contextmenu", "contextClick", "notPassive"]
    ] : v = [
      [s.value, "click", "toggle", "passive"],
      [s.value, "keyup", "toggleKey", "passive"]
    ], Qs(c, "anchor", v);
  });
  function u() {
    rf(c, "anchor");
  }
  function d(p) {
    for (s.value = p; s.value.classList.contains("q-anchor--skip"); )
      s.value = s.value.parentNode;
    n();
  }
  function f() {
    if (o.target === !1 || o.target === "" || r.$el.parentNode === null)
      s.value = null;
    else if (o.target === !0)
      d(r.$el.parentNode);
    else {
      let p = o.target;
      if (typeof o.target == "string")
        try {
          p = document.querySelector(o.target);
        } catch {
          p = void 0;
        }
      p != null ? (s.value = p.$el || p, n()) : (s.value = null, console.error(`Anchor: target "${o.target}" not found`));
    }
  }
  return ye(() => o.contextMenu, (p) => {
    s.value !== null && (u(), n(p));
  }), ye(() => o.target, () => {
    s.value !== null && u(), f();
  }), ye(() => o.noParentEvent, (p) => {
    s.value !== null && (p === !0 ? u() : n());
  }), Ct(() => {
    f(), t !== !0 && o.modelValue === !0 && s.value === null && i("update:modelValue", !1);
  }), St(() => {
    a !== null && clearTimeout(a), u();
  }), {
    anchorEl: s,
    canShow: l,
    anchorEvents: c
  };
}
function Fy(e, t) {
  const n = te(null);
  let o;
  function r(a, l) {
    const c = `${l !== void 0 ? "add" : "remove"}EventListener`, u = l !== void 0 ? l : o;
    a !== window && a[c]("scroll", u, Dn.passive), window[c]("scroll", u, Dn.passive), o = l;
  }
  function i() {
    n.value !== null && (r(n.value), n.value = null);
  }
  const s = ye(() => e.noParentEvent, () => {
    n.value !== null && (i(), t());
  });
  return St(s), {
    localScrollTarget: n,
    unconfigureScrollTarget: i,
    changeScrollEvent: r
  };
}
const Wy = {
  modelValue: {
    type: Boolean,
    default: null
  },
  "onUpdate:modelValue": [Function, Array]
}, By = [
  "beforeShow",
  "show",
  "beforeHide",
  "hide"
];
function zy({
  showing: e,
  canShow: t,
  // optional
  hideOnRouteChange: n,
  // optional
  handleShow: o,
  // optional
  handleHide: r,
  // optional
  processOnMount: i
  // optional
}) {
  const s = Fe(), { props: a, emit: l, proxy: c } = s;
  let u;
  function d(S) {
    e.value === !0 ? v(S) : f(S);
  }
  function f(S) {
    if (a.disable === !0 || S !== void 0 && S.qAnchorHandled === !0 || t !== void 0 && t(S) !== !0)
      return;
    const N = a["onUpdate:modelValue"] !== void 0;
    N === !0 && (l("update:modelValue", !0), u = S, tt(() => {
      u === S && (u = void 0);
    })), (a.modelValue === null || N === !1) && p(S);
  }
  function p(S) {
    e.value !== !0 && (e.value = !0, l("beforeShow", S), o !== void 0 ? o(S) : l("show", S));
  }
  function v(S) {
    if (a.disable === !0)
      return;
    const N = a["onUpdate:modelValue"] !== void 0;
    N === !0 && (l("update:modelValue", !1), u = S, tt(() => {
      u === S && (u = void 0);
    })), (a.modelValue === null || N === !1) && w(S);
  }
  function w(S) {
    e.value !== !1 && (e.value = !1, l("beforeHide", S), r !== void 0 ? r(S) : l("hide", S));
  }
  function _(S) {
    a.disable === !0 && S === !0 ? a["onUpdate:modelValue"] !== void 0 && l("update:modelValue", !1) : S === !0 !== e.value && (S === !0 ? p : w)(u);
  }
  ye(() => a.modelValue, _), n !== void 0 && Zd(s) === !0 && ye(() => c.$route.fullPath, () => {
    n.value === !0 && e.value === !0 && v();
  }), i === !0 && Ct(() => {
    _(a.modelValue);
  });
  const C = { show: f, hide: v, toggle: d };
  return Object.assign(c, C), C;
}
let Gn = [], yr = [];
function mf(e) {
  yr = yr.filter((t) => t !== e);
}
function Hy(e) {
  mf(e), yr.push(e);
}
function vu(e) {
  mf(e), yr.length === 0 && Gn.length !== 0 && (Gn[Gn.length - 1](), Gn = []);
}
function ja(e) {
  yr.length === 0 ? e() : Gn.push(e);
}
function Uy(e) {
  Gn = Gn.filter((t) => t !== e);
}
const wi = {};
let hf = !1;
function Ky() {
  hf = !0;
}
let Yy = 1, Gy = document.body;
function Qy(e, t) {
  const n = document.createElement("div");
  if (n.id = `q-portal--${t}--${Yy++}`, wi.globalNodes !== void 0) {
    const o = wi.globalNodes.class;
    o !== void 0 && (n.className = o);
  }
  return Gy.appendChild(n), n;
}
function Xy(e) {
  e.remove();
}
const or = [];
function Jy(e, t) {
  do {
    if (e.$options.name === "QMenu") {
      if (e.hide(t), e.$props.separateClosePopup === !0)
        return ps(e);
    } else if (e.__qPortal === !0) {
      const n = ps(e);
      return n !== void 0 && n.$options.name === "QPopupProxy" ? (e.hide(t), n) : e;
    }
    e = ps(e);
  } while (e != null);
}
function Zy(e, t, n, o) {
  const r = te(!1), i = te(!1);
  let s = null;
  const a = {};
  function l(u) {
    if (u === !0) {
      vu(a), i.value = !0;
      return;
    }
    i.value = !1, r.value === !1 && (s === null && (s = Qy(!1, o)), r.value = !0, or.push(e.proxy), Hy(a));
  }
  function c(u) {
    if (i.value = !1, u !== !0)
      return;
    vu(a), r.value = !1;
    const d = or.indexOf(e.proxy);
    d !== -1 && or.splice(d, 1), s !== null && (Xy(s), s = null);
  }
  return kr(() => {
    c(!0);
  }), e.proxy.__qPortal = !0, Fo(e.proxy, "contentEl", () => t.value), {
    showPortal: l,
    hidePortal: c,
    portalIsActive: r,
    portalIsAccessible: i,
    renderPortal: () => r.value === !0 ? [U(cm, { to: s }, n())] : void 0
  };
}
const vf = {
  transitionShow: {
    type: String,
    default: "fade"
  },
  transitionHide: {
    type: String,
    default: "fade"
  },
  transitionDuration: {
    type: [String, Number],
    default: 300
  }
};
function ew(e, t = () => {
}, n = () => {
}) {
  return {
    transitionProps: V(() => {
      const o = `q-transition--${e.transitionShow || t()}`, r = `q-transition--${e.transitionHide || n()}`;
      return {
        appear: !0,
        enterFromClass: `${o}-enter-from`,
        enterActiveClass: `${o}-enter-active`,
        enterToClass: `${o}-enter-to`,
        leaveFromClass: `${r}-leave-from`,
        leaveActiveClass: `${r}-leave-active`,
        leaveToClass: `${r}-leave-to`
      };
    }),
    transitionStyle: V(() => `--q-transition-duration: ${e.transitionDuration}ms`)
  };
}
function tw() {
  let e;
  const t = Fe();
  function n() {
    e = void 0;
  }
  return Ai(n), St(n), {
    removeTick: n,
    registerTick(o) {
      e = o, tt(() => {
        e === o && (ef(t) === !1 && e(), e = void 0);
      });
    }
  };
}
function nw() {
  let e = null;
  const t = Fe();
  function n() {
    e !== null && (clearTimeout(e), e = null);
  }
  return Ai(n), St(n), {
    removeTimeout: n,
    registerTimeout(o, r) {
      n(), ef(t) === !1 && (e = setTimeout(o, r));
    }
  };
}
const ow = [null, document, document.body, document.scrollingElement, document.documentElement];
function rw(e, t) {
  let n = yy(t);
  if (n === void 0) {
    if (e == null)
      return window;
    n = e.closest(".scroll,.scroll-y,.overflow-auto");
  }
  return ow.includes(n) ? window : n;
}
let Hr;
function iw() {
  if (Hr !== void 0)
    return Hr;
  const e = document.createElement("p"), t = document.createElement("div");
  Xs(e, {
    width: "100%",
    height: "200px"
  }), Xs(t, {
    position: "absolute",
    top: "0px",
    left: "0px",
    visibility: "hidden",
    width: "200px",
    height: "150px",
    overflow: "hidden"
  }), t.appendChild(e), document.body.appendChild(t);
  const n = e.offsetWidth;
  t.style.overflow = "scroll";
  let o = e.offsetWidth;
  return n === o && (o = t.clientWidth), t.remove(), Hr = n - o, Hr;
}
const oo = [];
let Vo;
function sw(e) {
  Vo = e.keyCode === 27;
}
function aw() {
  Vo === !0 && (Vo = !1);
}
function lw(e) {
  Vo === !0 && (Vo = !1, Ao(e, 27) === !0 && oo[oo.length - 1](e));
}
function gf(e) {
  window[e]("keydown", sw), window[e]("blur", aw), window[e]("keyup", lw), Vo = !1;
}
function uw(e) {
  at.is.desktop === !0 && (oo.push(e), oo.length === 1 && gf("addEventListener"));
}
function gu(e) {
  const t = oo.indexOf(e);
  t > -1 && (oo.splice(t, 1), oo.length === 0 && gf("removeEventListener"));
}
const ro = [];
function bf(e) {
  ro[ro.length - 1](e);
}
function yf(e) {
  at.is.desktop === !0 && (ro.push(e), ro.length === 1 && document.body.addEventListener("focusin", bf));
}
function wf(e) {
  const t = ro.indexOf(e);
  t > -1 && (ro.splice(t, 1), ro.length === 0 && document.body.removeEventListener("focusin", bf));
}
const { notPassiveCapture: _i } = Dn, io = [];
function Ei(e) {
  const t = e.target;
  if (t === void 0 || t.nodeType === 8 || t.classList.contains("no-pointer-events") === !0)
    return;
  let n = or.length - 1;
  for (; n >= 0; ) {
    const o = or[n].$;
    if (o.type.name === "QTooltip") {
      n--;
      continue;
    }
    if (o.type.name !== "QDialog")
      break;
    if (o.props.seamless !== !0)
      return;
    n--;
  }
  for (let o = io.length - 1; o >= 0; o--) {
    const r = io[o];
    if ((r.anchorEl.value === null || r.anchorEl.value.contains(t) === !1) && (t === document.body || r.innerRef.value !== null && r.innerRef.value.contains(t) === !1))
      e.qClickOutside = !0, r.onClickOutside(e);
    else
      return;
  }
}
function cw(e) {
  io.push(e), io.length === 1 && (document.addEventListener("mousedown", Ei, _i), document.addEventListener("touchstart", Ei, _i));
}
function bu(e) {
  const t = io.findIndex((n) => n === e);
  t > -1 && (io.splice(t, 1), io.length === 0 && (document.removeEventListener("mousedown", Ei, _i), document.removeEventListener("touchstart", Ei, _i)));
}
let yu, wu;
function _u(e) {
  const t = e.split(" ");
  return t.length !== 2 ? !1 : ["top", "center", "bottom"].includes(t[0]) !== !0 ? (console.error("Anchor/Self position must start with one of top/center/bottom"), !1) : ["left", "middle", "right", "start", "end"].includes(t[1]) !== !0 ? (console.error("Anchor/Self position must end with one of left/middle/right/start/end"), !1) : !0;
}
function dw(e) {
  return e ? !(e.length !== 2 || typeof e[0] != "number" || typeof e[1] != "number") : !0;
}
const Js = {
  "start#ltr": "left",
  "start#rtl": "right",
  "end#ltr": "right",
  "end#rtl": "left"
};
["left", "middle", "right"].forEach((e) => {
  Js[`${e}#ltr`] = e, Js[`${e}#rtl`] = e;
});
function Eu(e, t) {
  const n = e.split(" ");
  return {
    vertical: n[0],
    horizontal: Js[`${n[1]}#${t === !0 ? "rtl" : "ltr"}`]
  };
}
function fw(e, t) {
  let { top: n, left: o, right: r, bottom: i, width: s, height: a } = e.getBoundingClientRect();
  return t !== void 0 && (n -= t[1], o -= t[0], i += t[1], r += t[0], s += t[0], a += t[1]), {
    top: n,
    bottom: i,
    height: a,
    left: o,
    right: r,
    width: s,
    middle: o + (r - o) / 2,
    center: n + (i - n) / 2
  };
}
function pw(e, t, n) {
  let { top: o, left: r } = e.getBoundingClientRect();
  return o += t.top, r += t.left, n !== void 0 && (o += n[1], r += n[0]), {
    top: o,
    bottom: o + 1,
    height: 1,
    left: r,
    right: r + 1,
    width: 1,
    middle: r,
    center: o
  };
}
function mw(e, t) {
  return {
    top: 0,
    center: t / 2,
    bottom: t,
    left: 0,
    middle: e / 2,
    right: e
  };
}
function xu(e, t, n, o) {
  return {
    top: e[n.vertical] - t[o.vertical],
    left: e[n.horizontal] - t[o.horizontal]
  };
}
function _f(e, t = 0) {
  if (e.targetEl === null || e.anchorEl === null || t > 5)
    return;
  if (e.targetEl.offsetHeight === 0 || e.targetEl.offsetWidth === 0) {
    setTimeout(() => {
      _f(e, t + 1);
    }, 10);
    return;
  }
  const {
    targetEl: n,
    offset: o,
    anchorEl: r,
    anchorOrigin: i,
    selfOrigin: s,
    absoluteOffset: a,
    fit: l,
    cover: c,
    maxHeight: u,
    maxWidth: d
  } = e;
  if (at.is.ios === !0 && window.visualViewport !== void 0) {
    const x = document.body.style, { offsetLeft: k, offsetTop: D } = window.visualViewport;
    k !== yu && (x.setProperty("--q-pe-left", k + "px"), yu = k), D !== wu && (x.setProperty("--q-pe-top", D + "px"), wu = D);
  }
  const { scrollLeft: f, scrollTop: p } = n, v = a === void 0 ? fw(r, c === !0 ? [0, 0] : o) : pw(r, a, o);
  Object.assign(n.style, {
    top: 0,
    left: 0,
    minWidth: null,
    minHeight: null,
    maxWidth: d || "100vw",
    maxHeight: u || "100vh",
    visibility: "visible"
  });
  const { offsetWidth: w, offsetHeight: _ } = n, { elWidth: C, elHeight: S } = l === !0 || c === !0 ? { elWidth: Math.max(v.width, w), elHeight: c === !0 ? Math.max(v.height, _) : _ } : { elWidth: w, elHeight: _ };
  let N = { maxWidth: d, maxHeight: u };
  (l === !0 || c === !0) && (N.minWidth = v.width + "px", c === !0 && (N.minHeight = v.height + "px")), Object.assign(n.style, N);
  const m = mw(C, S);
  let y = xu(v, m, i, s);
  if (a === void 0 || o === void 0)
    vs(y, v, m, i, s);
  else {
    const { top: x, left: k } = y;
    vs(y, v, m, i, s);
    let D = !1;
    if (y.top !== x) {
      D = !0;
      const E = 2 * o[1];
      v.center = v.top -= E, v.bottom -= E + 2;
    }
    if (y.left !== k) {
      D = !0;
      const E = 2 * o[0];
      v.middle = v.left -= E, v.right -= E + 2;
    }
    D === !0 && (y = xu(v, m, i, s), vs(y, v, m, i, s));
  }
  N = {
    top: y.top + "px",
    left: y.left + "px"
  }, y.maxHeight !== void 0 && (N.maxHeight = y.maxHeight + "px", v.height > y.maxHeight && (N.minHeight = N.maxHeight)), y.maxWidth !== void 0 && (N.maxWidth = y.maxWidth + "px", v.width > y.maxWidth && (N.minWidth = N.maxWidth)), Object.assign(n.style, N), n.scrollTop !== p && (n.scrollTop = p), n.scrollLeft !== f && (n.scrollLeft = f);
}
function vs(e, t, n, o, r) {
  const i = n.bottom, s = n.right, a = iw(), l = window.innerHeight - a, c = document.body.clientWidth;
  if (e.top < 0 || e.top + i > l)
    if (r.vertical === "center")
      e.top = t[o.vertical] > l / 2 ? Math.max(0, l - i) : 0, e.maxHeight = Math.min(i, l);
    else if (t[o.vertical] > l / 2) {
      const u = Math.min(
        l,
        o.vertical === "center" ? t.center : o.vertical === r.vertical ? t.bottom : t.top
      );
      e.maxHeight = Math.min(i, u), e.top = Math.max(0, u - i);
    } else
      e.top = Math.max(
        0,
        o.vertical === "center" ? t.center : o.vertical === r.vertical ? t.top : t.bottom
      ), e.maxHeight = Math.min(i, l - e.top);
  if (e.left < 0 || e.left + s > c)
    if (e.maxWidth = Math.min(s, c), r.horizontal === "middle")
      e.left = t[o.horizontal] > c / 2 ? Math.max(0, c - s) : 0;
    else if (t[o.horizontal] > c / 2) {
      const u = Math.min(
        c,
        o.horizontal === "middle" ? t.middle : o.horizontal === r.horizontal ? t.right : t.left
      );
      e.maxWidth = Math.min(s, u), e.left = Math.max(0, u - e.maxWidth);
    } else
      e.left = Math.max(
        0,
        o.horizontal === "middle" ? t.middle : o.horizontal === r.horizontal ? t.left : t.right
      ), e.maxWidth = Math.min(s, c - e.left);
}
const hw = wt({
  name: "QMenu",
  inheritAttrs: !1,
  props: {
    ...jy,
    ...Wy,
    ...Io,
    ...vf,
    persistent: Boolean,
    autoClose: Boolean,
    separateClosePopup: Boolean,
    noRouteDismiss: Boolean,
    noRefocus: Boolean,
    noFocus: Boolean,
    fit: Boolean,
    cover: Boolean,
    square: Boolean,
    anchor: {
      type: String,
      validator: _u
    },
    self: {
      type: String,
      validator: _u
    },
    offset: {
      type: Array,
      validator: dw
    },
    scrollTarget: {
      default: void 0
    },
    touchPosition: Boolean,
    maxHeight: {
      type: String,
      default: null
    },
    maxWidth: {
      type: String,
      default: null
    }
  },
  emits: [
    ...By,
    "click",
    "escapeKey"
  ],
  setup(e, { slots: t, emit: n, attrs: o }) {
    let r = null, i, s, a;
    const l = Fe(), { proxy: c } = l, { $q: u } = c, d = te(null), f = te(!1), p = V(
      () => e.persistent !== !0 && e.noRouteDismiss !== !0
    ), v = jo(e, u), { registerTick: w, removeTick: _ } = tw(), { registerTimeout: C } = nw(), { transitionProps: S, transitionStyle: N } = ew(e), { localScrollTarget: m, changeScrollEvent: y, unconfigureScrollTarget: x } = Fy(e, ve), { anchorEl: k, canShow: D } = qy({ showing: f }), { hide: E } = zy({
      showing: f,
      canShow: D,
      handleShow: fe,
      handleHide: we,
      hideOnRouteChange: p,
      processOnMount: !0
    }), { showPortal: O, hidePortal: A, renderPortal: g } = Zy(l, d, ot, "menu"), R = {
      anchorEl: k,
      innerRef: d,
      onClickOutside(de) {
        if (e.persistent !== !0 && f.value === !0)
          return E(de), // always prevent touch event
          (de.type === "touchstart" || de.target.classList.contains("q-dialog__backdrop")) && an(de), !0;
      }
    }, M = V(
      () => Eu(
        e.anchor || (e.cover === !0 ? "center middle" : "bottom start"),
        u.lang.rtl
      )
    ), G = V(() => e.cover === !0 ? M.value : Eu(e.self || "top start", u.lang.rtl)), Q = V(
      () => (e.square === !0 ? " q-menu--square" : "") + (v.value === !0 ? " q-menu--dark q-dark" : "")
    ), $ = V(() => e.autoClose === !0 ? { onClick: Ve } : {}), W = V(
      () => f.value === !0 && e.persistent !== !0
    );
    ye(W, (de) => {
      de === !0 ? (uw(xe), cw(R)) : (gu(xe), bu(R));
    });
    function he() {
      ja(() => {
        let de = d.value;
        de && de.contains(document.activeElement) !== !0 && (de = de.querySelector("[autofocus][tabindex], [data-autofocus][tabindex]") || de.querySelector("[autofocus] [tabindex], [data-autofocus] [tabindex]") || de.querySelector("[autofocus], [data-autofocus]") || de, de.focus({ preventScroll: !0 }));
      });
    }
    function fe(de) {
      if (r = e.noRefocus === !1 ? document.activeElement : null, yf(Te), O(), ve(), i = void 0, de !== void 0 && (e.touchPosition || e.contextMenu)) {
        const lt = of(de);
        if (lt.left !== void 0) {
          const { top: vt, left: en } = k.value.getBoundingClientRect();
          i = { left: lt.left - en, top: lt.top - vt };
        }
      }
      s === void 0 && (s = ye(
        () => u.screen.width + "|" + u.screen.height + "|" + e.self + "|" + e.anchor + "|" + u.lang.rtl,
        Re
      )), e.noFocus !== !0 && document.activeElement.blur(), w(() => {
        Re(), e.noFocus !== !0 && he();
      }), C(() => {
        u.platform.is.ios === !0 && (a = e.autoClose, d.value.click()), Re(), O(!0), n("show", de);
      }, e.transitionDuration);
    }
    function we(de) {
      _(), A(), q(!0), r !== null && // menu was hidden from code or ESC plugin
      (de === void 0 || de.qClickOutside !== !0) && (((de && de.type.indexOf("key") === 0 ? r.closest('[tabindex]:not([tabindex^="-"])') : void 0) || r).focus(), r = null), C(() => {
        A(!0), n("hide", de);
      }, e.transitionDuration);
    }
    function q(de) {
      i = void 0, s !== void 0 && (s(), s = void 0), (de === !0 || f.value === !0) && (wf(Te), x(), bu(R), gu(xe)), de !== !0 && (r = null);
    }
    function ve() {
      (k.value !== null || e.scrollTarget !== void 0) && (m.value = rw(k.value, e.scrollTarget), y(m.value, Re));
    }
    function Ve(de) {
      a !== !0 ? (Jy(c, de), n("click", de)) : a = !1;
    }
    function Te(de) {
      W.value === !0 && e.noFocus !== !0 && wy(d.value, de.target) !== !0 && he();
    }
    function xe(de) {
      n("escapeKey"), E(de);
    }
    function Re() {
      _f({
        targetEl: d.value,
        offset: e.offset,
        anchorEl: k.value,
        anchorOrigin: M.value,
        selfOrigin: G.value,
        absoluteOffset: i,
        fit: e.fit,
        cover: e.cover,
        maxHeight: e.maxHeight,
        maxWidth: e.maxWidth
      });
    }
    function ot() {
      return U(
        Sa,
        S.value,
        () => f.value === !0 ? U("div", {
          role: "menu",
          ...o,
          ref: d,
          tabindex: -1,
          class: [
            "q-menu q-position-engine scroll" + Q.value,
            o.class
          ],
          style: [
            o.style,
            N.value
          ],
          ...$.value
        }, Pt(t.default)) : null
      );
    }
    return St(q), Object.assign(c, { focus: he, updatePosition: Re }), g;
  }
});
let gs, Ur = 0;
const Ze = new Array(256);
for (let e = 0; e < 256; e++)
  Ze[e] = (e + 256).toString(16).substring(1);
const vw = (() => {
  const e = typeof crypto < "u" ? crypto : typeof window < "u" ? window.crypto || window.msCrypto : void 0;
  if (e !== void 0) {
    if (e.randomBytes !== void 0)
      return e.randomBytes;
    if (e.getRandomValues !== void 0)
      return (t) => {
        const n = new Uint8Array(t);
        return e.getRandomValues(n), n;
      };
  }
  return (t) => {
    const n = [];
    for (let o = t; o > 0; o--)
      n.push(Math.floor(Math.random() * 256));
    return n;
  };
})(), ku = 4096;
function qa() {
  (gs === void 0 || Ur + 16 > ku) && (Ur = 0, gs = vw(ku));
  const e = Array.prototype.slice.call(gs, Ur, Ur += 16);
  return e[6] = e[6] & 15 | 64, e[8] = e[8] & 63 | 128, Ze[e[0]] + Ze[e[1]] + Ze[e[2]] + Ze[e[3]] + "-" + Ze[e[4]] + Ze[e[5]] + "-" + Ze[e[6]] + Ze[e[7]] + "-" + Ze[e[8]] + Ze[e[9]] + "-" + Ze[e[10]] + Ze[e[11]] + Ze[e[12]] + Ze[e[13]] + Ze[e[14]] + Ze[e[15]];
}
const gw = Object.keys(Ia), bw = (e) => gw.reduce(
  (t, n) => {
    const o = e[n];
    return o !== void 0 && (t[n] = o), t;
  },
  {}
), Ef = wt({
  name: "QBtnDropdown",
  props: {
    ...Ia,
    ...vf,
    modelValue: Boolean,
    split: Boolean,
    dropdownIcon: String,
    contentClass: [Array, String, Object],
    contentStyle: [Array, String, Object],
    cover: Boolean,
    persistent: Boolean,
    noRouteDismiss: Boolean,
    autoClose: Boolean,
    menuAnchor: {
      type: String,
      default: "bottom end"
    },
    menuSelf: {
      type: String,
      default: "top end"
    },
    menuOffset: Array,
    disableMainBtn: Boolean,
    disableDropdown: Boolean,
    noIconAnimation: Boolean,
    toggleAriaLabel: String
  },
  emits: ["update:modelValue", "click", "beforeShow", "show", "beforeHide", "hide"],
  setup(e, { slots: t, emit: n }) {
    const { proxy: o } = Fe(), r = te(e.modelValue), i = te(null), s = qa(), a = V(() => {
      const m = {
        "aria-expanded": r.value === !0 ? "true" : "false",
        "aria-haspopup": "true",
        "aria-controls": s,
        "aria-label": e.toggleAriaLabel || o.$q.lang.label[r.value === !0 ? "collapse" : "expand"](e.label)
      };
      return (e.disable === !0 || e.split === !1 && e.disableMainBtn === !0 || e.disableDropdown === !0) && (m["aria-disabled"] = "true"), m;
    }), l = V(
      () => "q-btn-dropdown__arrow" + (r.value === !0 && e.noIconAnimation === !1 ? " rotate-180" : "") + (e.split === !1 ? " q-btn-dropdown__arrow-container" : "")
    ), c = V(() => Ty(e)), u = V(() => bw(e));
    ye(() => e.modelValue, (m) => {
      i.value !== null && i.value[m ? "show" : "hide"]();
    }), ye(() => e.split, N);
    function d(m) {
      r.value = !0, n("beforeShow", m);
    }
    function f(m) {
      n("show", m), n("update:modelValue", !0);
    }
    function p(m) {
      r.value = !1, n("beforeHide", m);
    }
    function v(m) {
      n("hide", m), n("update:modelValue", !1);
    }
    function w(m) {
      n("click", m);
    }
    function _(m) {
      gr(m), N(), n("click", m);
    }
    function C(m) {
      i.value !== null && i.value.toggle(m);
    }
    function S(m) {
      i.value !== null && i.value.show(m);
    }
    function N(m) {
      i.value !== null && i.value.hide(m);
    }
    return Object.assign(o, {
      show: S,
      hide: N,
      toggle: C
    }), Ct(() => {
      e.modelValue === !0 && S();
    }), () => {
      const m = [
        U(br, {
          class: l.value,
          name: e.dropdownIcon || o.$q.iconSet.arrow.dropdown
        })
      ];
      return e.disableDropdown !== !0 && m.push(
        U(hw, {
          ref: i,
          id: s,
          class: e.contentClass,
          style: e.contentStyle,
          cover: e.cover,
          fit: !0,
          persistent: e.persistent,
          noRouteDismiss: e.noRouteDismiss,
          autoClose: e.autoClose,
          anchor: e.menuAnchor,
          self: e.menuSelf,
          offset: e.menuOffset,
          separateClosePopup: !0,
          transitionShow: e.transitionShow,
          transitionHide: e.transitionHide,
          transitionDuration: e.transitionDuration,
          onBeforeShow: d,
          onShow: f,
          onBeforeHide: p,
          onHide: v
        }, t.default)
      ), e.split === !1 ? U(hs, {
        class: "q-btn-dropdown q-btn-dropdown--simple",
        ...u.value,
        ...a.value,
        disable: e.disable === !0 || e.disableMainBtn === !0,
        noWrap: !0,
        round: !1,
        onClick: w
      }, {
        default: () => Pt(t.label, []).concat(m),
        loading: t.loading
      }) : U(Dy, {
        class: "q-btn-dropdown q-btn-dropdown--split no-wrap q-btn-item",
        rounded: e.rounded,
        square: e.square,
        ...c.value,
        glossy: e.glossy,
        stretch: e.stretch
      }, () => [
        U(hs, {
          class: "q-btn-dropdown--current",
          ...u.value,
          disable: e.disable === !0 || e.disableMainBtn === !0,
          noWrap: !0,
          round: !1,
          onClick: _
        }, {
          default: t.label,
          loading: t.loading
        }),
        U(hs, {
          class: "q-btn-dropdown__arrow-container q-anchor--skip",
          ...a.value,
          ...c.value,
          disable: e.disable === !0 || e.disableDropdown === !0,
          rounded: e.rounded,
          color: e.color,
          textColor: e.textColor,
          dense: e.dense,
          size: e.size,
          padding: e.padding,
          ripple: e.ripple
        }, () => m)
      ]);
    };
  }
}), yw = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M19.293%207.293l1.414%201.414L12%2017.414%203.293%208.707l1.414-1.414L12%2014.586z'%20fill-rule='evenodd'/%3e%3c/svg%3e";
function ww(e, {
  i18next: t,
  rerenderOn: n = ["languageChanged", "loaded", "added", "removed"],
  slotStart: o = "{",
  slotEnd: r = "}"
}) {
  const i = te(/* @__PURE__ */ new Date()), s = () => tt(() => {
    i.value = /* @__PURE__ */ new Date();
  }), a = () => i.value;
  n.forEach((c) => {
    var u;
    switch (c) {
      case "added":
      case "removed":
        (u = t.store) == null || u.on(c, s);
        break;
      default:
        t.on(c, s);
        break;
    }
  }), e.component("i18next", xw);
  const l = () => t.isInitialized;
  e.config.globalProperties.$t = Cu(
    t.t.bind(t),
    a,
    l
  ), e.config.globalProperties.$i18next = new Proxy(t, {
    get(c, u) {
      switch (u) {
        case "__withAccessRecording":
          return (d, f) => Cu(d, a, f);
        case "__slotPattern":
          return Ew(o, r);
        default:
          return a(), Reflect.get(c, u);
      }
    }
  });
}
function xf(e, t) {
  const n = kf();
  let o;
  return o = n.getFixedT(null, null, void 0), {
    i18next: n,
    t: n.__withAccessRecording(o, _w(n, e))
  };
}
function _w(e, t = []) {
  let n;
  return () => {
    if (n === void 0)
      if (e.isInitialized) {
        const r = (typeof t == "string" ? [t] : t).filter((i) => !e.hasLoadedNamespace(i));
        r.length ? (n = !1, e.loadNamespaces(r).then(() => n = !0)) : n = !0;
      } else
        return !1;
    return n;
  };
}
function Cu(e, t, n) {
  return new Proxy(e, {
    apply: function(o, r, i) {
      return t(), n() ? Reflect.apply(o, r, i) : "";
    }
  });
}
function kf() {
  const e = Fe();
  if (!e)
    throw new Error(
      "i18next-vue: No Vue instance in context. This needs to be called inside setup()."
    );
  const t = e.appContext.config.globalProperties;
  if (!t.$i18next)
    throw new Error(
      "i18next-vue: Make sure to register the i18next-vue plugin using app.use(...)."
    );
  return t.$i18next;
}
function Ew(e, t) {
  const n = `${e}\\s*([a-z0-9\\-]+)\\s*${t}`;
  return new RegExp(n, "gi");
}
var xw = /* @__PURE__ */ Ee({
  props: {
    translation: {
      type: String,
      required: !0
    }
  },
  setup(e, { slots: t }) {
    const n = kf().__slotPattern;
    return () => {
      const o = e.translation, r = [];
      let i, s = 0;
      for (; (i = n.exec(o)) !== null; ) {
        r.push(o.substring(s, i.index));
        const a = t[i[1]];
        a ? r.push(...a()) : r.push(i[0]), s = n.lastIndex;
      }
      return r.push(o.substring(s)), r;
    };
  }
});
const kw = { class: "row items-center no-wrap" }, Cw = { class: "ws-color-navy text-center text-capitalize q-px-sm" }, Sw = /* @__PURE__ */ Ee({
  __name: "WsSelectLanguage",
  setup(e) {
    const { i18next: t } = xf(), { setLang: n } = Ci(), o = V(() => t.language);
    return (r, i) => (X(), He(Ef, {
      "data-test": "select-country",
      class: "q-mt-xs",
      "content-class": "ws-select-language-menu",
      "dropdown-icon": `img:${re(yw)}`
    }, {
      label: Me(() => [
        ce("div", kw, [
          (X(), He(ru, {
            key: o.value,
            country: o.value,
            class: "q-my-none",
            size: "small"
          }, null, 8, ["country"])),
          ce("div", Cw, De(re(Ha)(re(Gr)(o.value))), 1)
        ])
      ]),
      default: Me(() => [
        le(dy, { class: "footer-dropdown cy-language-selector" }, {
          default: Me(() => [
            (X(!0), ue(Je, null, Ri(re(Lf), (s, a) => (X(), He(cy, {
              key: a,
              title: s,
              clickable: "",
              "data-test": `set-language-${s}`,
              onClick: (l) => re(n)(s)
            }, {
              default: Me(() => [
                le(iu, { side: "" }, {
                  default: Me(() => [
                    le(ru, {
                      size: "small",
                      country: re(Gr)(s)
                    }, null, 8, ["country"])
                  ]),
                  _: 2
                }, 1024),
                le(iu, null, {
                  default: Me(() => [
                    le(iy, null, {
                      default: Me(() => [
                        ft(De(re(Ha)(re(Gr)(s))), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1032, ["title", "data-test", "onClick"]))), 128))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["dropdown-icon"]));
  }
}), Ow = /* @__PURE__ */ je(Sw, [["__scopeId", "data-v-6356aa10"]]), Nw = { class: "ws-typography section-fit" }, $w = { class: "row no-wrap justify-between items-center q-mt-md" }, Tw = { class: "flex justify-center max-w-custom" }, Pw = ["href"], Dw = /* @__PURE__ */ Ee({
  __name: "WsLoginCard",
  props: {
    config: {
      type: Object,
      required: !0,
      default: () => ({})
    }
  },
  setup(e) {
    const t = e, { i18next: n } = xf(), { theme: o } = qo(), r = Cr(), i = [
      "help",
      "terms",
      "privacy"
    ];
    Jd(t.config);
    const s = V(() => {
      switch (o.value) {
        case Be.LOOPIA:
          return {
            src: "https://cdn.websupport.eu/companies/loopia/logo-small.svg",
            alt: "Loopia",
            height: 31
          };
        case Be.CARY:
        default:
          return {
            src: "https://cdn.websupport.eu/companies/ws/logo.svg",
            alt: "Websupport",
            height: 40
          };
      }
    });
    return (a, l) => (X(), ue("section", Nw, [
      le(ry, { class: "login-card" }, {
        default: Me(() => [
          ce("img", Bt(s.value, { alt: "" }), null, 16),
          le(re(Wi), {
            "component-id": re(r)["component-id"]
          }, null, 8, ["component-id"])
        ]),
        _: 1
      }),
      ce("div", $w, [
        le(Ow, {
          config: e.config,
          class: "cy-language-btn",
          "aria-controls": "select-language"
        }, null, 8, ["config"]),
        ce("div", Tw, [
          (X(), ue(Je, null, Ri(i, (c, u) => ce("a", {
            key: u,
            class: "anchor-text1 q-mr-lg",
            href: re(Gs)(c, re(n).language)
          }, De(a.$t(`uikit:login_pages.footer.${c}`)), 9, Pw)), 64))
        ])
      ])
    ]));
  }
}), K1 = /* @__PURE__ */ je(Dw, [["__scopeId", "data-v-b9d3a200"]]), Mw = { class: "ws-typography row" }, Aw = ["srcset", "sizes"], Vw = ["srcset", "sizes"], Rw = ["src", "width", "height"], Lw = /* @__PURE__ */ Ee({
  __name: "WsLoginAside",
  setup(e) {
    const { theme: t } = qo(), n = te({}), o = () => {
      switch (t.value) {
        case Be.LOOPIA:
          return {
            width: 460,
            height: 460
          };
        case Be.ACTIVE_24:
        case Be.CARY:
        default:
          return {
            width: 607,
            height: 460
          };
      }
    }, r = async () => {
      var l;
      const { width: i, height: s } = o(), a = `assets/images/${(l = t.value) == null ? void 0 : l.toLowerCase()}/logins`;
      n.value = {
        src: `${a}/aside.png`,
        src2x: `${a}/aside@2x.png`,
        srcWebp: `${a}/aside.webp`,
        srcWebp2x: `${a}/aside@2x.webp`,
        width: i,
        height: s
      };
    };
    return ye(t, () => {
      r();
    }, { immediate: !0 }), (i, s) => (X(), ue("section", Mw, [
      ce("picture", null, [
        ce("source", {
          type: "image/webp",
          srcset: `${n.value.srcWebp} 1x, ${n.value.srcWebp2x} 2x`,
          sizes: n.value.width + "px"
        }, null, 8, Aw),
        ce("source", {
          srcset: `${n.value.src2x} 2x`,
          sizes: n.value.width + "px"
        }, null, 8, Vw),
        ce("img", {
          src: n.value.src,
          width: n.value.width,
          height: n.value.height,
          class: "login-image",
          alt: ""
        }, null, 8, Rw)
      ])
    ]));
  }
}), Y1 = /* @__PURE__ */ je(Lw, [["__scopeId", "data-v-042fd7ac"]]);
function Nn(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Iw(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
const Su = 6e4, Ou = 525600, Nu = 43200, $u = 1440;
let jw = {};
function Cf() {
  return jw;
}
function Tu(e, t) {
  var a, l, c, u;
  const n = Cf(), o = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (a = t == null ? void 0 : t.locale) == null ? void 0 : a.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = Nn(e), i = r.getDay(), s = (i < o ? 7 : 0) + i - o;
  return r.setDate(r.getDate() - s), r.setHours(0, 0, 0, 0), r;
}
function Pu(e) {
  const t = Nn(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function qw(e, t) {
  const n = Nn(e), o = Nn(t), r = n.getTime() - o.getTime();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function Fw(e) {
  return Iw(e, Date.now());
}
function Ww(e) {
  return (t) => {
    const o = (e ? Math[e] : Math.trunc)(t);
    return o === 0 ? 0 : o;
  };
}
const Bw = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, zw = (e, t, n) => {
  let o;
  const r = Bw[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + o : o + " ago" : o;
};
function ht(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const Hw = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Uw = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Kw = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yw = {
  date: ht({
    formats: Hw,
    defaultWidth: "full"
  }),
  time: ht({
    formats: Uw,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: Kw,
    defaultWidth: "full"
  })
}, Gw = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Qw = (e, t, n, o) => Gw[e];
function Le(e) {
  return (t, n) => {
    const o = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (o === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : s;
      r = e.formattingValues[a] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, a = n != null && n.width ? String(n.width) : e.defaultWidth;
      r = e.values[a] || e.values[s];
    }
    const i = e.argumentCallback ? e.argumentCallback(t) : t;
    return r[i];
  };
}
const Xw = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Jw = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Zw = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, e_ = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, t_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, n_ = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, o_ = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, r_ = {
  ordinalNumber: o_,
  era: Le({
    values: Xw,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: Jw,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Le({
    values: Zw,
    defaultWidth: "wide"
  }),
  day: Le({
    values: e_,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: t_,
    defaultWidth: "wide",
    formattingValues: n_,
    defaultFormattingWidth: "wide"
  })
};
function Ie(e) {
  return (t, n = {}) => {
    const o = n.width, r = o && e.matchPatterns[o] || e.matchPatterns[e.defaultMatchWidth], i = t.match(r);
    if (!i)
      return null;
    const s = i[0], a = o && e.parsePatterns[o] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(a) ? s_(a, (d) => d.test(s)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      i_(a, (d) => d.test(s))
    );
    let c;
    c = e.valueCallback ? e.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = t.slice(s.length);
    return { value: c, rest: u };
  };
}
function i_(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function s_(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Tr(e) {
  return (t, n = {}) => {
    const o = t.match(e.matchPattern);
    if (!o) return null;
    const r = o[0], i = t.match(e.parsePattern);
    if (!i) return null;
    let s = e.valueCallback ? e.valueCallback(i[0]) : i[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const a = t.slice(r.length);
    return { value: s, rest: a };
  };
}
const a_ = /^(\d+)(th|st|nd|rd)?/i, l_ = /\d+/i, u_ = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, c_ = {
  any: [/^b/i, /^(a|c)/i]
}, d_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, f_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, p_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, m_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, h_ = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, v_ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, g_ = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, b_ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, y_ = {
  ordinalNumber: Tr({
    matchPattern: a_,
    parsePattern: l_,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ie({
    matchPatterns: u_,
    defaultMatchWidth: "wide",
    parsePatterns: c_,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: d_,
    defaultMatchWidth: "wide",
    parsePatterns: f_,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ie({
    matchPatterns: p_,
    defaultMatchWidth: "wide",
    parsePatterns: m_,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: h_,
    defaultMatchWidth: "wide",
    parsePatterns: v_,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: g_,
    defaultMatchWidth: "any",
    parsePatterns: b_,
    defaultParseWidth: "any"
  })
}, Sf = {
  code: "en-US",
  formatDistance: zw,
  formatLong: Yw,
  formatRelative: Qw,
  localize: r_,
  match: y_,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function w_(e, t, n) {
  const o = Cf(), r = (n == null ? void 0 : n.locale) ?? o.locale ?? Sf, i = qw(e, t);
  if (isNaN(i))
    throw new RangeError("Invalid time value");
  const s = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: i
  });
  let a, l;
  i > 0 ? (a = Nn(t), l = Nn(e)) : (a = Nn(e), l = Nn(t));
  const c = Ww((n == null ? void 0 : n.roundingMethod) ?? "round"), u = l.getTime() - a.getTime(), d = u / Su, f = Pu(l) - Pu(a), p = (u - f) / Su, v = n == null ? void 0 : n.unit;
  let w;
  if (v ? w = v : d < 1 ? w = "second" : d < 60 ? w = "minute" : d < $u ? w = "hour" : p < Nu ? w = "day" : p < Ou ? w = "month" : w = "year", w === "second") {
    const _ = c(u / 1e3);
    return r.formatDistance("xSeconds", _, s);
  } else if (w === "minute") {
    const _ = c(d);
    return r.formatDistance("xMinutes", _, s);
  } else if (w === "hour") {
    const _ = c(d / 60);
    return r.formatDistance("xHours", _, s);
  } else if (w === "day") {
    const _ = c(p / $u);
    return r.formatDistance("xDays", _, s);
  } else if (w === "month") {
    const _ = c(p / Nu);
    return _ === 12 && v !== "month" ? r.formatDistance("xYears", 1, s) : r.formatDistance("xMonths", _, s);
  } else {
    const _ = c(p / Ou);
    return r.formatDistance("xYears", _, s);
  }
}
function __(e, t) {
  return w_(e, Fw(e), t);
}
function Du(e, t, n) {
  const o = Tu(e, n), r = Tu(t, n);
  return +o == +r;
}
function E_(e, t) {
  return t === 1 && e.one ? e.one : t >= 2 && t <= 4 && e.twoFour ? e.twoFour : e.other;
}
function bs(e, t, n) {
  return E_(e, t)[n].replace("{{count}}", String(t));
}
function x_(e) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(n) {
      return !!e.match(new RegExp("^" + n));
    }
  )[0];
}
function ys(e) {
  let t = "";
  return e === "almost" && (t = "takmer"), e === "about" && (t = "približne"), t.length > 0 ? t + " " : "";
}
function ws(e) {
  let t = "";
  return e === "lessThan" && (t = "menej než"), e === "over" && (t = "viac než"), t.length > 0 ? t + " " : "";
}
function k_(e) {
  return e.charAt(0).toLowerCase() + e.slice(1);
}
const C_ = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, S_ = (e, t, n) => {
  const o = x_(e) || "", r = k_(e.substring(o.length)), i = C_[r];
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? ys(o) + "o " + ws(o) + bs(i, t, "future") : ys(o) + "pred " + ws(o) + bs(i, t, "past") : ys(o) + ws(o) + bs(i, t, "present");
}, O_ = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, N_ = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, $_ = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, T_ = {
  date: ht({
    formats: O_,
    defaultWidth: "full"
  }),
  time: ht({
    formats: N_,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: $_,
    defaultWidth: "full"
  })
}, Fa = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function P_(e) {
  const t = Fa[e];
  switch (e) {
    case 0:
    case 3:
    case 6:
      return "'minulú " + t + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function Mu(e) {
  const t = Fa[e];
  return e === 4 ? "'vo' eeee 'o' p" : "'v " + t + " o' p";
}
function D_(e) {
  const t = Fa[e];
  switch (e) {
    case 0:
    case 4:
    case 6:
      return "'budúcu " + t + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const M_ = {
  lastWeek: (e, t, n) => {
    const o = e.getDay();
    return Du(e, t, n) ? Mu(o) : P_(o);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (e, t, n) => {
    const o = e.getDay();
    return Du(e, t, n) ? Mu(o) : D_(o);
  },
  other: "P"
}, A_ = (e, t, n, o) => {
  const r = M_[e];
  return typeof r == "function" ? r(t, n, o) : r;
}, V_ = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, R_ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, L_ = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, I_ = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, j_ = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, q_ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, F_ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, W_ = (e, t) => Number(e) + ".", B_ = {
  ordinalNumber: W_,
  era: Le({
    values: V_,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: R_,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Le({
    values: L_,
    defaultWidth: "wide",
    formattingValues: I_,
    defaultFormattingWidth: "wide"
  }),
  day: Le({
    values: j_,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: q_,
    defaultWidth: "wide",
    formattingValues: F_,
    defaultFormattingWidth: "wide"
  })
}, z_ = /^(\d+)\.?/i, H_ = /\d+/i, U_ = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, K_ = {
  any: [/^pr/i, /^(po|n)/i]
}, Y_ = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, G_ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Q_ = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, X_ = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, J_ = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, Z_ = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, e0 = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, t0 = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, n0 = {
  ordinalNumber: Tr({
    matchPattern: z_,
    parsePattern: H_,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ie({
    matchPatterns: U_,
    defaultMatchWidth: "wide",
    parsePatterns: K_,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: Y_,
    defaultMatchWidth: "wide",
    parsePatterns: G_,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ie({
    matchPatterns: Q_,
    defaultMatchWidth: "wide",
    parsePatterns: X_,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: J_,
    defaultMatchWidth: "wide",
    parsePatterns: Z_,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: e0,
    defaultMatchWidth: "any",
    parsePatterns: t0,
    defaultParseWidth: "any"
  })
}, o0 = {
  code: "sk",
  formatDistance: S_,
  formatLong: T_,
  formatRelative: A_,
  localize: B_,
  match: n0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, r0 = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, i0 = (e, t, n) => {
  let o;
  const r = r0[e];
  r.type === "other" ? o = r.other : t === 1 ? o = r.one : t > 1 && t < 5 ? o = r.few : o = r.many;
  const i = (n == null ? void 0 : n.addSuffix) === !0, s = n == null ? void 0 : n.comparison;
  let a;
  return i && s === -1 ? a = o.past : i && s === 1 ? a = o.future : a = o.regular, a.replace("{{count}}", String(t));
}, s0 = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, a0 = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, l0 = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, u0 = {
  date: ht({
    formats: s0,
    defaultWidth: "full"
  }),
  time: ht({
    formats: a0,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: l0,
    defaultWidth: "full"
  })
}, c0 = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu"
], d0 = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (e) => {
    const t = e.getDay();
    return "'v " + c0[t] + " o' p";
  },
  other: "P"
}, f0 = (e, t) => {
  const n = d0[e];
  return typeof n == "function" ? n(t) : n;
}, p0 = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, m0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, h0 = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec"
  ]
}, v0 = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince"
  ]
}, g0 = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, b0 = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, y0 = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, w0 = (e, t) => Number(e) + ".", _0 = {
  ordinalNumber: w0,
  era: Le({
    values: p0,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: m0,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Le({
    values: h0,
    defaultWidth: "wide",
    formattingValues: v0,
    defaultFormattingWidth: "wide"
  }),
  day: Le({
    values: g0,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: b0,
    defaultWidth: "wide",
    formattingValues: y0,
    defaultFormattingWidth: "wide"
  })
}, E0 = /^(\d+)\.?/i, x0 = /\d+/i, k0 = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, C0 = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, S0 = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, O0 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, N0 = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, $0 = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i
  ],
  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i
  ]
}, T0 = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, P0 = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, D0 = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, M0 = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, A0 = {
  ordinalNumber: Tr({
    matchPattern: E0,
    parsePattern: x0,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ie({
    matchPatterns: k0,
    defaultMatchWidth: "wide",
    parsePatterns: C0,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: S0,
    defaultMatchWidth: "wide",
    parsePatterns: O0,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ie({
    matchPatterns: N0,
    defaultMatchWidth: "wide",
    parsePatterns: $0,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: T0,
    defaultMatchWidth: "wide",
    parsePatterns: P0,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: D0,
    defaultMatchWidth: "any",
    parsePatterns: M0,
    defaultParseWidth: "any"
  })
}, V0 = {
  code: "cs",
  formatDistance: i0,
  formatLong: u0,
  formatRelative: f0,
  localize: _0,
  match: A0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, R0 = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, L0 = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], I0 = (e, t, n) => {
  let o;
  const r = R0[e];
  return typeof r == "string" ? o = r : t === 1 ? o = r.one : o = r.other.replace(
    "{{count}}",
    t < 13 ? L0[t] : String(t)
  ), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + o : o + " sedan" : o;
}, j0 = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, q0 = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, F0 = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, W0 = {
  date: ht({
    formats: j0,
    defaultWidth: "full"
  }),
  time: ht({
    formats: q0,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: F0,
    defaultWidth: "full"
  })
}, B0 = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, z0 = (e, t, n, o) => B0[e], H0 = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, U0 = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, K0 = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Y0 = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, G0 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, Q0 = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, X0 = (e, t) => {
  const n = Number(e), o = n % 100;
  if (o > 20 || o < 10)
    switch (o % 10) {
      case 1:
      case 2:
        return n + ":a";
    }
  return n + ":e";
}, J0 = {
  ordinalNumber: X0,
  era: Le({
    values: H0,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: U0,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Le({
    values: K0,
    defaultWidth: "wide"
  }),
  day: Le({
    values: Y0,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: G0,
    defaultWidth: "wide",
    formattingValues: Q0,
    defaultFormattingWidth: "wide"
  })
}, Z0 = /^(\d+)(:a|:e)?/i, eE = /\d+/i, tE = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, nE = {
  any: [/^f/i, /^[ev]/i]
}, oE = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, rE = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, iE = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, sE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, aE = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, lE = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, uE = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, cE = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, dE = {
  ordinalNumber: Tr({
    matchPattern: Z0,
    parsePattern: eE,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ie({
    matchPatterns: tE,
    defaultMatchWidth: "wide",
    parsePatterns: nE,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: oE,
    defaultMatchWidth: "wide",
    parsePatterns: rE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ie({
    matchPatterns: iE,
    defaultMatchWidth: "wide",
    parsePatterns: sE,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: aE,
    defaultMatchWidth: "wide",
    parsePatterns: lE,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: uE,
    defaultMatchWidth: "any",
    parsePatterns: cE,
    defaultParseWidth: "any"
  })
}, fE = {
  code: "sv",
  formatDistance: I0,
  formatLong: W0,
  formatRelative: z0,
  localize: J0,
  match: dE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, pE = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
}, mE = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
}, hE = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
}, vE = (e, t, n) => {
  const o = e.match(/about|over|almost|lessthan/i), r = o ? e.replace(o[0], "") : e, i = (n == null ? void 0 : n.addSuffix) === !0, s = r.toLowerCase(), a = (n == null ? void 0 : n.comparison) || 0, l = i ? hE[s][a] : mE[s];
  let c = s === "halfaminute" ? l : t + l;
  if (o) {
    const u = o[0].toLowerCase();
    c = pE[u] + " " + c;
  }
  return c;
}, gE = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
}, bE = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, yE = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, wE = {
  date: ht({
    formats: gE,
    defaultWidth: "full"
  }),
  time: ht({
    formats: bE,
    defaultWidth: "full"
  }),
  dateTime: ht({
    formats: yE,
    defaultWidth: "full"
  })
}, _E = [
  "vasárnap",
  "hétfőn",
  "kedden",
  "szerdán",
  "csütörtökön",
  "pénteken",
  "szombaton"
];
function Au(e) {
  return (t) => {
    const n = _E[t.getDay()];
    return `${e ? "" : "'múlt' "}'${n}' p'-kor'`;
  };
}
const EE = {
  lastWeek: Au(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: Au(!0),
  other: "P"
}, xE = (e, t) => {
  const n = EE[e];
  return typeof n == "function" ? n(t) : n;
}, kE = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
}, CE = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
}, SE = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
}, OE = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "febr.",
    "márc.",
    "ápr.",
    "máj.",
    "jún.",
    "júl.",
    "aug.",
    "szept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "január",
    "február",
    "március",
    "április",
    "május",
    "június",
    "július",
    "augusztus",
    "szeptember",
    "október",
    "november",
    "december"
  ]
}, NE = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: [
    "vasárnap",
    "hétfő",
    "kedd",
    "szerda",
    "csütörtök",
    "péntek",
    "szombat"
  ]
}, $E = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
}, TE = (e, t) => Number(e) + ".", PE = {
  ordinalNumber: TE,
  era: Le({
    values: kE,
    defaultWidth: "wide"
  }),
  quarter: Le({
    values: CE,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1,
    formattingValues: SE,
    defaultFormattingWidth: "wide"
  }),
  month: Le({
    values: OE,
    defaultWidth: "wide"
  }),
  day: Le({
    values: NE,
    defaultWidth: "wide"
  }),
  dayPeriod: Le({
    values: $E,
    defaultWidth: "wide"
  })
}, DE = /^(\d+)\.?/i, ME = /\d+/i, AE = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
}, VE = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
}, RE = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
}, LE = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
}, IE = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
}, jE = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a|á/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s|sz/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^már/i,
    /^áp/i,
    /^máj/i,
    /^jún/i,
    /^júl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, qE = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
}, FE = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
}, WE = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
}, BE = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
}, zE = {
  ordinalNumber: Tr({
    matchPattern: DE,
    parsePattern: ME,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ie({
    matchPatterns: AE,
    defaultMatchWidth: "wide",
    parsePatterns: VE,
    defaultParseWidth: "any"
  }),
  quarter: Ie({
    matchPatterns: RE,
    defaultMatchWidth: "wide",
    parsePatterns: LE,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ie({
    matchPatterns: IE,
    defaultMatchWidth: "wide",
    parsePatterns: jE,
    defaultParseWidth: "any"
  }),
  day: Ie({
    matchPatterns: qE,
    defaultMatchWidth: "wide",
    parsePatterns: FE,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ie({
    matchPatterns: WE,
    defaultMatchWidth: "any",
    parsePatterns: BE,
    defaultParseWidth: "any"
  })
}, HE = {
  code: "hu",
  formatDistance: vE,
  formatLong: wE,
  formatRelative: xE,
  localize: PE,
  match: zE,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, UE = { class: "ws-users-list" }, KE = ["onClick"], YE = { class: "ws-users-list__data" }, GE = { class: "ws-users-list__name" }, QE = {
  key: 0,
  class: "ws-users-list__date"
}, XE = /* @__PURE__ */ Ee({
  __name: "WsUsersList",
  props: {
    users: {
      type: Array,
      required: !0,
      default: () => []
    }
  },
  setup(e) {
    const { i18next: t } = Ci(), n = () => ({
      "sk-SK": o0,
      "cs-CZ": V0,
      "en-US": Sf,
      "sv-SE": fE,
      "hu-HU": HE
    })[t.language], o = (r) => __(r, {
      locale: n(),
      addSuffix: !0
    });
    return (r, i) => (X(), ue("ul", UE, [
      (X(!0), ue(Je, null, Ri(e.users, (s) => (X(), ue("li", {
        key: s.login
      }, [
        ce("button", {
          class: "ws-users-list__user",
          onClick: (a) => r.$emit("select", s)
        }, [
          le(Tn, {
            name: "account",
            size: 24,
            class: "ws-users-list__icon"
          }),
          ce("span", YE, [
            ce("span", GE, De(s.login), 1),
            s.date ? (X(), ue("span", QE, De(o(s.date)), 1)) : Pe("", !0)
          ])
        ], 8, KE)
      ]))), 128))
    ]));
  }
}), G1 = /* @__PURE__ */ je(XE, [["__scopeId", "data-v-6d5426ba"]]);
var Wa = /* @__PURE__ */ ((e) => (e.NONE = "none", e.INCLUDE = "include", e.EXCLUDE = "exclude", e))(Wa || {});
const Q1 = {
  VatInfoDisplayMode: Wa
}, JE = { class: "ws-price-badge grid items-center" }, ZE = { class: "row items-baseline" }, ex = {
  key: 0,
  class: "q-mr-sm"
}, tx = {
  key: 1,
  class: "q-ml-sm"
}, nx = {
  key: 0,
  class: "row justify-center"
}, ox = { key: 0 }, rx = { key: 1 }, ix = /* @__PURE__ */ Ee({
  __name: "WsPriceBadge",
  props: {
    prefix: {
      type: String,
      default: ""
    },
    timeAmount: {
      type: String,
      default: ""
    },
    vatInfoDisplayMode: {
      type: String,
      default: Wa.NONE
    }
  },
  setup(e) {
    const t = e;
    return (n, o) => {
      const r = nt("portal-slot");
      return X(), ue("div", JE, [
        ce("div", null, [
          ce("div", ZE, [
            t.prefix ? (X(), ue("span", ex, De(t.prefix), 1)) : Pe("", !0),
            le(r, {
              slot: n.$slots.default,
              "component-id": n.$attrs["component-id"]
            }, null, 8, ["slot", "component-id"]),
            t.timeAmount ? (X(), ue("span", tx, "/ " + De(t.timeAmount), 1)) : Pe("", !0)
          ]),
          t.vatInfoDisplayMode !== "none" ? (X(), ue("div", nx, [
            t.vatInfoDisplayMode === "include" ? (X(), ue("span", ox, De(n.$t("uikit:price_badge.including_vat")), 1)) : Pe("", !0),
            t.vatInfoDisplayMode === "exclude" ? (X(), ue("span", rx, De(n.$t("uikit:price_badge.excluding_vat")), 1)) : Pe("", !0)
          ])) : Pe("", !0)
        ])
      ]);
    };
  }
}), X1 = /* @__PURE__ */ je(ix, [["__scopeId", "data-v-2ffc6950"]]);
var Tt = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.NEUTRAL = "neutral", e.WARNING = "warning", e.ERROR = "error", e.ALERT = "alert", e.SUCCESS = "success", e))(Tt || {}), Ba = /* @__PURE__ */ ((e) => (e.LARGE = "large", e.MEDIUM = "medium", e.SMALL = "small", e))(Ba || {});
const J1 = {
  Variant: Tt,
  Size: Ba
};
var Vt = /* @__PURE__ */ ((e) => (e.READY = "ready", e.SENDING = "sending", e.ON_COOLDOWN = "on_cooldown", e))(Vt || {});
const Z1 = {
  ResendCodeStatus: Vt
}, sx = { class: "totp-inputs justify-between" }, ax = ["onUpdate:modelValue", "onKeydown", "onInput"], lx = {
  key: 0,
  class: "flex items-center q-my-lg"
}, ux = /* @__PURE__ */ Ee({
  __name: "WsTwoFactorAuthenticationInput",
  props: {
    numberOfFields: {
      type: Number,
      default: 6
    },
    resendCodeUrl: {
      type: String,
      default: ""
    },
    resendCodeCooldown: {
      type: [Number, String],
      default: 30
    },
    resendCodeMethod: {
      type: String,
      default: "get"
    }
  },
  emits: ["update:value"],
  setup(e, { emit: t }) {
    const { t: n } = Ci(), o = e, { numberOfFields: r, resendCodeUrl: i, resendCodeCooldown: s, resendCodeMethod: a } = _c(o), l = t, c = te(Tt.ERROR), u = te(""), d = te(null), f = te(Array(r.value).fill("")), p = (g) => {
      var M;
      const R = (M = d.value) == null ? void 0 : M.children[g];
      R && R.focus();
    }, v = (g, R) => {
      const G = g.data ?? f.value[R];
      f.value[R] = G, R === r.value - 1 ? tt(() => {
        p(R);
      }) : p(R + 1);
    }, w = (g, R) => {
      const M = m(g.key);
      if (M) {
        switch (u.value = "", M) {
          case "Backspace":
            _(g, R);
            return;
          case "ArrowRight":
          case "Right":
            p(R + 1);
            return;
          case "ArrowLeft":
          case "Left":
            p(R - 1);
            return;
        }
        g.metaKey || g.ctrlKey || g.altKey || M.length === 1 && !/\d/.test(M) && g.preventDefault();
      }
    }, _ = (g, R) => {
      g.preventDefault(), f.value[R].trim() && (f.value[R] = ""), R === 0 ? tt(() => {
        p(0);
      }) : p(R - 1);
    };
    function C(g) {
      return g.length === r.value && /^\d+$/.test(g);
    }
    const S = (g) => {
      const R = N(g);
      if (R !== void 0) {
        if (!C(R)) {
          p(0), c.value = Tt.ERROR, u.value = n("uikit:ws_two_factor_authentication_input.invalid_code_pasted");
          return;
        }
        f.value = R.split(""), tt(() => {
          p(r.value - 1);
        });
      }
    }, N = (g) => {
      g.preventDefault();
      const R = g.clipboardData || typeof window < "u" && window.clipboardData;
      return R ? (R.getData("Text") || R.getData("text/plain")).trim() : void 0;
    };
    function m(g) {
      return g === "Unidentified" ? void 0 : g;
    }
    ye(f, () => {
      const g = f.value.join("");
      l("update:value", g);
    }, { deep: !0 });
    const x = te(Vt.READY), k = te(0), D = te(void 0), E = () => {
      u.value = "", x.value = Vt.SENDING, Gu[a.value](i.value).then(function() {
        O();
      }).catch(function(g) {
        c.value = Tt.ERROR, u.value = n("uikit:ws_two_factor_authentication_input.error_sending_code") + g.message, x.value = Vt.READY;
      });
    };
    function O() {
      c.value = Tt.SUCCESS, u.value = n("uikit:ws_two_factor_authentication_input.code_sent_successfully"), x.value = Vt.ON_COOLDOWN;
      const g = parseInt(s.value);
      k.value = g, A(), setTimeout(() => {
        x.value = Vt.READY;
      }, g * 1e3);
    }
    function A() {
      D.value = setInterval(() => {
        k.value -= 1, k.value <= 0 && clearInterval(D.value);
      }, 1e3);
    }
    return kr(() => {
      clearInterval(D.value);
    }), (g, R) => {
      const M = nt("ws-button"), G = nt("ws-tooltip"), Q = nt("ws-state-banner");
      return X(), ue("div", sx, [
        ce("div", {
          ref_key: "wrap",
          ref: d,
          class: "code-input-container self-center"
        }, [
          (X(!0), ue(Je, null, Ri(f.value, ($, W) => ga((X(), ue("input", {
            key: `wstfa-${$}-${W}`,
            "onUpdate:modelValue": (he) => f.value[W] = he,
            class: "code-input",
            autocomplete: "one-time-code",
            "data-test": "totp-input",
            onKeydown: (he) => {
              w(he, W);
            },
            onInput: (he) => {
              v(he, W);
            },
            onPaste: S
          }, null, 40, ax)), [
            [Zh, f.value[W]]
          ])), 128))
        ], 512),
        re(i) ? (X(), ue("div", lx, [
          le(M, {
            class: "resend-code-button",
            "data-test": "resend-code-button",
            disabled: x.value !== re(Vt).READY,
            type: re(et).TERTIARY,
            onClick: E
          }, {
            default: Me(() => [
              ft(De(g.$t("uikit:ws_two_factor_authentication_input.resend_code")), 1)
            ]),
            _: 1
          }, 8, ["disabled", "type"]),
          x.value !== re(Vt).READY ? (X(), He(G, { key: 0 }, {
            default: Me(() => [
              x.value === re(Vt).SENDING ? (X(), ue(Je, { key: 0 }, [
                ft(De(g.$t("uikit:ws_two_factor_authentication_input.code_being_sent")), 1)
              ], 64)) : x.value === re(Vt).ON_COOLDOWN ? (X(), ue(Je, { key: 1 }, [
                ft(De(g.$t("uikit:ws_two_factor_authentication_input.on_cooldown", { count: k.value })), 1)
              ], 64)) : Pe("", !0)
            ]),
            _: 1
          })) : Pe("", !0)
        ])) : Pe("", !0),
        u.value ? (X(), He(Q, {
          key: 1,
          text: g.$t(u.value),
          type: c.value
        }, {
          text: Me(() => [
            ft(De(g.$t(u.value)), 1)
          ]),
          _: 1
        }, 8, ["text", "type"])) : Pe("", !0)
      ]);
    };
  }
}), ek = /* @__PURE__ */ je(ux, [["__scopeId", "data-v-3d0ca511"]]), tk = /* @__PURE__ */ Ee({
  __name: "WsLabelLink",
  props: {
    href: {
      type: String,
      required: !0
    },
    target: {
      type: String,
      default: void 0
    },
    label: {
      type: String,
      default: "uikit:general.link"
    }
  },
  setup(e) {
    const t = e, n = () => window.open(t.href, t.target);
    return (o, r) => {
      const i = nt("portal-slot");
      return X(), ue("a", {
        class: "ws-link",
        href: "javascript:void(0)",
        onClick: nv(n, ["prevent", "stop"])
      }, [
        le(i, {
          slot: o.$slots.default,
          "component-id": o.$attrs["component-id"]
        }, {
          default: Me(() => [
            ft(De(o.$t(t.label)), 1)
          ]),
          _: 1
        }, 8, ["slot", "component-id"])
      ]);
    };
  }
}), cx = { class: "ws-state-banner-inner-wrapper flex row" }, dx = {
  key: 1,
  class: "ws-state-banner__content"
}, fx = {
  key: 0,
  class: "ws-state-banner__title"
}, px = {
  key: 1,
  class: "ws-state-banner__text"
}, mx = {
  key: 3,
  class: "ws-state-banner__closable justify-end"
}, hx = {
  key: 0,
  class: "flex justify-end"
}, vx = ["href"], gx = /* @__PURE__ */ Ee({
  __name: "WsStateBanner",
  props: {
    size: { type: String, default: Ba.LARGE },
    type: { type: String, default: Tt.DEFAULT },
    closable: { type: Boolean, default: !1 },
    icon: { type: Boolean, default: !1 },
    title: { type: String, default: "" },
    text: { type: String, default: "" },
    button: { type: String, default: "" },
    headerIcon: { type: String, default: "" },
    portalSlots: {
      type: Array,
      default: null
    }
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = te(!1), i = () => {
      switch (n.type) {
        case Tt.NEUTRAL:
          return "success_full";
        case Tt.SUCCESS:
          return "success_full";
        case Tt.WARNING:
          return "alert_triangle_full";
        case Tt.ERROR:
          return "alert_circle_full";
        case Tt.DEFAULT:
        default:
          return "info_full";
      }
    }, s = () => {
      r.value = !0, o("close");
    }, a = V(() => n.button ? JSON.parse(n.button).label : ""), l = V(() => n.button ? JSON.parse(n.button).url : ""), c = V(() => n.button ? JSON.parse(n.button).icon : ""), u = V(() => {
      var p;
      return (p = n.portalSlots) == null ? void 0 : p.includes("title");
    }), d = V(() => {
      var p;
      return (p = n.portalSlots) == null ? void 0 : p.includes("text");
    }), f = V(() => {
      var p;
      return (p = n.portalSlots) == null ? void 0 : p.includes("default");
    });
    return (p, v) => {
      const w = nt("portal-slot");
      return r.value ? Pe("", !0) : (X(), ue("div", {
        key: 0,
        ref: "banner",
        class: pt(["ws-state-banner column", `${e.size} ${e.type}`])
      }, [
        ce("div", cx, [
          n.icon ? (X(), He(Tn, {
            key: 0,
            name: i(),
            size: 22,
            wrap: "",
            class: "ws-state-banner__icon"
          }, null, 8, ["name"])) : Pe("", !0),
          f.value ? (X(), He(w, {
            key: 2,
            slot: p.$slots.default,
            "component-id": p.$attrs["component-id"],
            name: "default"
          }, null, 8, ["slot", "component-id"])) : (X(), ue("div", dx, [
            u.value || n.title ? (X(), ue("div", fx, [
              le(w, {
                slot: p.$slots.title,
                "component-id": p.$attrs["component-id"],
                name: "title"
              }, {
                default: Me(() => [
                  ft(De(n.title), 1)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : Pe("", !0),
            d.value || n.text ? (X(), ue("p", px, [
              le(w, {
                slot: p.$slots.text,
                "component-id": p.$attrs["component-id"],
                name: "text"
              }, {
                default: Me(() => [
                  ft(De(n.text), 1)
                ]),
                _: 1
              }, 8, ["slot", "component-id"])
            ])) : Pe("", !0)
          ])),
          n.closable ? (X(), ue("div", mx, [
            ce("button", {
              class: "ws-button self-start closable q-px-sm q-py-sm",
              onClick: s
            }, [
              le(Tn, {
                name: "close",
                size: 14
              })
            ])
          ])) : Pe("", !0)
        ]),
        n.button ? (X(), ue("div", hx, [
          ce("a", {
            class: "q-btn self-end",
            href: l.value
          }, [
            le(Tn, { name: c.value }, null, 8, ["name"]),
            ft(" " + De(a.value), 1)
          ], 8, vx)
        ])) : Pe("", !0)
      ], 2));
    };
  }
}), nk = /* @__PURE__ */ je(gx, [["__scopeId", "data-v-f0b35b68"]]);
var sn = /* @__PURE__ */ ((e) => (e.PAST = "past", e.PRESENT = "present", e.FUTURE = "future", e))(sn || {});
const ok = {
  Status: sn
}, bx = { class: "ws-timeline-step flex items-center q-pa-sm" }, yx = { class: "ws-timeline-step__content" }, wx = { class: "flex items-center" }, rk = /* @__PURE__ */ Ee({
  __name: "WsTimelineStep",
  props: {
    date: { type: String, default: "" },
    tooltip: { type: String, default: "" },
    description: { type: String, default: "" },
    status: { type: String, default: sn.FUTURE },
    url: { type: String, default: "" }
  },
  setup(e) {
    const t = V(() => e.status === sn.PAST), n = V(() => e.status === sn.PRESENT), o = V(() => e.status === sn.FUTURE), r = V(() => {
      switch (e.status) {
        case sn.PAST:
          return { name: "success_full", color: "ws-gem-100" };
        case sn.PRESENT:
          return { name: "circle", color: "ws-king-220" };
        case sn.FUTURE:
        default:
          return { name: "circle", color: "ws-navy-70" };
      }
    });
    return (i, s) => {
      const a = nt("ws-icon"), l = nt("ws-tooltip");
      return X(), ue("div", bx, [
        ce("div", yx, [
          ce("div", wx, [
            le(a, {
              name: r.value.name,
              color: r.value.color
            }, null, 8, ["name", "color"])
          ]),
          ce("div", null, [
            ce("div", null, De(e.date), 1),
            (X(), He(ba(e.url ? "a" : "div"), Bt(e.url ? { href: e.url } : {}, {
              class: ["text-weight-bold", {
                "text-ws-navy-100": t.value || n.value,
                "text-ws-navy-70": o.value
              }]
            }), {
              default: Me(() => [
                ft(De(e.description), 1)
              ]),
              _: 1
            }, 16, ["class"]))
          ]),
          e.tooltip ? (X(), He(l, {
            key: 0,
            color: r.value.color,
            icon: r.value.name
          }, {
            default: Me(() => [
              ft(De(e.tooltip), 1)
            ]),
            _: 1
          }, 8, ["color", "icon"])) : Pe("", !0)
        ])
      ]);
    };
  }
}), _x = {}, Ex = { class: "ws-timeline" };
function xx(e, t) {
  const n = nt("portal-slot");
  return X(), ue("div", Ex, [
    le(n, {
      slot: e.$slots.default,
      "component-id": e.$attrs["component-id"],
      name: "default"
    }, null, 8, ["slot", "component-id"])
  ]);
}
const ik = /* @__PURE__ */ je(_x, [["render", xx], ["__scopeId", "data-v-14e7d4bb"]]), kx = { class: "expandable-text flex items-center no-wrap" }, Cx = ["innerHTML"], Sx = /* @__PURE__ */ Ee({
  __name: "WsExpandableText",
  props: {
    expandableLength: {},
    content: {}
  },
  setup(e) {
    const t = e, { content: n, expandableLength: o } = _c(t), r = te(!1), i = V(() => r.value ? "initial" : o.value + "ch"), s = V(() => typeof n.value == "string" && n.value.length > o.value), a = () => {
      r.value = !r.value;
    }, l = V(() => {
      const c = typeof n.value == "string" ? xs(n.value) : n.value.toString();
      return s.value && !r.value && o.value ? c.substring(0, o.value) + "&hellip;" : c;
    });
    return (c, u) => (X(), ue("div", kx, [
      ce("div", {
        style: Ni({ "max-width": i.value }),
        class: pt(["paragraph", { "paragraph-expanded": r.value }]),
        innerHTML: re(xs)(l.value)
      }, null, 14, Cx),
      s.value ? (X(), ue("button", {
        key: 0,
        class: "expandable-button remove-button-defaults",
        onClick: a
      }, [
        le(Tn, {
          name: "arrow_down",
          color: "primary",
          "data-test": "expandable-icon",
          class: pt({ expanded: r.value })
        }, null, 8, ["class"])
      ])) : Pe("", !0)
    ]));
  }
}), sk = /* @__PURE__ */ je(Sx, [["__scopeId", "data-v-de29bfe6"]]), Ox = "_q_", Nx = "_q_fo_";
function $x({ validate: e, resetValidation: t, requiresQForm: n }) {
  const o = Xo(Nx, !1);
  if (o !== !1) {
    const { props: r, proxy: i } = Fe();
    Object.assign(i, { validate: e, resetValidation: t }), ye(() => r.disable, (s) => {
      s === !0 ? (typeof t == "function" && t(), o.unbindComponent(i)) : o.bindComponent(i);
    }), Ct(() => {
      r.disable !== !0 && o.bindComponent(i);
    }), St(() => {
      r.disable !== !0 && o.unbindComponent(i);
    });
  } else n === !0 && console.error("Parent QForm not found on useFormChild()!");
}
const Vu = /^#[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/, Ru = /^#[0-9a-fA-F]{4}([0-9a-fA-F]{4})?$/, Lu = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{4}|[0-9a-fA-F]{6}|[0-9a-fA-F]{8})$/, Kr = /^rgb\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5])\)$/, Yr = /^rgba\(((0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),){2}(0|[1-9][\d]?|1[\d]{0,2}|2[\d]?|2[0-4][\d]|25[0-5]),(0|0\.[0-9]+[1-9]|0\.[1-9]+|1)\)$/, _s = {
  date: (e) => /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(e),
  time: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d$/.test(e),
  fulltime: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d:[0-5]\d$/.test(e),
  timeOrFulltime: (e) => /^([0-1]?\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/.test(e),
  // -- RFC 5322 --
  // -- Added in v2.6.6 --
  // This is a basic helper validation.
  // For something more complex (like RFC 822) you should write and use your own rule.
  // We won't be accepting PRs to enhance the one below because of the reason above.
  // eslint-disable-next-line
  email: (e) => /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(e),
  hexColor: (e) => Vu.test(e),
  hexaColor: (e) => Ru.test(e),
  hexOrHexaColor: (e) => Lu.test(e),
  rgbColor: (e) => Kr.test(e),
  rgbaColor: (e) => Yr.test(e),
  rgbOrRgbaColor: (e) => Kr.test(e) || Yr.test(e),
  hexOrRgbColor: (e) => Vu.test(e) || Kr.test(e),
  hexaOrRgbaColor: (e) => Ru.test(e) || Yr.test(e),
  anyColor: (e) => Lu.test(e) || Kr.test(e) || Yr.test(e)
};
function Of(e, t = 250, n) {
  let o = null;
  function r() {
    const i = arguments, s = () => {
      o = null, e.apply(this, i);
    };
    o !== null && clearTimeout(o), o = setTimeout(s, t);
  }
  return r.cancel = () => {
    o !== null && clearTimeout(o);
  }, r;
}
const Tx = [!0, !1, "ondemand"], Px = {
  modelValue: {},
  error: {
    type: Boolean,
    default: null
  },
  errorMessage: String,
  noErrorIcon: Boolean,
  rules: Array,
  reactiveRules: Boolean,
  lazyRules: {
    type: [Boolean, String],
    default: !1,
    // statement unneeded but avoids future vue implementation changes
    validator: (e) => Tx.includes(e)
  }
};
function Dx(e, t) {
  const { props: n, proxy: o } = Fe(), r = te(!1), i = te(null), s = te(null);
  $x({ validate: v, resetValidation: p });
  let a = 0, l;
  const c = V(
    () => n.rules !== void 0 && n.rules !== null && n.rules.length !== 0
  ), u = V(() => n.disable !== !0 && c.value === !0 && t.value === !1), d = V(
    () => n.error === !0 || r.value === !0
  ), f = V(() => typeof n.errorMessage == "string" && n.errorMessage.length !== 0 ? n.errorMessage : i.value);
  ye(() => n.modelValue, () => {
    s.value = !0, u.value === !0 && n.lazyRules === !1 && w();
  }), ye(() => n.reactiveRules, (_) => {
    _ === !0 ? l === void 0 && (l = ye(() => n.rules, () => {
      u.value === !0 && s.value === !0 && n.lazyRules !== "ondemand" && w();
    }, { immediate: !0 })) : l !== void 0 && (l(), l = void 0);
  }, { immediate: !0 }), ye(() => n.lazyRules, (_) => {
    _ === !1 && u.value === !0 && s.value === !0 && w();
  }), ye(e, (_) => {
    _ === !0 ? s.value === null && (s.value = n.lazyRules === !0) : u.value === !0 && // props.lazyRules can also be 'ondemand',
    // hence the following form:
    (n.lazyRules === !1 || n.lazyRules === !0 && s.value === !0) && w();
  });
  function p() {
    a++, t.value = !1, s.value = null, r.value = !1, i.value = null, w.cancel();
  }
  function v(_ = n.modelValue) {
    if (n.disable === !0 || c.value === !1)
      return !0;
    const C = ++a, S = t.value !== !0 ? () => {
      s.value = !0;
    } : () => {
    }, N = (y, x) => {
      y === !0 && S(), r.value = y, i.value = x || null, t.value = !1;
    }, m = [];
    for (let y = 0; y < n.rules.length; y++) {
      const x = n.rules[y];
      let k;
      if (typeof x == "function" ? k = x(_, _s) : typeof x == "string" && _s[x] !== void 0 && (k = _s[x](_)), k === !1 || typeof k == "string")
        return N(!0, k), !1;
      k !== !0 && k !== void 0 && m.push(k);
    }
    return m.length === 0 ? (N(!1), !0) : (t.value = !0, Promise.all(m).then(
      (y) => {
        if (y === void 0 || Array.isArray(y) === !1 || y.length === 0)
          return C === a && N(!1), !0;
        const x = y.find((k) => k === !1 || typeof k == "string");
        return C === a && N(x !== void 0, x), x === void 0;
      },
      (y) => (C === a && (console.error(y), N(!0)), !1)
    ));
  }
  const w = Of(v, 0);
  return St(() => {
    l !== void 0 && l(), w.cancel();
  }), Object.assign(o, { resetValidation: p, validate: v }), Fo(o, "hasError", () => d.value), {
    isDirtyModel: s,
    hasRules: c,
    hasError: d,
    errorMessage: f,
    validate: v,
    resetValidation: p
  };
}
const Iu = /^on[A-Z]/;
function Mx(e, t) {
  const n = {
    listeners: te({}),
    attributes: te({})
  };
  function o() {
    const r = {}, i = {};
    for (const s in e)
      s !== "class" && s !== "style" && Iu.test(s) === !1 && (r[s] = e[s]);
    for (const s in t.props)
      Iu.test(s) === !0 && (i[s] = t.props[s]);
    n.attributes.value = r, n.listeners.value = i;
  }
  return zc(o), o(), n;
}
function Nf(e, t) {
  return e === void 0 ? t === !0 ? `f_${qa()}` : void 0 : e;
}
function Zs(e) {
  return e != null && ("" + e).length !== 0;
}
const Ax = {
  ...Io,
  ...Px,
  label: String,
  stackLabel: Boolean,
  hint: String,
  hideHint: Boolean,
  prefix: String,
  suffix: String,
  labelColor: String,
  color: String,
  bgColor: String,
  filled: Boolean,
  outlined: Boolean,
  borderless: Boolean,
  standout: [Boolean, String],
  square: Boolean,
  loading: Boolean,
  labelSlot: Boolean,
  bottomSlots: Boolean,
  hideBottomSpace: Boolean,
  rounded: Boolean,
  dense: Boolean,
  itemAligned: Boolean,
  counter: Boolean,
  clearable: Boolean,
  clearIcon: String,
  disable: Boolean,
  readonly: Boolean,
  autofocus: Boolean,
  for: String,
  maxlength: [Number, String]
}, Vx = ["update:modelValue", "clear", "focus", "blur", "popupShow", "popupHide"];
function Rx({ requiredForAttr: e = !0, tagProp: t } = {}) {
  const { props: n, attrs: o, proxy: r, vnode: i } = Fe(), s = jo(n, r.$q);
  return {
    requiredForAttr: e,
    tag: t === !0 ? V(() => n.tag) : { value: "label" },
    isDark: s,
    editable: V(
      () => n.disable !== !0 && n.readonly !== !0
    ),
    innerLoading: te(!1),
    focused: te(!1),
    hasPopupOpen: !1,
    splitAttrs: Mx(o, i),
    targetUid: te(
      Nf(n.for, e)
    ),
    rootRef: te(null),
    targetRef: te(null),
    controlRef: te(null)
    /**
         * user supplied additionals:
    
         * innerValue - computed
         * floatingLabel - computed
         * inputRef - computed
    
         * fieldClass - computed
         * hasShadow - computed
    
         * controlEvents - Object with fn(e)
    
         * getControl - fn
         * getInnerAppend - fn
         * getControlChild - fn
         * getShadowControl - fn
         * showPopup - fn
         */
  };
}
function Lx(e) {
  const { props: t, emit: n, slots: o, attrs: r, proxy: i } = Fe(), { $q: s } = i;
  let a = null;
  e.hasValue === void 0 && (e.hasValue = V(() => Zs(t.modelValue))), e.emitValue === void 0 && (e.emitValue = ($) => {
    n("update:modelValue", $);
  }), e.controlEvents === void 0 && (e.controlEvents = {
    onFocusin: E,
    onFocusout: O
  }), Object.assign(e, {
    clearValue: A,
    onControlFocusin: E,
    onControlFocusout: O,
    focus: k
  }), e.computedCounter === void 0 && (e.computedCounter = V(() => {
    if (t.counter !== !1) {
      const $ = typeof t.modelValue == "string" || typeof t.modelValue == "number" ? ("" + t.modelValue).length : Array.isArray(t.modelValue) === !0 ? t.modelValue.length : 0, W = t.maxlength !== void 0 ? t.maxlength : t.maxValues;
      return $ + (W !== void 0 ? " / " + W : "");
    }
  }));
  const {
    isDirtyModel: l,
    hasRules: c,
    hasError: u,
    errorMessage: d,
    resetValidation: f
  } = Dx(e.focused, e.innerLoading), p = e.floatingLabel !== void 0 ? V(() => t.stackLabel === !0 || e.focused.value === !0 || e.floatingLabel.value === !0) : V(() => t.stackLabel === !0 || e.focused.value === !0 || e.hasValue.value === !0), v = V(
    () => t.bottomSlots === !0 || t.hint !== void 0 || c.value === !0 || t.counter === !0 || t.error !== null
  ), w = V(() => t.filled === !0 ? "filled" : t.outlined === !0 ? "outlined" : t.borderless === !0 ? "borderless" : t.standout ? "standout" : "standard"), _ = V(
    () => `q-field row no-wrap items-start q-field--${w.value}` + (e.fieldClass !== void 0 ? ` ${e.fieldClass.value}` : "") + (t.rounded === !0 ? " q-field--rounded" : "") + (t.square === !0 ? " q-field--square" : "") + (p.value === !0 ? " q-field--float" : "") + (S.value === !0 ? " q-field--labeled" : "") + (t.dense === !0 ? " q-field--dense" : "") + (t.itemAligned === !0 ? " q-field--item-aligned q-item-type" : "") + (e.isDark.value === !0 ? " q-field--dark" : "") + (e.getControl === void 0 ? " q-field--auto-height" : "") + (e.focused.value === !0 ? " q-field--focused" : "") + (u.value === !0 ? " q-field--error" : "") + (u.value === !0 || e.focused.value === !0 ? " q-field--highlighted" : "") + (t.hideBottomSpace !== !0 && v.value === !0 ? " q-field--with-bottom" : "") + (t.disable === !0 ? " q-field--disabled" : t.readonly === !0 ? " q-field--readonly" : "")
  ), C = V(
    () => "q-field__control relative-position row no-wrap" + (t.bgColor !== void 0 ? ` bg-${t.bgColor}` : "") + (u.value === !0 ? " text-negative" : typeof t.standout == "string" && t.standout.length !== 0 && e.focused.value === !0 ? ` ${t.standout}` : t.color !== void 0 ? ` text-${t.color}` : "")
  ), S = V(
    () => t.labelSlot === !0 || t.label !== void 0
  ), N = V(
    () => "q-field__label no-pointer-events absolute ellipsis" + (t.labelColor !== void 0 && u.value !== !0 ? ` text-${t.labelColor}` : "")
  ), m = V(() => ({
    id: e.targetUid.value,
    editable: e.editable.value,
    focused: e.focused.value,
    floatingLabel: p.value,
    modelValue: t.modelValue,
    emitValue: e.emitValue
  })), y = V(() => {
    const $ = {
      for: e.targetUid.value
    };
    return t.disable === !0 && ($["aria-disabled"] = "true"), $;
  });
  ye(() => t.for, ($) => {
    e.targetUid.value = Nf($, e.requiredForAttr);
  });
  function x() {
    const $ = document.activeElement;
    let W = e.targetRef !== void 0 && e.targetRef.value;
    W && ($ === null || $.id !== e.targetUid.value) && (W.hasAttribute("tabindex") === !0 || (W = W.querySelector("[tabindex]")), W && W !== $ && W.focus({ preventScroll: !0 }));
  }
  function k() {
    ja(x);
  }
  function D() {
    Uy(x);
    const $ = document.activeElement;
    $ !== null && e.rootRef.value.contains($) && $.blur();
  }
  function E($) {
    a !== null && (clearTimeout(a), a = null), e.editable.value === !0 && e.focused.value === !1 && (e.focused.value = !0, n("focus", $));
  }
  function O($, W) {
    a !== null && clearTimeout(a), a = setTimeout(() => {
      a = null, !(document.hasFocus() === !0 && (e.hasPopupOpen === !0 || e.controlRef === void 0 || e.controlRef.value === null || e.controlRef.value.contains(document.activeElement) !== !1)) && (e.focused.value === !0 && (e.focused.value = !1, n("blur", $)), W !== void 0 && W());
    });
  }
  function A($) {
    an($), s.platform.is.mobile !== !0 ? (e.targetRef !== void 0 && e.targetRef.value || e.rootRef.value).focus() : e.rootRef.value.contains(document.activeElement) === !0 && document.activeElement.blur(), t.type === "file" && (e.inputRef.value.value = null), n("update:modelValue", null), n("clear", t.modelValue), tt(() => {
      f(), s.platform.is.mobile !== !0 && (l.value = !1);
    });
  }
  function g() {
    const $ = [];
    return o.prepend !== void 0 && $.push(
      U("div", {
        class: "q-field__prepend q-field__marginal row no-wrap items-center",
        key: "prepend",
        onClick: On
      }, o.prepend())
    ), $.push(
      U("div", {
        class: "q-field__control-container col relative-position row no-wrap q-anchor--skip"
      }, R())
    ), u.value === !0 && t.noErrorIcon === !1 && $.push(
      G("error", [
        U(br, { name: s.iconSet.field.error, color: "negative" })
      ])
    ), t.loading === !0 || e.innerLoading.value === !0 ? $.push(
      G(
        "inner-loading-append",
        o.loading !== void 0 ? o.loading() : [U(La, { color: t.color })]
      )
    ) : t.clearable === !0 && e.hasValue.value === !0 && e.editable.value === !0 && $.push(
      G("inner-clearable-append", [
        U(br, {
          class: "q-field__focusable-action",
          tag: "button",
          name: t.clearIcon || s.iconSet.field.clear,
          tabindex: 0,
          type: "button",
          "aria-hidden": null,
          role: null,
          onClick: A
        })
      ])
    ), o.append !== void 0 && $.push(
      U("div", {
        class: "q-field__append q-field__marginal row no-wrap items-center",
        key: "append",
        onClick: On
      }, o.append())
    ), e.getInnerAppend !== void 0 && $.push(
      G("inner-append", e.getInnerAppend())
    ), e.getControlChild !== void 0 && $.push(
      e.getControlChild()
    ), $;
  }
  function R() {
    const $ = [];
    return t.prefix !== void 0 && t.prefix !== null && $.push(
      U("div", {
        class: "q-field__prefix no-pointer-events row items-center"
      }, t.prefix)
    ), e.getShadowControl !== void 0 && e.hasShadow.value === !0 && $.push(
      e.getShadowControl()
    ), e.getControl !== void 0 ? $.push(e.getControl()) : o.rawControl !== void 0 ? $.push(o.rawControl()) : o.control !== void 0 && $.push(
      U("div", {
        ref: e.targetRef,
        class: "q-field__native row",
        tabindex: -1,
        ...e.splitAttrs.attributes.value,
        "data-autofocus": t.autofocus === !0 || void 0
      }, o.control(m.value))
    ), S.value === !0 && $.push(
      U("div", {
        class: N.value
      }, Pt(o.label, t.label))
    ), t.suffix !== void 0 && t.suffix !== null && $.push(
      U("div", {
        class: "q-field__suffix no-pointer-events row items-center"
      }, t.suffix)
    ), $.concat(Pt(o.default));
  }
  function M() {
    let $, W;
    u.value === !0 ? d.value !== null ? ($ = [U("div", { role: "alert" }, d.value)], W = `q--slot-error-${d.value}`) : ($ = Pt(o.error), W = "q--slot-error") : (t.hideHint !== !0 || e.focused.value === !0) && (t.hint !== void 0 ? ($ = [U("div", t.hint)], W = `q--slot-hint-${t.hint}`) : ($ = Pt(o.hint), W = "q--slot-hint"));
    const he = t.counter === !0 || o.counter !== void 0;
    if (t.hideBottomSpace === !0 && he === !1 && $ === void 0)
      return;
    const fe = U("div", {
      key: W,
      class: "q-field__messages col"
    }, $);
    return U("div", {
      class: "q-field__bottom row items-start q-field__bottom--" + (t.hideBottomSpace !== !0 ? "animated" : "stale"),
      onClick: On
    }, [
      t.hideBottomSpace === !0 ? fe : U(Sa, { name: "q-transition--field-message" }, () => fe),
      he === !0 ? U("div", {
        class: "q-field__counter"
      }, o.counter !== void 0 ? o.counter() : e.computedCounter.value) : null
    ]);
  }
  function G($, W) {
    return W === null ? null : U("div", {
      key: $,
      class: "q-field__append q-field__marginal row no-wrap items-center q-anchor--skip"
    }, W);
  }
  let Q = !1;
  return Ai(() => {
    Q = !0;
  }), Wc(() => {
    Q === !0 && t.autofocus === !0 && i.focus();
  }), Ct(() => {
    Mn.value === !0 && e.requiredForAttr === !0 && t.for === void 0 && (e.targetUid.value = `f_${qa()}`), t.autofocus === !0 && i.focus();
  }), St(() => {
    a !== null && clearTimeout(a);
  }), Object.assign(i, { focus: k, blur: D }), function() {
    const W = e.getControl === void 0 && o.control === void 0 ? {
      ...e.splitAttrs.attributes.value,
      "data-autofocus": t.autofocus === !0 || void 0,
      ...y.value
    } : y.value;
    return U(e.tag.value, {
      ref: e.rootRef,
      class: [
        _.value,
        r.class
      ],
      style: r.style,
      ...W
    }, [
      o.before !== void 0 ? U("div", {
        class: "q-field__before q-field__marginal row no-wrap items-center",
        onClick: On
      }, o.before()) : null,
      U("div", {
        class: "q-field__inner relative-position col self-stretch"
      }, [
        U("div", {
          ref: e.controlRef,
          class: C.value,
          tabindex: -1,
          ...e.controlEvents
        }, g()),
        v.value === !0 ? M() : null
      ]),
      o.after !== void 0 ? U("div", {
        class: "q-field__after q-field__marginal row no-wrap items-center",
        onClick: On
      }, o.after()) : null
    ]);
  };
}
const ju = {
  date: "####/##/##",
  datetime: "####/##/## ##:##",
  time: "##:##",
  fulltime: "##:##:##",
  phone: "(###) ### - ####",
  card: "#### #### #### ####"
}, xi = {
  "#": { pattern: "[\\d]", negate: "[^\\d]" },
  S: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]" },
  N: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]" },
  A: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (e) => e.toLocaleUpperCase() },
  a: { pattern: "[a-zA-Z]", negate: "[^a-zA-Z]", transform: (e) => e.toLocaleLowerCase() },
  X: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (e) => e.toLocaleUpperCase() },
  x: { pattern: "[0-9a-zA-Z]", negate: "[^0-9a-zA-Z]", transform: (e) => e.toLocaleLowerCase() }
}, $f = Object.keys(xi);
$f.forEach((e) => {
  xi[e].regex = new RegExp(xi[e].pattern);
});
const Ix = new RegExp("\\\\([^.*+?^${}()|([\\]])|([.*+?^${}()|[\\]])|([" + $f.join("") + "])|(.)", "g"), qu = /[.*+?^${}()|[\]\\]/g, Ue = "", jx = {
  mask: String,
  reverseFillMask: Boolean,
  fillMask: [Boolean, String],
  unmaskedValue: Boolean
};
function qx(e, t, n, o) {
  let r, i, s, a, l, c;
  const u = te(null), d = te(p());
  function f() {
    return e.autogrow === !0 || ["textarea", "text", "search", "url", "tel", "password"].includes(e.type);
  }
  ye(() => e.type + e.autogrow, w), ye(() => e.mask, (E) => {
    if (E !== void 0)
      _(d.value, !0);
    else {
      const O = k(d.value);
      w(), e.modelValue !== O && t("update:modelValue", O);
    }
  }), ye(() => e.fillMask + e.reverseFillMask, () => {
    u.value === !0 && _(d.value, !0);
  }), ye(() => e.unmaskedValue, () => {
    u.value === !0 && _(d.value);
  });
  function p() {
    if (w(), u.value === !0) {
      const E = y(k(e.modelValue));
      return e.fillMask !== !1 ? D(E) : E;
    }
    return e.modelValue;
  }
  function v(E) {
    if (E < r.length)
      return r.slice(-E);
    let O = "", A = r;
    const g = A.indexOf(Ue);
    if (g > -1) {
      for (let R = E - A.length; R > 0; R--)
        O += Ue;
      A = A.slice(0, g) + O + A.slice(g);
    }
    return A;
  }
  function w() {
    if (u.value = e.mask !== void 0 && e.mask.length !== 0 && f(), u.value === !1) {
      a = void 0, r = "", i = "";
      return;
    }
    const E = ju[e.mask] === void 0 ? e.mask : ju[e.mask], O = typeof e.fillMask == "string" && e.fillMask.length !== 0 ? e.fillMask.slice(0, 1) : "_", A = O.replace(qu, "\\$&"), g = [], R = [], M = [];
    let G = e.reverseFillMask === !0, Q = "", $ = "";
    E.replace(Ix, (we, q, ve, Ve, Te) => {
      if (Ve !== void 0) {
        const xe = xi[Ve];
        M.push(xe), $ = xe.negate, G === !0 && (R.push("(?:" + $ + "+)?(" + xe.pattern + "+)?(?:" + $ + "+)?(" + xe.pattern + "+)?"), G = !1), R.push("(?:" + $ + "+)?(" + xe.pattern + ")?");
      } else if (ve !== void 0)
        Q = "\\" + (ve === "\\" ? "" : ve), M.push(ve), g.push("([^" + Q + "]+)?" + Q + "?");
      else {
        const xe = q !== void 0 ? q : Te;
        Q = xe === "\\" ? "\\\\\\\\" : xe.replace(qu, "\\\\$&"), M.push(xe), g.push("([^" + Q + "]+)?" + Q + "?");
      }
    });
    const W = new RegExp(
      "^" + g.join("") + "(" + (Q === "" ? "." : "[^" + Q + "]") + "+)?" + (Q === "" ? "" : "[" + Q + "]*") + "$"
    ), he = R.length - 1, fe = R.map((we, q) => q === 0 && e.reverseFillMask === !0 ? new RegExp("^" + A + "*" + we) : q === he ? new RegExp(
      "^" + we + "(" + ($ === "" ? "." : $) + "+)?" + (e.reverseFillMask === !0 ? "$" : A + "*")
    ) : new RegExp("^" + we));
    s = M, a = (we) => {
      const q = W.exec(e.reverseFillMask === !0 ? we : we.slice(0, M.length + 1));
      q !== null && (we = q.slice(1).join(""));
      const ve = [], Ve = fe.length;
      for (let Te = 0, xe = we; Te < Ve; Te++) {
        const Re = fe[Te].exec(xe);
        if (Re === null)
          break;
        xe = xe.slice(Re.shift().length), ve.push(...Re);
      }
      return ve.length !== 0 ? ve.join("") : we;
    }, r = M.map((we) => typeof we == "string" ? we : Ue).join(""), i = r.split(Ue).join(O);
  }
  function _(E, O, A) {
    const g = o.value, R = g.selectionEnd, M = g.value.length - R, G = k(E);
    O === !0 && w();
    const Q = y(G), $ = e.fillMask !== !1 ? D(Q) : Q, W = d.value !== $;
    g.value !== $ && (g.value = $), W === !0 && (d.value = $), document.activeElement === g && tt(() => {
      if ($ === i) {
        const fe = e.reverseFillMask === !0 ? i.length : 0;
        g.setSelectionRange(fe, fe, "forward");
        return;
      }
      if (A === "insertFromPaste" && e.reverseFillMask !== !0) {
        const fe = g.selectionEnd;
        let we = R - 1;
        for (let q = l; q <= we && q < fe; q++)
          r[q] !== Ue && we++;
        S.right(g, we);
        return;
      }
      if (["deleteContentBackward", "deleteContentForward"].indexOf(A) > -1) {
        const fe = e.reverseFillMask === !0 ? R === 0 ? $.length > Q.length ? 1 : 0 : Math.max(0, $.length - ($ === i ? 0 : Math.min(Q.length, M) + 1)) + 1 : R;
        g.setSelectionRange(fe, fe, "forward");
        return;
      }
      if (e.reverseFillMask === !0)
        if (W === !0) {
          const fe = Math.max(0, $.length - ($ === i ? 0 : Math.min(Q.length, M + 1)));
          fe === 1 && R === 1 ? g.setSelectionRange(fe, fe, "forward") : S.rightReverse(g, fe);
        } else {
          const fe = $.length - M;
          g.setSelectionRange(fe, fe, "backward");
        }
      else if (W === !0) {
        const fe = Math.max(0, r.indexOf(Ue), Math.min(Q.length, R) - 1);
        S.right(g, fe);
      } else {
        const fe = R - 1;
        S.right(g, fe);
      }
    });
    const he = e.unmaskedValue === !0 ? k($) : $;
    String(e.modelValue) !== he && (e.modelValue !== null || he !== "") && n(he, !0);
  }
  function C(E, O, A) {
    const g = y(k(E.value));
    O = Math.max(0, r.indexOf(Ue), Math.min(g.length, O)), l = O, E.setSelectionRange(O, A, "forward");
  }
  const S = {
    left(E, O) {
      const A = r.slice(O - 1).indexOf(Ue) === -1;
      let g = Math.max(0, O - 1);
      for (; g >= 0; g--)
        if (r[g] === Ue) {
          O = g, A === !0 && O++;
          break;
        }
      if (g < 0 && r[O] !== void 0 && r[O] !== Ue)
        return S.right(E, 0);
      O >= 0 && E.setSelectionRange(O, O, "backward");
    },
    right(E, O) {
      const A = E.value.length;
      let g = Math.min(A, O + 1);
      for (; g <= A; g++)
        if (r[g] === Ue) {
          O = g;
          break;
        } else r[g - 1] === Ue && (O = g);
      if (g > A && r[O - 1] !== void 0 && r[O - 1] !== Ue)
        return S.left(E, A);
      E.setSelectionRange(O, O, "forward");
    },
    leftReverse(E, O) {
      const A = v(E.value.length);
      let g = Math.max(0, O - 1);
      for (; g >= 0; g--)
        if (A[g - 1] === Ue) {
          O = g;
          break;
        } else if (A[g] === Ue && (O = g, g === 0))
          break;
      if (g < 0 && A[O] !== void 0 && A[O] !== Ue)
        return S.rightReverse(E, 0);
      O >= 0 && E.setSelectionRange(O, O, "backward");
    },
    rightReverse(E, O) {
      const A = E.value.length, g = v(A), R = g.slice(0, O + 1).indexOf(Ue) === -1;
      let M = Math.min(A, O + 1);
      for (; M <= A; M++)
        if (g[M - 1] === Ue) {
          O = M, O > 0 && R === !0 && O--;
          break;
        }
      if (M > A && g[O - 1] !== void 0 && g[O - 1] !== Ue)
        return S.leftReverse(E, A);
      E.setSelectionRange(O, O, "forward");
    }
  };
  function N(E) {
    t("click", E), c = void 0;
  }
  function m(E) {
    if (t("keydown", E), af(E) === !0 || E.altKey === !0)
      return;
    const O = o.value, A = O.selectionStart, g = O.selectionEnd;
    if (E.shiftKey || (c = void 0), E.keyCode === 37 || E.keyCode === 39) {
      E.shiftKey && c === void 0 && (c = O.selectionDirection === "forward" ? A : g);
      const R = S[(E.keyCode === 39 ? "right" : "left") + (e.reverseFillMask === !0 ? "Reverse" : "")];
      if (E.preventDefault(), R(O, c === A ? g : A), E.shiftKey) {
        const M = O.selectionStart;
        O.setSelectionRange(Math.min(c, M), Math.max(c, M), "forward");
      }
    } else E.keyCode === 8 && e.reverseFillMask !== !0 && A === g ? (S.left(O, A), O.setSelectionRange(O.selectionStart, g, "backward")) : E.keyCode === 46 && e.reverseFillMask === !0 && A === g && (S.rightReverse(O, g), O.setSelectionRange(A, O.selectionEnd, "forward"));
  }
  function y(E) {
    if (E == null || E === "")
      return "";
    if (e.reverseFillMask === !0)
      return x(E);
    const O = s;
    let A = 0, g = "";
    for (let R = 0; R < O.length; R++) {
      const M = E[A], G = O[R];
      if (typeof G == "string")
        g += G, M === G && A++;
      else if (M !== void 0 && G.regex.test(M))
        g += G.transform !== void 0 ? G.transform(M) : M, A++;
      else
        return g;
    }
    return g;
  }
  function x(E) {
    const O = s, A = r.indexOf(Ue);
    let g = E.length - 1, R = "";
    for (let M = O.length - 1; M >= 0 && g > -1; M--) {
      const G = O[M];
      let Q = E[g];
      if (typeof G == "string")
        R = G + R, Q === G && g--;
      else if (Q !== void 0 && G.regex.test(Q))
        do
          R = (G.transform !== void 0 ? G.transform(Q) : Q) + R, g--, Q = E[g];
        while (A === M && Q !== void 0 && G.regex.test(Q));
      else
        return R;
    }
    return R;
  }
  function k(E) {
    return typeof E != "string" || a === void 0 ? typeof E == "number" ? a("" + E) : E : a(E);
  }
  function D(E) {
    return i.length - E.length <= 0 ? E : e.reverseFillMask === !0 && E.length !== 0 ? i.slice(0, -E.length) + E : E + i.slice(E.length);
  }
  return {
    innerValue: d,
    hasMask: u,
    moveCursorForPaste: C,
    updateMaskValue: _,
    onMaskedKeydown: m,
    onMaskedClick: N
  };
}
const Fx = {
  name: String
};
function Wx(e) {
  return V(() => e.name || e.for);
}
function Bx(e, t) {
  function n() {
    const o = e.modelValue;
    try {
      const r = "DataTransfer" in window ? new DataTransfer() : "ClipboardEvent" in window ? new ClipboardEvent("").clipboardData : void 0;
      return Object(o) === o && ("length" in o ? Array.from(o) : [o]).forEach((i) => {
        r.items.add(i);
      }), {
        files: r.files
      };
    } catch {
      return {
        files: void 0
      };
    }
  }
  return V(() => {
    if (e.type === "file")
      return n();
  });
}
const zx = /[\u3000-\u303f\u3040-\u309f\u30a0-\u30ff\uff00-\uff9f\u4e00-\u9faf\u3400-\u4dbf]/, Hx = /[\u4e00-\u9fff\u3400-\u4dbf\u{20000}-\u{2a6df}\u{2a700}-\u{2b73f}\u{2b740}-\u{2b81f}\u{2b820}-\u{2ceaf}\uf900-\ufaff\u3300-\u33ff\ufe30-\ufe4f\uf900-\ufaff\u{2f800}-\u{2fa1f}]/u, Ux = /[\u3131-\u314e\u314f-\u3163\uac00-\ud7a3]/, Kx = /[a-z0-9_ -]$/i;
function Yx(e) {
  return function(n) {
    if (n.type === "compositionend" || n.type === "change") {
      if (n.target.qComposing !== !0)
        return;
      n.target.qComposing = !1, e(n);
    } else n.type === "compositionupdate" && n.target.qComposing !== !0 && typeof n.data == "string" && (at.is.firefox === !0 ? Kx.test(n.data) === !1 : zx.test(n.data) === !0 || Hx.test(n.data) === !0 || Ux.test(n.data) === !0) === !0 && (n.target.qComposing = !0);
  };
}
const Gx = wt({
  name: "QInput",
  inheritAttrs: !1,
  props: {
    ...Ax,
    ...jx,
    ...Fx,
    modelValue: { required: !1 },
    shadowText: String,
    type: {
      type: String,
      default: "text"
    },
    debounce: [String, Number],
    autogrow: Boolean,
    // makes a textarea
    inputClass: [Array, String, Object],
    inputStyle: [Array, String, Object]
  },
  emits: [
    ...Vx,
    "paste",
    "change",
    "keydown",
    "click",
    "animationend"
  ],
  setup(e, { emit: t, attrs: n }) {
    const { proxy: o } = Fe(), { $q: r } = o, i = {};
    let s = NaN, a, l, c = null, u;
    const d = te(null), f = Wx(e), {
      innerValue: p,
      hasMask: v,
      moveCursorForPaste: w,
      updateMaskValue: _,
      onMaskedKeydown: C,
      onMaskedClick: S
    } = qx(e, t, Q, d), N = Bx(e), m = V(() => Zs(p.value)), y = Yx(M), x = Rx(), k = V(
      () => e.type === "textarea" || e.autogrow === !0
    ), D = V(
      () => k.value === !0 || ["text", "search", "url", "tel", "password"].includes(e.type)
    ), E = V(() => {
      const q = {
        ...x.splitAttrs.listeners.value,
        onInput: M,
        onPaste: R,
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        onChange: W,
        onBlur: he,
        onFocus: gr
      };
      return q.onCompositionstart = q.onCompositionupdate = q.onCompositionend = y, v.value === !0 && (q.onKeydown = C, q.onClick = S), e.autogrow === !0 && (q.onAnimationend = G), q;
    }), O = V(() => {
      const q = {
        tabindex: 0,
        "data-autofocus": e.autofocus === !0 || void 0,
        rows: e.type === "textarea" ? 6 : void 0,
        "aria-label": e.label,
        name: f.value,
        ...x.splitAttrs.attributes.value,
        id: x.targetUid.value,
        maxlength: e.maxlength,
        disabled: e.disable === !0,
        readonly: e.readonly === !0
      };
      return k.value === !1 && (q.type = e.type), e.autogrow === !0 && (q.rows = 1), q;
    });
    ye(() => e.type, () => {
      d.value && (d.value.value = e.modelValue);
    }), ye(() => e.modelValue, (q) => {
      if (v.value === !0) {
        if (l === !0 && (l = !1, String(q) === s))
          return;
        _(q);
      } else p.value !== q && (p.value = q, e.type === "number" && i.hasOwnProperty("value") === !0 && (a === !0 ? a = !1 : delete i.value));
      e.autogrow === !0 && tt($);
    }), ye(() => e.autogrow, (q) => {
      q === !0 ? tt($) : d.value !== null && n.rows > 0 && (d.value.style.height = "auto");
    }), ye(() => e.dense, () => {
      e.autogrow === !0 && tt($);
    });
    function A() {
      ja(() => {
        const q = document.activeElement;
        d.value !== null && d.value !== q && (q === null || q.id !== x.targetUid.value) && d.value.focus({ preventScroll: !0 });
      });
    }
    function g() {
      d.value !== null && d.value.select();
    }
    function R(q) {
      if (v.value === !0 && e.reverseFillMask !== !0) {
        const ve = q.target;
        w(ve, ve.selectionStart, ve.selectionEnd);
      }
      t("paste", q);
    }
    function M(q) {
      if (!q || !q.target)
        return;
      if (e.type === "file") {
        t("update:modelValue", q.target.files);
        return;
      }
      const ve = q.target.value;
      if (q.target.qComposing === !0) {
        i.value = ve;
        return;
      }
      if (v.value === !0)
        _(ve, !1, q.inputType);
      else if (Q(ve), D.value === !0 && q.target === document.activeElement) {
        const { selectionStart: Ve, selectionEnd: Te } = q.target;
        Ve !== void 0 && Te !== void 0 && tt(() => {
          q.target === document.activeElement && ve.indexOf(q.target.value) === 0 && q.target.setSelectionRange(Ve, Te);
        });
      }
      e.autogrow === !0 && $();
    }
    function G(q) {
      t("animationend", q), $();
    }
    function Q(q, ve) {
      u = () => {
        c = null, e.type !== "number" && i.hasOwnProperty("value") === !0 && delete i.value, e.modelValue !== q && s !== q && (s = q, ve === !0 && (l = !0), t("update:modelValue", q), tt(() => {
          s === q && (s = NaN);
        })), u = void 0;
      }, e.type === "number" && (a = !0, i.value = q), e.debounce !== void 0 ? (c !== null && clearTimeout(c), i.value = q, c = setTimeout(u, e.debounce)) : u();
    }
    function $() {
      requestAnimationFrame(() => {
        const q = d.value;
        if (q !== null) {
          const ve = q.parentNode.style, { scrollTop: Ve } = q, { overflowY: Te, maxHeight: xe } = r.platform.is.firefox === !0 ? {} : window.getComputedStyle(q), Re = Te !== void 0 && Te !== "scroll";
          Re === !0 && (q.style.overflowY = "hidden"), ve.marginBottom = q.scrollHeight - 1 + "px", q.style.height = "1px", q.style.height = q.scrollHeight + "px", Re === !0 && (q.style.overflowY = parseInt(xe, 10) < q.scrollHeight ? "auto" : "hidden"), ve.marginBottom = "", q.scrollTop = Ve;
        }
      });
    }
    function W(q) {
      y(q), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), t("change", q.target.value);
    }
    function he(q) {
      q !== void 0 && gr(q), c !== null && (clearTimeout(c), c = null), u !== void 0 && u(), a = !1, l = !1, delete i.value, e.type !== "file" && setTimeout(() => {
        d.value !== null && (d.value.value = p.value !== void 0 ? p.value : "");
      });
    }
    function fe() {
      return i.hasOwnProperty("value") === !0 ? i.value : p.value !== void 0 ? p.value : "";
    }
    St(() => {
      he();
    }), Ct(() => {
      e.autogrow === !0 && $();
    }), Object.assign(x, {
      innerValue: p,
      fieldClass: V(
        () => `q-${k.value === !0 ? "textarea" : "input"}` + (e.autogrow === !0 ? " q-textarea--autogrow" : "")
      ),
      hasShadow: V(
        () => e.type !== "file" && typeof e.shadowText == "string" && e.shadowText.length !== 0
      ),
      inputRef: d,
      emitValue: Q,
      hasValue: m,
      floatingLabel: V(
        () => m.value === !0 && (e.type !== "number" || isNaN(p.value) === !1) || Zs(e.displayValue)
      ),
      getControl: () => U(k.value === !0 ? "textarea" : "input", {
        ref: d,
        class: [
          "q-field__native q-placeholder",
          e.inputClass
        ],
        style: e.inputStyle,
        ...O.value,
        ...E.value,
        ...e.type !== "file" ? { value: fe() } : N.value
      }),
      getShadowControl: () => U("div", {
        class: "q-field__native q-field__shadow absolute-bottom no-pointer-events" + (k.value === !0 ? "" : " text-no-wrap")
      }, [
        U("span", { class: "invisible" }, fe()),
        U("span", e.shadowText)
      ])
    });
    const we = Lx(x);
    return Object.assign(o, {
      focus: A,
      select: g,
      getNativeElement: () => d.value
      // deprecated
    }), Fo(o, "nativeEl", () => d.value), we;
  }
}), Qx = !1, Xx = /* @__PURE__ */ Ee({
  __name: "WsInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    dark: {
      type: Boolean,
      default: !1
    },
    error: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    responsive: {
      type: Boolean,
      default: !0
    },
    type: {
      type: String,
      default: "text"
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: t }) {
    const { isTheme: n } = qo(), o = e, r = t, i = (s) => {
      r("update:modelValue", s);
    };
    return (s, a) => {
      const l = nt("portal-slot");
      return X(), He(re(Gx), {
        ref: "qfield",
        class: pt(["ws-input ws-field", {
          responsive: e.responsive,
          "ws-dark": e.dark,
          "ws-has-value": e.modelValue
        }]),
        error: o.error,
        standout: re(n)(re(Be).ADMIN) ? void 0 : e.dark ? "bg-dark text-white" : "bg-white ws-text-darker",
        "bg-color": re(n)(re(Be).ADMIN) ? void 0 : e.dark ? "dark" : "white",
        square: re(n)(re(Be).ADMIN),
        outlined: "",
        "bottom-slots": "",
        "no-error-icon": "",
        type: e.type,
        "lazy-rules": Qx,
        required: o.required,
        "model-value": o.modelValue,
        "onUpdate:modelValue": i
      }, {
        default: Me(() => [
          le(l, {
            slot: s.$slots.default,
            "component-id": s.$attrs["component-id"],
            name: "default"
          }, null, 8, ["slot", "component-id"])
        ]),
        _: 1
      }, 8, ["class", "error", "standout", "bg-color", "square", "type", "required", "model-value"]);
    };
  }
}), Jx = /* @__PURE__ */ je(Xx, [["__scopeId", "data-v-6ac2160a"]]), Zx = { class: "ws-password-input ws-field" }, e1 = {
  key: 0,
  class: "password-toggle-visibility-wrapper"
}, t1 = /* @__PURE__ */ Ee({
  __name: "WsPasswordInput",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    autocomplete: { type: String, default: "password" },
    hideIcon: { type: Boolean, default: !1 },
    expose: { type: Boolean },
    strength: { type: Boolean },
    strengthAbove: { type: Boolean },
    error: { type: Boolean }
  },
  emits: ["expose", "update:modelValue"],
  setup(e, { emit: t }) {
    const n = e, o = te(!1);
    let r = !1, i = !1;
    const s = t;
    ye(() => n.expose, (c) => {
      o.value = c;
    });
    const a = (c) => {
      s("update:modelValue", c);
    };
    function l(c) {
      r = !r, o.value = r, s("expose", o);
    }
    return (c, u) => {
      const d = nt("portal-slot");
      return X(), ue("div", Zx, [
        le(Jx, Bt({
          ref: "qfield",
          class: { append: !e.hideIcon, exposed: o.value }
        }, c.$attrs, {
          "data-test": "password-input",
          autocomplete: e.autocomplete,
          type: o.value ? "text" : "password",
          spellcheck: "false",
          autocapitalize: "off",
          error: n.error,
          "model-value": n.modelValue,
          onBlur: u[1] || (u[1] = (f) => {
            $e(i) ? i.value = !0 : i = !0;
          }),
          "onUpdate:modelValue": a
        }), {
          default: Me(() => [
            n.modelValue && !e.hideIcon ? (X(), ue("div", e1, [
              le(Tn, {
                name: o.value ? "hidden" : "view",
                class: "password-toggle-visibility",
                "data-test": "password-toggle-visibility",
                alt: "expose",
                onClick: u[0] || (u[0] = (f) => l())
              }, null, 8, ["name"]),
              le(d, {
                slot: c.$slots.default,
                "component-id": c.$attrs["component-id"],
                name: "default"
              }, null, 8, ["slot", "component-id"])
            ])) : Pe("", !0)
          ]),
          _: 1
        }, 16, ["class", "autocomplete", "type", "error", "model-value"])
      ]);
    };
  }
}), ak = /* @__PURE__ */ je(t1, [["__scopeId", "data-v-23add205"]]), n1 = { class: "heading q-mb-sm" }, o1 = { class: "description" }, r1 = /* @__PURE__ */ Ee({
  __name: "WsEmptyMarkupTable",
  setup(e) {
    const t = Li();
    return (n, o) => {
      const r = nt("portal-slot");
      return X(), ue("div", Bt({ class: "ws-empty-markup-table text-center q-px-lg q-py-xl" }, n.$attrs), [
        ce("p", n1, [
          le(r, {
            slot: re(t).heading,
            "component-id": n.$attrs["component-id"],
            name: "heading"
          }, null, 8, ["slot", "component-id"])
        ]),
        ce("p", o1, [
          le(r, {
            slot: re(t).description,
            "component-id": n.$attrs["component-id"],
            name: "description"
          }, null, 8, ["slot", "component-id"])
        ]),
        le(r, {
          slot: re(t).actions,
          "component-id": n.$attrs["component-id"],
          name: "actions"
        }, null, 8, ["slot", "component-id"])
      ], 16);
    };
  }
}), lk = /* @__PURE__ */ je(r1, [["__scopeId", "data-v-21bff4a5"]]);
var Tf = /* @__PURE__ */ ((e) => (e.danger = "danger", e.base = "base", e.positive = "positive", e.neutral = "neutral", e.alert = "alert", e.dark = "dark", e.basic = "basic", e.advanced = "advanced", e.premium = "premium", e))(Tf || {});
const uk = {
  Type: Tf
}, i1 = /* @__PURE__ */ Ee({
  __name: "WsTag",
  props: {
    bg: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: ""
    }
  },
  setup(e) {
    const t = Li(), n = Cr(), o = e;
    return (r, i) => {
      const s = nt("portal-slot");
      return X(), ue("div", Bt(re(n), {
        class: ["ws-tag", [
          o.bg ? "bg-" + o.bg : "",
          o.color ? "text-" + o.color : "",
          o.type ? "badge-type-" + o.type : ""
        ]]
      }), [
        le(s, {
          slot: re(t).default,
          "component-id": r.$attrs["component-id"]
        }, null, 8, ["slot", "component-id"])
      ], 16);
    };
  }
}), ck = /* @__PURE__ */ je(i1, [["__scopeId", "data-v-fc0bcded"]]);
function s1(e) {
  const t = document.createElement("textarea");
  t.value = e, t.contentEditable = "true", t.style.position = "fixed";
  const n = () => {
  };
  yf(n), document.body.appendChild(t), t.focus(), t.select();
  const o = document.execCommand("copy");
  return t.remove(), wf(n), o;
}
function a1(e) {
  return navigator.clipboard !== void 0 ? navigator.clipboard.writeText(e) : new Promise((t, n) => {
    const o = s1(e);
    o ? t(!0) : n(o);
  });
}
const l1 = { class: "ws-copy__content" }, u1 = /* @__PURE__ */ Ee({
  __name: "WsCopy",
  props: {
    modelValue: { type: String, default: "" },
    fullWidth: { type: Boolean, default: !1 }
  },
  setup(e) {
    var d;
    const t = e, n = Cr(), o = Li(), r = te(!1), i = te(!1);
    let s = null, a = null;
    const l = !!(o.default || (d = n.portalSlots) != null && d.includes("default")), c = async () => {
      let f = t.modelValue;
      f || (f = ri(o, "default[0].elm.data", "")), a1(f).then(() => {
        r.value = !0, i.value = !0, s = setTimeout(() => {
          i.value = !1;
        }, 5e3), a = setTimeout(() => {
          r.value = !1;
        }, 6e3);
      }).catch((p) => {
        console.error(p);
      });
    }, u = (f) => {
      r.value || (i.value = f);
    };
    return St(() => {
      clearTimeout(s), clearTimeout(a);
    }), (f, p) => {
      const v = nt("portal-slot");
      return l ? (X(), ue("div", {
        key: 0,
        class: pt(["ws-copy", { "ws-copy--full-width": e.fullWidth }])
      }, [
        ce("div", l1, [
          le(v, {
            slot: re(o).default,
            "component-id": f.$attrs["component-id"]
          }, null, 8, ["slot", "component-id"])
        ]),
        ce("button", {
          class: "ws-copy__button",
          "data-test": "button",
          onClick: c,
          onFocus: p[0] || (p[0] = (w) => u(!0)),
          onFocusout: p[1] || (p[1] = (w) => u(!1)),
          onMouseenter: p[2] || (p[2] = (w) => u(!0)),
          onMouseleave: p[3] || (p[3] = (w) => u(!1))
        }, [
          le(Tn, {
            name: r.value ? "success" : "copy",
            width: 16,
            height: 16
          }, null, 8, ["name"]),
          le(Gd, {
            ref: "tooltip",
            "model-value": i.value,
            offset: [8, 8],
            anchor: "bottom right",
            self: "top right"
          }, {
            default: Me(() => [
              ft(De(r.value ? f.$t("uikit:copy.saved_in_clipboard") : f.$t("uikit:copy.copy")), 1)
            ]),
            _: 1
          }, 8, ["model-value"])
        ], 32)
      ], 2)) : Pe("", !0);
    };
  }
}), dk = /* @__PURE__ */ je(u1, [["__scopeId", "data-v-66903428"]]), fk = /* @__PURE__ */ Ee({
  __name: "WsButtonDropdown",
  props: {
    a11yHideFocusElSel: {
      type: String,
      required: !1,
      default: null
    },
    a11yLastItemFocusElSel: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: {
    hide: (e) => e instanceof Event,
    input: (e) => e instanceof Event,
    show: (e) => e instanceof Event,
    "before-hide": (e) => e instanceof Event,
    "before-show": (e) => e instanceof Event,
    click: (e) => e instanceof Event
  },
  setup(e, { emit: t }) {
    const n = e, o = t, r = Cr(), i = Li(), s = te(null), a = (u) => {
      if (typeof u > "u")
        return;
      const d = document.querySelector(
        `${u} button[role="button"]`
      );
      d && d.focus({ focusVisible: !0 });
    }, l = (u) => {
      typeof u > "u" || (o("hide", u), u instanceof FocusEvent && a(n.a11yHideFocusElSel));
    }, c = (u) => {
      if (u.key === "Tab" && !u.shiftKey) {
        const f = document.querySelectorAll('.button-dropdown__list a, .button-dropdown__list [tabindex]:not([tabindex="-1"])'), p = f[f.length - 1];
        document.activeElement === p && (u.preventDefault(), s.value && s.value.hide(), a(n.a11yLastItemFocusElSel));
      }
    };
    return (u, d) => {
      const f = nt("portal-slot");
      return X(), He(Ef, Bt({
        ref_key: "quasarDropdownEl",
        ref: s,
        "component-id": u.$attrs["component-id"]
      }, re(r), {
        "close-on-iframe-click": "",
        onHide: l,
        onInput: d[1] || (d[1] = (p) => u.$emit("input", p)),
        onShow: d[2] || (d[2] = (p) => u.$emit("show", p)),
        onBeforeHide: d[3] || (d[3] = (p) => u.$emit("before-hide", p)),
        onBeforeShow: d[4] || (d[4] = (p) => u.$emit("before-show", p)),
        onClick: d[5] || (d[5] = (p) => u.$emit("click", p))
      }), {
        label: Me(() => [
          le(f, {
            slot: re(i).label,
            "component-id": u.$attrs["component-id"],
            name: "label"
          }, null, 8, ["slot", "component-id"])
        ]),
        loading: Me(() => [
          le(f, {
            slot: re(i).loading,
            "component-id": u.$attrs["component-id"],
            name: "loading"
          }, null, 8, ["slot", "component-id"])
        ]),
        default: Me(() => [
          ce("button", {
            class: "button-dropdown__list remove-button-defaults",
            onKeydown: d[0] || (d[0] = (p) => c(p))
          }, [
            le(f, {
              slot: re(i).default,
              "component-id": u.$attrs["component-id"],
              name: "default"
            }, null, 8, ["slot", "component-id"])
          ], 32)
        ]),
        _: 1
      }, 16, ["component-id"]);
    };
  }
}), Ui = (e, t) => {
  const n = Ro(e);
  for (const o in e)
    Fo(
      t,
      o,
      () => n[o],
      (r) => {
        n[o] = r;
      }
    );
  return t;
}, Es = ["sm", "md", "lg", "xl"], { passive: Fu } = Dn, c1 = Ui({
  width: 0,
  height: 0,
  name: "xs",
  sizes: {
    sm: 600,
    md: 1024,
    lg: 1440,
    xl: 1920
  },
  lt: {
    sm: !0,
    md: !0,
    lg: !0,
    xl: !0
  },
  gt: {
    xs: !1,
    sm: !1,
    md: !1,
    lg: !1
  },
  xs: !0,
  sm: !1,
  md: !1,
  lg: !1,
  xl: !1
}, {
  setSizes: vr,
  setDebounce: vr,
  install({ $q: e, onSSRHydrated: t }) {
    if (e.screen = this, this.__installed === !0) {
      e.config.screen !== void 0 && (e.config.screen.bodyClasses === !1 ? document.body.classList.remove(`screen--${this.name}`) : this.__update(!0));
      return;
    }
    const { visualViewport: n } = window, o = n || window, r = document.scrollingElement || document.documentElement, i = n === void 0 || at.is.mobile === !0 ? () => [
      Math.max(window.innerWidth, r.clientWidth),
      Math.max(window.innerHeight, r.clientHeight)
    ] : () => [
      n.width * n.scale + window.innerWidth - r.clientWidth,
      n.height * n.scale + window.innerHeight - r.clientHeight
    ], s = e.config.screen !== void 0 && e.config.screen.bodyClasses === !0;
    this.__update = (d) => {
      const [f, p] = i();
      if (p !== this.height && (this.height = p), f !== this.width)
        this.width = f;
      else if (d !== !0)
        return;
      let v = this.sizes;
      this.gt.xs = f >= v.sm, this.gt.sm = f >= v.md, this.gt.md = f >= v.lg, this.gt.lg = f >= v.xl, this.lt.sm = f < v.sm, this.lt.md = f < v.md, this.lt.lg = f < v.lg, this.lt.xl = f < v.xl, this.xs = this.lt.sm, this.sm = this.gt.xs === !0 && this.lt.md === !0, this.md = this.gt.sm === !0 && this.lt.lg === !0, this.lg = this.gt.md === !0 && this.lt.xl === !0, this.xl = this.gt.lg, v = this.xs === !0 && "xs" || this.sm === !0 && "sm" || this.md === !0 && "md" || this.lg === !0 && "lg" || "xl", v !== this.name && (s === !0 && (document.body.classList.remove(`screen--${this.name}`), document.body.classList.add(`screen--${v}`)), this.name = v);
    };
    let a, l = {}, c = 16;
    this.setSizes = (d) => {
      Es.forEach((f) => {
        d[f] !== void 0 && (l[f] = d[f]);
      });
    }, this.setDebounce = (d) => {
      c = d;
    };
    const u = () => {
      const d = getComputedStyle(document.body);
      d.getPropertyValue("--q-size-sm") && Es.forEach((f) => {
        this.sizes[f] = parseInt(d.getPropertyValue(`--q-size-${f}`), 10);
      }), this.setSizes = (f) => {
        Es.forEach((p) => {
          f[p] && (this.sizes[p] = f[p]);
        }), this.__update(!0);
      }, this.setDebounce = (f) => {
        a !== void 0 && o.removeEventListener("resize", a, Fu), a = f > 0 ? Of(this.__update, f) : this.__update, o.addEventListener("resize", a, Fu);
      }, this.setDebounce(c), Object.keys(l).length !== 0 ? (this.setSizes(l), l = void 0) : this.__update(), s === !0 && this.name === "xs" && document.body.classList.add("screen--xs");
    };
    Mn.value === !0 ? t.push(u) : u();
  }
}), rt = Ui({
  isActive: !1,
  mode: !1
}, {
  __media: void 0,
  set(e) {
    rt.mode = e, e === "auto" ? (rt.__media === void 0 && (rt.__media = window.matchMedia("(prefers-color-scheme: dark)"), rt.__updateMedia = () => {
      rt.set("auto");
    }, rt.__media.addListener(rt.__updateMedia)), e = rt.__media.matches) : rt.__media !== void 0 && (rt.__media.removeListener(rt.__updateMedia), rt.__media = void 0), rt.isActive = e === !0, document.body.classList.remove(`body--${e === !0 ? "light" : "dark"}`), document.body.classList.add(`body--${e === !0 ? "dark" : "light"}`);
  },
  toggle() {
    rt.set(rt.isActive === !1);
  },
  install({ $q: e, onSSRHydrated: t, ssrContext: n }) {
    const { dark: o } = e.config;
    if (e.dark = this, this.__installed === !0 && o === void 0)
      return;
    this.isActive = o === !0;
    const r = o !== void 0 ? o : !1;
    if (Mn.value === !0) {
      const i = (a) => {
        this.__fromSSR = a;
      }, s = this.set;
      this.set = i, i(r), t.push(() => {
        this.set = s, this.set(this.__fromSSR);
      });
    } else
      this.set(r);
  }
}), Pf = () => !0;
function d1(e) {
  return typeof e == "string" && e !== "" && e !== "/" && e !== "#/";
}
function f1(e) {
  return e.startsWith("#") === !0 && (e = e.substring(1)), e.startsWith("/") === !1 && (e = "/" + e), e.endsWith("/") === !0 && (e = e.substring(0, e.length - 1)), "#" + e;
}
function p1(e) {
  if (e.backButtonExit === !1)
    return () => !1;
  if (e.backButtonExit === "*")
    return Pf;
  const t = ["#/"];
  return Array.isArray(e.backButtonExit) === !0 && t.push(
    ...e.backButtonExit.filter(d1).map(f1)
  ), () => t.includes(window.location.hash);
}
const m1 = {
  __history: [],
  add: vr,
  remove: vr,
  install({ $q: e }) {
    if (this.__installed === !0)
      return;
    const { cordova: t, capacitor: n } = at.is;
    if (t !== !0 && n !== !0)
      return;
    const o = e.config[t === !0 ? "cordova" : "capacitor"];
    if (o !== void 0 && o.backButton === !1 || // if we're on Capacitor mode
    n === !0 && (window.Capacitor === void 0 || window.Capacitor.Plugins.App === void 0))
      return;
    this.add = (s) => {
      s.condition === void 0 && (s.condition = Pf), this.__history.push(s);
    }, this.remove = (s) => {
      const a = this.__history.indexOf(s);
      a >= 0 && this.__history.splice(a, 1);
    };
    const r = p1(
      Object.assign(
        { backButtonExit: !0 },
        o
      )
    ), i = () => {
      if (this.__history.length) {
        const s = this.__history[this.__history.length - 1];
        s.condition() === !0 && (this.__history.pop(), s.handler());
      } else r() === !0 ? navigator.app.exitApp() : window.history.back();
    };
    t === !0 ? document.addEventListener("deviceready", () => {
      document.addEventListener("backbutton", i, !1);
    }) : window.Capacitor.Plugins.App.addListener("backButton", i);
  }
}, Wu = {
  isoName: "en-US",
  nativeName: "English (US)",
  label: {
    clear: "Clear",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    set: "Set",
    select: "Select",
    reset: "Reset",
    remove: "Remove",
    update: "Update",
    create: "Create",
    search: "Search",
    filter: "Filter",
    refresh: "Refresh",
    expand: (e) => e ? `Expand "${e}"` : "Expand",
    collapse: (e) => e ? `Collapse "${e}"` : "Collapse"
  },
  date: {
    days: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
    daysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
    months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
    monthsShort: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
    firstDayOfWeek: 0,
    // 0-6, 0 - Sunday, 1 Monday, ...
    format24h: !1,
    pluralDay: "days"
  },
  table: {
    noData: "No data available",
    noResults: "No matching records found",
    loading: "Loading...",
    selectedRecords: (e) => e === 1 ? "1 record selected." : (e === 0 ? "No" : e) + " records selected.",
    recordsPerPage: "Records per page:",
    allRows: "All",
    pagination: (e, t, n) => e + "-" + t + " of " + n,
    columns: "Columns"
  },
  editor: {
    url: "URL",
    bold: "Bold",
    italic: "Italic",
    strikethrough: "Strikethrough",
    underline: "Underline",
    unorderedList: "Unordered List",
    orderedList: "Ordered List",
    subscript: "Subscript",
    superscript: "Superscript",
    hyperlink: "Hyperlink",
    toggleFullscreen: "Toggle Fullscreen",
    quote: "Quote",
    left: "Left align",
    center: "Center align",
    right: "Right align",
    justify: "Justify align",
    print: "Print",
    outdent: "Decrease indentation",
    indent: "Increase indentation",
    removeFormat: "Remove formatting",
    formatting: "Formatting",
    fontSize: "Font Size",
    align: "Align",
    hr: "Insert Horizontal Rule",
    undo: "Undo",
    redo: "Redo",
    heading1: "Heading 1",
    heading2: "Heading 2",
    heading3: "Heading 3",
    heading4: "Heading 4",
    heading5: "Heading 5",
    heading6: "Heading 6",
    paragraph: "Paragraph",
    code: "Code",
    size1: "Very small",
    size2: "A bit small",
    size3: "Normal",
    size4: "Medium-large",
    size5: "Big",
    size6: "Very big",
    size7: "Maximum",
    defaultFont: "Default Font",
    viewSource: "View Source"
  },
  tree: {
    noNodes: "No nodes available",
    noResults: "No matching nodes found"
  }
};
function Bu() {
  const e = Array.isArray(navigator.languages) === !0 && navigator.languages.length !== 0 ? navigator.languages[0] : navigator.language;
  if (typeof e == "string")
    return e.split(/[-_]/).map((t, n) => n === 0 ? t.toLowerCase() : n > 1 || t.length < 4 ? t.toUpperCase() : t[0].toUpperCase() + t.slice(1).toLowerCase()).join("-");
}
const Rt = Ui({
  __langPack: {}
}, {
  getLocale: Bu,
  set(e = Wu, t) {
    const n = {
      ...e,
      rtl: e.rtl === !0,
      getLocale: Bu
    };
    {
      if (n.set = Rt.set, Rt.__langConfig === void 0 || Rt.__langConfig.noHtmlAttrs !== !0) {
        const o = document.documentElement;
        o.setAttribute("dir", n.rtl === !0 ? "rtl" : "ltr"), o.setAttribute("lang", n.isoName);
      }
      Object.assign(Rt.__langPack, n), Rt.props = n, Rt.isoName = n.isoName, Rt.nativeName = n.nativeName;
    }
  },
  install({ $q: e, lang: t, ssrContext: n }) {
    e.lang = Rt.__langPack, Rt.__langConfig = e.config.lang, this.__installed === !0 ? t !== void 0 && this.set(t) : this.set(t || Wu);
  }
});
function h1(e, t, n = document.body) {
  if (typeof e != "string")
    throw new TypeError("Expected a string as propName");
  if (typeof t != "string")
    throw new TypeError("Expected a string as value");
  if (!(n instanceof Element))
    throw new TypeError("Expected a DOM element");
  n.style.setProperty(`--q-${e}`, t);
}
function Df(e) {
  if (e.ios === !0) return "ios";
  if (e.android === !0) return "android";
}
function v1({ is: e, has: t, within: n }, o) {
  const r = [
    e.desktop === !0 ? "desktop" : "mobile",
    `${t.touch === !1 ? "no-" : ""}touch`
  ];
  if (e.mobile === !0) {
    const i = Df(e);
    i !== void 0 && r.push("platform-" + i);
  }
  if (e.nativeMobile === !0) {
    const i = e.nativeMobileWrapper;
    r.push(i), r.push("native-mobile"), e.ios === !0 && (o[i] === void 0 || o[i].iosStatusBarPadding !== !1) && r.push("q-ios-padding");
  } else e.electron === !0 ? r.push("electron") : e.bex === !0 && r.push("bex");
  return n.iframe === !0 && r.push("within-iframe"), r;
}
function g1() {
  const { is: e } = at, t = document.body.className, n = new Set(t.replace(/ {2}/g, " ").split(" "));
  if (Hi !== void 0)
    n.delete("desktop"), n.add("platform-ios"), n.add("mobile");
  else if (e.nativeMobile !== !0 && e.electron !== !0 && e.bex !== !0) {
    if (e.desktop === !0)
      n.delete("mobile"), n.delete("platform-ios"), n.delete("platform-android"), n.add("desktop");
    else if (e.mobile === !0) {
      n.delete("desktop"), n.add("mobile");
      const r = Df(e);
      r !== void 0 ? (n.add(`platform-${r}`), n.delete(`platform-${r === "ios" ? "android" : "ios"}`)) : (n.delete("platform-ios"), n.delete("platform-android"));
    }
  }
  at.has.touch === !0 && (n.delete("no-touch"), n.add("touch")), at.within.iframe === !0 && n.add("within-iframe");
  const o = Array.from(n).join(" ");
  t !== o && (document.body.className = o);
}
function b1(e) {
  for (const t in e)
    h1(t, e[t]);
}
const y1 = {
  install(e) {
    if (this.__installed !== !0) {
      if (Mn.value === !0)
        g1();
      else {
        const { $q: t } = e;
        t.config.brand !== void 0 && b1(t.config.brand);
        const n = v1(at, t.config);
        document.body.classList.add.apply(document.body.classList, n);
      }
      at.is.ios === !0 && document.body.addEventListener("touchstart", vr), window.addEventListener("keydown", uy, !0);
    }
  }
}, w1 = {
  name: "material-icons",
  type: {
    positive: "check_circle",
    negative: "warning",
    info: "info",
    warning: "priority_high"
  },
  arrow: {
    up: "arrow_upward",
    right: "arrow_forward",
    down: "arrow_downward",
    left: "arrow_back",
    dropdown: "arrow_drop_down"
  },
  chevron: {
    left: "chevron_left",
    right: "chevron_right"
  },
  colorPicker: {
    spectrum: "gradient",
    tune: "tune",
    palette: "style"
  },
  pullToRefresh: {
    icon: "refresh"
  },
  carousel: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down",
    navigationIcon: "lens"
  },
  chip: {
    remove: "cancel",
    selected: "check"
  },
  datetime: {
    arrowLeft: "chevron_left",
    arrowRight: "chevron_right",
    now: "access_time",
    today: "today"
  },
  editor: {
    bold: "format_bold",
    italic: "format_italic",
    strikethrough: "strikethrough_s",
    underline: "format_underlined",
    unorderedList: "format_list_bulleted",
    orderedList: "format_list_numbered",
    subscript: "vertical_align_bottom",
    superscript: "vertical_align_top",
    hyperlink: "link",
    toggleFullscreen: "fullscreen",
    quote: "format_quote",
    left: "format_align_left",
    center: "format_align_center",
    right: "format_align_right",
    justify: "format_align_justify",
    print: "print",
    outdent: "format_indent_decrease",
    indent: "format_indent_increase",
    removeFormat: "format_clear",
    formatting: "text_format",
    fontSize: "format_size",
    align: "format_align_left",
    hr: "remove",
    undo: "undo",
    redo: "redo",
    heading: "format_size",
    code: "code",
    size: "format_size",
    font: "font_download",
    viewSource: "code"
  },
  expansionItem: {
    icon: "keyboard_arrow_down",
    denseIcon: "arrow_drop_down"
  },
  fab: {
    icon: "add",
    activeIcon: "close"
  },
  field: {
    clear: "cancel",
    error: "error"
  },
  pagination: {
    first: "first_page",
    prev: "keyboard_arrow_left",
    next: "keyboard_arrow_right",
    last: "last_page"
  },
  rating: {
    icon: "grade"
  },
  stepper: {
    done: "check",
    active: "edit",
    error: "warning"
  },
  tabs: {
    left: "chevron_left",
    right: "chevron_right",
    up: "keyboard_arrow_up",
    down: "keyboard_arrow_down"
  },
  table: {
    arrowUp: "arrow_upward",
    warning: "warning",
    firstPage: "first_page",
    prevPage: "chevron_left",
    nextPage: "chevron_right",
    lastPage: "last_page"
  },
  tree: {
    icon: "play_arrow"
  },
  uploader: {
    done: "done",
    clear: "clear",
    add: "add_box",
    upload: "cloud_upload",
    removeQueue: "clear_all",
    removeUploaded: "done_all"
  }
}, ki = Ui({
  iconMapFn: null,
  __icons: {}
}, {
  set(e, t) {
    const n = { ...e, rtl: e.rtl === !0 };
    n.set = ki.set, Object.assign(ki.__icons, n);
  },
  install({ $q: e, iconSet: t, ssrContext: n }) {
    e.config.iconMapFn !== void 0 && (this.iconMapFn = e.config.iconMapFn), e.iconSet = this.__icons, Fo(e, "iconMapFn", () => this.iconMapFn, (o) => {
      this.iconMapFn = o;
    }), this.__installed === !0 ? t !== void 0 && this.set(t) : this.set(t || w1);
  }
});
function zu(e) {
  return e !== null && typeof e == "object" && Array.isArray(e) !== !0;
}
const Hu = [
  yi,
  y1,
  rt,
  c1,
  m1,
  Rt,
  ki
];
function Uu(e, t) {
  t.forEach((n) => {
    n.install(e), n.__installed = !0;
  });
}
function _1(e, t, n) {
  e.config.globalProperties.$q = n.$q, e.provide(Ox, n.$q), Uu(n, Hu), t.components !== void 0 && Object.values(t.components).forEach((o) => {
    zu(o) === !0 && o.name !== void 0 && e.component(o.name, o);
  }), t.directives !== void 0 && Object.values(t.directives).forEach((o) => {
    zu(o) === !0 && o.name !== void 0 && e.directive(o.name, o);
  }), t.plugins !== void 0 && Uu(
    n,
    Object.values(t.plugins).filter(
      (o) => typeof o.install == "function" && Hu.includes(o) === !1
    )
  ), Mn.value === !0 && (n.$q.onSSRHydrated = () => {
    n.onSSRHydrated.forEach((o) => {
      o();
    }), n.$q.onSSRHydrated = () => {
    };
  });
}
const E1 = function(e, t = {}) {
  const n = { version: "2.14.2" };
  hf === !1 ? (t.config !== void 0 && Object.assign(wi, t.config), n.config = { ...wi }, Ky()) : n.config = t.config || {}, _1(e, t, {
    parentApp: e,
    $q: n,
    lang: t.lang,
    iconSet: t.iconSet,
    onSSRHydrated: []
  });
}, x1 = {
  version: "2.14.2",
  install: E1,
  lang: Rt,
  iconSet: ki
}, k1 = {
  updated: Ku,
  created: Ku
};
function Ku(e, t) {
  var n;
  if (!window.ws_analytics || !t.value)
    return null;
  e.getAttribute("data-tracking") || e.setAttribute("data-tracking", t.value), (n = window.ws_analytics.stored) != null && n[t.value] && (Object.keys(window.ws_analytics.stored[t.value]).forEach((o) => {
    e.addEventListener(o, window.ws_analytics.stored[t.value][o]);
  }), delete window.ws_analytics.stored[t.value]);
}
const Yn = Ws(() => U(cv)), pk = async (e) => {
  C1(e), mv(window._WS_COMPONENTS_PACKAGE_TARGET), Yn.component("PortalSlot", Wi), Yn.directive("ws-analytics", k1), Yn.use(x1, {
    plugins: {}
    // import Quasar plugins and add here
  }), Yn.use(vb, {
    component: "tippy"
  }), If({ translate: e.i18next.t }), O1(), S1(e), Yn.mount(e.mountTarget || "#uikit-app");
};
function C1(e) {
  if (!e.mountTarget) {
    const t = document.createElement("div");
    t.setAttribute("id", "uikit-app"), document.querySelector("body").appendChild(t);
  }
}
Yn.use(Hb);
function S1(e) {
  document.documentElement.lang = e.i18next.language, e.i18next && Yn.use(ww, {
    i18next: e.i18next,
    rerenderOn: ["languageChanged"]
  });
}
function O1() {
  const { theme: e } = qo();
  Ff(() => e.value);
}
export {
  I1 as TestItem,
  H1 as WsBack,
  Kb as WsButton,
  fk as WsButtonDropdown,
  z1 as WsButtonEnum,
  Lb as WsCarySpinner,
  dk as WsCopy,
  ru as WsCountryFlag,
  j1 as WsDelimiter,
  lk as WsEmptyMarkupTable,
  sk as WsExpandableText,
  U1 as WsHelpSection,
  q1 as WsHorizontalDivider,
  Tn as WsIcon,
  Jx as WsInput,
  tk as WsLabelLink,
  F1 as WsLinearProgress,
  Y1 as WsLoginAside,
  K1 as WsLoginCard,
  ak as WsPasswordInput,
  X1 as WsPriceBadge,
  Q1 as WsPriceBadgeEnum,
  W1 as WsQrCode,
  Ow as WsSelectLanguage,
  Wb as WsSpinner,
  B1 as WsSpinnerEnum,
  nk as WsStateBanner,
  J1 as WsStateBannerEnum,
  ck as WsTag,
  uk as WsTagEnum,
  ik as WsTimeline,
  rk as WsTimelineStep,
  ok as WsTimelineStepEnum,
  Gd as WsTooltip,
  ek as WsTwoFactorAuthenticationInput,
  Z1 as WsTwoFactorAuthenticationInputEnum,
  G1 as WsUsersList,
  Yn as app,
  V1 as mountComponent,
  pk as setupComponents,
  L1 as unMountComponent,
  R1 as updateAttrs
};
//# sourceMappingURL=core.es.js.map
